/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
      'ui.router',
      'BlurAdmin.pages.services',
      'BlurAdmin.pages.config',
      'BlurAdmin.pages.main',
      'BlurAdmin.pages.dashboard',
      // 'BlurAdmin.pages.ui',
      //'BlurAdmin.pages.components',
      'BlurAdmin.pages.form',
      // 'BlurAdmin.pages.tables',
      // 'BlurAdmin.pages.charts',
      // 'BlurAdmin.pages.maps',
      'BlurAdmin.pages.profile',
      'BlurAdmin.pages.authSignIn',
      'BlurAdmin.pages.authSignUp',
      // 'BlurAdmin.pages.system',
      'BlurAdmin.pages.account',
      'BlurAdmin.pages.reports',
      'BlurAdmin.pages.operational',
      'BlurAdmin.pages.expense',
      'BlurAdmin.pages.flowtransaction',
      'BlurAdmin.pages.assignagent',
      'BlurAdmin.pages.clerkSetup',


    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/authSignIn');

    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Pages',
    //   icon: 'ion-document',
    //   subMenu: [{
    //     title: 'Sign In',
    //     fixedHref: 'auth.html',
    //     blank: true
    //   }, {
    //     title: 'Sign Up',
    //     fixedHref: 'reg.html',
    //     blank: true
    //   }, {
    //     title: 'User Profile',
    //     stateRef: 'profile'
    //   }, {
    //     title: '404 Page',
    //     fixedHref: '404.html',
    //     blank: true
    //   }]
    // });
    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Menu Level 1',
    //   icon: 'ion-ios-more',
    //   subMenu: [{
    //     title: 'Menu Level 1.1',
    //     disabled: true
    //   }, {
    //     title: 'Menu Level 1.2',
    //     subMenu: [{
    //       title: 'Menu Level 1.2.1',
    //       disabled: true
    //     }]
    //   }]
    // });
  }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      // 'chart.js',
      'angular-chartist',
      // 'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account', [ 
    'ui.select',
    'BlurAdmin.pages.account.roles',
    'BlurAdmin.pages.account.users',
  //   'BlurAdmin.pages.account.partner',
  //   'BlurAdmin.pages.account.collector',
  //   'BlurAdmin.pages.account.supplier',
	// 'BlurAdmin.pages.account.usermapping'

  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.account', {
          url: '/account',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'User Setup 用户设置',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 102,
          },
          authRoles:[1],
          authenticate: true
        }).state('main.account.roles', {
          url: '/roles',
          templateUrl: 'app/pages/account/roles/roles.html',
          title: 'Roles 部门',
          controller: 'RolesPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.account.users', {
          url: '/users',
          templateUrl: 'app/pages/account/users/users.html',
          title: 'Users 用户',
          controller: 'UsersPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        // }).state('main.account.collector', {
        //   url: '/collector',
        //   templateUrl: 'app/pages/account/collector/collector.html',
        //   title: 'Collectors',
        //   controller: 'CollectorPageCtrl',
        //   sidebarMeta: {
        //     order: 2,
        //   },
        //   authenticate: true
        // }).state('main.account.partner', {
        //   url: '/partner',
        //   templateUrl: 'app/pages/account/partner/partner.html',
        //   title: 'Partners',
        //   controller: 'PartnerPageCtrl',
        //   sidebarMeta: {
        //     order: 3,
        //   },
        //   authenticate: true
        // }).state('main.account.supplier', {
        //   url: '/supplier',
        //   templateUrl: 'app/pages/account/supplier/supplier.html',
        //   title: 'Suppliers',
        //   controller: 'SupplierPageCtrl',
        //   sidebarMeta: {
        //     order: 4,
        //   },
        //   authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.assignagent', [
      'BlurAdmin.pages.assignagent.assignAgent'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.assignagent', {
          url: '/assignagent',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'LoanSync',
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 201,
          },
          authRoles:[1,5],
          // removed authRoles :[7] as 7 is using clerk rolemapping....done by kishen
          authenticate: true
        }).state('main.assignagent.assignAgent', {
          url: '/assignAgent',
          templateUrl: 'app/pages/assignagent/assignAgent/assignAgent.html',
          title: 'Assign Agent',
          controller: 'assignAgentPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        });
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignIn', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignIn', {
        url: '/authSignIn',
        templateUrl: 'app/pages/authSignIn/authSignIn.html',
        title: 'My Page',
        controller: 'authSignInCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignUp', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignUp', {
        url: '/authSignUp',
        templateUrl: 'app/pages/authSignUp/authSignUp.html',
        title: 'My Page',
        controller: 'authSignUpCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts', {
        url: '/charts',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        title: 'Charts',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 150,
        },
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
      'BlurAdmin.pages.components.mail',
      'BlurAdmin.pages.components.timeline',
      'BlurAdmin.pages.components.tree',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components', {
        url: '/components',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Components',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.clerkSetup', ['ui.select',
            'ngSanitize',
            'BlurAdmin.pages.clerkSetup.customer',
            // 'BlurAdmin.pages.form.case',
            'BlurAdmin.pages.clerkSetup.payment',
            'BlurAdmin.pages.clerkSetup.case',
            // 'BlurAdmin.pages.form.interval',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.clerkSetup', {
                url: '/clerkSetup',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'Clerk',
                sidebarMeta: {
                    icon: 'ion-document',
                    order: 103,
                },
                authRoles: [1, 7],
                authenticate: true
            }).state('main.clerkSetup.payment', {
                url: '/payment',
                templateUrl: 'app/pages/clerkSetup/payment/payment.html',
                title: 'Import Payment 付款',
                controller: 'ClerkPaymentImportPageCtrl',
                sidebarMeta: {
                    order: 1,
                },
                authenticate: true
            }).state('main.clerkSetup.customer', {
                url: '/customer',
                templateUrl: 'app/pages/clerkSetup/customer/customer.html',
                title: 'Customer 顾客',
                controller: 'ClerkCustomerPageCtrl',
                sidebarMeta: {
                    order: 0,
                },
                authenticate: true
            }).state('main.clerkSetup.case', {
                url: '/case',
                templateUrl: 'app/pages/clerkSetup/case/case.html',
                title: 'Case Payment',
                controller: 'CasePaymentPageCtrl',
                sidebarMeta: {
                    order: 0,
                },
                authenticate: true

            })
    }
})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.config', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'Dashboard 主页',
        controller: 'DashboardPageCtrl',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0,
        },
        authRoles:[1,3,5],
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.expense', [
	'BlurAdmin.pages.expense.category'
	])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.expense', {
          url: '/expense',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Expense Setup 費用設置',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 106,
          },
          authRoles:[1,3],
          authenticate: true
        }).state('main.expense.category', {
          url: '/category',
          templateUrl: 'app/pages/expense/category/category.html',
          title: 'Category 種類',
          controller: 'categoryPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.flowtransaction', [
      'BlurAdmin.pages.flowtransaction.transaction'
      ])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.flowtransaction', {
            url: '/flowtransaction',
            template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'Transaction 交易',
            sidebarMeta: {
              icon: 'ion-gear-a',
              order: 107,
            },
            authRoles:[1,3],
            authenticate: true
          }).state('main.flowtransaction.transaction', {
            url: '/transaction',
            templateUrl: 'app/pages/flowtransaction/transaction/transaction.html',
            title: 'Transaction 交易',
            controller: 'transactionPageCtrl',
            sidebarMeta: {
              order: 0,
            },
            authenticate: true
          });
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select',
      'ngSanitize',
      'BlurAdmin.pages.form.customer',
      'BlurAdmin.pages.form.case',
      'BlurAdmin.pages.form.payment',
      'BlurAdmin.pages.form.interval',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.form', {
        url: '/form',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Import 输送资料',
        sidebarMeta: {
          icon: 'ion-compose',
          order: 103,
        },
        authRoles:[1,5,6],
        authenticate: true
      })
      // .state('main.form.inputs', {
      //   url: '/inputs',
      //   templateUrl: 'app/pages/form/inputs/inputs.html',
      //   title: 'Form Inputs',
      //   sidebarMeta: {
      //     order: 0,
      //   },
      //   authenticate: true
      // })
      // .state('main.form.layouts', {
      //   url: '/layouts',
      //   templateUrl: 'app/pages/form/layouts/layouts.html',
      //   title: 'Form Layouts',
      //   sidebarMeta: {
      //     order: 100,
      //   },
      //   authenticate: true
      // })
      // .state('main.form.wizard', {
      //   url: '/wizard',
      //   templateUrl: 'app/pages/form/wizard/wizard.html',
      //   controller: 'WizardCtrl',
      //   controllerAs: 'vm',
      //   title: 'Form Wizard',
      //   sidebarMeta: {
      //     order: 200,
      //   },
      //   authenticate: true
      // })
      // .state('main.form.onlinesales', {
      //   url: '/onlinesales',
      //   templateUrl: 'app/pages/form/onlinesales/onlinesales.html',
      //   title: 'Online Sales',
      //   controller: 'OnlinesalesPageCtrl',
      //   sidebarMeta: {
      //     order: 300,
      //   },
      //   authenticate: true
      // })
      .state('main.form.customer', {
        url: '/customer',
        templateUrl: 'app/pages/form/customer/customer.html',
        title: 'Customer 顾客',
        controller: 'CustomerImportPageCtrl',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.form.case', {
        url: '/case',
        templateUrl: 'app/pages/form/case/case.html',
        title: 'Case 案件',
        controller: 'CaseImportPageCtrl',
        sidebarMeta: {
          order: 1,
        },
        authenticate: true
      }).state('main.form.payment', {
        url: '/payment',
        templateUrl: 'app/pages/form/payment/payment.html',
        title: 'Payment 付款',
        controller: 'PaymentImportPageCtrl',
        sidebarMeta: {
          order: 2,
        },
        authenticate: true
      }).state('main.form.interval', {
        url: '/interval',
        templateUrl: 'app/pages/form/interval/interval.html',
        title: 'Intervals 间隔時間',
        controller: 'IntervalImportPageCtrl',
        sidebarMeta: {
          order: 2,
        },
        authenticate: true
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.maps', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.maps', {
        url: '/maps',
        templateUrl: 'app/pages/maps/maps.html',
        abstract: true,
        title: 'Maps',
        sidebarMeta: {
          icon: 'ion-ios-location-outline',
          order: 500,
        },
        authenticate: true
      })
      .state('main.maps.gmap', {
        url: '/gmap',
        templateUrl: 'app/pages/maps/google-maps/google-maps.html',
        controller: 'GmapPageCtrl',
        title: 'Google Maps',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      })
      .state('main.maps.leaflet', {
        url: '/leaflet',
        templateUrl: 'app/pages/maps/leaflet/leaflet.html',
        controller: 'LeafletPageCtrl',
        title: 'Leaflet Maps',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      })
      .state('main.maps.bubble', {
        url: '/bubble',
        templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
        controller: 'MapBubblePageCtrl',
        title: 'Bubble Maps',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      })
      .state('main.maps.line', {
        url: '/line',
        templateUrl: 'app/pages/maps/map-lines/map-lines.html',
        controller: 'MapLinesPageCtrl',
        title: 'Line Maps',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author dufrolabs
 * created on 29.07.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.main', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/pages/main/main.html',
        redirectTo: 'main.dashboard',
        authenticate: true


      });
  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational', [
	'BlurAdmin.pages.operational.customer',
	'BlurAdmin.pages.operational.case',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.operational', {
          url: '/operational',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Sales Setup 销售设置',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 101,
          },
          authRoles:[1],
          authenticate: true
        }).state('main.operational.customer', {
          url: '/customer',
          templateUrl: 'app/pages/operational/customer/customer.html',
          title: 'Customer 顾客',
          controller: 'CustomerPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authenticate: true
        }).state('main.operational.case', {
          url: '/case',
          templateUrl: 'app/pages/operational/case/case.html',
          title: 'Case 案件',
          controller: 'CasePageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.profile', {
        url: '/profile',
        title: 'Profile 资料',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageCtrl',
        authenticate: true
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports', [
      'BlurAdmin.pages.report.casesummary',
      'BlurAdmin.pages.report.collection',
      'BlurAdmin.pages.report.closecasesummary',
      'BlurAdmin.pages.report.cashinhand'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.report', {
        url: '/report',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Reports 報告',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 105,
        },
        authRoles: [1, 3],
        authenticate: true
      }).state('main.report.casesummary', {
        url: '/casesummary?from_date&status&type',
        templateUrl: 'app/pages/reports/casesummary/casesummary.html',
        title: 'Case Summary',
        controller: 'CaseSummaryreportPageCtrl',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
        // }).state('main.report.casesummarydeposit', {
        //   url: '/casesummary-deposit',
        //   templateUrl: 'app/pages/reports/casesummary/casesummary.html',
        //   title: 'Case-D Summary',
        //   controller: 'CaseSummaryreportPageCtrl',
        //   sidebarMeta: {
        //     order: 1,
        //   },
        //   authenticate: true
      }).state('main.report.collection', {
        url: '/collection',
        templateUrl: 'app/pages/reports/collection/collection.html',
        title: 'Collection Report',
        controller: 'CollectionreportPageCtrl',
        sidebarMeta: {
          order: 2,
        },
        authenticate: true
      }).state('main.report.closecasesummary', {
        url: '/closecasesummary',
        templateUrl: 'app/pages/reports/closecasesummary/closecasesummary.html',
        title: 'Close Case Summary',
        controller: 'CloseCaseSummaryreportPageCtrl',
        sidebarMeta: {
          order: 3,
        },
        authenticate: true
      }).state('main.report.cashinhand', {
        url: '/cashinhand',
        templateUrl: 'app/pages/reports/cashinhand/cashinhand.html',
        title: 'Cash in Hand',
        controller: 'CashinHandreportPageCtrl',
        sidebarMeta: {
          order: 4,
        },
        authenticate: true
      });
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.services', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system', [
    'BlurAdmin.pages.system.states',
    'BlurAdmin.pages.system.areas',
    'BlurAdmin.pages.system.gamecategory',
	'BlurAdmin.pages.system.games',
	'BlurAdmin.pages.system.zones',
	'BlurAdmin.pages.system.site'

  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.system', {
          url: '/system',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'System Setup',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
          authRoles:[1],
          authenticate: true
        }).state('main.system.states', {
          url: '/states',
          templateUrl: 'app/pages/system/states/states.html',
          title: 'States',
          controller: 'StatesPageCtrl',
          sidebarMeta: {
            order: 0,
          },
          authRoles:[1],
          authenticate: true
        }).state('main.system.zones', {
          url: '/zones',
          templateUrl: 'app/pages/system/zones/zones.html',
          title: 'Zones',
          controller: 'ZonesPageCtrl',
          sidebarMeta: {
            order: 1,
          },
          authenticate: true
        }).state('main.system.areas', {
          url: '/areas',
          templateUrl: 'app/pages/system/areas/areas.html',
          title: 'Areas',
          controller: 'AreasPageCtrl',
          sidebarMeta: {
            order: 2,
          },
          authenticate: true
        }).state('main.system.site', {
          url: '/site',
          templateUrl: 'app/pages/system/site/site.html',
          title: 'Balai',
          controller: 'SitePageCtrl',
          sidebarMeta: {
            order: 3,
          },
          authenticate: true
        }).state('main.system.gamecategory', {
          url: '/gamecategory',
          templateUrl: 'app/pages/system/gamecategory/gamecategory.html',
          title: 'Game Category',
          controller: 'GamecategoryPageCtrl',
          sidebarMeta: {
            order: 4,
          },
          authenticate: true
        }).state('main.system.games', {
          url: '/games',
          templateUrl: 'app/pages/system/games/games.html',
          title: 'Games',
          controller: 'GamesPageCtrl',
          sidebarMeta: {
            order: 5,
          },
          authenticate: true
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.tables', {
        url: '/tables',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        controller: 'TablesPageCtrl',
        title: 'Tables',
        sidebarMeta: {
          icon: 'ion-grid',
          order: 300,
        },
        authenticate: true
      }).state('main.tables.basic', {
        url: '/basic',
        templateUrl: 'app/pages/tables/basic/tables.html',
        title: 'Basic Tables',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.tables.smart', {
        url: '/smart',
        templateUrl: 'app/pages/tables/smart/tables.html',
        title: 'Smart Tables',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
    $urlRouterProvider.when('/main/tables', '/main/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
      'BlurAdmin.pages.ui.typography',
      'BlurAdmin.pages.ui.buttons',
      'BlurAdmin.pages.ui.icons',
      'BlurAdmin.pages.ui.modals',
      'BlurAdmin.pages.ui.grid',
      'BlurAdmin.pages.ui.alerts',
      'BlurAdmin.pages.ui.progressBars',
      'BlurAdmin.pages.ui.notifications',
      'BlurAdmin.pages.ui.tabs',
      'BlurAdmin.pages.ui.slider',
      'BlurAdmin.pages.ui.panels',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui', {
        url: '/ui',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'UI Features',
        sidebarMeta: {
          icon: 'ion-android-laptop',
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.roles', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () { 
  'use strict';

  angular.module('BlurAdmin.pages.account.users', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/account/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.assignagent.assignAgent', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
    .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.amCharts', {
        url: '/amCharts',
        templateUrl: 'app/pages/charts/amCharts/charts.html',
        title: 'amCharts',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs', [])
    .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartJs', {
        url: '/chartJs',
        templateUrl: 'app/pages/charts/chartJs/chartJs.html',
        title: 'Chart.js',
        sidebarMeta: {
          order: 200
        },
        authenticate: true
      });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      chartColors: [
        layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight
      ],
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 2500
      },
      scale: {
        gridLines: {
          color: layoutColors.border
        },
        scaleLabel: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          fontColor: layoutColors.defaultText,
          showLabelBackdrop: false
        }
      }
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
    // Configure all radar charts
    ChartJsProvider.setOptions('radar', {
      scale: {
        pointLabels: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          maxTicksLimit: 5,
          display: false
        }
      }
    });
    // Configure all bar charts
    ChartJsProvider.setOptions('bar', {
      tooltips: {
        enabled: false
      }
    });
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartist', {
        url: '/chartist',
        templateUrl: 'app/pages/charts/chartist/chartist.html',
        title: 'Chartist',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider) {
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.morris', {
        url: '/morris',
        templateUrl: 'app/pages/charts/morris/morris.html',
        title: 'Morris',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.components.mail', {
        url: '/mail',
        abstract: true,
        templateUrl: 'app/pages/components/mail/mail.html',
        controller: "MailTabCtrl",
        controllerAs: "tabCtrl",
        title: 'Mail',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.components.mail.label', {
        url: '/:label',
        templateUrl: 'app/pages/components/mail/list/mailList.html',
        title: 'Mail',
        controller: "MailListCtrl",
        controllerAs: "listCtrl",
        authenticate: true
      }).state('main.components.mail.detail', {
        url: '/:label/:id',
        templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
        title: 'Mail',
        controller: "MailDetailCtrl",
        controllerAs: "detailCtrl",
        authenticate: true
      });
    $urlRouterProvider.when('/main/components/mail', '/main/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function() {
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.tree', {
        url: '/tree',
        templateUrl: 'app/pages/components/tree/tree.html',
        title: 'Tree View',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
        title: 'Timeline',
        sidebarMeta: {
          icon: 'ion-ios-pulse',
          order: 100,
        },
        authenticate: true
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.clerkSetup.case', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'CasePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.clerkSetup.customer', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.customer.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.clerkSetup.payment', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.expense.category', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.flowtransaction.transaction', [])
      .config(routeConfig);
  
    /** @ngInject */ 
    function routeConfig($stateProvider, $urlRouterProvider) {
      // $stateProvider
      //     .state('states', {
      //       url: '/states',
      //       templateUrl: 'app/pages/system/states.html',
      //       abstract: true,
      //       controller: 'StatesPageCtrl',
      //       title: 'States',
      //       sidebarMeta: {
      //         icon: 'ion-grid',
      //         order: 300,
      //       },
      //     });
      // $urlRouterProvider.when('/states','/states');
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.case', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.customer', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.interval', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.onlinesales', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form.payment', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.case', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'CasePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.customer', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.operational.customer.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.casesummary', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.cashinhand', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.closecasesummary', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.collection', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory', [])
    .config(routeConfig);

  /** @ngInject */ 
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.system.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'MachinePageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //   .state('main.system.machine.edit', {
    //     url: '/editMachine',
    //     title: 'Edit Machine',
    //     templateUrl: './editMachine.html',
    //     controller: 'ShopPageCtrl',
    //     authenticate: true
    //   });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.site', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    // $stateProvider
    //     .state('states', {
    //       url: '/states',
    //       templateUrl: 'app/pages/system/states.html',
    //       abstract: true,
    //       controller: 'StatesPageCtrl',
    //       title: 'States',
    //       sidebarMeta: {
    //         icon: 'ion-grid',
    //         order: 300,
    //       },
    //     });
    // $urlRouterProvider.when('/states','/states');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.alerts', {
        url: '/alerts',
        templateUrl: 'app/pages/ui/alerts/alerts.html',
        title: 'Alerts',
        sidebarMeta: {
          order: 500,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.buttons', {
        url: '/buttons',
        templateUrl: 'app/pages/ui/buttons/buttons.html',
        controller: 'ButtonPageCtrl',
        title: 'Buttons',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.grid', {
        url: '/grid',
        templateUrl: 'app/pages/ui/grid/grid.html',
        title: 'Grid',
        sidebarMeta: {
          order: 400,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.icons', {
        url: '/icons',
        templateUrl: 'app/pages/ui/icons/icons.html',
        controller: 'IconsPageCtrl',
        title: 'Icons',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.modals', {
        url: '/modals',
        templateUrl: 'app/pages/ui/modals/modals.html',
        controller: 'ModalsPageCtrl',
        title: 'Modals',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.notifications', {
        url: '/notifications',
        templateUrl: 'app/pages/ui/notifications/notifications.html',
        controller: 'NotificationsPageCtrl',
        title: 'Notifications',
        sidebarMeta: {
          order: 700,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.panels', {
        url: '/panels',
        templateUrl: 'app/pages/ui/panels/panels.html',
        controller: 'NotificationsPageCtrl',
        title: 'Panels',
        sidebarMeta: {
          order: 1100,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.progressBars', {
        url: '/progressBars',
        templateUrl: 'app/pages/ui/progressBars/progressBars.html',
        title: 'Progress Bars',
        sidebarMeta: {
          order: 600,
        },
        authenticate: true
      });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.slider', {
        url: '/slider',
        templateUrl: 'app/pages/ui/slider/slider.html',
        title: 'Sliders',
        sidebarMeta: {
          order: 1000,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.tabs', {
        url: '/tabs',
        templateUrl: 'app/pages/ui/tabs/tabs.html',
        title: 'Tabs & Accordions',
        sidebarMeta: {
          order: 800,
        },
        authenticate: true
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.typography', {
        url: '/typography',
        templateUrl: 'app/pages/ui/typography/typography.html',
        title: 'Typography',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

})();

'use strict';

angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'ngResource',
    'lbServices',
    'BlurAdmin.theme',
    'BlurAdmin.pages',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.exporter',
    'angular.filter',
    'AngularPrint',
    'ja.qr',
    'chart.js'
  ])
  .run(function ($locale) {
    var currencyPatterns = $locale.NUMBER_FORMATS.PATTERNS[1];
    currencyPatterns.negPre = '(\u00a4';
    currencyPatterns.negSuf = ')';
  })
  .config(function (LoopBackResourceProvider) {

    // Use a custom auth header instead of the default 'Authorization'
    LoopBackResourceProvider.setAuthHeader('X-Access-Token');

    // Change the URL where to access the LoopBack REST API server
    LoopBackResourceProvider.setUrlBase('https://api.loansync.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://dev.api.loansync.tswlab.com/api');
    // LoopBackResourceProvider.setUrlBase('https://apiLoansync.au-syd.mybluemix.net/api');
    // LoopBackResourceProvider.setUrlBase('http://localhost:3000/api');
  });
// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Role
 * @header lbServices.Role
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Role` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Role",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Roles/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Role.principals.findById() instead.
            "prototype$__findById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.destroyById() instead.
            "prototype$__destroyById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.updateById() instead.
            "prototype$__updateById__principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Role.principals() instead.
            "prototype$__get__principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.create() instead.
            "prototype$__create__principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.destroyAll() instead.
            "prototype$__delete__principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.count() instead.
            "prototype$__count__principals": {
              url: urlBase + "/Roles/:id/principals/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#create
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Roles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#upsert
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Roles",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#replaceOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Roles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#upsertWithWhere
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Roles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#exists
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Roles/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#findById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Roles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#replaceById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Roles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#find
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Roles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#findOne
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Roles/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#updateAll
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Roles/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#deleteById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Roles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#count
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Roles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#prototype$updateAttributes
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Roles/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#createChangeStream
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Roles/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Role#createMany
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.findById() instead.
            "::findById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roles.destroyById() instead.
            "::destroyById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.updateById() instead.
            "::updateById::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.link() instead.
            "::link::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.unlink() instead.
            "::unlink::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.exists() instead.
            "::exists::User::roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.roles() instead.
            "::get::User::roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use User.roles.create() instead.
            "::create::User::roles": {
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.createMany() instead.
            "::createMany::User::roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.destroyAll() instead.
            "::delete::User::roles": {
              url: urlBase + "/users/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.count() instead.
            "::count::User::roles": {
              url: urlBase + "/users/:id/roles/count",
              method: "GET",
            },

            // INTERNAL. Use Rolemapping.role() instead.
            "::get::Rolemapping::role": {
              url: urlBase + "/Rolemappings/:id/role",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Role#patchOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Role#updateOrCreate
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Role#patchOrCreateWithWhere
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Role#update
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Role#destroyById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Role#removeById
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Role#prototype$patchAttributes
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Role#modelName
        * @propertyOf lbServices.Role
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Role`.
        */
        R.modelName = "Role";

    /**
     * @ngdoc object
     * @name lbServices.Role.principals
     * @header lbServices.Role.principals
     * @object
     * @description
     *
     * The object `Role.principals` groups methods
     * manipulating `RoleMapping` instances related to `Role`.
     *
     * Call {@link lbServices.Role#principals Role.principals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Role#principals
             * @methodOf lbServices.Role
             *
             * @description
             *
             * Queries principals of Role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::get::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#count
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Counts principals of Role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.principals.count = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::count::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#create
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Creates a new instance in principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.create = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::create::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#createMany
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Creates a new instance in principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.createMany = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::createMany::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#destroyAll
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Deletes all principals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.principals.destroyAll = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::delete::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#destroyById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Delete a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.principals.destroyById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::destroyById::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#findById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Find a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.findById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::findById::Role::principals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Role.principals#updateById
             * @methodOf lbServices.Role.principals
             *
             * @description
             *
             * Update a related item by id for principals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Role id
             *
             *  - `fk` – `{*}` - Foreign key for principals
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.principals.updateById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::updateById::Role::principals"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ACL
 * @header lbServices.ACL
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ACL` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ACL",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ACLs/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ACL#create
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ACLs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#upsert
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/ACLs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#replaceOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ACLs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#upsertWithWhere
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ACLs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#exists
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ACLs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#findById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ACLs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#replaceById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ACLs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#find
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ACLs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#findOne
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ACLs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#updateAll
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ACLs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#deleteById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ACLs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#count
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ACLs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#prototype$updateAttributes
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ACL id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/ACLs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#createChangeStream
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ACLs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ACL#createMany
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ACLs",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ACL#patchOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#updateOrCreate
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#patchOrCreateWithWhere
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#update
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#destroyById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#removeById
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ACL#prototype$patchAttributes
             * @methodOf lbServices.ACL
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ACL id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ACL` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ACL#modelName
        * @propertyOf lbServices.ACL
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ACL`.
        */
        R.modelName = "ACL";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.User
 * @header lbServices.User
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `User` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "User",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/users/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use User.accessTokens.findById() instead.
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.destroyById() instead.
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.updateById() instead.
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rolemap.findById() instead.
            "prototype$__findById__rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.destroyById() instead.
            "prototype$__destroyById__rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.updateById() instead.
            "prototype$__updateById__rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.findById() instead.
            "prototype$__findById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roles.destroyById() instead.
            "prototype$__destroyById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.updateById() instead.
            "prototype$__updateById__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.link() instead.
            "prototype$__link__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roles.unlink() instead.
            "prototype$__unlink__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.exists() instead.
            "prototype$__exists__roles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.create() instead.
            "prototype$__create__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.destroyAll() instead.
            "prototype$__delete__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.count() instead.
            "prototype$__count__accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap() instead.
            "prototype$__get__rolemap": {
              isArray: true,
              url: urlBase + "/users/:id/rolemap",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.create() instead.
            "prototype$__create__rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "POST",
            },

            // INTERNAL. Use User.rolemap.destroyAll() instead.
            "prototype$__delete__rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.count() instead.
            "prototype$__count__rolemap": {
              url: urlBase + "/users/:id/rolemap/count",
              method: "GET",
            },

            // INTERNAL. Use User.roles() instead.
            "prototype$__get__roles": {
              isArray: true,
              url: urlBase + "/users/:id/roles",
              method: "GET",
            },

            // INTERNAL. Use User.roles.create() instead.
            "prototype$__create__roles": {
              url: urlBase + "/users/:id/roles",
              method: "POST",
            },

            // INTERNAL. Use User.roles.destroyAll() instead.
            "prototype$__delete__roles": {
              url: urlBase + "/users/:id/roles",
              method: "DELETE",
            },

            // INTERNAL. Use User.roles.count() instead.
            "prototype$__count__roles": {
              url: urlBase + "/users/:id/roles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#create
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsert
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/users",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsertWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#exists
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#find
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findOne
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#updateAll
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#deleteById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#count
             * @methodOf lbServices.User
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updateAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/users/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createChangeStream
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#login
             * @methodOf lbServices.User
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#logout
             * @methodOf lbServices.User
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#confirm
             * @methodOf lbServices.User
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/users/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#resetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/users/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createMany
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            // INTERNAL. Use Payment.payagent() instead.
            "::get::Payment::payagent": {
              url: urlBase + "/Payments/:id/payagent",
              method: "GET",
            },

            // INTERNAL. Use Case.agent() instead.
            "::get::Case::agent": {
              url: urlBase + "/Cases/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Case.manager() instead.
            "::get::Case::manager": {
              url: urlBase + "/Cases/:id/manager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreateWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.User#update
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.User#destroyById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#removeById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$patchAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.User#getCachedCurrent
         * @methodOf lbServices.User
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.User#login} or
         * {@link lbServices.User#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A User instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#isAuthenticated
         * @methodOf lbServices.User
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#getCurrentId
         * @methodOf lbServices.User
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.User#modelName
        * @propertyOf lbServices.User
        * @description
        * The name of the model represented by this $resource,
        * i.e. `User`.
        */
        R.modelName = "User";

    /**
     * @ngdoc object
     * @name lbServices.User.accessTokens
     * @header lbServices.User.accessTokens
     * @object
     * @description
     *
     * The object `User.accessTokens` groups methods
     * manipulating `AccessToken` instances related to `User`.
     *
     * Call {@link lbServices.User#accessTokens User.accessTokens()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::get::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#count
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Counts accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.accessTokens.count = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::count::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#create
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.create = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::create::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#createMany
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.createMany = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::createMany::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#destroyAll
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accessTokens.destroyAll = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::delete::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#destroyById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accessTokens.destroyById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::destroyById::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#findById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.findById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::findById::User::accessTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.accessTokens#updateById
             * @methodOf lbServices.User.accessTokens
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens.updateById = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::updateById::User::accessTokens"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.rolemap
     * @header lbServices.User.rolemap
     * @object
     * @description
     *
     * The object `User.rolemap` groups methods
     * manipulating `RoleMapping` instances related to `User`.
     *
     * Call {@link lbServices.User#rolemap User.rolemap()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#rolemap
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries rolemap of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.rolemap = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::get::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#count
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Counts rolemap of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.rolemap.count = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::count::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#create
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Creates a new instance in rolemap of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.rolemap.create = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::create::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#createMany
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Creates a new instance in rolemap of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.rolemap.createMany = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::createMany::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#destroyAll
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Deletes all rolemap of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.rolemap.destroyAll = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::delete::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#destroyById
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Delete a related item by id for rolemap.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rolemap
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.rolemap.destroyById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::destroyById::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#findById
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Find a related item by id for rolemap.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rolemap
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.rolemap.findById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::findById::User::rolemap"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rolemap#updateById
             * @methodOf lbServices.User.rolemap
             *
             * @description
             *
             * Update a related item by id for rolemap.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rolemap
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoleMapping` object.)
             * </em>
             */
        R.rolemap.updateById = function() {
          var TargetResource = $injector.get("RoleMapping");
          var action = TargetResource["::updateById::User::rolemap"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.roles
     * @header lbServices.User.roles
     * @object
     * @description
     *
     * The object `User.roles` groups methods
     * manipulating `Role` instances related to `User`.
     *
     * Call {@link lbServices.User#roles User.roles()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#roles
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries roles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#count
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Counts roles of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.roles.count = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::count::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#create
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.create = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::create::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#createMany
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Creates a new instance in roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.createMany = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::createMany::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#destroyAll
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Deletes all roles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyAll = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::delete::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#destroyById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Delete a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.destroyById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::destroyById::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#exists
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Check the existence of roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.exists = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::exists::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#findById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Find a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.findById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::findById::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#link
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Add a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.link = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::link::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#unlink
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Remove the roles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roles.unlink = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::unlink::User::roles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roles#updateById
             * @methodOf lbServices.User.roles
             *
             * @description
             *
             * Update a related item by id for roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roles
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.roles.updateById = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::updateById::User::roles"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Accounts
 * @header lbServices.Accounts
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Accounts` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Accounts",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Accounts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Accounts#create
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Accounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#upsert
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Accounts",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#replaceOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Accounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#upsertWithWhere
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Accounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#exists
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Accounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#findById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Accounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#replaceById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Accounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#find
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#findOne
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Accounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#updateAll
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Accounts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#deleteById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Accounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#count
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Accounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#prototype$updateAttributes
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accounts id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Accounts/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#createChangeStream
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Accounts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accounts#createMany
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Accounts#patchOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#updateOrCreate
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#patchOrCreateWithWhere
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#update
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#destroyById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#removeById
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accounts#prototype$patchAttributes
             * @methodOf lbServices.Accounts
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accounts id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accounts` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Accounts#modelName
        * @propertyOf lbServices.Accounts
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Accounts`.
        */
        R.modelName = "Accounts";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Area
 * @header lbServices.Area
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Area` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Area",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Areas/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Area#create
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Areas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#upsert
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Areas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#replaceOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Areas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#upsertWithWhere
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Areas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#exists
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Areas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#findById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Areas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#replaceById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Areas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#find
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Areas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#findOne
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Areas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#updateAll
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Areas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#deleteById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Areas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#count
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Areas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#prototype$updateAttributes
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Areas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#createChangeStream
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Areas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Area#createMany
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Areas",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Area#patchOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Area#updateOrCreate
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Area#patchOrCreateWithWhere
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Area#update
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Area#destroyById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Area#removeById
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Area#prototype$patchAttributes
             * @methodOf lbServices.Area
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Area id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Area` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Area#modelName
        * @propertyOf lbServices.Area
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Area`.
        */
        R.modelName = "Area";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Rolemapping
 * @header lbServices.Rolemapping
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Rolemapping` model.
 *
 * **Details**
 *
 * Map principals to roles
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Rolemapping",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Rolemappings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Rolemapping.role() instead.
            "prototype$__get__role": {
              url: urlBase + "/Rolemappings/:id/role",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#create
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Rolemappings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#upsert
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Rolemappings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#replaceOrCreate
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Rolemappings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#upsertWithWhere
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Rolemappings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#exists
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Rolemappings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#findById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Rolemappings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#replaceById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Rolemappings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#find
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Rolemappings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#findOne
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Rolemappings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#updateAll
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Rolemappings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#deleteById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Rolemappings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#count
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Rolemappings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#prototype$updateAttributes
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Rolemapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Rolemappings/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#createChangeStream
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Rolemappings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#createMany
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Rolemappings",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.findById() instead.
            "::findById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.destroyById() instead.
            "::destroyById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.updateById() instead.
            "::updateById::Role::principals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Roles/:id/principals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Role.principals() instead.
            "::get::Role::principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "GET",
            },

            // INTERNAL. Use Role.principals.create() instead.
            "::create::Role::principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.createMany() instead.
            "::createMany::Role::principals": {
              isArray: true,
              url: urlBase + "/Roles/:id/principals",
              method: "POST",
            },

            // INTERNAL. Use Role.principals.destroyAll() instead.
            "::delete::Role::principals": {
              url: urlBase + "/Roles/:id/principals",
              method: "DELETE",
            },

            // INTERNAL. Use Role.principals.count() instead.
            "::count::Role::principals": {
              url: urlBase + "/Roles/:id/principals/count",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.findById() instead.
            "::findById::User::rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.destroyById() instead.
            "::destroyById::User::rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.updateById() instead.
            "::updateById::User::rolemap": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rolemap/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rolemap() instead.
            "::get::User::rolemap": {
              isArray: true,
              url: urlBase + "/users/:id/rolemap",
              method: "GET",
            },

            // INTERNAL. Use User.rolemap.create() instead.
            "::create::User::rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "POST",
            },

            // INTERNAL. Use User.rolemap.createMany() instead.
            "::createMany::User::rolemap": {
              isArray: true,
              url: urlBase + "/users/:id/rolemap",
              method: "POST",
            },

            // INTERNAL. Use User.rolemap.destroyAll() instead.
            "::delete::User::rolemap": {
              url: urlBase + "/users/:id/rolemap",
              method: "DELETE",
            },

            // INTERNAL. Use User.rolemap.count() instead.
            "::count::User::rolemap": {
              url: urlBase + "/users/:id/rolemap/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#patchOrCreate
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#updateOrCreate
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#patchOrCreateWithWhere
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#update
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#destroyById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#removeById
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#prototype$patchAttributes
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Rolemapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Rolemapping` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Rolemapping#modelName
        * @propertyOf lbServices.Rolemapping
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Rolemapping`.
        */
        R.modelName = "Rolemapping";


            /**
             * @ngdoc method
             * @name lbServices.Rolemapping#role
             * @methodOf lbServices.Rolemapping
             *
             * @description
             *
             * Fetches belongsTo relation role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Rolemapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Role` object.)
             * </em>
             */
        R.role = function() {
          var TargetResource = $injector.get("Role");
          var action = TargetResource["::get::Rolemapping::role"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Category
 * @header lbServices.Category
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Category` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Category",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Categories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Category.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/Categories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.findById() instead.
            "prototype$__findById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.destroyById() instead.
            "prototype$__destroyById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.updateById() instead.
            "prototype$__updateById__subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.main() instead.
            "prototype$__get__main": {
              url: urlBase + "/Categories/:id/main",
              method: "GET",
            },

            // INTERNAL. Use Category.subs() instead.
            "prototype$__get__subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.create() instead.
            "prototype$__create__subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.destroyAll() instead.
            "prototype$__delete__subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.count() instead.
            "prototype$__count__subs": {
              url: urlBase + "/Categories/:id/subs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#create
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Categories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#upsert
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Categories",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Categories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#upsertWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Categories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#exists
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Categories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Categories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#replaceById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Categories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#find
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Categories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findOne
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Categories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#updateAll
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Categories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#deleteById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Categories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#count
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Categories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$updateAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Categories/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createChangeStream
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Categories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createMany
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Categories",
              method: "POST",
            },

            // INTERNAL. Use Category.parent() instead.
            "::get::Category::parent": {
              url: urlBase + "/Categories/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.findById() instead.
            "::findById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.destroyById() instead.
            "::destroyById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.updateById() instead.
            "::updateById::Category::subs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Categories/:id/subs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.subs() instead.
            "::get::Category::subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "GET",
            },

            // INTERNAL. Use Category.subs.create() instead.
            "::create::Category::subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.createMany() instead.
            "::createMany::Category::subs": {
              isArray: true,
              url: urlBase + "/Categories/:id/subs",
              method: "POST",
            },

            // INTERNAL. Use Category.subs.destroyAll() instead.
            "::delete::Category::subs": {
              url: urlBase + "/Categories/:id/subs",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subs.count() instead.
            "::count::Category::subs": {
              url: urlBase + "/Categories/:id/subs/count",
              method: "GET",
            },

            // INTERNAL. Use Usertransaction.category() instead.
            "::get::Usertransaction::category": {
              url: urlBase + "/Usertransactions/:id/category",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Category#updateOrCreate
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Category#patchOrCreateWithWhere
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Category#update
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Category#destroyById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#removeById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$patchAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Category#modelName
        * @propertyOf lbServices.Category
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Category`.
        */
        R.modelName = "Category";


            /**
             * @ngdoc method
             * @name lbServices.Category#parent
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::parent"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Category.subs
     * @header lbServices.Category.subs
     * @object
     * @description
     *
     * The object `Category.subs` groups methods
     * manipulating `Category` instances related to `Category`.
     *
     * Call {@link lbServices.Category#subs Category.subs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Category#subs
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Queries subs of Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#count
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Counts subs of Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subs.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#create
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#createMany
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Creates a new instance in subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#destroyAll
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Deletes all subs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#destroyById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Delete a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subs.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#findById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Find a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subs#updateById
             * @methodOf lbServices.Category.subs
             *
             * @description
             *
             * Update a related item by id for subs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Foreign key for subs
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subs.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Category::subs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category#main
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Fetches belongsTo relation main.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R.main = function() {
          var TargetResource = $injector.get("Maincategory");
          var action = TargetResource["::get::Category::main"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Zones
 * @header lbServices.Zones
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Zones` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Zones",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Zones/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Zones#create
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Zones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#upsert
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Zones",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#replaceOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Zones/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#upsertWithWhere
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Zones/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#exists
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Zones/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#findById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Zones/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#replaceById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Zones/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#find
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Zones",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#findOne
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Zones/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#updateAll
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Zones/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#deleteById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Zones/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#count
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Zones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#prototype$updateAttributes
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Zones/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#createChangeStream
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Zones/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Zones#createMany
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Zones",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Zones#patchOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#updateOrCreate
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#patchOrCreateWithWhere
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#update
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#destroyById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#removeById
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Zones#prototype$patchAttributes
             * @methodOf lbServices.Zones
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Zones id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Zones` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Zones#modelName
        * @propertyOf lbServices.Zones
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Zones`.
        */
        R.modelName = "Zones";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Collector
 * @header lbServices.Collector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Collector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Collector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Collectors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Collector#create
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Collectors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#upsert
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Collectors",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#replaceOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Collectors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#upsertWithWhere
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Collectors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#exists
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Collectors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#findById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Collectors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#replaceById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Collectors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#find
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Collectors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#findOne
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Collectors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#updateAll
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Collectors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#deleteById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Collectors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#count
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Collectors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#prototype$updateAttributes
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Collectors/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#createChangeStream
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Collectors/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collector#createMany
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Collectors",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Collector#patchOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#updateOrCreate
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#patchOrCreateWithWhere
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#update
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#destroyById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#removeById
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collector#prototype$patchAttributes
             * @methodOf lbServices.Collector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collector id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collector` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Collector#modelName
        * @propertyOf lbServices.Collector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Collector`.
        */
        R.modelName = "Collector";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Collectormap
 * @header lbServices.Collectormap
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Collectormap` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Collectormap",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Collectormaps/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#create
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Collectormaps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#upsert
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Collectormaps",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#replaceOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Collectormaps/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#upsertWithWhere
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Collectormaps/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#exists
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Collectormaps/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#findById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Collectormaps/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#replaceById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Collectormaps/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#find
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Collectormaps",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#findOne
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Collectormaps/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#updateAll
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Collectormaps/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#deleteById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Collectormaps/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#count
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Collectormaps/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#prototype$updateAttributes
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Collectormaps/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#createChangeStream
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Collectormaps/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#createMany
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Collectormaps",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Collectormap#patchOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#updateOrCreate
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#patchOrCreateWithWhere
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#update
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#destroyById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#removeById
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Collectormap#prototype$patchAttributes
             * @methodOf lbServices.Collectormap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Collectormap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Collectormap` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Collectormap#modelName
        * @propertyOf lbServices.Collectormap
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Collectormap`.
        */
        R.modelName = "Collectormap";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Accesstoken
 * @header lbServices.Accesstoken
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Accesstoken` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Accesstoken",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Accesstokens/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#create
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Accesstokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#upsert
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Accesstokens",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#replaceOrCreate
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Accesstokens/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#upsertWithWhere
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Accesstokens/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#exists
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Accesstokens/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#findById
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Accesstokens/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#replaceById
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Accesstokens/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#find
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Accesstokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#findOne
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Accesstokens/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#updateAll
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Accesstokens/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#deleteById
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Accesstokens/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#count
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Accesstokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#prototype$updateAttributes
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accesstoken id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Accesstokens/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#createChangeStream
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Accesstokens/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#createMany
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Accesstokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.findById() instead.
            "::findById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.destroyById() instead.
            "::destroyById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.updateById() instead.
            "::updateById::User::accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "::get::User::accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            // INTERNAL. Use User.accessTokens.create() instead.
            "::create::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.createMany() instead.
            "::createMany::User::accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens.destroyAll() instead.
            "::delete::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            // INTERNAL. Use User.accessTokens.count() instead.
            "::count::User::accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#patchOrCreate
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#updateOrCreate
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#patchOrCreateWithWhere
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#update
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#destroyById
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#removeById
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Accesstoken#prototype$patchAttributes
             * @methodOf lbServices.Accesstoken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Accesstoken id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Accesstoken` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Accesstoken#modelName
        * @propertyOf lbServices.Accesstoken
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Accesstoken`.
        */
        R.modelName = "Accesstoken";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Customerdetails
 * @header lbServices.Customerdetails
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Customerdetails` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Customerdetails",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Customerdetails/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#create
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Customerdetails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#upsert
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Customerdetails",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#replaceOrCreate
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Customerdetails/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#upsertWithWhere
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Customerdetails/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#exists
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Customerdetails/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#findById
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Customerdetails/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#replaceById
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Customerdetails/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#find
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Customerdetails",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#findOne
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Customerdetails/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#updateAll
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Customerdetails/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#deleteById
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Customerdetails/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#count
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Customerdetails/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#prototype$updateAttributes
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customerdetails id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Customerdetails/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#createChangeStream
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Customerdetails/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#createMany
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Customerdetails",
              method: "POST",
            },

            // INTERNAL. Use Customer.details.findById() instead.
            "::findById::Customer::details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/details/:fk",
              method: "GET",
            },

            // INTERNAL. Use Customer.details.destroyById() instead.
            "::destroyById::Customer::details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/details/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.details.updateById() instead.
            "::updateById::Customer::details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/details/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Customer.details() instead.
            "::get::Customer::details": {
              isArray: true,
              url: urlBase + "/Customers/:id/details",
              method: "GET",
            },

            // INTERNAL. Use Customer.details.create() instead.
            "::create::Customer::details": {
              url: urlBase + "/Customers/:id/details",
              method: "POST",
            },

            // INTERNAL. Use Customer.details.createMany() instead.
            "::createMany::Customer::details": {
              isArray: true,
              url: urlBase + "/Customers/:id/details",
              method: "POST",
            },

            // INTERNAL. Use Customer.details.destroyAll() instead.
            "::delete::Customer::details": {
              url: urlBase + "/Customers/:id/details",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.details.count() instead.
            "::count::Customer::details": {
              url: urlBase + "/Customers/:id/details/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#patchOrCreate
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#updateOrCreate
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#patchOrCreateWithWhere
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#update
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#destroyById
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#removeById
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Customerdetails#prototype$patchAttributes
             * @methodOf lbServices.Customerdetails
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customerdetails id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Customerdetails#modelName
        * @propertyOf lbServices.Customerdetails
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Customerdetails`.
        */
        R.modelName = "Customerdetails";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Acl
 * @header lbServices.Acl
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Acl` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Acl",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Acls/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Acl#create
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Acls",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#upsert
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Acls",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#replaceOrCreate
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Acls/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#upsertWithWhere
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Acls/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#exists
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Acls/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#findById
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Acls/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#replaceById
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Acls/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#find
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Acls",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#findOne
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Acls/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#updateAll
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Acls/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#deleteById
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Acls/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#count
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Acls/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#prototype$updateAttributes
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Acl id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Acls/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#createChangeStream
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Acls/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Acl#createMany
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Acls",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Acl#patchOrCreate
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Acl#updateOrCreate
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Acl#patchOrCreateWithWhere
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Acl#update
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Acl#destroyById
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Acl#removeById
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Acl#prototype$patchAttributes
             * @methodOf lbServices.Acl
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Acl id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Acl` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Acl#modelName
        * @propertyOf lbServices.Acl
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Acl`.
        */
        R.modelName = "Acl";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Customer
 * @header lbServices.Customer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Customer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Customer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Customers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Customer.details.findById() instead.
            "prototype$__findById__details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/details/:fk",
              method: "GET",
            },

            // INTERNAL. Use Customer.details.destroyById() instead.
            "prototype$__destroyById__details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/details/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.details.updateById() instead.
            "prototype$__updateById__details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/details/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Customer.details() instead.
            "prototype$__get__details": {
              isArray: true,
              url: urlBase + "/Customers/:id/details",
              method: "GET",
            },

            // INTERNAL. Use Customer.details.create() instead.
            "prototype$__create__details": {
              url: urlBase + "/Customers/:id/details",
              method: "POST",
            },

            // INTERNAL. Use Customer.details.destroyAll() instead.
            "prototype$__delete__details": {
              url: urlBase + "/Customers/:id/details",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.details.count() instead.
            "prototype$__count__details": {
              url: urlBase + "/Customers/:id/details/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#create
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Customers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#upsert
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Customers",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#replaceOrCreate
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Customers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#upsertWithWhere
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Customers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#exists
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Customers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#findById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Customers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#replaceById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Customers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#find
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Customers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#findOne
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Customers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#updateAll
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Customers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#deleteById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Customers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#count
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Customers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#prototype$updateAttributes
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Customers/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#createChangeStream
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Customers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#createMany
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Customers",
              method: "POST",
            },

            // INTERNAL. Use Case.customer() instead.
            "::get::Case::customer": {
              url: urlBase + "/Cases/:id/customer",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Customer#patchOrCreate
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#updateOrCreate
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#patchOrCreateWithWhere
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#update
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#destroyById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#removeById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#prototype$patchAttributes
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Customer#modelName
        * @propertyOf lbServices.Customer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Customer`.
        */
        R.modelName = "Customer";

    /**
     * @ngdoc object
     * @name lbServices.Customer.details
     * @header lbServices.Customer.details
     * @object
     * @description
     *
     * The object `Customer.details` groups methods
     * manipulating `Customerdetails` instances related to `Customer`.
     *
     * Call {@link lbServices.Customer#details Customer.details()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Customer#details
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Queries details of Customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R.details = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::get::Customer::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.details#count
             * @methodOf lbServices.Customer.details
             *
             * @description
             *
             * Counts details of Customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.details.count = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::count::Customer::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.details#create
             * @methodOf lbServices.Customer.details
             *
             * @description
             *
             * Creates a new instance in details of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R.details.create = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::create::Customer::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.details#createMany
             * @methodOf lbServices.Customer.details
             *
             * @description
             *
             * Creates a new instance in details of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R.details.createMany = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::createMany::Customer::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.details#destroyAll
             * @methodOf lbServices.Customer.details
             *
             * @description
             *
             * Deletes all details of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.details.destroyAll = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::delete::Customer::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.details#destroyById
             * @methodOf lbServices.Customer.details
             *
             * @description
             *
             * Delete a related item by id for details.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `fk` – `{*}` - Foreign key for details
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.details.destroyById = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::destroyById::Customer::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.details#findById
             * @methodOf lbServices.Customer.details
             *
             * @description
             *
             * Find a related item by id for details.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `fk` – `{*}` - Foreign key for details
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R.details.findById = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::findById::Customer::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.details#updateById
             * @methodOf lbServices.Customer.details
             *
             * @description
             *
             * Update a related item by id for details.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `fk` – `{*}` - Foreign key for details
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customerdetails` object.)
             * </em>
             */
        R.details.updateById = function() {
          var TargetResource = $injector.get("Customerdetails");
          var action = TargetResource["::updateById::Customer::details"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.State
 * @header lbServices.State
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `State` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "State",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/States/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.State#create
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/States",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#upsert
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/States",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#replaceOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/States/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#upsertWithWhere
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/States/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#exists
             * @methodOf lbServices.State
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/States/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#findById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/States/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#replaceById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/States/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#find
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/States",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#findOne
             * @methodOf lbServices.State
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/States/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#updateAll
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/States/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#deleteById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/States/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#count
             * @methodOf lbServices.State
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/States/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#prototype$updateAttributes
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/States/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#createChangeStream
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/States/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#tokenByRole
             * @methodOf lbServices.State
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `roleId` – `{integer=}` -
             *
             *  - `realm` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "tokenByRole": {
              url: urlBase + "/States/tokenByRole",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.State#createMany
             * @methodOf lbServices.State
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/States",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.State#patchOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.State#updateOrCreate
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.State#patchOrCreateWithWhere
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.State#update
             * @methodOf lbServices.State
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.State#destroyById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.State#removeById
             * @methodOf lbServices.State
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.State#prototype$patchAttributes
             * @methodOf lbServices.State
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - State id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `State` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.State#modelName
        * @propertyOf lbServices.State
        * @description
        * The name of the model represented by this $resource,
        * i.e. `State`.
        */
        R.modelName = "State";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Payment
 * @header lbServices.Payment
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Payment` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Payment",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Payments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Payment.payagent() instead.
            "prototype$__get__payagent": {
              url: urlBase + "/Payments/:id/payagent",
              method: "GET",
            },

            // INTERNAL. Use Payment.case() instead.
            "prototype$__get__case": {
              url: urlBase + "/Payments/:id/case",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#create
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Payments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#upsert
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Payments",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#replaceOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Payments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#upsertWithWhere
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Payments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#exists
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Payments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#findById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Payments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#replaceById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Payments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#find
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Payments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#findOne
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Payments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#updateAll
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Payments/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#deleteById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Payments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#count
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Payments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$updateAttributes
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Payments/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#createChangeStream
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Payments/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#createMany
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Payments",
              method: "POST",
            },

            // INTERNAL. Use Case.payment.findById() instead.
            "::findById::Case::payment": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/payment/:fk",
              method: "GET",
            },

            // INTERNAL. Use Case.payment.destroyById() instead.
            "::destroyById::Case::payment": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/payment/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Case.payment.updateById() instead.
            "::updateById::Case::payment": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/payment/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Case.payment() instead.
            "::get::Case::payment": {
              isArray: true,
              url: urlBase + "/Cases/:id/payment",
              method: "GET",
            },

            // INTERNAL. Use Case.payment.create() instead.
            "::create::Case::payment": {
              url: urlBase + "/Cases/:id/payment",
              method: "POST",
            },

            // INTERNAL. Use Case.payment.createMany() instead.
            "::createMany::Case::payment": {
              isArray: true,
              url: urlBase + "/Cases/:id/payment",
              method: "POST",
            },

            // INTERNAL. Use Case.payment.destroyAll() instead.
            "::delete::Case::payment": {
              url: urlBase + "/Cases/:id/payment",
              method: "DELETE",
            },

            // INTERNAL. Use Case.payment.count() instead.
            "::count::Case::payment": {
              url: urlBase + "/Cases/:id/payment/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Payment#patchOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#updateOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#patchOrCreateWithWhere
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#update
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#destroyById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#removeById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$patchAttributes
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Payment#modelName
        * @propertyOf lbServices.Payment
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Payment`.
        */
        R.modelName = "Payment";


            /**
             * @ngdoc method
             * @name lbServices.Payment#payagent
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation payagent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.payagent = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Payment::payagent"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#case
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation case.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
        R.case = function() {
          var TargetResource = $injector.get("Case");
          var action = TargetResource["::get::Payment::case"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Case
 * @header lbServices.Case
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Case` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Case",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Cases/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Case.customer() instead.
            "prototype$__get__customer": {
              url: urlBase + "/Cases/:id/customer",
              method: "GET",
            },

            // INTERNAL. Use Case.agent() instead.
            "prototype$__get__agent": {
              url: urlBase + "/Cases/:id/agent",
              method: "GET",
            },

            // INTERNAL. Use Case.manager() instead.
            "prototype$__get__manager": {
              url: urlBase + "/Cases/:id/manager",
              method: "GET",
            },

            // INTERNAL. Use Case.payment.findById() instead.
            "prototype$__findById__payment": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/payment/:fk",
              method: "GET",
            },

            // INTERNAL. Use Case.payment.destroyById() instead.
            "prototype$__destroyById__payment": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/payment/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Case.payment.updateById() instead.
            "prototype$__updateById__payment": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/payment/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Case.terms.findById() instead.
            "prototype$__findById__terms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/terms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Case.terms.destroyById() instead.
            "prototype$__destroyById__terms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/terms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Case.terms.updateById() instead.
            "prototype$__updateById__terms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/terms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Case.details.findById() instead.
            "prototype$__findById__details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/details/:fk",
              method: "GET",
            },

            // INTERNAL. Use Case.details.destroyById() instead.
            "prototype$__destroyById__details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/details/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Case.details.updateById() instead.
            "prototype$__updateById__details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/details/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Case.payment() instead.
            "prototype$__get__payment": {
              isArray: true,
              url: urlBase + "/Cases/:id/payment",
              method: "GET",
            },

            // INTERNAL. Use Case.payment.create() instead.
            "prototype$__create__payment": {
              url: urlBase + "/Cases/:id/payment",
              method: "POST",
            },

            // INTERNAL. Use Case.payment.destroyAll() instead.
            "prototype$__delete__payment": {
              url: urlBase + "/Cases/:id/payment",
              method: "DELETE",
            },

            // INTERNAL. Use Case.payment.count() instead.
            "prototype$__count__payment": {
              url: urlBase + "/Cases/:id/payment/count",
              method: "GET",
            },

            // INTERNAL. Use Case.terms() instead.
            "prototype$__get__terms": {
              isArray: true,
              url: urlBase + "/Cases/:id/terms",
              method: "GET",
            },

            // INTERNAL. Use Case.terms.create() instead.
            "prototype$__create__terms": {
              url: urlBase + "/Cases/:id/terms",
              method: "POST",
            },

            // INTERNAL. Use Case.terms.destroyAll() instead.
            "prototype$__delete__terms": {
              url: urlBase + "/Cases/:id/terms",
              method: "DELETE",
            },

            // INTERNAL. Use Case.terms.count() instead.
            "prototype$__count__terms": {
              url: urlBase + "/Cases/:id/terms/count",
              method: "GET",
            },

            // INTERNAL. Use Case.details() instead.
            "prototype$__get__details": {
              isArray: true,
              url: urlBase + "/Cases/:id/details",
              method: "GET",
            },

            // INTERNAL. Use Case.details.create() instead.
            "prototype$__create__details": {
              url: urlBase + "/Cases/:id/details",
              method: "POST",
            },

            // INTERNAL. Use Case.details.destroyAll() instead.
            "prototype$__delete__details": {
              url: urlBase + "/Cases/:id/details",
              method: "DELETE",
            },

            // INTERNAL. Use Case.details.count() instead.
            "prototype$__count__details": {
              url: urlBase + "/Cases/:id/details/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#create
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Cases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#upsert
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Cases",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#replaceOrCreate
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Cases/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#upsertWithWhere
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Cases/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#exists
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Cases/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#findById
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Cases/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#replaceById
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Cases/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#find
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Cases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#findOne
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Cases/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#updateAll
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Cases/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#deleteById
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Cases/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#count
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Cases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#prototype$updateAttributes
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Cases/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#createChangeStream
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Cases/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getSummaryL1
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `from_rel_date` – `{string=}` -
             *
             *  - `to_rel_date` – `{string=}` -
             *
             *  - `from_close_date` – `{string=}` -
             *
             *  - `to_close_date` – `{string=}` -
             *
             *  - `type` – `{string=}` -
             *
             *  - `status` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getSummaryL1": {
              url: urlBase + "/Cases/getSummaryL1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getCloseSummaryL1
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `type` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getCloseSummaryL1": {
              url: urlBase + "/Cases/getCloseSummaryL1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getDashboardV1
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDashboardV1": {
              url: urlBase + "/Cases/getDashboardV1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getDashboardV2
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDashboardV2": {
              url: urlBase + "/Cases/getDashboardV2",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getDepositSummary
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getDepositSummary": {
              url: urlBase + "/Cases/getDepositSummary",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getCashinHandL1
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             *  - `bdate` – `{string=}` -
             *
             *  - `categoryid` – `{string=}` -
             *
             *  - `parentid` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getCashinHandL1": {
              url: urlBase + "/Cases/getCashinHandL1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getScheduleV1
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getScheduleV1": {
              url: urlBase + "/Cases/getScheduleV1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#getScheduleCollector
             * @methodOf lbServices.Case
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `adate` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "getScheduleCollector": {
              url: urlBase + "/Cases/getScheduleCollector",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Case#createMany
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Cases",
              method: "POST",
            },

            // INTERNAL. Use Payment.case() instead.
            "::get::Payment::case": {
              url: urlBase + "/Payments/:id/case",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Case#patchOrCreate
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Case#updateOrCreate
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Case#patchOrCreateWithWhere
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Case#update
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Case#destroyById
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Case#removeById
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Case#prototype$patchAttributes
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Case` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Case#modelName
        * @propertyOf lbServices.Case
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Case`.
        */
        R.modelName = "Case";


            /**
             * @ngdoc method
             * @name lbServices.Case#customer
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Fetches belongsTo relation customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customer = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::get::Case::customer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case#agent
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Fetches belongsTo relation agent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.agent = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Case::agent"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case#manager
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Fetches belongsTo relation manager.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.manager = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Case::manager"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Case.payment
     * @header lbServices.Case.payment
     * @object
     * @description
     *
     * The object `Case.payment` groups methods
     * manipulating `Payment` instances related to `Case`.
     *
     * Call {@link lbServices.Case#payment Case.payment()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Case#payment
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Queries payment of Case.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payment = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::Case::payment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.payment#count
             * @methodOf lbServices.Case.payment
             *
             * @description
             *
             * Counts payment of Case.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.payment.count = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::count::Case::payment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.payment#create
             * @methodOf lbServices.Case.payment
             *
             * @description
             *
             * Creates a new instance in payment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payment.create = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::create::Case::payment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.payment#createMany
             * @methodOf lbServices.Case.payment
             *
             * @description
             *
             * Creates a new instance in payment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payment.createMany = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::createMany::Case::payment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.payment#destroyAll
             * @methodOf lbServices.Case.payment
             *
             * @description
             *
             * Deletes all payment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payment.destroyAll = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::delete::Case::payment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.payment#destroyById
             * @methodOf lbServices.Case.payment
             *
             * @description
             *
             * Delete a related item by id for payment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for payment
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payment.destroyById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::destroyById::Case::payment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.payment#findById
             * @methodOf lbServices.Case.payment
             *
             * @description
             *
             * Find a related item by id for payment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for payment
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payment.findById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::findById::Case::payment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.payment#updateById
             * @methodOf lbServices.Case.payment
             *
             * @description
             *
             * Update a related item by id for payment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for payment
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payment.updateById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::updateById::Case::payment"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Case.terms
     * @header lbServices.Case.terms
     * @object
     * @description
     *
     * The object `Case.terms` groups methods
     * manipulating `Terms` instances related to `Case`.
     *
     * Call {@link lbServices.Case#terms Case.terms()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Case#terms
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Queries terms of Case.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R.terms = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::get::Case::terms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.terms#count
             * @methodOf lbServices.Case.terms
             *
             * @description
             *
             * Counts terms of Case.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.terms.count = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::count::Case::terms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.terms#create
             * @methodOf lbServices.Case.terms
             *
             * @description
             *
             * Creates a new instance in terms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R.terms.create = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::create::Case::terms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.terms#createMany
             * @methodOf lbServices.Case.terms
             *
             * @description
             *
             * Creates a new instance in terms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R.terms.createMany = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::createMany::Case::terms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.terms#destroyAll
             * @methodOf lbServices.Case.terms
             *
             * @description
             *
             * Deletes all terms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.terms.destroyAll = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::delete::Case::terms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.terms#destroyById
             * @methodOf lbServices.Case.terms
             *
             * @description
             *
             * Delete a related item by id for terms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for terms
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.terms.destroyById = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::destroyById::Case::terms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.terms#findById
             * @methodOf lbServices.Case.terms
             *
             * @description
             *
             * Find a related item by id for terms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for terms
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R.terms.findById = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::findById::Case::terms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.terms#updateById
             * @methodOf lbServices.Case.terms
             *
             * @description
             *
             * Update a related item by id for terms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for terms
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R.terms.updateById = function() {
          var TargetResource = $injector.get("Terms");
          var action = TargetResource["::updateById::Case::terms"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Case.details
     * @header lbServices.Case.details
     * @object
     * @description
     *
     * The object `Case.details` groups methods
     * manipulating `Casedetails` instances related to `Case`.
     *
     * Call {@link lbServices.Case#details Case.details()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Case#details
             * @methodOf lbServices.Case
             *
             * @description
             *
             * Queries details of Case.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R.details = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::get::Case::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.details#count
             * @methodOf lbServices.Case.details
             *
             * @description
             *
             * Counts details of Case.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.details.count = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::count::Case::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.details#create
             * @methodOf lbServices.Case.details
             *
             * @description
             *
             * Creates a new instance in details of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R.details.create = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::create::Case::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.details#createMany
             * @methodOf lbServices.Case.details
             *
             * @description
             *
             * Creates a new instance in details of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R.details.createMany = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::createMany::Case::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.details#destroyAll
             * @methodOf lbServices.Case.details
             *
             * @description
             *
             * Deletes all details of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.details.destroyAll = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::delete::Case::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.details#destroyById
             * @methodOf lbServices.Case.details
             *
             * @description
             *
             * Delete a related item by id for details.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for details
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.details.destroyById = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::destroyById::Case::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.details#findById
             * @methodOf lbServices.Case.details
             *
             * @description
             *
             * Find a related item by id for details.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for details
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R.details.findById = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::findById::Case::details"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Case.details#updateById
             * @methodOf lbServices.Case.details
             *
             * @description
             *
             * Update a related item by id for details.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Case id
             *
             *  - `fk` – `{*}` - Foreign key for details
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R.details.updateById = function() {
          var TargetResource = $injector.get("Casedetails");
          var action = TargetResource["::updateById::Case::details"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Terms
 * @header lbServices.Terms
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Terms` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Terms",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Terms/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Terms#create
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Terms",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#upsert
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Terms",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#replaceOrCreate
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Terms/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#upsertWithWhere
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Terms/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#exists
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Terms/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#findById
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Terms/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#replaceById
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Terms/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#find
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Terms",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#findOne
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Terms/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#updateAll
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Terms/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#deleteById
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Terms/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#count
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Terms/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#prototype$updateAttributes
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Terms id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Terms/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#createChangeStream
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Terms/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Terms#createMany
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Terms",
              method: "POST",
            },

            // INTERNAL. Use Case.terms.findById() instead.
            "::findById::Case::terms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/terms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Case.terms.destroyById() instead.
            "::destroyById::Case::terms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/terms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Case.terms.updateById() instead.
            "::updateById::Case::terms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/terms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Case.terms() instead.
            "::get::Case::terms": {
              isArray: true,
              url: urlBase + "/Cases/:id/terms",
              method: "GET",
            },

            // INTERNAL. Use Case.terms.create() instead.
            "::create::Case::terms": {
              url: urlBase + "/Cases/:id/terms",
              method: "POST",
            },

            // INTERNAL. Use Case.terms.createMany() instead.
            "::createMany::Case::terms": {
              isArray: true,
              url: urlBase + "/Cases/:id/terms",
              method: "POST",
            },

            // INTERNAL. Use Case.terms.destroyAll() instead.
            "::delete::Case::terms": {
              url: urlBase + "/Cases/:id/terms",
              method: "DELETE",
            },

            // INTERNAL. Use Case.terms.count() instead.
            "::count::Case::terms": {
              url: urlBase + "/Cases/:id/terms/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Terms#patchOrCreate
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Terms#updateOrCreate
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Terms#patchOrCreateWithWhere
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Terms#update
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Terms#destroyById
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Terms#removeById
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Terms#prototype$patchAttributes
             * @methodOf lbServices.Terms
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Terms id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Terms` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Terms#modelName
        * @propertyOf lbServices.Terms
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Terms`.
        */
        R.modelName = "Terms";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Maincategory
 * @header lbServices.Maincategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Maincategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Maincategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Maincategories/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#create
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Maincategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#upsert
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Maincategories",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#replaceOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Maincategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#upsertWithWhere
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Maincategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#exists
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Maincategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#findById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Maincategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#replaceById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Maincategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#find
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Maincategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#findOne
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Maincategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#updateAll
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Maincategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#deleteById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Maincategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#count
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Maincategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#prototype$updateAttributes
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Maincategories/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#createChangeStream
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Maincategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#createMany
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Maincategories",
              method: "POST",
            },

            // INTERNAL. Use Category.main() instead.
            "::get::Category::main": {
              url: urlBase + "/Categories/:id/main",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Maincategory#patchOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#updateOrCreate
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#patchOrCreateWithWhere
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#update
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#destroyById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#removeById
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Maincategory#prototype$patchAttributes
             * @methodOf lbServices.Maincategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Maincategory id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Maincategory` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Maincategory#modelName
        * @propertyOf lbServices.Maincategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Maincategory`.
        */
        R.modelName = "Maincategory";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Usertransaction
 * @header lbServices.Usertransaction
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Usertransaction` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Usertransaction",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Usertransactions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Usertransaction.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/Usertransactions/:id/category",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#create
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Usertransactions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#upsert
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Usertransactions",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#replaceOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Usertransactions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#upsertWithWhere
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Usertransactions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#exists
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Usertransactions/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#findById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Usertransactions/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#replaceById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Usertransactions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#find
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Usertransactions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#findOne
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Usertransactions/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#updateAll
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Usertransactions/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#deleteById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Usertransactions/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#count
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Usertransactions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#prototype$updateAttributes
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Usertransactions/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#createChangeStream
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Usertransactions/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#createMany
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Usertransactions",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#patchOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#updateOrCreate
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#patchOrCreateWithWhere
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#update
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#destroyById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#removeById
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#prototype$patchAttributes
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usertransaction` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Usertransaction#modelName
        * @propertyOf lbServices.Usertransaction
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Usertransaction`.
        */
        R.modelName = "Usertransaction";


            /**
             * @ngdoc method
             * @name lbServices.Usertransaction#category
             * @methodOf lbServices.Usertransaction
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usertransaction id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Usertransaction::category"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Casedetails
 * @header lbServices.Casedetails
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Casedetails` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Casedetails",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Casedetails/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#create
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Casedetails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#upsert
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Casedetails",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#replaceOrCreate
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Casedetails/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#upsertWithWhere
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Casedetails/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#exists
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Casedetails/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#findById
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Casedetails/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#replaceById
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Casedetails/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#find
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Casedetails",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#findOne
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Casedetails/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#updateAll
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Casedetails/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#deleteById
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Casedetails/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#count
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Casedetails/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#prototype$updateAttributes
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Casedetails id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Casedetails/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#createChangeStream
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Casedetails/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#createMany
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Casedetails",
              method: "POST",
            },

            // INTERNAL. Use Case.details.findById() instead.
            "::findById::Case::details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/details/:fk",
              method: "GET",
            },

            // INTERNAL. Use Case.details.destroyById() instead.
            "::destroyById::Case::details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/details/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Case.details.updateById() instead.
            "::updateById::Case::details": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Cases/:id/details/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Case.details() instead.
            "::get::Case::details": {
              isArray: true,
              url: urlBase + "/Cases/:id/details",
              method: "GET",
            },

            // INTERNAL. Use Case.details.create() instead.
            "::create::Case::details": {
              url: urlBase + "/Cases/:id/details",
              method: "POST",
            },

            // INTERNAL. Use Case.details.createMany() instead.
            "::createMany::Case::details": {
              isArray: true,
              url: urlBase + "/Cases/:id/details",
              method: "POST",
            },

            // INTERNAL. Use Case.details.destroyAll() instead.
            "::delete::Case::details": {
              url: urlBase + "/Cases/:id/details",
              method: "DELETE",
            },

            // INTERNAL. Use Case.details.count() instead.
            "::count::Case::details": {
              url: urlBase + "/Cases/:id/details/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Casedetails#patchOrCreate
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#updateOrCreate
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#patchOrCreateWithWhere
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#update
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#destroyById
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#removeById
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Casedetails#prototype$patchAttributes
             * @methodOf lbServices.Casedetails
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Casedetails id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Casedetails` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Casedetails#modelName
        * @propertyOf lbServices.Casedetails
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Casedetails`.
        */
        R.modelName = "Casedetails";



        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme);
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors);
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(50)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignIn')
    .controller('authSignInCtrl', authSignInCtrl);

  /** @ngInject */
  function authSignInCtrl($scope, localStorage, $state, validationService,
  toastr, userService, $rootScope) {
    var vm = this;

    console.log("Inside authSignInCtrl");
    $scope.user={};

    init();

    function init() {
      localStorage.clear();
    }

    vm.logar = logar;



    function logar() {
      var dadosUser = {
        user: vm.user,
        passWord: vm.passWord
      };
      localStorage.setObject('dataUser', dadosUser);
      $state.go('main.dashboard');
    }

    $scope.login = function(user){
             console.log("Login  Tapped");
             //Performing Validations
             var isFormValidated = true;

             if (validationService.isEmptyOrNullValidation(user.username) &&
               validationService.isEmptyOrNullValidation(user.password)) {
                 //No More Checks
                 console.log("All Passed");
               } else {
               isFormValidated = false;
               toastr.error('Please fill all the Required Fields', 'ERROR');
             }

             if (isFormValidated) {
               var obj = {};
               obj.params = {};
               obj.params = user;
               console.log("LoginID is "+obj.params.username);
               console.log("Password is "+obj.params.password);

               obj.onSuccess = function (result){
               console.log("Inside SUCCESS Login");
               console.log(result);
               $rootScope.userData = {};
               $rootScope.userData = result.user;
               $rootScope.userData.tokenId = result.id;
               $rootScope.userData.roleId = result.roleId;
               var localUser = {};
              //  userData.roleId = result.roleId;
              localUser.tokenId = result.id;
              //  userData.name = result.user.credentials.name;
              //  userData.mobile = result.user.credentials.mobile;
               localStorage.setObject('userData', $rootScope.userData);

               $state.go('main.dashboard');
               };

               obj.onFailure = function (err){
                 console.log("Inside Failure");
                 console.log(err);
                 if (err.status === -1){
                   toastr.error('Service Unavailable. Please try again later', 'ERROR');
                 }else{
                   $scope.user = {};
                   toastr.error('Unauthorized Access', 'ERROR');
                 }
               };

               userService.userLogin(obj);
             }
           };
         }
       })();

(function() {
    'use strict';

    angular.module('BlurAdmin.pages.authSignUp')
      .controller('authSignUpCtrl', authSignUpCtrl);

    /** @ngInject */
    function authSignUpCtrl($scope, validationService, toastr,userService, $state) {
      var vm = this;
      console.log("Inside authSignUpCtrl");

      $scope.register = {};


      $scope.validateRegistration = function(register) {
        console.log("Inside validateRegistration");
        console.log("Name = " + register.name);
        console.log("username = " + register.username);
        console.log("mobile = " + register.mobile);
        console.log("mobile = " + register.password);

        //Performing Validations
        var isFormValidated = true;

        if (validationService.isEmptyOrNullValidation(register.name) &&
          validationService.isEmptyOrNullValidation(register.username) &&
          validationService.isEmptyOrNullValidation(register.password) &&
          validationService.isEmptyOrNullValidation(register.mobile)) {

          if (!validationService.verifyPhoneFormat(register.mobile)) {
            isFormValidated = false;
            console.log("Not a numer");
            toastr.error('Please enter a valid Mobile Nummber. Should be either 9 digits or 10 digits', 'ERROR');
          }

        } else {
          isFormValidated = false;
          console.log("Fill all required fields");
          toastr.error('Please fill all the Required Fields', 'ERROR');
        }

        if (isFormValidated) {

          var obj = {};
          obj.params = {};
          obj.params = register;
          obj.params.credentials={};
          obj.params.credentials.name=register.name;
          obj.params.credentials.mobile="+60"+register.mobile;

          console.log("username is " + obj.params.username);
          console.log("name is " + obj.params.name);
          console.log("mobile is " + obj.params.mobile);
          console.log("password is " + obj.params.password);

          obj.onSuccess = function(result) {
            console.log("Inside SUCCESS");
            console.log(result);
            $scope.register = {};
            toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
            $state.transitionTo("authSignIn");
          };

          obj.onFailure = function(err) {
            console.log("Inside Failure");
            console.log(err);

            if (err.status === -1) {
              toastr.error('Service Unavailable. Please try again later', 'ERROR');
            } else if (err.status === 422) {
              $scope.register = {};
              toastr.error('Username or Mobile Already Exists', 'ERROR');
            } else {
              $scope.register = {};
              toastr.error('Unauthorized Access', 'ERROR');
            }
          };

          userService.userSignup(obj);
        }
      };
    }
  })();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.config')
    .run(stateChangeStart);

  /** @ngInject */
  function stateChangeStart($rootScope, $state, localStorage) {
    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $rootScope.userData = localStorage.getObject('userData');
      if (toState.authenticate && _.isEmpty($rootScope.userData)) {
        // User isn’t authenticated
        $state.transitionTo("authSignIn");
        event.preventDefault();
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
    .controller('DashboardPageCtrl', DashboardPageCtrl);

  /** @ngInject */
  // function DashboardPageCtrl($scope, $filter, editableOptions, editableThemes,
  //   collectorreportService, zoneService, gameService, shopService, partnerService,machinesalesService, validationService, toastr, $uibModal,
  //   $rootScope, dashboardService) {

  function DashboardPageCtrl($scope, $filter, editableOptions, editableThemes,
    validationService, toastr, $uibModal, $state,
    $rootScope, dashboardService) {
    console.log("Inside DashboardPageCtrl");

    if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
      $scope.shopTypeFilter = [{
        value: $rootScope.userData.credentials.shopType
      }];
    } else {
      $scope.shopTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }

    $scope.getWeeklyData = function (zoneid) {
      console.log('Inside getWeeklyData');

      if (zoneid && $scope.dashboardV2List.length) {
        var weekMachineData = [];
        var weekOnlinbeData = [];
        var weeklyData = [];
        var selected = $filter('filter')($scope.dashboardV2List, {
          zoneid: zoneid
        }, true);

        for (var index = 0; index < selected.length; index++) {
          weekMachineData.push(selected[index].mactotal);
          weekOnlinbeData.push(selected[index].ontotal);
        }
        weeklyData.push(weekMachineData);
        weeklyData.push(weekOnlinbeData);

        return weeklyData;
      }
    };

    $scope.dashboardV1List = [];
    $scope.getDashboardV1 = function () {
      console.log("Inside getDashboardV1");
      console.log($scope.dateList);

      var obj = {};
      obj.params = {};

      //$scope.manageAreasList.push($scope.inserted);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getDashboardV1");
        console.log(result.result);
        if (result.result) {
          $scope.dashboardV1List = result.result;
          $scope.getDashboardV2();
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dashboardService.getDashboardV1(obj);

    };

    $scope.getDepositSummary = function () {
      var obj = {};
      obj.params = {};

      obj.onSuccess = function (
        data
      ) {
        if (data.result) {
          $scope.depositSummary = data.result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dashboardService.getDepositSummary(obj);
    };

    $scope.dashboardV2List = [];
    $scope.getDashboardV2 = function () {
      console.log("Inside getDashboardV1");
      console.log($scope.dateList);

      var obj = {};
      obj.params = {};

      //$scope.manageAreasList.push($scope.inserted);
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS getDashboardV1");
        console.log(result.result);
        if (result.result) {
          $scope.dashboardV2List = result.result;
          //$scope.getDashboardV2();
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      dashboardService.getDashboardV2(obj);

    };

    $scope.init = function () {
      $scope.getDashboardV1();
      $scope.getDepositSummary();
    };

    $scope.init();

    /****************************************** */

    //getting Zones
    $scope.manageZones = {};
    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
          console.log('Inside Zonemap');
          for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
            var zonelist = $filter('filter')(result, {
              id: $rootScope.userData.credentials.zonemap[index]
            }, true);
            console.log('zonelist', zonelist);

            $scope.manageZonesList.push(zonelist[0]);
          }
        } else {
          $scope.manageZonesList = result;
        }
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};
    $scope.dateList.from = new Date();
    $scope.dateList.to = new Date();
    $scope.managePartnersales = {};
    $scope.managePartnersalesList = [];
    $scope.reportFilter = {};
    $scope.searchSales = function (reportFilter) {
      console.log("Inside searchSales");
      console.log($scope.dateList);
      //Performing Validations
      var isFormValidated = true;

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        var fd = new Date($scope.dateList.from),
          y = fd.getFullYear(),
          m = fd.getMonth() + 1;
        var date1 = y + '-' + m + '-' + (fd.getDate() - 1);

        var td = new Date($scope.dateList.to);
        y = td.getFullYear();
        m = td.getMonth() + 1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y + '-' + m + '-' + (td.getDate() - 1);

        obj.params.adate = date1;
        obj.params.bdate = date2;

        if (reportFilter.zone) {
          obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        } else {
          if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
            var value = "";
            for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
              if (index == 0) {
                value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
              } else {
                value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
              }
            }
            value = value + ")";
            obj.params.zoneid = value;
          } else {
            obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
          }
        }

        if (typeof $rootScope.userData.credentials.shopType !== "undefined") {
          obj.params.shoptype = $rootScope.userData.credentials.shopType;
        } else {
          obj.params.shoptype = reportFilter.shoptype ? reportFilter.shoptype.value : null;
        }


        //$scope.manageAreasList.push($scope.inserted);
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result.result);
          if (result.result) {
            $scope.totalSalesLabel = 0;
            $scope.managePartnersalesList = result.result;
            var mactotalData = [];
            for (var i = 0; i < $scope.managePartnersalesList.length; i++) {

              mactotalData.push($scope.managePartnersalesList[i].mactotal);

              var onmacTotal = parseFloat($scope.managePartnersalesList[i].ontotal) + parseFloat($scope.managePartnersalesList[i].mactotal);
              $scope.managePartnersalesList[i].total = onmacTotal;
              $scope.totalSalesLabel = $scope.totalSalesLabel + onmacTotal;
            }
            console.log('mactotalData', mactotalData);
            $scope.isEdit = false;
          }
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectorreportService.getGrpSalesInRange(obj);
      }
    };




    $scope.dateFormater = function (ikey) {
      var dateRaw = ikey.substring(ikey.length - 8);
      var dateLength = dateRaw.length
      var mm = dateRaw.substring(0, dateLength - 6)
      var dd = dateRaw.substring(2, dateLength - 4)
      var yy = dateRaw.substring(dateLength - 4)

      return mm + '/' + dd + '/' + yy
    };

    $scope.smartTablePageSize = 250;

    $scope.totalSalesLabel = 0;
    $scope.totalSalesLabelFooter = 0;


    // $scope.getTotalpayment = function (items) {
    //   if (items){
    //     return items
    //     .map(function (x) { return x.payment; })
    //     .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    //   }
    // };
    // $scope.getTotalcashout = function (items) {
    //   if (items){
    //   return items
    //     .map(function (x) { return x.cashout; })
    //     .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    //   }
    // };
    $scope.totalpayment = 0;
    $scope.totalcashout = 0;
    $scope.totalamount = 0;
    $scope.totaldebit = 0;
    $scope.totalcredit = 0;
    $scope.getTotalpayment = function (items) {
      if (items) {
        var totalpayment = 0;
        for (var index = 0; index < items.length; index++) {
          if (items[index] != '0') {
            totalpayment = totalpayment + parseFloat(items[index].payment);
          }
        }
        $scope.totalpayment = totalpayment;
        return totalpayment;
      }
    };
    $scope.getTotaldebit = function (items) {
      if (items) {
        var totaldebit = 0;
        for (var index = 0; index < items.length; index++) {
          if (items[index] != '0') {
            totaldebit = totaldebit + parseFloat(items[index].debit);
          }
        }
        $scope.totaldebit = totaldebit;
        return totaldebit;
      }
    };
    $scope.getTotalcredit = function (items) {
      if (items) {
        var totalcredit = 0;
        for (var index = 0; index < items.length; index++) {
          if (items[index] != '0') {
            totalcredit = totalcredit + parseFloat(items[index].credit);
          }
        }
        $scope.totalcredit = totalcredit;
        return totalcredit;
      }
    };
    $scope.getTotalcashout = function (items) {
      if (items) {
        var totalcashout = 0;
        for (var index = 0; index < items.length; index++) {
          if (items[index] != '0') {
            totalcashout = totalcashout + parseFloat(items[index].cashout);
          }
        }
        $scope.totalcashout = totalcashout;
        return totalcashout;
      }
    };
    $scope.getTotalamount = function (items) {
      if (items) {
        var totalamount = 0;
        for (var index = 0; index < items.length; index++) {
          if (items[index] != '0') {
            totalamount = totalamount + parseFloat(items[index].amount);
          }
        }
        $scope.totalamount = totalamount;
        return totalamount;
      }
    };
    $scope.getTotalbalance = function () {
      var totalbalance = 0;
      if ($scope.totalpayment != 0 && $scope.totalcashout != 0 && $scope.totaldebit != 0 && $scope.totalcredit != 0) {
        totalbalance = ($scope.totaldebit + $scope.totalpayment) - ($scope.totalcashout + $scope.totalcredit);
      }
      return totalbalance;
    };
    $scope.getTotalbalanceV2 = function () {
      var totalbalance = 0;
      if ($scope.totalpayment != 0 && $scope.totalamount != 0) {
        totalbalance = $scope.totalamount - $scope.totalpayment;
      }
      return totalbalance;
    };

    $scope.getDebit = function (items) {
      if (items) {
        for (var index = 0; index < items.length; index++) {
          if (items[index].debit != '0') {
            return parseFloat(items[index].debit);
          }
        }
      }
    };
    $scope.getCredit = function (items) {
      if (items) {
        for (var index = 0; index < items.length; index++) {
          if (items[index].credit != '0') {
            return parseFloat(items[index].credit);
          }
        }
      }
    };
    $scope.getPayment = function (items) {
      if (items) {
        for (var index = 0; index < items.length; index++) {
          if (items[index].payment != '0') {
            return parseFloat(items[index].payment);
          }
        }
      }
    };
    $scope.getCashout = function (items) {
      if (items) {
        for (var index = 0; index < items.length; index++) {
          if (items[index].cashout != '0') {
            return parseFloat(items[index].cashout);
          }
        }
      }
    };
    $scope.getAmount = function (items) {
      if (items) {
        var amount = 0;
        for (var index = 0; index < items.length; index++) {
          if (items[index].amount != '0') {
            amount = amount + parseFloat(items[index].amount);
          }
        }
        return amount;
      }
    };

    $scope.getBalance = function (items) {
      if (items) {
        var amount = 0;
        var payment = 0;
        var balance = 0;
        for (var index = 0; index < items.length; index++) {
          if (items[index].amount != '0') {
            amount = amount + parseFloat(items[index].amount);
          }
          if (items[index].payment != '0') {
            payment = payment + parseFloat(items[index].payment);
          }
          balance = amount - payment;
          if (items[index].isloan) {
            balance = balance + parseFloat(items[index].amount);
          }
        }
        return balance;
      }
    };

    $scope.viewMonthlyCaseDetail = function (caseOverview, status) {
      var from_date = new Date(caseOverview.month + "-" + caseOverview.year).toISOString();
      $state.go('main.report.casesummary', {
        from_date: from_date,
        type: 'D',
        status: status,
      })
    }

    $scope.monthLabels = ["May", "Jun", "Jul", "Aug", "Sep"];

    $scope.weekSeries = ['Machine (大机)', 'Online (网机)'];

    $scope.weeklyData = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.backgroundColor = ['#dfb81c', '#2dacd1'];

    $scope.datasetOverride = [{
      fill: true,
      backgroundColor: [
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
        "#dfb81c",
      ]
    }, {
      fill: true,
      backgroundColor: [
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
        "#2dacd1",
      ]
    }];

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
    .service('dashboardService', dashboardService);

  /** @ngInject */
  function dashboardService(Case) {

    var getDashboardV1 = function (obj) {

      Case.getDashboardV1().$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getDashboardV2 = function (obj) {

      Case.getDashboardV2().$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getDepositSummary = function (obj) {
      Case.getDepositSummary().$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    }


    return {
      getDashboardV1: getDashboardV1,
      getDashboardV2: getDashboardV2,
      getDepositSummary: getDepositSummary
    };

  }

})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal,
  validationService, toastr, userService, $state, $rootScope,roleService) {

    console.log("Inside ProfilePageCtrl");

        //Getting Roles
        $scope.manageRoleList=[];
        $scope.initManageRole = function() {
          var obj = {};
          obj.onSuccess = function(result) {
            console.log("Inside SUCCESS");
            console.log(result);
            $scope.manageRoleList = result;
          };
          obj.onFailure = function(err) {
            console.log("Inside Failure");
            console.log(err);
          };
          roleService.getRoles(obj);
        };

        $scope.initManageRole();

    $scope.manageProfile ={};
    $scope.manageProfile = $rootScope.userData;
    // $scope.manageProfile.id = $rootScope.userData.id;
    // $scope.manageProfile.name = $rootScope.userData.credentials.name;
    // $scope.manageProfile.mobile = $rootScope.userData.credentials.mobile;
    // $scope.manageProfile.role = $rootScope.userData.credentials.role;
    // $scope.manageProfile.credentials = $rootScope.userData.credentials;

    console.log($scope.manageProfile.id);


$scope.udpateProfile = function(manageProfile){
  console.log("Inside udpateProfile");
  //Performing Validations
  var isFormValidated = true;

  if (validationService.isEmptyOrNullValidation(manageProfile.credentials.name) &&
    validationService.isEmptyOrNullValidation(manageProfile.password) &&
    validationService.isEmptyOrNullValidation(manageProfile.credentials.mobile)) {

    if (!validationService.verifyPhoneFormat(manageProfile.credentials.mobile.substring(3))) {
      isFormValidated = false;
      console.log("Not a numer");
      toastr.error('Please enter a valid Mobile Nummber. Should be either 9 digits or 10 digits', 'ERROR');
    }

    if (manageProfile.password!==manageProfile.confirmPassword){
      isFormValidated = false;
      console.log("Not a numer");
      toastr.error('Password does not match', 'ERROR');
    }

  } else {
    isFormValidated = false;
    console.log("Fill all required fields");
    toastr.error('Please fill all the Required Fields', 'ERROR');
  }

        if (isFormValidated) {
          console.log("All cOmpleted");

          var obj = {};
          obj.params = {};
          obj.params = $scope.manageProfile;
          //obj.params.credentials = manageProfile.credentials;
          //obj.params.id = manageProfile.userId;

          console.log(obj.params);

          obj.onSuccess = function(result) {
            console.log("Inside SUCCESS");
            console.log(result);
            $scope.register = {};
            toastr.success('Your Profile is updated. Please Login again', 'SUCCESS');
            $state.transitionTo("authSignIn");
          };

          obj.onFailure = function(err) {
            console.log("Inside Failure");
            console.log(err);

            if (err.status === -1) {
              toastr.error('Service Unavailable. Please try again later', 'ERROR');
            } else if (err.status === 422) {
              $scope.register = {};
              toastr.error('Username or Mobile Already Exists', 'ERROR');
            } else {
              $scope.register = {};
              toastr.error('Unauthorized Access', 'ERROR');
            }
          };
          userService.saveUser(obj);

        }

};




    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.showRoles = function(role) {
      if (role && $scope.manageRoleList.length) {
        var selected = $filter('filter')($scope.manageRoleList, {
          id: role
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .factory('validationService', validationService);

  /** @ngInject */
  function validationService() {

        var obj = {};

        obj.verifyPhoneFormat = function (phoneNo) {
            //var expression1 = /^0\(?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            var expression1 = /^([0-9]{2})([0-9]{3})([0-9]{4}|[0-9]{5})$/;
            return expression1.test(phoneNo);

        };

        obj.verifyEmailFormat = function (email) {
            var expression2 = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            return expression2.test(email);
        };

        obj.verifyAliasName = function (value) {
            var expression3 = /^([a-zA-Z0-9\s]){1,20}$/;
            return expression3.test(value);
        };
        obj.isEmptyOrNullValidation = function (value) {
            if (value === undefined || value === "" || value === null || value === "null") {
                return false
            } else {
                return true;
            }
        };

        obj.hasSpaces = function (value) {
            var expression4 = /^[a-zA-Z0-9_\-]+$/;
            return expression4.test(value);
        };

        //Checks that a password has a minimum of 6 characters, at least 1 uppercase letter, 1 lowercase letter, and 1 number with no spaces.
        obj.verifyPasswordPolicy = function (value){
            var expression5 = /^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9]).{6,})\S$/;
            return expression5.test(value);
        };

        obj.verifyDate = function(value){
            // var expression6 = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
            // return expression6.test(value);
            return !isNaN( Date.parse( value ) );
        };

        obj.compareDates= function(value1,value2){
            return value1.getTime()<value2.getTime()? true:false;

        };

        return obj;

      }

      })();

/**
 * @author dufrolabs
 * created on 29/06/2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('localStorage', localStorage);

  /** @ngInject */
  function localStorage($window) {
    var service = {
      set: set,
      get: get,
      setObject: setObject,
      getObject: getObject,
      clear: clear
    }

    return service;

    function set(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = value;
      } else {
        $window.localStorage[key] = value;
      }
    }

    function get(key, defaultValue) {
      return !$window.fakeLocalStorage ? $window.localStorage[key] || defaultValue : $window.fakeLocalStorage[key] || defaultValue;
    }

    function setObject(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = angular.toJson(value);
      } else {
        $window.localStorage[key] = angular.toJson(value);
      }
    }

    function getObject(key) {
      return !$window.fakeLocalStorage ? angular.fromJson($window.localStorage[key] || '{}') : angular.fromJson($window.fakeLocalStorage[key] || '{}');
    }

    function clear() {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage = {};
      } else {
        $window.localStorage.clear();
      }
    }
  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('receiptService', receiptService);

  /** @ngInject */
  function receiptService(Receipts) {

  var getReceipts = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Receipts.find({
      filter: {
        where:{
          id: obj.params.receiptid
        }
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  return {
    getReceipts: getReceipts

  };
}

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('rolemappingService', rolemappingService);

  /** @ngInject */
  function rolemappingService(Rolemapping) {

    var getRolemappings = function(obj) {
      Rolemapping.find({
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getRolemappingsbyID = function (obj) {
      Rolemapping.find({
        filter: {
          where: {
            and: [
              { principalId: obj.params.principalid },
              { principalType: "Rolemapping.USER" }
            ],
            include: ["role"]
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };
  
    var createRolemapping = function(obj) {
      var date = new Date();
  
      Rolemapping.create({
        principalType: "Rolemapping.USER",
        principalId: obj.params.userid,
        roleId:obj.params.roleid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
  
    var deleteRolemapping = function(obj) {
  
      Rolemapping.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
    var saveRolemapping = function(obj) {
      var date = new Date();
  
      Rolemapping.prototype$updateAttributes({
        id: obj.params.id,
        principalType: "Rolemapping.USER",
        principalId: obj.params.userid,
        roleId:obj.params.roleid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
  
    return {
      getRolemappings: getRolemappings,
      createRolemapping: createRolemapping,
      deleteRolemapping: deleteRolemapping,
      saveRolemapping: saveRolemapping,
      getRolemappingsbyID:getRolemappingsbyID
    };
}

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .factory('SheetJSExportService', SheetJSExportService);


  /** @ngInject */
    SheetJSExportService.inject = ['uiGridExporterService'];
        })();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('userService', userService);

  /** @ngInject */
  function userService(User) {

  var userLogin = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    User.login({
      username: obj.params.username,
      password: obj.params.password
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var userSignup = function(obj) {
    var date = new Date();
    User.create({
      realm: "loan",
      username: obj.params.username,
      password: obj.params.password,
      credentials: obj.params.credentials,
      email: obj.params.credentials.mobile + "@loan-portal.com",
      emailVerified: false,
      status: "Active",
      created: date,
      lastUpdated: date,
      challenges:obj.params.challenges?obj.params.challenges:null

    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  var partnerSignup = function(obj) {
    var date = new Date();
    User.create({
      realm: "loan",
      username: obj.params.username,
      password: obj.params.password,
      credentials: obj.params.credentials,
      email: obj.params.username + "@loan-portal.com",
      emailVerified: false,
      status: "Active",
      created: date,
      lastUpdated: date,
      challenges:obj.params.challenges?obj.params.challenges:null

    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  
  var collectorSignup = function(obj) {
    var date = new Date();
    User.create({
      realm: "loan",
      username: obj.params.username,
      password: obj.params.password,
      credentials: obj.params.credentials,
      email: obj.params.username + "@loan-portal.com",
      emailVerified: false,
      status: "Active",
      created: date,
      lastUpdated: date,
      challenges:obj.params.challenges?obj.params.challenges:null

    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  var userApproval = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    User.find({
      filter: {
        where: {
          emailVerified: false
        }
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data)

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err)
    })
  }

  var userAccessApproved = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    console.log(obj.params.userId, obj.params.userId);
    User.prototype$updateAttributes({
      id: obj.params.userId,
      emailVerified: true
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data)

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err)
   app })
  }


  var getUsers = function(obj) {
    User.find({
      filter:{
        where:{
          realm:"loan"
        },
        include:"roles"
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };

  var getParterUsers = function(obj) {
    User.find({
      filter:{
        where:{
          and:[
            {realm:"loan"},
            {challenges: obj.params.parentid}
          ]
        },
        include:"rolemap"
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };
//emailVerified: true
  var getUsersMSync = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    User.find({
      filter:{
        where:{
          and:[
            {realm: "msync"},
            {emailVerified: "true"}
          ]
        },
        include:"rolemap"
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);
    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var getUserLoanSync = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
    User.find({
      filter:{
        where:{
          and:[
            {realm: "loansync"},
            {emailVerified: "true"}
          ]
        },
        include:"roles"
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };
  // get all user for collection report agent filter
  var getAllUser = function(obj) {
    User.find({
      filter:{
        where:{
          and:[
            {
              or:[
                {realm: "loansync"},
                {realm: "loan"}
              ]
            },
            {emailVerified: "true"}
          ]
        },
        include:"roles",
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };
  // end

  var getUsersCSyncVIP = function(obj) {

    User.find({
      filter:{
        where:{
          and:[
            {or:[
              {realm: "csync"},
              {realm: "loan"}
            ]},
            {emailVerified: "true"}
          ]
        },
        include:"rolemap"
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };


  var deleteUser = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    User.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };
  var saveUser = function(obj) {
    var date = new Date();

    User.prototype$updateAttributes({
      id: obj.params.id,
      password: obj.params.password,
      credentials: obj.params.credentials,
      emailVerified: obj.params.emailVerified,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);

    }, function(err) {
      obj.onFailure(err);
    });
  };

  var resetPassword = function(obj) {
    var date = new Date();
    
    User.prototype$updateAttributes({
      id: obj.params.id,
      password: obj.params.password,
      lastupdated: date
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };

  var updateCaseMap = function(obj) {
    var date = new Date();

    User.prototype$updateAttributes({
      id: obj.params.id,
      credentials: obj.params.credentials,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      ////$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var getUsersFromList = function(obj) {

    User.find({
      filter:{
        where:{
          and:[
            {realm:"csync"},
            {id:{inq:obj.params.userIDs}}
          ]          
        },
        include:["rolemap","roles"]
      }
    }).$promise.then(function(data) {
      obj.onSuccess(data);
    }, function(err) {
      obj.onFailure(err);
    });
  };

  return {
    userLogin: userLogin,
    userSignup: userSignup,
    userApproval: userApproval,
    userAccessApproved: userAccessApproved,
    getUsers: getUsers,
    getUsersMSync: getUsersMSync,
    getUserLoanSync: getUserLoanSync,
    deleteUser:deleteUser,
    updateCaseMap: updateCaseMap,
    saveUser:saveUser,
    getParterUsers: getParterUsers,
    partnerSignup: partnerSignup,
    resetPassword: resetPassword,
    getUsersCSyncVIP: getUsersCSyncVIP,
    collectorSignup: collectorSignup,
    getUsersFromList:getUsersFromList,
    getAllUser:getAllUser
    

  };
}

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive("importSheetJs", [SheetJSImportDirective]);


  /** @ngInject */


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      scope: {
        onFileSelect: '&',
        fileSizeMb: '='
      },
      link: function ($scope, el, attrs) {

        function fileToBase64() {
          var reader = new FileReader();

          reader.addEventListener("load", function () {
            $scope.onFileSelect({
              result: reader.result
            });
          }, false);

          if ($scope.file) {
            reader.readAsDataURL($scope.file);
          }
        }

        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];

          if ($scope.file.size > ($scope.fileSizeMb * 1024 * 1024)) {

            $scope.onFileSelect({
              error: new Error('File size reach maximum limit: ' + $scope.fileSizeMb + 'MB.')
            });

            $scope.file = null;
            (e.srcElement || e.target).value = '';

          } else {
            fileToBase64();
          }
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector')
    .controller('CollectorPageCtrl', CollectorPageCtrl);

  /** @ngInject */
  function CollectorPageCtrl($scope, $filter, editableOptions, editableThemes,
    collectorService, toastr, $uibModal, userService) {
    console.log("Inside CollectorPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCollector(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;

    //$scope.isparent = [{ value: 'Yes' }, { value: 'No' }];

    //Parent Collector List
    $scope.manageParentCollectorList = [];
    $scope.initManageParentCollector = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentCollectorList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      collectorService.getParentCollector(obj);
    };

    $scope.manageCollector = {};
    $scope.manageCollectorList = [];
    $scope.initManageCollector = function () {
      $scope.initManageParentCollector();
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCollectorList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      collectorService.getCollector(obj);
    };
    $scope.initManageCollector();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.manageCollectorList.push($scope.inserted);
    };

    $scope.createCollector = function (manageCollector) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createCollector");
      console.log(manageCollector);
      console.log(manageCollector.name);
      console.log(manageCollector.code);
      console.log(manageCollector.contact);
      //console.log(manageCollector.description);

      var obj = {};
      obj.params = {};
      obj.params.name = manageCollector.name;
      obj.params.code = manageCollector.code;
      obj.params.contact = manageCollector.contact;
      obj.params.parentid = manageCollector.parent?manageCollector.parent.id:null;
      // obj.params.isparent = manageCollector.isparent.value === 'Yes' ? true : false;
      obj.params.isparent = manageCollector.isparent;
      //obj.params.description = manageCollector.description;
      console.log('obj.params',obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCollector = {};
        toastr.success('New Collector has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Collector successfully created.");
        $scope.initManageCollector();

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      collectorService.createCollector(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/account/collector/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteCollector = function (res) {
      console.log("Inside deleteCollector");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Collector has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageCollector();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        collectorService.deleteCollector(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (collector) {
      console.log("Inside editCollector");
      console.log(collector);
      // $scope.manageCollector.id = $scope.manageCollector.id;
      // $scope.manageCollector.name = state.name;
      // $scope.manageCollector.description = state.description;
      // $scope.manageCollector.created = state.created;
      // $scope.manageCollector.lastupdated = state.lastupdated;
      $scope.manageCollector = collector;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveCollector = function (manageCollector, id) {

      console.log("Inside saveCollector");
      console.log(manageCollector);
      console.log(id);

      if (id === undefined) {
        $scope.createCollector(manageCollector);
      } else {

        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = manageCollector.name;
        obj.params.code = manageCollector.code;
        obj.params.contact = manageCollector.contact;
        obj.params.parentid = manageCollector.parent?manageCollector.parent.id:null;
        //obj.params.userid = manageCollector.userid?manageCollector.userid:null;
        obj.params.isparent = manageCollector.isparent;
        
        console.log('obj.params',obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageCollector = {};
          toastr.success('Collector has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageCollector();

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        collectorService.saveCollector(obj);

      }

    };
    $scope.showStatus = function() {
      var selected = $filter('filter')($scope.statuses, {value: $scope.user.status});
      return ($scope.user.status && selected.length) ? selected[0].text : 'Not set';
    };

    $scope.userAccess = function(manageCollector){
      console.log('Inside userAccess');
      console.log('manageCollector',manageCollector);

      var obj = {};
      obj.params = {};
      obj.params.username = manageCollector.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=manageCollector.name;
      obj.params.credentials.mobile=manageCollector.contact?manageCollector.contact:null;
      obj.params.credentials.role = manageCollector.isparent?7:8;
      obj.params.credentials.collector = manageCollector;
      obj.params.challenges = manageCollector.parentid;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageCollector.userid = result.id;
        $scope.saveCollector(manageCollector,manageCollector.id);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.collectorSignup(obj);

      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.collector')
    .service('collectorService', collectorService);

  /** @ngInject */
  function collectorService(Collector) {
    var getCollector = function (obj) {

      Collector.find({
        filter: {
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getParentCollector = function (obj) {

      Collector.find({
        filter: {
          where: {
            isparent: true
          },
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getCollectorStaff = function (obj) {

      Collector.find({
        filter: {
          where: {
            parentid: obj.params.parentid
          },
          include: ["user"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createCollector = function (obj) {
      var date = new Date();

      Collector.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteCollector = function (obj) {

      Collector.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveCollector = function (obj) {
      var date = new Date();

      Collector.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var unbindCollector = function (obj) {
      var date = new Date();

      Collector.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getCollector: getCollector,
      createCollector: createCollector,
      deleteCollector: deleteCollector,
      saveCollector: saveCollector,
      getParentCollector: getParentCollector,
      unbindCollector: unbindCollector,
      getCollectorStaff: getCollectorStaff
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner')
    .controller('PartnerPageCtrl', PartnerPageCtrl);

  /** @ngInject */
  function PartnerPageCtrl($scope, $filter, editableOptions, editableThemes,
    partnerService, toastr, $uibModal, userService) {
    console.log("Inside PartnerPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deletePartner(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;

    //$scope.isparent = [{ value: 'Yes' }, { value: 'No' }];

    //Parent Partner List
    $scope.manageParentPartnerList = [];
    $scope.initManageParentPartner = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageParentPartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getParentPartner(obj);
    };

    $scope.managePartner = {};
    $scope.managePartnerList = [];
    $scope.initManagePartner = function () {
      $scope.initManageParentPartner();
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);
    };
    $scope.initManagePartner();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.managePartnerList.push($scope.inserted);
    };

    $scope.createPartner = function (managePartner) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createPartner");
      console.log(managePartner);
      console.log(managePartner.name);
      console.log(managePartner.code);
      console.log(managePartner.contact);
      //console.log(managePartner.description);

      var obj = {};
      obj.params = {};
      obj.params.name = managePartner.name;
      obj.params.code = managePartner.code;
      obj.params.contact = managePartner.contact;
      obj.params.parentid = managePartner.parent?managePartner.parent.id:null;
      // obj.params.isparent = managePartner.isparent.value === 'Yes' ? true : false;
      obj.params.isparent = managePartner.isparent;
      //obj.params.description = managePartner.description;
      console.log('obj.params',obj.params);

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartner = {};
        toastr.success('New Partner has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Partner successfully created.");
        $scope.initManagePartner();

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      partnerService.createPartner(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/account/partner/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deletePartner = function (res) {
      console.log("Inside deletePartner");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Partner has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManagePartner();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        partnerService.deletePartner(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (partner) {
      console.log("Inside editPartner");
      console.log(partner);
      // $scope.managePartner.id = $scope.managePartner.id;
      // $scope.managePartner.name = state.name;
      // $scope.managePartner.description = state.description;
      // $scope.managePartner.created = state.created;
      // $scope.managePartner.lastupdated = state.lastupdated;
      $scope.managePartner = partner;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.savePartner = function (managePartner, id) {

      console.log("Inside savePartner");
      console.log(managePartner);
      console.log(id);

      if (id === undefined) {
        $scope.createPartner(managePartner);
      } else {

        var obj = {};
        obj.params = {};
        obj.params.id = id;
        obj.params.name = managePartner.name;
        obj.params.code = managePartner.code;
        obj.params.contact = managePartner.contact;
        obj.params.parentid = managePartner.parent?managePartner.parent.id:null;
        //obj.params.userid = managePartner.userid?managePartner.userid:null;
        obj.params.isparent = managePartner.isparent;
        
        console.log('obj.params',obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartner = {};
          toastr.success('Partner has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManagePartner();

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        };
        partnerService.savePartner(obj);

      }

    };
    $scope.showStatus = function() {
      var selected = $filter('filter')($scope.statuses, {value: $scope.user.status});
      return ($scope.user.status && selected.length) ? selected[0].text : 'Not set';
    };

    $scope.userAccess = function(managePartner){
      console.log('Inside userAccess');
      console.log('managePartner',managePartner);

      var obj = {};
      obj.params = {};
      obj.params.username = managePartner.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=managePartner.name;
      obj.params.credentials.mobile=managePartner.contact?managePartner.contact:null;
      obj.params.credentials.role = managePartner.isparent?9:13;
      obj.params.credentials.partner = managePartner;
      obj.params.challenges = managePartner.parentid;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        managePartner.userid = result.id;
        $scope.savePartner(managePartner,managePartner.id);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.partnerSignup(obj);

      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.partner')
    .service('partnerService', partnerService);

  /** @ngInject */
  function partnerService(Partner) {
    var getPartner = function (obj) {

      Partner.find({
        filter: {
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getParentPartner = function (obj) {

      Partner.find({
        filter: {
          where: {
            isparent: true
          },
          include: ["user","parent"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getPartnerStaff = function (obj) {

      Partner.find({
        filter: {
          where: {
            parentid: obj.params.parentid
          },
          include: ["user"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createPartner = function (obj) {
      var date = new Date();

      Partner.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deletePartner = function (obj) {

      Partner.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var savePartner = function (obj) {
      var date = new Date();

      Partner.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        isparent: obj.params.isparent,
        parentid: obj.params.parentid,
        userid: obj.params.userid
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var unbindPartner = function (obj) {
      var date = new Date();

      Partner.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getPartner: getPartner,
      createPartner: createPartner,
      deletePartner: deletePartner,
      savePartner: savePartner,
      getParentPartner: getParentPartner,
      unbindPartner: unbindPartner,
      getPartnerStaff: getPartnerStaff
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.roles')
      .controller('RolesPageCtrl', RolesPageCtrl);

  /** @ngInject */
  function RolesPageCtrl($scope, $filter, editableOptions, editableThemes,
    roleService,toastr,$uibModal ) {
    console.log("Inside RolesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteRole(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;


    $scope.manageRole={};
    $scope.manageRolesList=[];
    $scope.initManageRoles = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageRolesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        roleService.getRoles(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageRoles();

    $scope.addRole = function (){
      //genericModalService.show('modules/modals/addRole.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageRolesList.push($scope.inserted);
    };

    $scope.createRole = function(manageRole) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createRole");
      console.log(manageRole.name);
      console.log(manageRole.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageRole.name;
      obj.params.description = manageRole.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRole = {};
        toastr.success('New Role has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Role successfully created.");
          $scope.initManageRoles();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      roleService.createRole(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/account/roles/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteRole = function (res){
      console.log("Inside deleteRole");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Role has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Role successfully deleted.");
              $scope.initManageRoles();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            roleService.deleteRole(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editRole = function (role){
      console.log("Inside editRole");
      console.log(role);
      // $scope.manageRole.id = $scope.manageRole.id;
      // $scope.manageRole.name = role.name;
      // $scope.manageRole.description = role.description;
      // $scope.manageRole.created = role.created;
      // $scope.manageRole.lastupdated = role.lastupdated;
      $scope.manageRole = role;
      genericModalService.show('modules/modals/addRole.html',$scope);
    }

    $scope.saveRole = function (manageRole, id){

      console.log("Inside saveRole");
      console.log(manageRole);
      console.log(id);

      if (id===undefined){
        $scope.createRole(manageRole);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageRole
      obj.params.id = id;
      // obj.params.name = $scope.manageRole.name;
      // obj.params.description = $scope.manageRole.description;
      //obj.params.created = $scope.manageRole.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRole = {};
        toastr.success('Role has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Role successfully Updated.");
        $scope.initManageRoles();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      roleService.saveRole(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.roles')
    .service('roleService', roleService);

  /** @ngInject */
  function roleService(Role) {
    var getRoles = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Role.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Role.create({
        name:obj.params.name,
        description:obj.params.description,
        created: date,
        modified: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Role.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveRole = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Role.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        modified: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getRoles: getRoles,
      createRole: createRole,
      deleteRole: deleteRole,
      saveRole: saveRole
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier')
    .controller('SupplierPageCtrl', SupplierPageCtrl);

  /** @ngInject */
  function SupplierPageCtrl($scope, $filter, editableOptions, editableThemes,
    supplierService, toastr, $uibModal,userService) {
    console.log("Inside SupplierPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteSupplier(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;


    $scope.manageSupplier = {};
    $scope.manageSupplierList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function() {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        contact: null,
        //description:null,
      };
      $scope.manageSupplierList.push($scope.inserted);
    };

    $scope.createSupplier = function(manageSupplier) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createSupplier");
      console.log(manageSupplier);
      console.log(manageSupplier.name);
      console.log(manageSupplier.code);
      console.log(manageSupplier.contact);
      //console.log(manageSupplier.description);

      var obj = {};
      obj.params = {};
      obj.params.name = manageSupplier.name;
      obj.params.code = manageSupplier.code;
      obj.params.contact = manageSupplier.contact;
      obj.params.rate = manageSupplier.rate;
      //obj.params.description = manageSupplier.description;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplier = {};
        toastr.success('New Supplier has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Supplier successfully created.");
        $scope.initManageStates();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      supplierService.createSupplier(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/account/supplier/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteSupplier = function(res) {
      console.log("Inside deleteSupplier");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Supplier has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageStates();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.deleteSupplier(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function(supplier) {
      console.log("Inside editSupplier");
      console.log(supplier);
      // $scope.manageSupplier.id = $scope.manageSupplier.id;
      // $scope.manageSupplier.name = state.name;
      // $scope.manageSupplier.description = state.description;
      // $scope.manageSupplier.created = state.created;
      // $scope.manageSupplier.lastupdated = state.lastupdated;
      $scope.manageSupplier = supplier;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveSupplier = function(manageSupplier, id) {

      console.log("Inside saveSupplier");
      console.log(manageSupplier);
      console.log(id);

      if (id === undefined && manageSupplier.id === undefined) {
        $scope.createSupplier(manageSupplier);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSupplier;
        obj.params.id = id?id:manageSupplier.id;
        //obj.params.contact = manageSupplier.contact;
        // obj.params.name = $scope.manageSupplier.name;
        // obj.params.description = $scope.manageSupplier.description;
        //obj.params.created = $scope.manageSupplier.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSupplier = {};
          toastr.success('Supplier has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageStates();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.saveSupplier(obj);

        //$scope.modal.hide();
      }

    };

    $scope.userAccess = function(manageSupplier){
      console.log('Inside userAccess');
      console.log('manageSupplier',manageSupplier);

      var obj = {};
      obj.params = {};
      obj.params.username = manageSupplier.code;
      obj.params.password = "password";
      obj.params.credentials={};
      obj.params.credentials.name=manageSupplier.name;
      obj.params.credentials.mobile=manageSupplier.contact?manageSupplier.contact:null;
      obj.params.credentials.role = 10; //Supplier Role id
      obj.params.credentials.supplier = manageSupplier;
      //obj.params.challenges = manageSupplier.id;
      
      console.log('obj.params',obj.params);


      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        manageSupplier.userid = result.id;
        $scope.saveSupplier(manageSupplier);
        toastr.success('Thank you! \n Your access request is successfully submited to Administration.\n Please wait until they approve your request.', 'SUCCESS');
      };

      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);

        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else if (err.status === 422) {
          toastr.error('Username or Mobile Already Exists', 'ERROR');
        } else {
          toastr.error('Unauthorized Access', 'ERROR');
        }
      };

      userService.partnerSignup(obj);

      };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.supplier')
    .service('supplierService', supplierService);

  /** @ngInject */
  function supplierService(Supplier) {
    var getSupplier = function(obj) {
      Supplier.find().$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createSupplier = function(obj) {
      var date = new Date();

      Supplier.create({
        name: obj.params.name,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        contact: obj.params.contact,
        rate: obj.params.rate

      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };


    var deleteSupplier = function(obj) {

      Supplier.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveSupplier = function(obj) {
      var date = new Date();

      Supplier.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        lastupdated: date,
        contact: obj.params.contact,
        code: obj.params.code,
        rate: obj.params.rate,
        userid: obj.params.userid
      }).$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {
        obj.onFailure(err);
      });
    };

    var unbindSupplier = function (obj) {
      var date = new Date();

      Supplier.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getSupplier: getSupplier,
      createSupplier: createSupplier,
      deleteSupplier: deleteSupplier,
      saveSupplier: saveSupplier,
      unbindSupplier:unbindSupplier
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping')
    .controller('UsermappingPageCtrl', UsermappingPageCtrl);

  /** @ngInject */
  function UsermappingPageCtrl($scope, $filter, editableOptions, editableThemes,
    usermappingService, toastr, $uibModal, userService, roleService, zoneService, areaService) {
    console.log("Inside UsermappingPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteUsermapping(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;

    //Getting States
    $scope.manageUserList = [];
	$scope.manageRoleList = [];
	$scope.manageAreaList = [];
    $scope.manageZonesList = [];
    
	$scope.initManageUser = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUserList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsers(obj);
    };

    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
	
	$scope.initManageRole = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
	
	$scope.initManageArea = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageUsermappingList = [];
    $scope.manageUsermapping = {};
    $scope.initManageUsermapping = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsermappingList = result;
        $scope.initManageUser();
		$scope.initManageRole();
		$scope.initManageArea();
        $scope.initManageZones();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      usermappingService.getUsermapping(obj);
    };
    $scope.initManageUsermapping();

    $scope.addUsermapping = function() {
      //genericModalService.show('modules/modals/addUsermapping.html',$scope);
      $scope.inserted = {
        //name: null,
        //description: null,
      };
      $scope.manageUsermappingList.push($scope.inserted);
    };

    $scope.createUsermapping = function(manageUsermapping) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUsermapping");
      console.log(manageUsermapping);

      var obj = {};
      obj.params = {};
      obj.params = manageUsermapping;
      // obj.params.name = manageUsermapping.name;
      // obj.params.description = manageUsermapping.description;
      // obj.params.zoneid = manageUsermapping.zones
      // obj.params.stateid = manageUsermapping.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsermapping = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageUsermapping();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      usermappingService.createUsermapping(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/account/usermapping/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteUsermapping = function(res) {
      console.log("Inside deleteUsermapping");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          $scope.initManageUsermapping();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        usermappingService.deleteUsermapping(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(usermapping) {
      console.log("Inside editArea");
      console.log(usermapping);
      // $scope.manageUsermapping.id = $scope.manageUsermapping.id;
      // $scope.manageUsermapping.name = state.name;
      // $scope.manageUsermapping.description = state.description;
      // $scope.manageUsermapping.created = state.created;
      // $scope.manageUsermapping.lastupdated = state.lastupdated;
      $scope.manageUsermapping = state;
      genericModalService.show('modules/modals/addUsermapping.html', $scope);
    }

    $scope.saveUsermapping = function(manageUsermapping, id) {

      console.log("Inside saveUsermapping");
      console.log(manageUsermapping);
      console.log(id);

      console.log(manageUsermapping.zones);
      console.log(manageUsermapping.role);
	  console.log(manageUsermapping.user);
	  console.log(manageUsermapping.area);


      if (id === undefined) {
        $scope.createUsermapping(manageUsermapping);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageUsermapping;
        obj.params.id = id;
        // obj.params.name = $scope.manageUsermapping.name;
        // obj.params.description = $scope.manageUsermapping.description;
        //obj.params.created = $scope.manageUsermapping.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageUsermapping = {};
          toastr.success('Area has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageUsermapping();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        usermappingService.saveUsermapping(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showUsers = function(user) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (user && $scope.manageUserList.length) {
        var selected = $filter('filter')($scope.manageUserList, {
          id: user.id
        },true);
        return selected.length ? selected[0].username : 'Not set';
      } else return 'Not set'
    };
	
	$scope.showRoles = function(role) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (role && $scope.manageRoleList.length) {
        var selected = $filter('filter')($scope.manageRoleList, {
          id: role.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };
	
	$scope.showAreas = function(area) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (area && $scope.manageAreaList.length) {
        var selected = $filter('filter')($scope.manageAreaList, {
          id: area.id
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.account.usermapping')
    .service('usermappingService', usermappingService);

  /** @ngInject */
  function usermappingService(Usermapping) {
    var getUsermapping = function(obj) {

    Usermapping.find({
      filter:{
        include:["user","zone","role","area"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var createUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Usermapping.create({
      userid: obj.params.user,
	  zoneid: obj.params.zone,
	  areaid: obj.params.area,
	  roleid: obj.params.role
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  var deleteUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Usermapping.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveUsermapping = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});


    Usermapping.prototype$updateAttributes({
      id: obj.params.id,
      userid: obj.params.user,
	  zoneid: obj.params.zone,
	  areaid: obj.params.area,
	  roleid: obj.params.role
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getUsermapping: getUsermapping,
      createUsermapping: createUsermapping,
      deleteUsermapping: deleteUsermapping,
      saveUsermapping: saveUsermapping
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.account.users')
    .controller('UsersPageCtrl', UsersPageCtrl);

  /** @ngInject */
  function UsersPageCtrl($scope, $filter, editableOptions, editableThemes,
    userService, toastr, $uibModal, roleService, $rootScope, rolemappingService ) {
    console.log("Inside UsersPageCtrl");
//zoneService, partnerService, collectorService, shopService, supplierService
    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteUser(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 25;
    $scope.status = [{value:'Active'},{value:'Inactive'}];
    $scope.emailVerified = [{value:true,text:'Yes'},{value:false,text:'No'}];
    $scope.shopTypeFilter = [{value:'5/5'},{value:'100%'},{value:''}];

    //Getting Zones
    $scope.manageZonesList = [];
    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };
    //Getting Roles
    $scope.manageRoleList=[];
    $scope.initManageRole = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageRoleList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      roleService.getRoles(obj);
    };
    //Getting Partners
    $scope.managePartnerList=[];
    $scope.initManagePartner = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managePartnerList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        partnerService.getPartner(obj);
    };
    //Getting Users   
    $scope.manageUsersList = [];
    $scope.manageUser = {};
    $scope.initManageUsers = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUsersList = result;
        // $scope.initManageZones();
        $scope.initManageRole();
        // $scope.initManagePartner();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      userService.getUsers(obj);
    };
    $scope.initManageUsers();

    $scope.addUser = function() {
      //genericModalService.show('modules/modals/addUser.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageUsersList.push($scope.inserted);
    };

    $scope.createUser = function(manageUser) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createUser");
      console.log(manageUser);

      var obj = {};
      obj.params = {};
      obj.params = manageUser;
      // obj.params.name = manageUser.name;
      // obj.params.description = manageUser.description;
      // obj.params.zoneid = manageUser.zones
      // obj.params.stateid = manageUser.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('New User has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New User successfully created.");
        $scope.initManageUsers();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      userService.createUser(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.partnerRecordid = null;
    $scope.collectorRecordid = null;
    $scope.shopRecordid = null;
    $scope.supplierRecordid = null;
    $scope.confirmDelete = function(id,partnerRecordid,collectorRecordid,shopRecordid,supplierRecordid) {
      $scope.open('app/pages/account/users/modals/dangerModal.html');
      console.log('partnerRecordid',partnerRecordid);
      console.log('collectorRecordid',collectorRecordid);
      console.log('shopRecordid',shopRecordid);
      console.log('supplierRecordid',supplierRecordid);
      
      $scope.deleteId = id;
      if (typeof partnerRecordid!=="undefined"){
        $scope.partnerRecordid = partnerRecordid;
      }
      if (typeof collectorRecordid!=="undefined"){
        $scope.collectorRecordid = collectorRecordid;
      }
      if (typeof shopRecordid!=="undefined"){
        $scope.shopRecordid = shopRecordid;
      }
      if (typeof supplierRecordid!=="undefined"){
        $scope.supplierRecordid = supplierRecordid;
      }
    };

    $scope.deleteUser = function(res) {
      console.log("Inside deleteUser");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        if ( $scope.partnerRecordid !== null ) {
          var objParnter = {};
          objParnter.params = {};
          objParnter.params.id = $scope.partnerRecordid;

          objParnter.onSuccess = function (result) {
            console.log("Inside SUCCESS");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Partner");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Partner");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objParnter.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          partnerService.unbindPartner(objParnter);

        } else if ($scope.collectorRecordid !== null) {

          var objCollector = {};
          objCollector.params = {};
          objCollector.params.id = $scope.collectorRecordid;

          objCollector.onSuccess = function (result) {
            console.log("Inside SUCCESS Collector");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Collector");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Collector");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objCollector.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          collectorService.unbindCollector(objCollector);

        } else if ($scope.shopRecordid !== null) {

          var objShop = {};
          objShop.params = {};
          objShop.params.id = $scope.shopRecordid;

          objShop.onSuccess = function (result) {
            console.log("Inside SUCCESS Collector");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Shop");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Shop");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objShop.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          shopService.unbindShopStaff(objShop);

        } else if ($scope.supplierRecordid !== null) {

          var objSupplier = {};
          objSupplier.params = {};
          objSupplier.params.id = $scope.supplierRecordid;

          objSupplier.onSuccess = function (result) {
            console.log("Inside SUCCESS Supplier");
            console.log(result);

            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result) {
              console.log("Inside SUCCESS Supplier");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function (err) {
              console.log("Inside Failure Supplier");
              console.log(err);
            };

            userService.deleteUser(obj);

          };
          objSupplier.onFailure = function (err) {
            console.log("Inside Failure");
            console.log(err);
          };

          supplierService.unbindSupplier(objSupplier);

        } else if (($scope.collectorRecordid === null) && ($scope.partnerRecordid === null) && ($scope.shopRecordid === null) && ($scope.supplierRecordid === null)) {
          var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function(result) {
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('User has been deleted successfully!', 'SUCCESS');
              $scope.initManageUsers();
            };
            obj.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
            };
            userService.deleteUser(obj);
        }


      } else {
        console.log('Not sure!');
      }

    }

    $scope.editUser = function(state) {
      console.log("Inside editUser");
      console.log(state);
      // $scope.manageUser.id = $scope.manageUser.id;
      // $scope.manageUser.name = state.name;
      // $scope.manageUser.description = state.description;
      // $scope.manageUser.created = state.created;
      // $scope.manageUser.lastupdated = state.lastupdated;
      $scope.manageUser = state;
      genericModalService.show('modules/modals/addUser.html', $scope);
    }

    $scope.saveUser = function(manageUser, userid,item) {

      console.log("Inside saveUser");
      console.log(manageUser);
      console.log(userid);

      if (userid === undefined) {
        $scope.createUser(manageUser);
      } else {

        var objRoleMap = {};
        objRoleMap.params = {};
        objRoleMap.params.principalid = userid;
        objRoleMap.params.roleid = manageUser.role;

  
        objRoleMap.onSuccess = function(result) {
          console.log("Inside SUCCESS objRoleMap");
          console.log(result);
         
            var objUpdateRole = {};
            objUpdateRole.params = {};
            if (result[0]){
            objUpdateRole.params.id = result[0].id;
            }
            objUpdateRole.params.userid = userid;
            objUpdateRole.params.roleid = manageUser.role;
            objUpdateRole.onSuccess = function(result) {
              console.log("Inside SUCCESS objUpdateRole");
              console.log(result);

              var obj = {};
              obj.params = {};
              obj.params.id = userid;
              obj.params.credentials ={};
              obj.params.credentials.name = manageUser.name;
              obj.params.credentials.mobile = manageUser.mobile;
              obj.params.credentials.days = manageUser.days;
              obj.params.credentials.zonemap = manageUser.zonemap;
              obj.params.credentials.role = manageUser.role;
              obj.params.credentials.partner = manageUser.partner;
              if (manageUser.shopType!=''){
                obj.params.credentials.shopType = manageUser.shopType;
              }
              if (typeof item.credentials.shop !== "undefined") {
                obj.params.credentials.shop = item.credentials.shop;
              }
              if (typeof item.credentials.supplier !== "undefined") {
                obj.params.credentials.supplier = item.credentials.supplier;
              }
              obj.params.emailVerified = manageUser.emailVerified;

              console.log(obj.params);
      
              obj.onSuccess = function(result) {
                console.log("Inside SUCCESS");
                console.log(result);
                $scope.manageUser = {};
                toastr.success('User has been updated successfully!', 'SUCCESS');
                $scope.initManageUsers();
      
              }
              obj.onFailure = function(err) {
                console.log("Inside Failure");
                console.log(err);
                if (err.status === -1) {
                  toastr.error('NO INTERNET CONNECTION', 'Error');
                } else {
                  toastr.error(err.data.error.message, 'Error');
                }
              }
              userService.saveUser(obj);
            }
            objUpdateRole.onFailure = function(err) {
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1) {
                toastr.error('NO INTERNET CONNECTION', 'Error');
              } else {
                toastr.error(err.data.error.message, 'Error');
              }
            };
            rolemappingService.saveRolemapping(objUpdateRole);
        };
        objRoleMap.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            toastr.error(err.data.error.message, 'Error');
          }
        };
        rolemappingService.getRolemappingsbyID(objRoleMap);
      }
    }

    $scope.showStatus = function(status) {
        var selected = [];
        if(typeof status==="object") {
          //selected = $filter('filter')($scope.status, {value: status.value});
          return status.value ? status.value : 'Not set';
        }else{
            return status;
        }
      };

      $scope.showAccess = function(emailVerified) {
          var selected = [];
          if(typeof emailVerified==="object") {
            //selected = $filter('filter')($scope.status, {value: status.value});
            return emailVerified.value? emailVerified.value : 'No';
          }else{
              return emailVerified?'Yes' : 'No';
          }
        };

        $scope.showRoles = function(role) {
          if (role && $scope.manageRoleList.length) {
            var selected = $filter('filter')($scope.manageRoleList, {
              id: role
            },true);
            return selected.length ? selected[0].name : 'Not set';
          } else return 'Not set';
        };

        $scope.showZones = function(zone) {
          if (zone && $scope.manageZonesList.length) {
            var selected = $filter('filter')($scope.manageZonesList, {
              id: zone
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.showPartners = function(partner) {
          if (partner && $scope.managePartnerList.length) {
            var selected = $filter('filter')($scope.managePartnerList, {
              id: partner
            },true);
            return selected.length ? selected[0].code : 'Not Set';
          } else return 'Not set';
        };

        $scope.generatePassword = function() {
          var length = 8,
              charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
              retVal = "";
          for (var i = 0, n = charset.length; i < length; ++i) {
              retVal += charset.charAt(Math.floor(Math.random() * n));
          }
          return retVal;
      };

      $scope.newPassword="";

      $scope.openPassword = function(page, size) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: page,
          scope: $scope,
          size: size
        });
        modalInstance.result.then(function(selectedItem) {
          //$scope.selected = selectedItem;
          $scope.deleteUser(selectedItem);
          console.log("hurry = " + selectedItem);
        }, function() {
          console.log('Modal dismissed at: ' + new Date());
        });
      };

    $scope.resetPassword = function (userid) {
      console.log('userid', userid);
      $scope.newPassword = $scope.generatePassword();
      console.log('newPassword',$scope.newPassword);

      var obj = {};
      obj.params = {};
      obj.params.id = userid;
      obj.params.password = $scope.newPassword;

      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageUser = {};
        toastr.success('User has been updated successfully!', 'SUCCESS');
        $scope.initManageUsers();
        $scope.openPassword('app/pages/account/users/modals/passwordModal.html');

      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else {
          toastr.error(err.data.error.message, 'Error');
        }
      };
      userService.resetPassword(obj);

    };



    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.assignagent.assignAgent')
    .controller('assignAgentPageCtrl', assignAgentPageCtrl);

  /** @ngInject */
  function assignAgentPageCtrl($scope, editableOptions, editableThemes,
     toastr, $uibModal, userService, caseService, $rootScope) {
    console.log("Inside assignAgentPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOfficer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


    $scope.smartTablePageSize = 100;
    $scope.manageAgent = {};
    $scope.manageAgentsList = [];
    $scope.initManageUsers = function () {
      console.log('Inside initManageUsers');
      console.log('$rootScope.userData.id', $rootScope.userData.id);

        var obj = {};

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageAgentsList = result;
          $scope.isEdit = false;
          $scope.isAssignNewCase = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getUserLoanSync(obj);

    };

    $scope.manageCase = {};
    $scope.manageCasesList = [];

    $scope.initManageCases = function () {
      var obj = {};
      obj.params={};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCasesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      caseService.getCase(obj);
    };


    $scope.selectedCaseList = [];
    $scope.notSelectedCaseList = [];
    $scope.viewAgentsDetails = function (manageAgent) {
      console.log("Inside editMachine");
      $scope.isEdit = true;

      $scope.manageAgent = manageAgent;
      console.log($scope.manageAgent)
      $scope.selectedCaseList = [];
      $scope.notSelectedCaseList = [];
      $scope.getSelectedCases(manageAgent);
      console.log($scope.selectedCaseList);
      $scope.getNotSelectedCases(manageAgent);
      console.log($scope.notSelectedCaseList);
    };

    $scope.getSelectedCases = function (manageAgent) {
      if (manageAgent.credentials.casemap) {
        var obj = {};
        obj.params = {};
        obj.params.casemap = manageAgent.credentials.casemap;
        console.log(manageAgent.credentials.casemap);

        obj.onSuccess = function (result) {
          console.log("Inside getSelectedCases SUCCESS");
          console.log(result);
          $scope.selectedCaseList = result;

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };
        caseService.findAssignedCase(obj);
      }
    };

    $scope.getNotSelectedCases = function (manageAgent) {

        var obj = {};
        obj.params = {};
        obj.params.casemap = manageAgent.credentials.casemap?manageAgent.credentials.casemap:[];

        console.log('obj.params', obj.params);
        obj.onSuccess = function (result) {
          console.log("Inside getNotSelectedCases SUCCESS");
          console.log(result);
          $scope.notSelectedCaseList = result;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
        };

        caseService.findNotAssignedCase(obj);      

    };


    $scope.removeCase = function (res) {
      console.log("Inside removeCase");
      console.log(res.id);

      if (res) {

        var arr = $scope.manageAgent.credentials.casemap;
        var index = arr.indexOf(res.id);
        if (index > -1) {
          arr.splice(index, 1);
        }
        $scope.manageAgent.credentials.casemap = arr;
        console.log($scope.manageAgent.credentials)

        var obj = {};
        obj.params = {};
        obj.params.credentials = {};
        obj.params.id = $scope.manageAgent.id
        obj.params.credentials = $scope.manageAgent.credentials
        obj.onSuccess = function (result) {
          console.log("Inside removeCase SUCCESS");
          console.log(result);
          toastr.success('Case has been removed successfully!', 'SUCCESS');
          $scope.viewAgentsDetails($scope.manageAgent)
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.updateCaseMap(obj);
      } else {
        console.log('Not sure!');
      }
    }
    $scope.addCase = function () {
      $scope.isAssignNewCase = true;
    };

    $scope.assignCase= function (res) {
      console.log("Inside assignCase");
      console.log(res.id);

      if (res) {


        var arr = $scope.manageAgent.credentials.casemap ? $scope.manageAgent.credentials.casemap : [];
        arr.push(res.id);
        $scope.manageAgent.credentials.casemap = arr;
        console.log($scope.manageAgent.credentials)
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.manageAgent.id;
        obj.params.credentials = $scope.manageAgent.credentials;
        obj.onSuccess = function (result) {
          console.log("Inside assignCase SUCCESS");
          console.log(result);
          toastr.success('Case has been assigned successfully!', 'SUCCESS');
          $scope.viewAgentsDetails($scope.manageAgent)
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        userService.updateCaseMap(obj);
      } else {
        console.log('Not sure!');
      }
    }
    $scope.viewAgents = function (items){
      $scope.manageAgentsList = items;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.init = function(){
      $scope.initManageUsers();
    };

    $scope.init();

  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.assignagent.assignAgent')
    .service('assignAgentService', assignAgentService);

  /** @ngInject */
  function assignAgentService(Collectormap) {

    var getCollectormaps = function(obj) {

      Collectormap.find({
        filter:{
          where: {
            vipid:obj.params.headid
          },
          include: ["head","staff"]
        }
      }).$promise.then(function(data) {
        Collectormap.find({
          filter:{
            where: {
              headid:data[0].headid
            },
            include: ["head","staff"],
          }
        }).$promise.then(function(data) {
          obj.onSuccess(data);
        }, function(err) {
          obj.onFailure(err);
        });
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return{
      getCollectormaps: getCollectormaps
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.clerkSetup.case')
    .controller('CasePaymentPageCtrl', CasePaymentPageCtrl);

  /** @ngInject */
  function CasePaymentPageCtrl($scope, $filter, editableOptions, editableThemes,
    caseService, customerService, toastr, $uibModal, $state,
    $rootScope, baConfig, paymentImportService) {
    console.log("Inside CasePaymentPageCtrl");

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};
    $scope.dpOpenStatus1 = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.setDpOpenStatus1 = function (id) {
      $scope.dpOpenStatus1[id] = true;
    };

    $scope.opened = {};

    $scope.open = function ($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened[elementOpened] = !$scope.opened[elementOpened];
    };

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCase(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    if (typeof $rootScope.userData.credentials.caseType !== "undefined") {
      $scope.caseTypeFilter = [{
        value: $rootScope.userData.credentials.caseType
      }];
    } else {
      $scope.caseTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }

    $scope.openDeleteOnlineCase = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlineCase(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };



    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;



    $scope.init = function () {
      // $scope.initManageZones();
      // $scope.initManagePartner();
      // $scope.initManageAreas();
      // $scope.initManageGames();
      // // $scope.initManageSupplier();
      // $scope.initManageSites();
    };
    // $scope.init();

    $scope.manageCase = {};
    $scope.manageCaseList = [];
    $scope.customerList = [];
    $scope.reportFilter = {};
    $scope.initManageCase = function (reportFilter) {
      //$scope.manageCase = {};
      $scope.isEditCustomer = false;
      $scope.isEditPayment = false;
      $scope.originalCustomer = {};
      var obj = {};
      obj.params = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCaseList = result;

        if ($scope.manageCaseList.length) {
          for (var i = 0; i < $scope.manageCaseList.length; i++) {
            // console.log('Inside Loop');
            var interval = 0;
            var days = 0;
            if ($scope.manageCaseList[i].terms.length) {
              for (var index = 0; index < $scope.manageCaseList[i].terms.length; index++) {
                if ($scope.manageCaseList[i].terms[index].status === true) {
                  interval = $scope.manageCaseList[i].terms[index].interval;
                }
              }

              if ($scope.manageCaseList[i].iamount !== $scope.manageCaseList[i].tamount) {
                days = parseFloat($scope.manageCaseList[i].amount) / parseFloat($scope.manageCaseList[i].tamount);
                days = days * interval;
              } else {
                days = 365 * 2;
              }
              // console.log('days',days);

              if (days) {
                var startDate = new Date($scope.manageCaseList[i].reldate);
                var endDate = new Date(startDate.getTime() + (days * 24 * 60 * 60 * 1000));
                $scope.manageCaseList[i].maturityDate = endDate;
              }
            }
          }
        }
        //$scope.initManageOnlineCase();
        $scope.isEdit = false;

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      caseService.getCase(obj);

    };
    $scope.initManageCase($scope.reportFilter);

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/operational/case/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteCase = function (res) {
      console.log("Inside deleteCase");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Case has been deleted successfully!', 'SUCCESS');

          $scope.initManageCase($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        caseService.deleteCase(obj);
      } else {
        console.log('Not sure!');
      }

    };


    $scope.saveCase = function (manageCase) {

      console.log("Inside saveCase");
      console.log($scope.manageCase);

      if (manageCase.id === undefined) {
        // $scope.createCase(manageCase);
        toastr.error('Case No. does not Exists', 'Error');
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageCase;

        if ($scope.originalCustomer.code !== manageCase.customer.code) {
          obj.params.custid = manageCase.customer.id;
          obj.params.custcode = manageCase.customer.code;
        }

        if (manageCase.reldate) {
          var d = new Date(manageCase.reldate),
            y = d.getFullYear(),
            m = d.getMonth() + 1;
          var selectedRelDate = y + '-' + m + '-' + d.getDate();

          obj.params.reldate = selectedRelDate;
        }

        if (manageCase.closedate) {
          var d1 = new Date(manageCase.closedate),
            y1 = d1.getFullYear(),
            m1 = d1.getMonth() + 1;
          var selectedCloseDate = y1 + '-' + m1 + '-' + d1.getDate();

          obj.params.closedate = selectedCloseDate;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageCase = {};
          toastr.success('Case has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageCase($scope.reportFilter);

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        caseService.saveCase(obj);
      }

    };

    $scope.showPartner = function (partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partner.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };



    $scope.getScheduleDate = function (adate) {
      var mm = adate.getMonth() + 1; // getMonth() is zero-based
      var dd = adate.getDate();

      if (dd <= 0) {
        var d1 = adate;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        adate.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
      ].join('-');
    };

    var dashboardColors = baConfig.colors;
    //var $element;
    $scope.editCase = function (manageCase) {
      console.log("Inside editCase");
      $scope.manageCase = {};
      $scope.manageCase = manageCase;
      $scope.originalCustomer = manageCase.customer;
      console.log($scope.manageCase);
      $scope.getSchedule();
    };
    $scope.scheduleEntry = [];
    $scope.interval = 0;
    $scope.getSchedule = function () {

      $scope.manageCase.totalPaid = $scope.getTotalpayment($scope.manageCase.payment) + parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.tamount * ($scope.manageCase.firstm + $scope.manageCase.lastm));
      $scope.manageCase.amountDue = $scope.manageCase.amount - $scope.manageCase.totalPaid;

      $scope.managePaymentList = $scope.manageCase.payment;


      $scope.scheduleEntry = [];
      $scope.interval = 0;
      if ($scope.manageCase.terms.length) {
        for (var index = 0; index < $scope.manageCase.terms.length; index++) {
          if ($scope.manageCase.terms[index].status === true) {
            $scope.interval = $scope.manageCase.terms[index].interval;
          }
        }

        if ($scope.manageCase.iamount !== $scope.manageCase.tamount) {
          $scope.terms = $scope.manageCase.amount / $scope.manageCase.tamount;
          $scope.terms = $scope.terms * $scope.interval;
        } else {
          $scope.terms = 365 * 2;
        }
        console.log('$scope.interval', $scope.interval);
        console.log('terms', $scope.terms);
        if ($scope.terms) {
          //var date = new Date($scope.manageCase.reldate);

          var days = $scope.terms; // Days you want to Add
          var startDate = new Date($scope.manageCase.reldate);
          // var syear = startDate.getFullYear();
          // var smonth = startDate.getMonth()+1;
          // var sday = startDate.getDate();
          $scope.eDate = new Date(startDate.getTime() + (days * 24 * 60 * 60 * 1000));
          // var eday =endDate.getDate();
          // var emonth=endDate.getMonth()+1;
          // var eyear=endDate.getFullYear();

          $scope.sDate = $scope.getScheduleDate(startDate);
          // $scope.eDate = $scope.getScheduleDate(endDate);

          console.log('startDate', $scope.sDate);
          console.log('endDate', $scope.eDate);

          for (var i = 0; i < $scope.terms; i++) {
            var entryDate;
            if (i === 0) {
              entryDate = new Date(startDate.getTime());
            } else {
              entryDate = new Date(entryDate.getTime() + ($scope.interval * 24 * 60 * 60 * 1000));
            }


            //var scheduleDate =

            var entry = {};
            entry.title = "Schedule: " + $scope.manageCase.tamount;
            entry.start = $scope.getScheduleDate(entryDate);
            // entry.color = '#C39BD3';
            entry.color = '#FFF';
            entry.allDay = true;
            $scope.scheduleEntry.push(entry);
          }

          console.log('scheduleEntry');
          console.log($scope.scheduleEntry);
        }



        if ($scope.manageCase.firstm) {
          for (var f = 0; f < $scope.manageCase.firstm; f++) {

            var firstmDate = new Date(new Date($scope.manageCase.reldate).getTime() + (f * 24 * 60 * 60 * 1000));
            var entryfirstm = {};
            entryfirstm.title = "First: " + $scope.manageCase.tamount;
            entryfirstm.start = $scope.getScheduleDate(firstmDate);
            entryfirstm.color = '#b9f2a1';
            entryfirstm.allDay = true;
            $scope.scheduleEntry.push(entryfirstm);
          }
        }

        if ($scope.manageCase.lastm) {
          for (var l = 0; l < $scope.manageCase.lastm; l++) {
            var lastmDate;
            if (l === 0) {
              lastmDate = new Date($scope.eDate.getTime() - ($scope.manageCase.lastm * 24 * 60 * 60 * 1000));
            } else {
              lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            }

            //var lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            var entrylastm = {};
            entrylastm.title = "Last: " + $scope.manageCase.tamount;
            entrylastm.start = $scope.getScheduleDate(lastmDate);
            entrylastm.color = '#b9f2a1';
            entrylastm.allDay = true;
            $scope.scheduleEntry.push(entrylastm);
          }
        }
      }

      if ($scope.manageCase.payment.length) {
        for (var n = 0; n < $scope.manageCase.payment.length; n++) {
          var entryPayment = {};
          entryPayment.title = "Payment 付: " + parseFloat($scope.manageCase.payment[n].amount).toFixed(2);
          entryPayment.start = $scope.getScheduleDate(new Date($scope.manageCase.payment[n].paydate));
          entryPayment.color = $scope.manageCase.payment[n].amount >= $scope.manageCase.tamount ? '#b9f2a1' : '#ff6666';
          entryPayment.allDay = true;
          $scope.scheduleEntry.push(entryPayment);
        }
      }

      if ($scope.manageCase.isdeposit) {
        var depositTerm = $scope.manageCase.deposit / $scope.manageCase.tamount;
        var depTermFull = Math.ceil(depositTerm);
        console.log('depositTerm', depositTerm);
        console.log('depTermFull', depTermFull);
        var check = depTermFull - depositTerm;
        if (check != 0 && check > 0.5) {
          check = check - 0.5;
          check = 0.5 - check;
        }
        console.log('check', check);
        for (var d = 0; d < depTermFull; d++) {
          var lastmDate;
          var title = "";
          var entrydeposit = {};

          if (d === 0) {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + depTermFull) * 24 * 60 * 60 * 1000));
            if (check != 0) {
              var amount = (parseFloat($scope.manageCase.tamount) * parseFloat(check)).toFixed(2);
              title = "Deposit: " + amount;
            } else {
              title = "Deposit: " + $scope.manageCase.tamount;
            }
          } else {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + d) * 24 * 60 * 60 * 1000));
            title = "Deposit: " + $scope.manageCase.tamount;
          }

          entrydeposit.title = title;
          entrydeposit.start = $scope.getScheduleDate(lastmDate);
          entrydeposit.color = '#C39BD3';
          entrydeposit.allDay = true;
          $scope.scheduleEntry.push(entrydeposit);
        }

      }





      // if ($scope.manageCase.firstm!=0){
      //   var entryfirstm = {};
      //   entryfirstm.title = $scope.manageCase.tamount;
      //   entryfirstm.start =   $scope.sDate;
      //   entryfirstm.color = '#b9f2a1';
      //   entryfirstm.allDay = true;
      //   $scope.scheduleEntry.push(entryfirstm);
      // }
      $scope.isEdit = true;
    };

    $scope.addCase = function () {
      console.log("Inside addCase");
      $scope.isEdit = true;
      $scope.manageCase = {};
      $scope.manageOnlineCaseList = [];
      $scope.manageMachinecaseList = [];
      console.log($scope.manageZonesList);
    };

    //Online Games

    $scope.addOnlineCase = function () {
      $scope.inserted = {
        caseid: $scope.manageCase.id,
        gameid: null,
        playtechid: null
      };
      $scope.manageOnlineCaseList.push($scope.inserted);
    };

    $scope.deleteOnlineCaseId = null;
    $scope.confirmOnlineCaseDelete = function (id) {
      $scope.openDeleteOnlineCase('app/pages/operational/case/modals/dangerOnlineGameModal.html');
      $scope.deleteOnlineCaseId = id;
    };

    $scope.deleteOnlineCase = function (res) {
      console.log("Inside deleteOnlineCase");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteOnlineCaseId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteOnlineCaseId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been deleted successfully!', 'SUCCESS');

          $scope.initManageOnlineCase();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineCase();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineCaseService.deleteOnlinecase(obj);
      }
    };

    // $scope.deleteMachinecaseId = null;
    // $scope.confirmMachinecaseDelete = function(id) {
    //   $scope.openDeleteMachinecase('app/pages/operational/case/modals/dangerMachineGameModal.html');
    //   $scope.deleteMachinecaseId = id;
    // };




    // $scope.updateInterest = function (value){
    //   $scope.manageCase.interest = value;
    //   switch ($scope.manageCase.interest) {
    //     case 'D':
    //       $scope.manageCase.iDAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.idaily / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iDAmount);
    //       break;
    //     case 'W':
    //       $scope.manageCase.iWAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.iweekly / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iWAmount);
    //       break;
    //     case 'M':
    //       $scope.manageCase.iMAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.imonthly / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iMAmount);
    //       break;
    //     case 'Y':
    //       $scope.manageCase.iYAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.iyearly / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iYAmount);
    //       break;
    //   }
    // };

    // $scope.updateTerm = function (value){
    //   $scope.manageCase.term = value;

    //   switch ($scope.manageCase.term) {
    //     case 'D':
    //     $scope.manageCase.tDAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tday;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tDAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //     break;
    //     case 'W':
    //     $scope.manageCase.tWAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tweek;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tWAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //       break;
    //     case 'M':
    //     $scope.manageCase.tMAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tmonth;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tMAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //       break;
    //     case 'Y':
    //     $scope.manageCase.tYAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tyear;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tYAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //       break;
    //   }
    // };

    $scope.getTotalpayment = function (items) {
      return items
        .map(function (x) {
          return x.amount || x.payment;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        }, 0);
    };

    $scope.recalculate = function () {
      var totalMethod = 0;
      var totalDeduction = 0;
      totalMethod = parseInt($scope.manageCase.firstm) + parseInt($scope.manageCase.lastm);
      totalDeduction = parseFloat($scope.manageCase.tamount) * parseInt(totalMethod);
      totalDeduction = totalDeduction + parseFloat($scope.manageCase.stampduty);
      totalDeduction = totalDeduction + parseFloat($scope.manageCase.deposit);
      if ($scope.manageCase.icollect) {
        totalDeduction = totalDeduction + parseFloat($scope.manageCase.iamount);
      }
      $scope.manageCase.deduction = parseFloat(totalDeduction).toFixed(2);
      $scope.manageCase.cashout = (parseFloat($scope.manageCase.principle) - parseFloat(totalDeduction)).toFixed(2);
    };

    $scope.addPayment = function () {
      $scope.isEditPayment = true;
    };
    $scope.cancelPayment = function () {
      $scope.isEditPayment = false;
    };

    $scope.savePaymentDetails = function (managePayment) {
      console.log('Inside savePaymentDetails');
      console.log('managePayment', managePayment);

      var date = new Date();
      var obj = {};
      obj.params = [];
      var record = {};
      record.caseid = $scope.manageCase.id;
      record.casecode = $scope.manageCase.code;
      record.amount = managePayment.amount;
      record.remarks = managePayment.remarks;
      record.agentid = $rootScope.userData.id;

      var d = managePayment.paydate,
        y = d.getFullYear(),
        m = d.getMonth() + 1;
      var selectedPayDate = y + '-' + m + '-' + d.getDate();

      record.paydate = selectedPayDate;
      record.created = date;
      record.lastupdated = date;

      obj.params.push(record);

      console.log('obj.params', obj.params);


      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS savePaymentDetails");
        console.log(result);
        toastr.success('Payment has been saved successfully!', 'SUCCESS');
        $scope.isEditPayment = false;
        $scope.initManageCase($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'Error');
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, 'Error');
        }
      };

      paymentImportService.createPayment(obj);

    };

    $scope.editPaymentDetails = function (managePayment, payid) {
      console.log('Inside editPaymentDetails');
      console.log('managePayment', managePayment);

      var obj = {};
      obj.params = {};
      obj.params.id = payid;
      obj.params.amount = managePayment.amount;
      obj.params.remarks = managePayment.remarks;

      console.log('obj.params', obj.params);


      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS editPaymentDetails");
        console.log(result);
        toastr.success('Payment has been saved successfully!', 'SUCCESS');
        $scope.initManageCase($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'Error');
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, 'Error');
        }
      };

      paymentImportService.savePayment(obj);

    };

    $scope.editCustomer = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log(result);
        $scope.customerList = result;
        $scope.isEditCustomer = true;
      };
      obj.onFailure = function (err) {
        console.log(err);
        $scope.isEditCustomer = false;
      };
      customerService.getCustomer(obj);
    };

    $scope.cancelEditCustomer = function () {
      $scope.isEditCustomer = false;
      $scope.manageCase.customer = $scope.originalCustomer;
    };

    $scope.openDeletePayment = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deletePayment(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.deletePaymentId = null;
    $scope.confirmPaymentDelete = function (id) {
      $scope.openDeletePayment('app/pages/operational/case/modals/dangerPayment.html');
      $scope.deletePaymentId = id;
    };

    $scope.deletePayment = function (res) {
      console.log("Inside deletePayment");
      if (res) {
        console.log('Sure!');
        console.log($scope.deletePaymentId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deletePaymentId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Payment has been deleted successfully!', 'SUCCESS');
          // $scope.getCaseById();
          $scope.initManageCase($scope.reportFilter);
          //$scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        paymentImportService.deletePayment(obj);
      }
    };

    editableOptions.theme = 'bs3';
    editableThemes.bs3.submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes.bs3.cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.getAgentName = function (credentials) {
      if (credentials.name != null && credentials.name.length > 0)
        return credentials.name;
      else
        return credentials.firstName + " " + credentials.lastName;
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.clerkSetup.case')
    .controller('scheduleCalendarCtrl', scheduleCalendarCtrl);

  /** @ngInject */
  function scheduleCalendarCtrl(baConfig, $scope) {
    console.log('Inside scheduleCalendarCtrl');

    var dashboardColors = baConfig.colors.dashboard;
    var date = new Date();
    var $element = $('#schedule').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month'
      },
      defaultDate: $scope.sDate,
      selectable: false,
      selectHelper: false,
      editable: false,
      eventLimit: true, // allow "more" link when too many events
      eventTextColor: '#000',
      events: $scope.scheduleEntry
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.clerkSetup.customer')
    .controller('ClerkCustomerPageCtrl', ClerkCustomerPageCtrl);

  /** @ngInject */
  function ClerkCustomerPageCtrl($scope, $filter, editableOptions, editableThemes,
    customerService, toastr, $uibModal, $state, $rootScope) {
    console.log("Inside ClerkCustomerPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size

      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCustomer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });
    };

    $scope.smartTablePageSize = 25;
    // $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No"
    };




    $scope.init = function () {};
    $scope.init();

    $scope.manageCustomer = {
      customer: {}
    };
    $scope.manageCustomerList = [];
    $scope.reportFilter = {};
    $scope.initManageCustomer = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        // console.log(result);
        $scope.manageCustomerList = result;
        // $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      customerService.getCustomer(obj);
    };
    $scope.initManageCustomer();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageCustomerList.push($scope.inserted);
    };

    $scope.createCustomer = function (manageCustomer) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createCustomer");
      console.log(manageCustomer);

      var obj = {};
      obj.params = {};
      obj.params.code = manageCustomer.code;
      obj.params.name = manageCustomer.name;
      obj.params.ic = manageCustomer.ic;
      obj.params.passport = manageCustomer.passport;
      obj.params.address = manageCustomer.address;
      obj.params.contact = manageCustomer.contact;
      obj.params.gname = manageCustomer.gname;
      obj.params.gic = manageCustomer.gic;
      obj.params.gpassport = manageCustomer.gpassport;
      obj.params.gaddress = manageCustomer.gaddress;
      obj.params.gcontact = manageCustomer.gcontact;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.isEditSupplier = false;
        toastr.success('New Customer has been saved successfully!', 'SUCCESS');
        $scope.manageCustomer = Object.assign({}, $scope.manageCustomer, result);

        $scope.saveCustomerDetails();
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Customer successfully created.");

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      customerService.createCustomer(obj);

      //$scope.modal.hide();
    };
    // $scope.deleteId = null;
    // $scope.confirmDelete = function (id) {
    //   $scope.open('app/pages/operational/customer/modals/dangerModal.html');
    //   $scope.deleteId = id;
    // };

    $scope.deleteCustomer = function (res) {
      console.log("Inside deleteCustomer");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Customer has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageCustomer($scope.reportFilter);
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        customerService.deleteCustomer(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (customer) {
      console.log("Inside editCustomer");
      console.log(customer);
      // $scope.manageCustomer.id = $scope.manageCustomer.id;
      // $scope.manageCustomer.name = state.name;
      // $scope.manageCustomer.description = state.description;
      // $scope.manageCustomer.created = state.created;
      // $scope.manageCustomer.lastupdated = state.lastupdated;
      $scope.manageCustomer = customer;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveCustomer = function (manageCustomer) {

      console.log("Inside saveCustomer");
      console.log(manageCustomer);

      if (manageCustomer.id === undefined) {
        $scope.createCustomer(manageCustomer);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageCustomer
        obj.params.id = manageCustomer.id;
        obj.params.code = manageCustomer.code;
        obj.params.name = manageCustomer.name;
        obj.params.ic = manageCustomer.ic;
        obj.params.passport = manageCustomer.passport;
        obj.params.address = manageCustomer.address;
        obj.params.contact = manageCustomer.contact;
        obj.params.gname = manageCustomer.gname;
        obj.params.gic = manageCustomer.gic;
        obj.params.gpassport = manageCustomer.gpassport;
        obj.params.gaddress = manageCustomer.gaddress;
        obj.params.gcontact = manageCustomer.gcontact;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.saveCustomerDetails();

          // $scope.manageCustomer = {};
          // toastr.success('Customer has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          // $scope.initManageCustomer($scope.reportFilter);

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        customerService.saveCustomer(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    //manageActiveCustomerList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveCustomerList.length) {
        var selected = $filter('filter')($scope.manageActiveCustomerList, {
          customerid: id
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editCustomer = function (manageCustomer) {
      console.log("Inside editCustomer");
      // $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageCustomer = manageCustomer;
      console.log('$scope.manageCustomer', $scope.manageCustomer);
      console.log('$scope.manageCustomer', $scope.manageCustomer.id);


      var obj = {};
      obj.params = {};
      obj.params.custid = $scope.manageCustomer.id;
      console.log('$scope.manageCustomer.custid', $scope.manageCustomer.custid)

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS addPayment");
        console.log(result);
        if (result.length) {
          $scope.manageCustomer.customer = result[0];
        }
        console.log('$scope.manageCustomer', $scope.manageCustomer.customer)
        console.log('$scope.manageCustomer.custid', $scope.manageCustomer.customer.custid)
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      customerService.getCustomerDetailsById(obj);

    };

    $scope.addCustomer = function () {
      console.log("Inside addCustomer");
      // $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageCustomer = {};
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;
    };


    // $scope.qrString = "";
    // $scope.viewQRcode = function (code) {
    //   console.log('Inside viewQRcode', code);
    //   $scope.open('app/pages/operational/customer/modals/qrModal.html');
    //   $scope.qrString = code;
    // };

    $scope.print = function () {
      window.print();
    };

    $scope.addCustomerShop = function () {
      $scope.inserted = {
        shopid: null,
        customerid: $scope.manageCustomer.id,
        macrate: null,
        macvirtual: null
      };
      $scope.manageCustomershopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function (supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showShop = function (shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shop.id
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.openDeleteCustomershop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCustomershop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.onFileSelect = function (model, key, result, error) {
      if (error) {
        toastr.error(error.message);
      } else {
        model[key] = result;
        $scope.$digest();
      }
    }

    $scope.saveCustomerDetails = function () {
      var params = $scope.manageCustomer.customer;
      params.custid = $scope.manageCustomer.id;

      var obj = {
        params: params,
        onSuccess: function (result) {
          console.log(result);
          $scope.manageCustomer = {
            customer: {}
          };
          toastr.success('Customer photos has been updated successfully!', 'SUCCESS');
          $scope.initManageCustomer($scope.reportFilter);

        },
        onFailure: function (err) {
          console.error('saveCustomerDetails', err);
        }
      }
      customerService.saveCustomerDetails(obj);
    }


    // $scope.deleteCustomershopId = null;
    // $scope.confirmCustomershopDelete = function (id) {
    //   $scope.openDeleteCustomershop('app/pages/operational/customer/modals/dangerCustomerGameModal.html');
    //   $scope.deleteCustomershopId = id;
    // };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.clerkSetup.payment')
    .controller('ClerkPaymentImportPageCtrl', ClerkPaymentImportPageCtrl);

  /** @ngInject */
  function ClerkPaymentImportPageCtrl($scope, $filter, editableOptions, editableThemes,
    paymentImportService, toastr, $uibModal, SheetJSExportService,
    validationService, caseService) {
    console.log("Inside PaymentImportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


    //    $scope.dateList = {};    
    //    $scope.dpOpenStatus = {};
    //    $scope.setDpOpenStatus = function(id) {
    //      $scope.dpOpenStatus[id] = true;
    //    };

    $scope.smartTablePageSize = 250;
    $scope.managePayment = {};

    $scope.managePaymentList = []; // temp line

    $scope.manageCaseList = [];
    $scope.initManageCase = function (reportFilter) {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCaseList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      caseService.getCase(obj);
    };

    $scope.initManagePayment = function () {
      $scope.initManageCase();
      $scope.managePayment = {};
      $scope.gridOptions = {};
      //$scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManagePayment();

    $scope.passOnlinesales = function (managePayment) {
      console.log("Inside passOnlinesales");
      console.log(managePayment);
    };

    $scope.getCaseId = function (caseNo) {
      if (caseNo && $scope.manageCaseList.length) {
        var selected = $filter('filter')($scope.manageCaseList, {
          code: caseNo
        }, true);
        return selected.length ? selected[0].id : null;
      } else {
        return null;
      }
    };

    $scope.createPayment = function (managePayment) {
      console.log("Inside managePayment");
      var isFormValidated = true;

      if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please choose a Date and File to Upload', 'ERROR');
        toastr.error('Please choose a file to Upload', 'ERROR');

      }

      if (isFormValidated) {

        var cdate = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          if ($scope.gridOptions.data[i].CaseNo) {

            record.caseid = $scope.getCaseId(($scope.gridOptions.data[i].CaseNo).trim());
            record.casecode = $scope.gridOptions.data[i].CaseNo;
            record.amount = $scope.gridOptions.data[i].Amount;
            record.paydate = $scope.gridOptions.data[i].PayDate;
            record.created = cdate;
            record.lastupdated = cdate;

            console.log(record);

            obj.params.push(record);
          } else {
            toastr.error('Case No. is empty', 'ERROR');
          }
        }

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};
          //$scope.dateList = {};
          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          $scope.initManagePayment();
          toastr.success('New Payments has been Imported Successfully!', 'SUCCESS');
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {

            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                // data.machineid = err.config.data[i].mid;
                // data.cmin = err.config.data[i].cmIn;
                // data.cmout = err.config.data[i].cmOut;
                // data.bmin = err.config.data[i].bmIn;
                // data.bmout = err.config.data[i].bmOut;

                data.CaseNo = err.config.data[i].casecode;
                data.Amount = err.config.data[i].amount;
                data.PayDate = err.config.data[i].paydate;
                // data.IC = $err.config.data[i].IC;
                // data.Passport = $err.config.data[i].Passport;
                // data.Address = $err.config.data[i].Address;
                // data.Contact = $err.config.data[i].Contact;
                // data.GName = $err.config.data[i].GName;
                // data.GIC = $err.config.data[i].GIC;
                // data.GPassport = $err.config.data[i].GPassport;
                // data.GAddress = $err.config.data[i].GAddress;
                // data.GContact = $err.config.data[i].GContact;
                if (err.config.data[i].caseid === null) {
                  data.ERROR = 'Case No. does not exists';
                }
                // } else if (typeof err.config.data[i].shopid === 'undefined') {
                //   data.ERROR = 'No Shop Reference';
                // } else if (typeof err.config.data[i].machineid === 'undefined') {
                //   data.ERROR = 'No Machine Reference';
                // } else if (err.config.data[i].shopid === null) {
                //   data.ERROR = 'No Shop Reference';
                // }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        };
        paymentImportService.createPayment(obj);
      }
    };

    $scope.getMachineShopDetails = function (mid) {
      if (mid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: mid
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getMachineDetails = function (mid) {
      if (mid && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: mid
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var date = new Date();
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month'
      },
      selectable: false,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'Today',
          start: date,
          color: dashboardColors.silverTree,
          allDay: true
        }
        // {
        //   title: 'Long Event',
        //   start: '2016-03-07',
        //   end: '2016-03-10',
        //   color: dashboardColors.blueStone
        // },
        // {
        //   title: 'Dinner',
        //   start: '2016-03-14T20:00:00',
        //   color: dashboardColors.surfieGreen
        // },
        // {
        //   title: 'Birthday Party',
        //   start: '2016-04-01T07:00:00',
        //   color: dashboardColors.gossipDark
        // }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.expense.category')
      .controller('categoryPageCtrl', categoryPageCtrl);

  /** @ngInject */
  function categoryPageCtrl($scope, $filter, editableOptions, editableThemes,
    categoryService,toastr,$uibModal,maincategoryService ) {
    console.log("Inside categoryPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    
    $scope.deletecategory(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 25;

    $scope.managecategory={};
    $scope.managecategoryList=[];
    $scope.initManagecategory = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managecategoryList = result;
          $scope.managecategoryList= result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        categoryService.getcategory(obj);
    };

    $scope.managemaincategoryList=[];
    $scope.initManageMaincategory = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managemaincategoryList = result;
          $scope.managemaincategoryList= result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        maincategoryService.getmaincategory(obj);
    };
    $scope.initManagecategory();
    $scope.initManageMaincategory();

    $scope.addcategory = function (){
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.managecategoryList.push($scope.inserted);
    };

    $scope.createcategory = function(managecategory) {
      console.log("Inside createcategory");
      console.log(managecategory);

      var obj ={};
      obj.params={};
      obj.params.code = managecategory.code;
      obj.params.name = managecategory.name;
      obj.params.mainid = managecategory.category?managecategory.category.mainid:null;
      obj.params.parentid = managecategory.category?managecategory.category.id:null;
      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managecategory = {};
        toastr.success('New category has been saved successfully!','SUCCESS');
          $scope.initManagecategory();
          $scope.isEditCategory = false;
      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
        } else {

        }
      }
      categoryService.createcategory(obj);
    };

    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/expense/category/modals/dangerModel.html');
      $scope.deleteId = id;
    };

    $scope.deletecategory = function (res){
      console.log("Inside deletecategory");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('category has been deleted successfully!','SUCCESS');
              $scope.initManagecategory();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
              } else {
              }
            }
            categoryService.deletecategory(obj);
         } else {
            console.log('Not sure!');
         }
    }
    $scope.editcategory = function (category){
      console.log("Inside editcategory");
      console.log(category);

      $scope.managecategory = category;
      genericModalService.show('modules/modals/addcategory.html',$scope);
    }
    $scope.savecategory = function (managecategory, id){

      console.log("Inside savecategory");
      console.log(managecategory);
      console.log(id);
      if (id===undefined){
        $scope.createcategory(managecategory);
      } else {

      var obj ={};
      obj.params={};
      obj.params = managecategory;
      obj.params.id = id;
      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS savecategory");
        console.log(result);
        $scope.managecategory = {};
        toastr.success('category has been saved successfully!','SUCCESS');
        $scope.initManagecategory();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

        }
      }
      categoryService.savecategory(obj);
    }

    };

    $scope.showparentid = function(parentid) {
      if (parentid && $scope.managecategoryList.length) {
        var selected = $filter('filter')($scope.managecategoryList, {
          id: parentid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showmainid= function(mainid) {
      if (mainid && $scope.managemaincategoryList.length) {
        var selected = $filter('filter')($scope.managemaincategoryList, {
          id: mainid
        },true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.addcategory = function (){
      $scope.isEditCategory = true;
    };

    $scope.cancelcategory = function () {
      $scope.isEditCategory = false;    
    };

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();
    $scope.dpOpenStatus = {};
    $scope.isEditCategory = false;
    $scope.setDpOpenStatus = function (id) {
    $scope.dpOpenStatus[id] = true;
  };


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.expense.category')
    .service('categoryService', categoryService);

  /** @ngInject */
  function categoryService(Category) {
    var getcategory = function(obj) {
      
      Category.find().$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {

        obj.onFailure(err);
      });
    };

    var createcategory = function(obj) {
    

      var date = new Date();

      Category.create({
        code:obj.params.code,
        name:obj.params.name,
        created: date,
        lastupdated: date,
        mainid:obj.params.mainid,
        parentid: obj.params.parentid
        
      }).$promise.then(function(data) {
         obj.onSuccess(data);
       }, 

      function(err) {
          obj.onFailure(err);
      });
    };


    var deletecategory = function(obj) {
      
      Category.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        
        obj.onSuccess(data);

      }, function(err) {

        obj.onFailure(err);
      });
    };

    var savecategory = function(obj) {
     

      var date = new Date();

      Category.prototype$updateAttributes({
        id: obj.params.id,
        code: obj.params.code,    
        name: obj.params.name,    
        lastupdated: date,
        parentid:obj.params.parentid,
        mainid: obj.params.mainid,
        parent: obj.params.parentid
      }).$promise.then(function(data) {

        obj.onSuccess(data);

      }, function(err) {

        obj.onFailure(err);
      });
    };

    return{
      getcategory: getcategory,
      createcategory: createcategory,
      deletecategory: deletecategory,
      savecategory: savecategory
    };

  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.expense.category')
    .service('maincategoryService', maincategoryService);

  /** @ngInject */
  function maincategoryService(Maincategory) {
    var getmaincategory = function(obj) {
      
        Maincategory.find().$promise.then(function(data) {
        obj.onSuccess(data);

      }, function(err) {

        obj.onFailure(err);
      });
    };

    var createmaincategory = function(obj) {
     

      var date = new Date();

      Maincategory.create({

        mainid:obj.params.mainid

      
      }).$promise.then(function(data) {
        
        obj.onSuccess(data);

      }, function(err) {
        
        obj.onFailure(err);
      });
    };


    var deletemaincategory = function(obj) {
      

      Maincategory.deleteById({

        id:obj.params.id

      }).$promise.then(function(data) {
        
        obj.onSuccess(data);

      }, function(err) {
       
        obj.onFailure(err);
      });
    };

    var savemaincategory = function(obj) {
       
    var date = new Date();

      Maincategory.prototype$updateAttributes({
     
            mainid: obj.params.mainid    
       
      }).$promise.then(function(data) {
       
        obj.onSuccess(data);

      }, function(err) {
       
        obj.onFailure(err);
      });
    };

    return{
      getmaincategory: getmaincategory,
      createmaincategory: createmaincategory,
      deletemaincategory: deletemaincategory,
      savemaincategory: savemaincategory
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.flowtransaction.transaction')
    .controller('transactionPageCtrl', transactionPageCtrl);

  /** @ngInject */
  function transactionPageCtrl($scope, $filter, editableOptions, editableThemes,
    transactionService, toastr, $uibModal, categoryService, maincategoryService, validationService) {
    console.log("Inside transactionPageCtrl");



    $scope.opened = {};

    $scope.open = function ($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened[elementOpened] = !$scope.opened[elementOpened];
    };




    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deletetransaction(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    // start date
    $scope.dayNightFilter = [{
      value: 'Open'
    }, {
      value: 'Closed'
    }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};

    $scope.shopTypeFilter = [{
      value: 'L'
    }, {
      value: 'D'
    }];
    $scope.init = function () {
      // $scope.initManageZones();
      // $scope.initManagePartner();
      // $scope.initManageGames();
      // $scope.initManageMachineShop();
      // $scope.initAgents();
    };
    $scope.init();

    $scope.reportFilter = {};
    $scope.searchCollection = function (reportFilter) {
      console.log("Inside searchCollection");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        // if (reportFilter.zone) {
        //   obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        // } else {
        //   if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        //     var value = "";
        //     for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
        //       if (index == 0) {
        //         value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
        //       } else {
        //         value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
        //       }
        //     }
        //     value = value + ")";
        //     obj.params.zoneid = value;
        //   } else {
        //     obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        //   }
        // }

        // start (by Nicky)
        if (reportFilter.managemaincategory && reportFilter.managemaincategory.maincategory) {
          obj.params.maincategory = reportFilter.managemaincategory.maincategory ? reportFilter.managemaincategory.maincategory.id : null;
        }
        // end (by Nicky)

        // if (reportFilter.agent){
        //   obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
        // }
        if (reportFilter.daynight) {
          obj.params.status = reportFilter.daynight ? reportFilter.daynight.value : null;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          // $scope.totalSalesLabel = 0;
          // $scope.totalCommissionLabel = 0;
          $scope.managetransactionList = result;
          // for (var i = 0; i < $scope.manageCollectionList.length; i++) {
          //   if ($scope.manageCollectionList[i].icollect){
          //     $scope.manageCollectionList[i].payment = parseFloat($scope.manageCollectionList[i].payment) + parseFloat($scope.manageCollectionList[i].iamount);
          //     $scope.manageCollectionList[i].balance = parseFloat($scope.manageCollectionList[i].amount) - parseFloat($scope.manageCollectionList[i].payment);
          //   }
          // }
          // console.log($scope.totalSalesLabel.toFixed(2));

          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        transactionService.getSummaryL1(obj);
      }
    };



    // end date




    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;

    $scope.managetransaction = {};
    $scope.managetransactionList = [];
    $scope.initManagetransaction = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managetransactionList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      transactionService.gettransaction(obj);
      $scope.$broadcast('scroll.refreshComplete');
    };
    // $scope.initManagetransaction();

    $scope.managecategoryList = [];
    $scope.initManagecategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managecategoryList = result;

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      categoryService.getcategory(obj);
    };
    $scope.initManagecategory();


    $scope.managemaincategoryList = [];
    $scope.initManagecategory = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managemaincategoryList = result;

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      maincategoryService.getmaincategory(obj);
    };
    $scope.initManagecategory();

    $scope.addtransaction = function () {
      //genericModalService.show('modules/modals/addtransaction.html',$scope);
      $scope.inserted = {
        categoryid: null,
        amount: null,
        remarks: null,
        entrydate: null,
      };
      $scope.managetransactionList.push($scope.inserted);
    };

    $scope.createtransaction = function (managetransaction) {

      var date = new Date();

      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createtransaction");
      console.log(managetransaction.categoryid);
      console.log(managetransaction.amount);
      console.log(managetransaction.remarks);
      console.log(managetransaction.entrydate);

      var obj = {};

      obj.params = {};
      obj.params.categoryid = managetransaction.category ? managetransaction.category.id : null;
      obj.params.mainid = managetransaction.category ? managetransaction.category.mainid : null;
      obj.params.parentid = managetransaction.category ? managetransaction.category.parentid : null;
      obj.params.amount = managetransaction.amount;
      obj.params.remarks = managetransaction.remarks;

      if (!managetransaction.entrydate) {
        managetransaction.entrydate = new Date();
      }

      if (managetransaction.entrydate) {
        var d = new Date(managetransaction.entrydate),
          y = d.getFullYear(),
          m = d.getMonth() + 1;
        var selectedEntryDate = y + '-' + m + '-' + d.getDate();

        obj.params.entrydate = selectedEntryDate;
      }

      if (managetransaction.category.mainid == 1) {
        obj.params.credit = managetransaction.amount;
      } else if (managetransaction.category.mainid == 2) {
        obj.params.debit = managetransaction.amount;
      }

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managetransaction = {};
        toastr.success('New transaction has been saved successfully!', 'SUCCESS');
        $scope.initManagetransaction();

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {} else {}
      };
      transactionService.createtransaction(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/flowtransaction/transaction/modals/dangerModel.html');
      $scope.deleteId = id;
    };

    $scope.deletetransaction = function (res) {
      console.log("Inside deletetransaction");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Transaction has been deleted successfully!', 'SUCCESS');

          $scope.initManagetransaction();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {

          } else {

          }
        };
        transactionService.deletetransaction(obj);
      } else {
        console.log('Not sure!');
      }

    };

    // $scope.edittransaction = function (transaction){
    //   console.log("Inside edittransaction");
    //   console.log(transaction);
    //   // $scope.manageState.id = $scope.manageState.id;
    //   // $scope.manageState.name = state.name;
    //   // $scope.manageState.description = state.description;
    //   // $scope.manageState.created = state.created;
    //   // $scope.manageState.lastupdated = state.lastupdated;
    //   $scope.managetransaction = transaction;
    //   genericModalService.show('modules/modals/addtransaction.html',$scope);
    // };

    $scope.savetransaction = function (managetransaction, item) {

      var date = new Date();

      console.log("Inside savetransaction");
      console.log(managetransaction);
      console.log(item);
      console.log(item.mainid);

      if (item.id === undefined) {
        $scope.createtransaction(managetransaction);
      } else {



        var date = new Date();
        var obj = {};
        obj.params = {};


        obj.params.id = item.id;
        obj.params.categoryid = managetransaction.category ? managetransaction.category.id : null;
        obj.params.mainid = managetransaction.category ? managetransaction.category.mainid : null;
        obj.params.parentid = managetransaction.category ? managetransaction.category.parentid : null;
        obj.params.amount = managetransaction.amount;
        obj.params.remarks = managetransaction.remarks;
        obj.params.entrydate = managetransaction.entrydate;
        obj.params.credit = 0;
        obj.params.debit = 0;


        if (item.mainid == 1) {
          obj.params.credit = item.amount;
        } else if (item.mainid == 2) {
          obj.params.debit = item.amount;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managetransaction = {};
          toastr.success('Transaction has been saved successfully!', 'SUCCESS');
          $scope.initManagetransaction();

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure transactionPageCtrl");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

          }
        };
        transactionService.savetransaction(obj);


      }

    };


    $scope.showcategoryid = function (categoryid) {

      if (categoryid && $scope.managecategoryList.length) {
        var selected = $filter('filter')($scope.managecategoryList, {
          id: categoryid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };


    $scope.showmainid = function (mainid) {

      if (mainid && $scope.managemaincategoryList.length) {
        var selected = $filter('filter')($scope.managemaincategoryList, {
          id: mainid
        }, true);
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };



    // start for add payment new line function
    $scope.addtransaction = function () {
      $scope.isEditPayment = true;
    };
    $scope.canceltransaction = function () {
      $scope.isEditPayment = false;
    };


    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus1 = {};
    $scope.isEditPayment = false;

    $scope.setDpOpenStatus1 = function (id) {
      $scope.dpOpenStatus1[id] = true;
    };
    $scope.getTotalamount = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.amount;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.flowtransaction.transaction')
      .service('transactionService', transactionService);
  
    /** @ngInject */
    function transactionService(Usertransaction) {
      var gettransaction = function(obj) {
        
        Usertransaction.find({
          filter: {
            include: ["category"]
          }
        }).$promise.then(function(data) {
          obj.onSuccess(data);
  
        }, function(err) {
  
          obj.onFailure(err);
        });
      };
  
      var createtransaction = function(obj) {
    
  
        var date = new Date();
  
        Usertransaction.create({
          categoryid: obj.params.categoryid,
          mainid: obj.params.mainid,
          parentid: obj.params.parentid,
          amount:obj.params.amount,
          remarks:obj.params.remarks,
          entrydate:obj.params.entrydate,
          credit:obj.params.credit,
          debit:obj.params.debit,
          created: date,
          lastupdated: date
        }).$promise.then(function(data) {
          obj.onSuccess(data);
        }, function(err) {
          obj.onFailure(err);
        });
      };
  
  
      var deletetransaction = function(obj) {
        //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});
  
        Usertransaction.deleteById({
          id:obj.params.id
        }).$promise.then(function(data) {
          obj.onSuccess(data);
  
        }, function(err) {
          obj.onFailure(err);
        });
      };
  
      var savetransaction = function(obj) {
  
        var date = new Date();
  
        Usertransaction.prototype$updateAttributes({
         id: obj.params.id,
         categoryid:obj.params.categoryid,
         amount:obj.params.amount, 
         remarks:obj.params.remarks,
         entrydate:obj.params.entrydate,
         mainid: obj.params.mainid,
         parentid: obj.params.parentid,
         credit:obj.params.credit,
         debit:obj.params.debit,
          //description: obj.params.description,
          lastupdated: date
        }).$promise.then(function(data) {
          obj.onSuccess(data);
  
        }, function(err) {
          obj.onFailure(err);
        });
      };
  // start date
      var getSummaryL1 = function (obj) {

        var from = obj.params.fromDt ? obj.params.fromDt : null;
        var to = obj.params.toDt ? obj.params.toDt : null;
  
        var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
        var date1 = y + '-' + m + '-' + fd.getDate();
  
        var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
        td.setHours(23);
        td.setMinutes(59);
        td.setSeconds(59);
        var date2 = y + '-' + m + '-' + td.getDate();
        console.log('client from date', fd);
        console.log('client from date1', date1);
        console.log('client to date', td);
        console.log('client to date2', date2);


        // Case.getSummaryL1({
        //   adate: date1,
        //   bdate: date2,
        //   type: obj.params.type ? obj.params.type : null,
        //   status: obj.params.status ? obj.params.status : null
        // }).$promise.then(function (data) {
        //   obj.onSuccess(data);
        // }, function (err) {
        //   obj.onFailure(err);
        // });
  
        // start (by nicky)
        var searchParams = [
          {entrydate: {gte: fd}},
          {entrydate: {lt: td}},
        ]

        !!obj.params.maincategory && (searchParams.push({mainid: obj.params.maincategory}));

        Usertransaction.find({
          filter: {
            include: ["category"],
            where:{
              and: searchParams
            }
          }
        }).$promise.then(function(data) {
          obj.onSuccess(data);
        }, function(err) {
          obj.onFailure(err);
        });
        // end (by nicky)
      };
      
      return{
        gettransaction: gettransaction,
        createtransaction: createtransaction,
        deletetransaction: deletetransaction,
        savetransaction: savetransaction,
        getSummaryL1: getSummaryL1
      };
  
    }

  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.form.case')
    .controller('CaseImportPageCtrl', CaseImportPageCtrl);

  /** @ngInject */
  function CaseImportPageCtrl($scope, $filter, editableOptions, editableThemes,
    caseService, toastr, $uibModal, SheetJSExportService,
   validationService,customerService) {
    console.log("Inside CaseImportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 250;
    $scope.manageCase = {};

    $scope.manageCaseList = []; // temp line

    $scope.manageCustomerList = [];
    $scope.initManageCustomer = function (reportFilter) {
      var obj = {};
      obj.params={};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCustomerList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      customerService.getCustomer(obj);
    };



    $scope.initManageCase = function() {

      $scope.manageCase = {};
      $scope.gridOptions = {};
      //$scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
      $scope.initManageCustomer();
    };

    $scope.initManageCase();

    $scope.passOnlinesales = function(manageCase) {
      console.log("Inside passOnlinesales");
      console.log(manageCase);
    };


    $scope.getCustomerId = function(accNo) {
      if(accNo && $scope.manageCustomerList.length) {
        var selected = $filter('filter')($scope.manageCustomerList, {code: accNo
        },true);
        return selected.length ? selected[0].id : null;
      } else {return null;}
    };


    $scope.createCase = function(manageCase) {
      console.log("Inside manageCase");
      var isFormValidated = true;

	  if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
          console.log("Fill all required fields");
          //toastr.error('Please choose a Date and File to Upload', 'ERROR');
		  toastr.error('Please choose a file to Upload', 'ERROR');

      }

      if (isFormValidated) {

        var cdate = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          var date = new Date();
          var totalMethod = 0;
          var totalDeduction=0;

          if ($scope.gridOptions.data[i].AccNo) {

              record.custid = $scope.getCustomerId(($scope.gridOptions.data[i].AccNo).trim());
              record.custcode = $scope.gridOptions.data[i].AccNo;
              record.code = $scope.gridOptions.data[i].CaseNo;
              record.agentid = 2; 
              record.managerid = 2; 
              record.verified = true; 
              record.principle = $scope.gridOptions.data[i].Principle;
              record.amount = $scope.gridOptions.data[i].LoanAmount;
              // record.idaily = $scope.gridOptions.data[i].DailyInterest;
              // record.iweekly = $scope.gridOptions.data[i].WeeklyInterest;
              // record.imonthly = $scope.gridOptions.data[i].MonthlyInterest;
              // record.iyearly = $scope.gridOptions.data[i].YearlyInterest;
              record.deposit = $scope.gridOptions.data[i].Deposit;
              record.stampduty = $scope.gridOptions.data[i].Stampduty;
              record.firstm = $scope.gridOptions.data[i].FirstMethod;
              record.lastm = $scope.gridOptions.data[i].LastMethod;
              record.iamount = $scope.gridOptions.data[i].InterestAmount;
              record.tamount = $scope.gridOptions.data[i].InstallmentAmount;
              record.icollect = $scope.gridOptions.data[i].CollectInterest=='Y'?true:false;
              record.reldate = $scope.gridOptions.data[i].ReleaseDate;
              record.type =  $scope.gridOptions.data[i].Type;
              record.pajakitem =  $scope.gridOptions.data[i].PajakItem;
              record.status =  true;
              record.isdeposit =  true;

              totalMethod = parseInt(record.firstm) + parseInt(record.lastm);
              totalDeduction =  parseFloat(record.tamount) * parseInt(totalMethod);
              totalDeduction = totalDeduction + parseFloat(record.stampduty);
              totalDeduction = totalDeduction + parseFloat(record.deposit);
              if (record.icollect){
                totalDeduction = totalDeduction + parseFloat(record.iamount);
              }
              record.deduction = totalDeduction;
              record.cashout = parseFloat(record.principle) - parseFloat(totalDeduction);

              record.created = date;
              record.lastupdated = date;

              

              
              //console.log(record);

              obj.params.push(record);
            }else{
              toastr.error('Account No. is empty', 'ERROR');
            }
        }


              console.log(obj.params);

              obj.onSuccess = function(result) {
                console.log("Inside SUCCESS");
                console.log(result);
                $scope.gridOptions = {};
                //$scope.dateList = {};
                var filename = document.querySelector('#uploadFile');
                angular.element(filename).val(null);
                $scope.initManageCase();
                toastr.success('New Cases has been Imported Successfully!', 'SUCCESS');
              };
              obj.onFailure = function(err) {
                console.log("Inside Failure");
                console.log(err);
                if (err.status === -1) {
                  toastr.error('Service Unavailable. Please try again later', 'ERROR');
                } else {
      
                  var errdetails = [];
                  errdetails = err.data.error.details;
      
                  toastr.error('Issue with upload!', 'ERROR');
                  var errObj = [];
      
      
                  for (var i = 0; i < errdetails.length; i++) {
                    if (errdetails[i]) {
                      var data = {};
                      data.AccNo = err.config.data[i].custcode;
                      data.CaseNo = err.config.data[i].code;
                      //data.agentid = err.config.data[i].agentid; 
                       data.Principle = err.config.data[i].principle;
                       data.LoanAmount = err.config.data[i].amount;
                       data.DailyInterest = err.config.data[i].idaily;
                       data.WeeklyInterest = err.config.data[i].iweekly;
                       data.MonthlyInterest = err.config.data[i].imonthly;
                       data.YearlyInterest = err.config.data[i].iyearly;
                       data.Deposit = err.config.data[i].deposit;
                       data.Stampduty = err.config.data[i].stampduty;
                       data.FirstMethod = err.config.data[i].firstm;
                       data.LastMethod = err.config.data[i].lastm;
                       data.CashOut = err.config.data[i].cashout;
                       data.DayTerms = err.config.data[i].tday;
                       data.WeekTerms = err.config.data[i].tweek;
                       data.MonthTerms = err.config.data[i].tmonth;
                       data.YearTerms = err.config.data[i].tyear;
                       data.Interest = err.config.data[i].interest;
                       data.Terms = err.config.data[i].term;
                       data.InterestAmount = err.config.data[i].iamount;
                       data.InstallmentAmount = err.config.data[i].tamount;
                       data.ReleaseDate = err.config.data[i].reldate;
                       data.Type = err.config.data[i].type;
                       data.PajakItem = err.config.data[i].pajakitem;

                      if (err.data.error.details[i].code=="23505"){
                        data.ERROR = 'Case No. Already Exists';
                      }
                      //else if (typeof err.config.data[i].shopid === 'undefined') {
                      //   data.ERROR = 'No Shop Reference';
                      // } else if (typeof err.config.data[i].machineid === 'undefined') {
                      //   data.ERROR = 'No Machine Reference';
                      // } else if (err.config.data[i].shopid === null) {
                      //   data.ERROR = 'No Shop Reference';
                      // }
                      errObj.push(data);
                    }
                  }
                  console.log(errObj);
                  $scope.gridOptions.data = errObj;
                }
              };
              caseService.createManyCases(obj);
      }
    };

    $scope.getMachineShopDetails = function(mid) {
      if (mid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getMachineDetails = function(mid) {
      if (mid && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.form.customer')
    .controller('CustomerImportPageCtrl', CustomerImportPageCtrl);

  /** @ngInject */
  function CustomerImportPageCtrl($scope, $filter, editableOptions, editableThemes,
    customerService, toastr, $uibModal, SheetJSExportService,
   validationService) {
    console.log("Inside CustomerImportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


//    $scope.dateList = {};    
//    $scope.dpOpenStatus = {};
//    $scope.setDpOpenStatus = function(id) {
//      $scope.dpOpenStatus[id] = true;
//    };

    $scope.smartTablePageSize = 250;
    $scope.manageCustomer = {};

    $scope.manageCustomerList = []; // temp line



    $scope.initManageCustomer = function() {

      $scope.manageCustomer = {};
      $scope.gridOptions = {};
      //$scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageCustomer();

    $scope.passOnlinesales = function(manageCustomer) {
      console.log("Inside passOnlinesales");
      console.log(manageCustomer);
    };

    $scope.ddmmyyyy = function (date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;

      if (dd <= 0) {
        var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear()
      ].join('');
    };

    $scope.getInDate = function(date, day) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - day;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.createCustomer = function(manageCustomer) {
      console.log("Inside manageCustomer");
      var isFormValidated = true;

	  if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
          console.log("Fill all required fields");
          //toastr.error('Please choose a Date and File to Upload', 'ERROR');
		  toastr.error('Please choose a file to Upload', 'ERROR');

      }

      if (isFormValidated) {

        var cdate = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          var date = new Date();
          var indate = new Date();

          record.code = $scope.gridOptions.data[i].AccNo;
          record.name = $scope.gridOptions.data[i].Name;
          record.ic = $scope.gridOptions.data[i].IC;
          record.passport = $scope.gridOptions.data[i].Passport;
          record.address = $scope.gridOptions.data[i].Address;
          record.contact = $scope.gridOptions.data[i].Contact;
          record.gname = $scope.gridOptions.data[i].GName;
          record.gic = $scope.gridOptions.data[i].GIC;
          record.gpassport = $scope.gridOptions.data[i].GPassport;
          record.gaddress = $scope.gridOptions.data[i].GAddress;
          record.gcontact = $scope.gridOptions.data[i].GContact;
          record.created = cdate;
          record.lastupdated = cdate;

          console.log(record);

          obj.params.push(record);
        }

        console.log(obj.params);

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};
          //$scope.dateList = {};
          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          $scope.initManageCustomer();
          toastr.success('New Customers has been Imported Successfully!', 'SUCCESS');
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {

            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                data.machineid = err.config.data[i].mid;
                data.cmin = err.config.data[i].cmIn;
                data.cmout = err.config.data[i].cmOut;
                data.bmin = err.config.data[i].bmIn;
                data.bmout = err.config.data[i].bmOut;

                data.AccNo = $err.config.data[i].AccNo;
                data.Name = $err.config.data[i].Name;
                data.IC = $err.config.data[i].IC;
                data.Passport = $err.config.data[i].Passport;
                data.Address = $err.config.data[i].Address;
                data.Contact = $err.config.data[i].Contact;
                data.GName = $err.config.data[i].GName;
                data.GIC = $err.config.data[i].GIC;
                data.GPassport = $err.config.data[i].GPassport;
                data.GAddress = $err.config.data[i].GAddress;
                data.GContact = $err.config.data[i].GContact;
                // if (typeof err.config.data[i].mid === 'undefined') {
                //   data.ERROR = 'Blank Machine Code';
                // } else if (typeof err.config.data[i].shopid === 'undefined') {
                //   data.ERROR = 'No Shop Reference';
                // } else if (typeof err.config.data[i].machineid === 'undefined') {
                //   data.ERROR = 'No Machine Reference';
                // } else if (err.config.data[i].shopid === null) {
                //   data.ERROR = 'No Shop Reference';
                // }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        };
        customerService.createManyCustomers(obj);
      }
    };

    $scope.getMachineShopDetails = function(mid) {
      if (mid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getMachineDetails = function(mid) {
      if (mid && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form.customer')
    .service('customerImportService', customerImportService);

  /** @ngInject */
  function customerImportService(Customer) {

    var getCustomer = function(obj) {
      //read data from gridoptions
      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var today = y+'-'+m+'-'+d.getUTCDate();
      //var today  = new Date(date);
      console.log('date',today);
      //var yesterday = new Date(today);
      //yesterday.setDate(today.getUTCDate() - 1);
      var today = y+'-'+m+'-'+(d.getUTCDate()-1);
      console.log('date', yesterday);

      Customer.find({
        filter: {
          where:{
            and:[
              {created: {gte: yesterday}},
              {created: {lt:today}}
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createCustomer = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Customer.createMany(
        obj.params

        // playtechid: obj.params.playtechid,
        // pshare: obj.params.pshare,
        // pwin: obj.params.pwin,
        // netpurchase: obj.params.netpurchase,
        // netgaming: obj.params.netgaming,
        // totalsales: obj.params.totalsales,
        // csales: obj.params.csales,
        // psales: obj.params.psales,
        // created: date,
        // lastupdated: date
        /*
          	    zoneid: obj.params.zone,
                shopid: obj.params.shop,
        */
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveCustomer = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Customer.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
    return {
      getCustomer: getCustomer,
      saveCustomer: saveCustomer,
      createCustomer: createCustomer
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.form.interval')
    .controller('IntervalImportPageCtrl', IntervalImportPageCtrl);

  /** @ngInject */
  function IntervalImportPageCtrl($scope, $filter, editableOptions, editableThemes,
    toastr, $uibModal, SheetJSExportService,
   validationService, caseService, intervalImportService ) {
    console.log("Inside IntervalImportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


//    $scope.dateList = {};    
//    $scope.dpOpenStatus = {};
//    $scope.setDpOpenStatus = function(id) {
//      $scope.dpOpenStatus[id] = true;
//    };

    $scope.smartTablePageSize = 250;
    $scope.manageInterval = {};

    $scope.manageIntervalList = []; // temp line

    $scope.manageCaseList = [];
    $scope.initManageCase = function (reportFilter) {
      var obj = {};
      obj.params={};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCaseList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      caseService.getCase(obj);
    };



    $scope.initManageInterval = function() {
      $scope.initManageCase();
      $scope.manageInterval = {};
      $scope.gridOptions = {};
      //$scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageInterval();

    $scope.passOnlinesales = function(manageInterval) {
      console.log("Inside passOnlinesales");
      console.log(manageInterval);
    };
    

    $scope.getCaseId = function(caseNo) {
      if(caseNo && $scope.manageCaseList.length) {
        var selected = $filter('filter')($scope.manageCaseList, {code: caseNo
        },true);
        return selected.length ? selected[0].id : null;
      } else {return null;}
    };


    $scope.createInterval = function(manageInterval) {
      console.log("Inside manageInterval");
      var isFormValidated = true;

	  if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
          console.log("Fill all required fields");
          //toastr.error('Please choose a Date and File to Upload', 'ERROR');
		  toastr.error('Please choose a file to Upload', 'ERROR');

      }

      if (isFormValidated) {

        var cdate = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          if ($scope.gridOptions.data[i].CaseNo) {

            record.caseid = $scope.getCaseId(($scope.gridOptions.data[i].CaseNo).trim());
            record.casecode = ($scope.gridOptions.data[i].CaseNo).trim();
            record.interval = $scope.gridOptions.data[i].Intervals;
            record.status = true;
            record.created = cdate;
            record.lastupdated = cdate;
  
            console.log(record);
  
            obj.params.push(record);
          
  
          
          } else {
            toastr.error('Case No. is empty', 'ERROR');
          }
        }
        console.log(obj.params);
          obj.onSuccess = function(result) {
            console.log("Inside SUCCESS");
            console.log(result);
            $scope.gridOptions = {};
            //$scope.dateList = {};
            var filename = document.querySelector('#uploadFile');
            angular.element(filename).val(null);
            $scope.initManageInterval();
            toastr.success('New Intervals has been Imported Successfully!', 'SUCCESS');
          };
          obj.onFailure = function(err) {
            console.log("Inside Failure");
            console.log(err);
            if (err.status === -1) {
              toastr.error('Service Unavailable. Please try again later', 'ERROR');
            } else {
  
              var errdetails = [];
              errdetails = err.data.error.details;
  
              toastr.error('Issue with upload!', 'ERROR');
              var errObj = [];
  
  
              for (var i = 0; i < errdetails.length; i++) {
                if (errdetails[i]) {
                  var data = {};
                  data.CaseNo = err.config.data[i].casecode;
                  data.Intervals = err.config.data[i].interval;

                  if (err.config.data[i].caseid === null) {
                    data.ERROR = 'Case No. does not exists';
                  }
                  // data.machineid = err.config.data[i].mid;
                  // data.cmin = err.config.data[i].cmIn;
                  // data.cmout = err.config.data[i].cmOut;
                  // data.bmin = err.config.data[i].bmIn;
                  // data.bmout = err.config.data[i].bmOut;
  
                  // data.AccNo = $err.config.data[i].AccNo;
                  // data.Name = $err.config.data[i].Name;
                  // data.IC = $err.config.data[i].IC;
                  // data.Passport = $err.config.data[i].Passport;
                  // data.Address = $err.config.data[i].Address;
                  // data.Contact = $err.config.data[i].Contact;
                  // data.GName = $err.config.data[i].GName;
                  // data.GIC = $err.config.data[i].GIC;
                  // data.GPassport = $err.config.data[i].GPassport;
                  // data.GAddress = $err.config.data[i].GAddress;
                  // data.GContact = $err.config.data[i].GContact;
                  // if (typeof err.config.data[i].mid === 'undefined') {
                  //   data.ERROR = 'Blank Machine Code';
                  // } else if (typeof err.config.data[i].shopid === 'undefined') {
                  //   data.ERROR = 'No Shop Reference';
                  // } else if (typeof err.config.data[i].machineid === 'undefined') {
                  //   data.ERROR = 'No Machine Reference';
                  // } else if (err.config.data[i].shopid === null) {
                  //   data.ERROR = 'No Shop Reference';
                  // }
                  errObj.push(data);
                }
              }
              console.log(errObj);
              $scope.gridOptions.data = errObj;
            }
          };
          intervalImportService.createTerms(obj);
         

      }
    };

    $scope.getMachineShopDetails = function(mid) {
      if (mid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getMachineDetails = function(mid) {
      if (mid && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form.interval')
    .service('intervalImportService', intervalImportService);

  /** @ngInject */
  function intervalImportService(Terms) {

    var getTerms = function(obj) {
      //read data from gridoptions
      var d = new Date(), y = d.getFullYear(), m = d.getMonth()+1;
      var today = y+'-'+m+'-'+d.getUTCDate();
      //var today  = new Date(date);
      console.log('date',today);
      //var yesterday = new Date(today);
      //yesterday.setDate(today.getUTCDate() - 1);
      var today = y+'-'+m+'-'+(d.getUTCDate()-1);
      console.log('date', yesterday);

      Terms.find({
        filter: {
          where:{
            and:[
              {created: {gte: yesterday}},
              {created: {lt:today}}
            ]
          },
          include: ["shop"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createTerms = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Terms.createMany(
        obj.params

        // playtechid: obj.params.playtechid,
        // pshare: obj.params.pshare,
        // pwin: obj.params.pwin,
        // netpurchase: obj.params.netpurchase,
        // netgaming: obj.params.netgaming,
        // totalsales: obj.params.totalsales,
        // csales: obj.params.csales,
        // psales: obj.params.psales,
        // created: date,
        // lastupdated: date
        /*
          	    zoneid: obj.params.zone,
                shopid: obj.params.shop,
        */
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveTerms = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Terms.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
    return {
      getTerms: getTerms,
      saveTerms: saveTerms,
      createTerms: createTerms
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.form.onlinesales')
    .controller('OnlinesalesPageCtrl', OnlinesalesPageCtrl);

  /** @ngInject */
  function OnlinesalesPageCtrl($scope, $filter, editableOptions, editableThemes,
    onlinesalesService, toastr, $uibModal, SheetJSExportService, gameService,
    onlineShopService,shopService,validationService) {
    console.log("Inside OnlinesalesPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

//    $scope.dateList = {};    
//    $scope.dpOpenStatus = {};
//    $scope.setDpOpenStatus = function(id) {
//      $scope.dpOpenStatus[id] = true;
//    };
    $scope.smartTablePageSize = 100;
    $scope.manageOnlinesales = {};
    $scope.manageOnlinesalesList = [];
    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getOnlineGame(obj);
    };

    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageOnlineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlineShopService.getAllOnlineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function() {
      var obj = {};
      obj.params={};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageShop");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);
    };

    $scope.initManageOnlinesales = function() {
      console.log($scope.manageOnlinesales.import);
      $scope.initManageGames();
      $scope.initManageShop();
      $scope.initManageOnlineShop();
      $scope.manageOnlinesales = {};
      $scope.gridOptions={};
//      $scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManageOnlinesales();
    $scope.passOnlinesales = function(manageOnlinesales) {
      console.log("Inside passOnlinesales");
      console.log(manageOnlinesales);
    }


    $scope.getShopId = function(playtechid) {
      if(playtechid && $scope.manageOnlineShopList.length) {
        var selected = $filter('filter')($scope.manageOnlineShopList, {playtechid: playtechid
        },true);
        return selected.length ? selected[0].shopid : null;
      } else return null;
    };

    $scope.getShopDetails = function(shopid) {
      if (shopid &&  $scope.manageShopList.length){
        var selected = $filter('filter')($scope.manageShopList, {id: shopid
        },true);
        return selected.length ? selected[0] : null;
      }else return null;
    };

    $scope.ddmmyyyy = function(date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear()
      ].join('');
    };

    $scope.getInDate = function(date) {
      var mm = date.getMonth() + 1; // getMonth() is zero-based
      var dd = date.getDate() - 1;
      
      if (dd <= 0) {
       var d1 = date;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/');
    };

    $scope.createOnlinesales = function(manageOnlinesales) {
      console.log("Inside manageOnlinesales");
      console.log($scope.gridOptions.data);
//      console.log($scope.dateList.from); 
      var isFormValidated = true;

//      if (validationService.isEmptyOrNullValidation(manageOnlinesales.game) && validationService.isEmptyOrNullValidation($scope.dateList.from) && 
		if (validationService.isEmptyOrNullValidation(manageOnlinesales.game) &&
          ($scope.gridOptions.data.length)) {
           //No Furhter Validations

      } else {
        isFormValidated = false;
        console.log("Fill all required fields");
        //toastr.error('Please select a Game, Date and choose a file to Upload', 'ERROR');
		toastr.error('Please select a Game and choose a file to Upload', 'ERROR');
      }


      if (isFormValidated){
        var cdate = new Date();
      var obj = {};
      obj.params=[];
      var dataLength = $scope.gridOptions.data.length;
      for (var i=0; i<dataLength;i++){
        var record = {};
        var date = new Date();
        var indate = new Date();
        record.playtechid = $scope.gridOptions.data[i].Kiosk;
        var localShopid  = $scope.getShopId(record.playtechid);
        record.pshare = $scope.gridOptions.data[i].PS?$scope.gridOptions.data[i].PS.replace('MYR','').replace(',',''):0;
        record.pwin = $scope.gridOptions.data[i].PW?$scope.gridOptions.data[i].PW.replace('MYR','').replace(',',''):0;
        record.netpurchase = $scope.gridOptions.data[i].NP?$scope.gridOptions.data[i].NP.replace('MYR','').replace(',',''):0;
        record.netgaming = $scope.gridOptions.data[i].NG?$scope.gridOptions.data[i].NG.replace('MYR','').replace(',',''):0;

        //var totalPSPW = parseFloat(record.pshare) + parseFloat(record.pwin);
        //record.totalsales = parseFloat(record.netpurchase - totalPSPW).toFixed(2);

        record.totalsales = ((parseFloat(record.netpurchase) - parseFloat(record.pshare)) + parseFloat(record.pwin)).toFixed(2);

        var localShop = $scope.getShopDetails(localShopid);

        if (localShop){
          record.csales = parseFloat(record.totalsales * parseFloat(localShop.onrate/100))
          record.psales = parseFloat(record.totalsales - record.csales).toFixed(2);
        }
        record.csales = ((record.csales + parseFloat(record.pshare)) - parseFloat(record.pwin)).toFixed(2);//bug fix code share by udit in sync with Ms lee

        record.shopid = localShopid;
        record.gameid = manageOnlinesales.game?manageOnlinesales.game.id:null;
        record.created = cdate; //$scope.dateList.from; // date;
        record.indate = $scope.getInDate(indate);
//		record.created = $scope.dateList.from;
        record.lastupdated = cdate;

        //var d = $scope.ddmmyyyy($scope.dateList.from);
		    var d = $scope.ddmmyyyy(date);
        record.ikey = localShopid+''+d;
        console.log(record.ikey);

        obj.params.push(record);
      }

      console.log(obj.params);

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.gridOptions={};
        //$scope.dateList = {};
        var filename = document.querySelector('#uploadFile');
        angular.element(filename).val(null);
        toastr.success('New Online Sales has been saved successfully!', 'SUCCESS');
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'ERROR');
        } else {
          var errdetails = [];
          errdetails = err.data.error.details;

          toastr.error('Issue with upload!', 'ERROR');
          var errObj = [];


          for (var i=0; i< errdetails.length;i++){
            if (errdetails[i]){
              var data = {};
                data.Kiosk = err.config.data[i].playtechid;
                data.PS = err.config.data[i].pshare;
                data.PW = err.config.data[i].pwin;
                data.NP = err.config.data[i].netpurchase;
                data.NG = err.config.data[i].netgaming;
                if (typeof err.config.data[i].playtechid==='undefined'){
                  data.ERROR = 'Blank Kiosk';
                }else if (err.config.data[i].shopid===null){
                  data.ERROR ='No Shop Reference';
                }
              errObj.push(data);
            }
          }
          console.log(errObj);
          $scope.gridOptions.data = errObj;
        }
      }
      onlinesalesService.createOnlinesales(obj);
    }
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form.onlinesales')
    .service('onlinesalesService', onlinesalesService);

  /** @ngInject */
  function onlinesalesService(Onlinesales) {

    var getOnlinesales = function(obj) {
      //read data from gridoptions
      Onlinesales.find({
        filter: {
          include: ["onlineshop","shop","game"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Onlinesales.createMany(
        obj.params
        // id: obj.params.id,
        // playtechid: obj.params.playtechid,
        // pshare: obj.params.pshare,
        // pwin: obj.params.pwin,
        // netpurchase: obj.params.netpurchase,
        // netgaming: obj.params.netgaming,
        // totalsales: obj.params.totalsales,
        // csales: obj.params.csales,
        // psales: obj.params.psales,
        // created: date,
        // lastupdated: date
        /*
          	    zoneid: obj.params.zone,
                shopid: obj.params.shop,
        */
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveOnlinesales = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Onlinesales.prototype$updateAttributes({
        id: obj.params.id,
        playtechid: obj.params.playtechid,
        pshare: obj.params.pshare,
        pwin: obj.params.pwin,
        netpurchase: obj.params.netpurchase,
        netgaming: obj.params.netgaming,
        totalsales: obj.params.totalsales,
        csales: obj.params.csales,
        psales: obj.params.psales,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };
    return {
      getOnlinesales: getOnlinesales,
      saveOnlinesales: saveOnlinesales,
      createOnlinesales: createOnlinesales
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.form.payment')
    .controller('PaymentImportPageCtrl', PaymentImportPageCtrl);

  /** @ngInject */
  function PaymentImportPageCtrl($scope, $filter, editableOptions, editableThemes,
    paymentImportService, toastr, $uibModal, SheetJSExportService,
   validationService, caseService) {
    console.log("Inside PaymentImportPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };


//    $scope.dateList = {};    
//    $scope.dpOpenStatus = {};
//    $scope.setDpOpenStatus = function(id) {
//      $scope.dpOpenStatus[id] = true;
//    };

    $scope.smartTablePageSize = 250;
    $scope.managePayment = {};

    $scope.managePaymentList = []; // temp line

    $scope.manageCaseList = [];
    $scope.initManageCase = function (reportFilter) {
      var obj = {};
      obj.params={};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCaseList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      caseService.getCase(obj);
    };

    $scope.initManagePayment = function() {
      $scope.initManageCase();
      $scope.managePayment = {};
      $scope.gridOptions = {};
      //$scope.dateList = {};
      var filename = document.querySelector('#uploadFile');
      angular.element(filename).val(null);
    };

    $scope.initManagePayment();

    $scope.passOnlinesales = function(managePayment) {
      console.log("Inside passOnlinesales");
      console.log(managePayment);
    };

    $scope.getCaseId = function(caseNo) {
      if(caseNo && $scope.manageCaseList.length) {
        var selected = $filter('filter')($scope.manageCaseList, {code: caseNo
        },true);
        return selected.length ? selected[0].id : null;
      } else {return null;}
    };

    $scope.createPayment = function(managePayment) {
      console.log("Inside managePayment");
      var isFormValidated = true;

	  if ($scope.gridOptions.data.length) {
        //No Furhter Validations
      } else {
        isFormValidated = false;
          console.log("Fill all required fields");
          //toastr.error('Please choose a Date and File to Upload', 'ERROR');
		  toastr.error('Please choose a file to Upload', 'ERROR');

      }

      if (isFormValidated) {

        var cdate = new Date();
        var obj = {};
        obj.params = [];
        var dataLength = $scope.gridOptions.data.length;
        for (var i = 0; i < dataLength; i++) {
          var record = {};
          if ($scope.gridOptions.data[i].CaseNo) {
          
          record.caseid = $scope.getCaseId(($scope.gridOptions.data[i].CaseNo).trim());
          record.casecode = $scope.gridOptions.data[i].CaseNo;
          record.amount = $scope.gridOptions.data[i].Amount;
          record.paydate = $scope.gridOptions.data[i].PayDate;
          record.created = cdate;
          record.lastupdated = cdate;

          console.log(record);

          obj.params.push(record);         
        } else {
          toastr.error('Case No. is empty', 'ERROR');
        }
        }

        console.log(obj.params);

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.gridOptions = {};
          //$scope.dateList = {};
          var filename = document.querySelector('#uploadFile');
          angular.element(filename).val(null);
          $scope.initManagePayment();
          toastr.success('New Payments has been Imported Successfully!', 'SUCCESS');
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'ERROR');
          } else {

            var errdetails = [];
            errdetails = err.data.error.details;

            toastr.error('Issue with upload!', 'ERROR');
            var errObj = [];


            for (var i = 0; i < errdetails.length; i++) {
              if (errdetails[i]) {
                var data = {};
                // data.machineid = err.config.data[i].mid;
                // data.cmin = err.config.data[i].cmIn;
                // data.cmout = err.config.data[i].cmOut;
                // data.bmin = err.config.data[i].bmIn;
                // data.bmout = err.config.data[i].bmOut;

                data.CaseNo = err.config.data[i].casecode;
                data.Amount = err.config.data[i].amount;
                data.PayDate = err.config.data[i].paydate;
                // data.IC = $err.config.data[i].IC;
                // data.Passport = $err.config.data[i].Passport;
                // data.Address = $err.config.data[i].Address;
                // data.Contact = $err.config.data[i].Contact;
                // data.GName = $err.config.data[i].GName;
                // data.GIC = $err.config.data[i].GIC;
                // data.GPassport = $err.config.data[i].GPassport;
                // data.GAddress = $err.config.data[i].GAddress;
                // data.GContact = $err.config.data[i].GContact;
                if (err.config.data[i].caseid === null) {
                  data.ERROR = 'Case No. does not exists';
                }
                  // } else if (typeof err.config.data[i].shopid === 'undefined') {
                //   data.ERROR = 'No Shop Reference';
                // } else if (typeof err.config.data[i].machineid === 'undefined') {
                //   data.ERROR = 'No Machine Reference';
                // } else if (err.config.data[i].shopid === null) {
                //   data.ERROR = 'No Shop Reference';
                // }
                errObj.push(data);
              }
            }
            console.log(errObj);
            $scope.gridOptions.data = errObj;
          }
        };
        paymentImportService.createPayment(obj);
      }
    };

    $scope.getMachineShopDetails = function(mid) {
      if (mid && $scope.manageMachineShopList.length) {
        var selected = $filter('filter')($scope.manageMachineShopList, {
          machineid: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    $scope.getMachineDetails = function(mid) {
      if (mid && $scope.manageMachineList.length) {
        var selected = $filter('filter')($scope.manageMachineList, {
          code: mid
        },true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form.payment')
    .service('paymentImportService', paymentImportService);

  /** @ngInject */
  function paymentImportService(Payment) {

    var getPayment = function(obj) {

      Payment.find({
        filter: {
          where:{
            caseid: obj.params.caseid
          }
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var createPayment = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();
      //read data from gridoptions instead of table
      Payment.createMany(
        obj.params
      ).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var savePayment = function(obj) {
      var date = new Date();

      Payment.prototype$updateAttributes({
        id: obj.params.id,
        amount: obj.params.amount,
        remarks: obj.params.remarks,
        lastupdated: date
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var deletePayment = function(obj) {

      Payment.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    return {
      getPayment: getPayment,
      savePayment: savePayment,
      createPayment: createPayment,
      deletePayment:deletePayment
    };

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.case')
    .controller('CasePageCtrl', CasePageCtrl);

  /** @ngInject */
  function CasePageCtrl($scope, $filter, editableOptions, editableThemes,
    caseService, customerService, toastr, $uibModal, $state,
    $rootScope, baConfig, paymentImportService) {
    console.log("Inside CasePageCtrl");

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};
    $scope.dpOpenStatus1 = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.setDpOpenStatus1 = function (id) {
      $scope.dpOpenStatus1[id] = true;
    };

    $scope.opened = {};

    $scope.open = function ($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened[elementOpened] = !$scope.opened[elementOpened];
    };

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCase(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    if (typeof $rootScope.userData.credentials.caseType !== "undefined") {
      $scope.caseTypeFilter = [{
        value: $rootScope.userData.credentials.caseType
      }];
    } else {
      $scope.caseTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }

    $scope.openDeleteOnlineCase = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlineCase(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };



    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;



    $scope.init = function () {
      // $scope.initManageZones();
      // $scope.initManagePartner();
      // $scope.initManageAreas();
      // $scope.initManageGames();
      // // $scope.initManageSupplier();
      // $scope.initManageSites();
    };
    // $scope.init();

    $scope.manageCase = {};
    $scope.manageCaseList = [];
    $scope.customerList = [];
    $scope.reportFilter = {};
    $scope.initManageCase = function (reportFilter) {
      //$scope.manageCase = {};
      $scope.isEditCustomer = false;
      $scope.isEditPayment = false;
      $scope.originalCustomer = {};
      var obj = {};
      obj.params = {};

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCaseList = result;

        if ($scope.manageCaseList.length) {
          for (var i = 0; i < $scope.manageCaseList.length; i++) {
            // console.log('Inside Loop');
            var interval = 0;
            var days = 0;
            if ($scope.manageCaseList[i].terms.length) {
              for (var index = 0; index < $scope.manageCaseList[i].terms.length; index++) {
                if ($scope.manageCaseList[i].terms[index].status === true) {
                  interval = $scope.manageCaseList[i].terms[index].interval;
                }
              }

              if ($scope.manageCaseList[i].iamount !== $scope.manageCaseList[i].tamount) {
                days = parseFloat($scope.manageCaseList[i].amount) / parseFloat($scope.manageCaseList[i].tamount);
                days = days * interval;
              } else {
                days = 365 * 2;
              }
              // console.log('days',days);

              if (days) {
                var startDate = new Date($scope.manageCaseList[i].reldate);
                var endDate = new Date(startDate.getTime() + (days * 24 * 60 * 60 * 1000));
                $scope.manageCaseList[i].maturityDate = endDate;
              }
            }
          }
        }
        //$scope.initManageOnlineCase();
        $scope.isEdit = false;

      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      caseService.getCase(obj);

    };
    $scope.initManageCase($scope.reportFilter);

    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/operational/case/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteCase = function (res) {
      console.log("Inside deleteCase");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Case has been deleted successfully!', 'SUCCESS');

          $scope.initManageCase($scope.reportFilter);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        caseService.deleteCase(obj);
      } else {
        console.log('Not sure!');
      }

    };


    $scope.saveCase = function (manageCase) {

      console.log("Inside saveCase");
      console.log($scope.manageCase);

      if (manageCase.id === undefined) {
        // $scope.createCase(manageCase);
        toastr.error('Case No. does not Exists', 'Error');
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageCase;

        if ($scope.originalCustomer.code !== manageCase.customer.code) {
          obj.params.custid = manageCase.customer.id;
          obj.params.custcode = manageCase.customer.code;
        }

        if (manageCase.reldate) {
          var d = new Date(manageCase.reldate),
            y = d.getFullYear(),
            m = d.getMonth() + 1;
          var selectedRelDate = y + '-' + m + '-' + d.getDate();

          obj.params.reldate = selectedRelDate;
        }

        if (manageCase.closedate) {
          var d1 = new Date(manageCase.closedate),
            y1 = d1.getFullYear(),
            m1 = d1.getMonth() + 1;
          var selectedCloseDate = y1 + '-' + m1 + '-' + d1.getDate();

          obj.params.closedate = selectedCloseDate;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageCase = {};
          toastr.success('Case has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageCase($scope.reportFilter);

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }
          var errmessage = err.data.error.message;
          if (errmessage === 'duplicate key value violates unique constraint "case_ukcode"') {
            toastr.error('Sorry.The Case no. is being used for another case.Please choose another case no.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        caseService.saveCase(obj);
      }

    };

    $scope.showPartner = function (partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partner.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };



    $scope.getScheduleDate = function (adate) {
      var mm = adate.getMonth() + 1; // getMonth() is zero-based
      var dd = adate.getDate();

      if (dd <= 0) {
        var d1 = adate;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        adate.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
      ].join('-');
    };

    var dashboardColors = baConfig.colors;
    //var $element;
    $scope.editCase = function (manageCase) {
      console.log("Inside editCase");

      caseService.getCaseById({
        params: {
          caseid: manageCase.id,
        },
        onSuccess: function (data) {

          $scope.manageCase = {};
          $scope.manageCase = data;
          $scope.originalCustomer = data.customer;
          console.log(data);
          $scope.getSchedule();
        },
        onFailure: function (err) {
          toastr.error('Unable to view case, contact Admin.', 'Error');
        }
      });

    };
    $scope.scheduleEntry = [];
    $scope.interval = 0;
    $scope.getSchedule = function () {

      $scope.manageCase.totalPaid = $scope.getTotalpayment($scope.manageCase.payment) + parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.tamount * ($scope.manageCase.firstm + $scope.manageCase.lastm));
      $scope.manageCase.amountDue = $scope.manageCase.amount - $scope.manageCase.totalPaid;

      $scope.managePaymentList = $scope.manageCase.payment;


      $scope.scheduleEntry = [];
      $scope.interval = 0;
      if ($scope.manageCase.terms.length) {
        for (var index = 0; index < $scope.manageCase.terms.length; index++) {
          if ($scope.manageCase.terms[index].status === true) {
            $scope.interval = $scope.manageCase.terms[index].interval;
          }
        }

        if ($scope.manageCase.iamount !== $scope.manageCase.tamount) {
          $scope.terms = $scope.manageCase.amount / $scope.manageCase.tamount;
          $scope.terms = $scope.terms * $scope.interval;
        } else {
          $scope.terms = 365 * 2;
        }
        console.log('$scope.interval', $scope.interval);
        console.log('terms', $scope.terms);
        if ($scope.terms) {
          //var date = new Date($scope.manageCase.reldate);

          var days = $scope.terms; // Days you want to Add
          var startDate = new Date($scope.manageCase.reldate);
          // var syear = startDate.getFullYear();
          // var smonth = startDate.getMonth()+1;
          // var sday = startDate.getDate();
          $scope.eDate = new Date(startDate.getTime() + (days * 24 * 60 * 60 * 1000));
          // var eday =endDate.getDate();
          // var emonth=endDate.getMonth()+1;
          // var eyear=endDate.getFullYear();

          $scope.sDate = $scope.getScheduleDate(startDate);
          // $scope.eDate = $scope.getScheduleDate(endDate);

          console.log('startDate', $scope.sDate);
          console.log('endDate', $scope.eDate);

          for (var i = 0; i < $scope.terms; i++) {
            var entryDate;
            if (i === 0) {
              entryDate = new Date(startDate.getTime());
            } else {
              entryDate = new Date(entryDate.getTime() + ($scope.interval * 24 * 60 * 60 * 1000));
            }


            //var scheduleDate =

            var entry = {};
            entry.title = "Schedule: " + $scope.manageCase.tamount;
            entry.start = $scope.getScheduleDate(entryDate);
            // entry.color = '#C39BD3';
            entry.color = '#FFF';
            entry.allDay = true;
            $scope.scheduleEntry.push(entry);
          }

          console.log('scheduleEntry');
          console.log($scope.scheduleEntry);
        }



        if ($scope.manageCase.firstm) {
          for (var f = 0; f < $scope.manageCase.firstm; f++) {

            var firstmDate = new Date(new Date($scope.manageCase.reldate).getTime() + (f * 24 * 60 * 60 * 1000));
            var entryfirstm = {};
            entryfirstm.title = "First: " + $scope.manageCase.tamount;
            entryfirstm.start = $scope.getScheduleDate(firstmDate);
            entryfirstm.color = '#b9f2a1';
            entryfirstm.allDay = true;
            $scope.scheduleEntry.push(entryfirstm);
          }
        }

        if ($scope.manageCase.lastm) {
          for (var l = 0; l < $scope.manageCase.lastm; l++) {
            var lastmDate;
            if (l === 0) {
              lastmDate = new Date($scope.eDate.getTime() - ($scope.manageCase.lastm * 24 * 60 * 60 * 1000));
            } else {
              lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            }

            //var lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            var entrylastm = {};
            entrylastm.title = "Last: " + $scope.manageCase.tamount;
            entrylastm.start = $scope.getScheduleDate(lastmDate);
            entrylastm.color = '#b9f2a1';
            entrylastm.allDay = true;
            $scope.scheduleEntry.push(entrylastm);
          }
        }
      }

      if ($scope.manageCase.payment.length) {
        for (var n = 0; n < $scope.manageCase.payment.length; n++) {
          var entryPayment = {};
          entryPayment.title = "Payment 付: " + parseFloat($scope.manageCase.payment[n].amount).toFixed(2);
          entryPayment.start = $scope.getScheduleDate(new Date($scope.manageCase.payment[n].paydate));
          entryPayment.color = $scope.manageCase.payment[n].amount >= $scope.manageCase.tamount ? '#b9f2a1' : '#ff6666';
          entryPayment.allDay = true;
          $scope.scheduleEntry.push(entryPayment);
        }
      }

      if ($scope.manageCase.isdeposit) {
        var depositTerm = $scope.manageCase.deposit / $scope.manageCase.tamount;
        var depTermFull = Math.ceil(depositTerm);
        console.log('depositTerm', depositTerm);
        console.log('depTermFull', depTermFull);
        var check = depTermFull - depositTerm;
        if (check != 0 && check > 0.5) {
          check = check - 0.5;
          check = 0.5 - check;
        }
        console.log('check', check);
        for (var d = 0; d < depTermFull; d++) {
          var lastmDate;
          var title = "";
          var entrydeposit = {};

          if (d === 0) {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + depTermFull) * 24 * 60 * 60 * 1000));
            if (check != 0) {
              var amount = (parseFloat($scope.manageCase.tamount) * parseFloat(check)).toFixed(2);
              title = "Deposit: " + amount;
            } else {
              title = "Deposit: " + $scope.manageCase.tamount;
            }
          } else {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + d) * 24 * 60 * 60 * 1000));
            title = "Deposit: " + $scope.manageCase.tamount;
          }

          entrydeposit.title = title;
          entrydeposit.start = $scope.getScheduleDate(lastmDate);
          entrydeposit.color = '#C39BD3';
          entrydeposit.allDay = true;
          $scope.scheduleEntry.push(entrydeposit);
        }

      }





      // if ($scope.manageCase.firstm!=0){
      //   var entryfirstm = {};
      //   entryfirstm.title = $scope.manageCase.tamount;
      //   entryfirstm.start =   $scope.sDate;
      //   entryfirstm.color = '#b9f2a1';
      //   entryfirstm.allDay = true;
      //   $scope.scheduleEntry.push(entryfirstm);
      // }
      $scope.isEdit = true;
    };

    $scope.addCase = function () {
      console.log("Inside addCase");
      $scope.isEdit = true;
      $scope.manageCase = {};
      $scope.manageOnlineCaseList = [];
      $scope.manageMachinecaseList = [];
      console.log($scope.manageZonesList);
    };

    //Online Games

    $scope.addOnlineCase = function () {
      $scope.inserted = {
        caseid: $scope.manageCase.id,
        gameid: null,
        playtechid: null
      };
      $scope.manageOnlineCaseList.push($scope.inserted);
    };

    $scope.deleteOnlineCaseId = null;
    $scope.confirmOnlineCaseDelete = function (id) {
      $scope.openDeleteOnlineCase('app/pages/operational/case/modals/dangerOnlineGameModal.html');
      $scope.deleteOnlineCaseId = id;
    };

    $scope.deleteOnlineCase = function (res) {
      console.log("Inside deleteOnlineCase");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteOnlineCaseId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteOnlineCaseId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been deleted successfully!', 'SUCCESS');

          $scope.initManageOnlineCase();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineCase();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineCaseService.deleteOnlinecase(obj);
      }
    };

    // $scope.deleteMachinecaseId = null;
    // $scope.confirmMachinecaseDelete = function(id) {
    //   $scope.openDeleteMachinecase('app/pages/operational/case/modals/dangerMachineGameModal.html');
    //   $scope.deleteMachinecaseId = id;
    // };




    // $scope.updateInterest = function (value){
    //   $scope.manageCase.interest = value;
    //   switch ($scope.manageCase.interest) {
    //     case 'D':
    //       $scope.manageCase.iDAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.idaily / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iDAmount);
    //       break;
    //     case 'W':
    //       $scope.manageCase.iWAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.iweekly / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iWAmount);
    //       break;
    //     case 'M':
    //       $scope.manageCase.iMAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.imonthly / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iMAmount);
    //       break;
    //     case 'Y':
    //       $scope.manageCase.iYAmount = parseFloat($scope.manageCase.principle) * ($scope.manageCase.iyearly / 100);
    //       $scope.manageCase.amount = parseFloat($scope.manageCase.principle) + parseFloat($scope.manageCase.iYAmount);
    //       break;
    //   }
    // };

    // $scope.updateTerm = function (value){
    //   $scope.manageCase.term = value;

    //   switch ($scope.manageCase.term) {
    //     case 'D':
    //     $scope.manageCase.tDAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tday;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tDAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //     break;
    //     case 'W':
    //     $scope.manageCase.tWAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tweek;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tWAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //       break;
    //     case 'M':
    //     $scope.manageCase.tMAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tmonth;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tMAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //       break;
    //     case 'Y':
    //     $scope.manageCase.tYAmount = parseFloat($scope.manageCase.amount) / $scope.manageCase.tyear;
    //     $scope.manageCase.totalMethodAmount = parseFloat($scope.manageCase.tYAmount) * parseInt($scope.manageCase.totalMethod);
    //     $scope.manageCase.totalDeductions = parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.totalMethodAmount)+ parseFloat($scope.manageCase.stampduty);
    //     $scope.manageCase.cashout = parseFloat($scope.manageCase.principle)-parseFloat($scope.manageCase.totalDeductions);
    //       break;
    //   }
    // };

    $scope.getTotalpayment = function (items) {
      return items
        .map(function (x) {
          return x.amount || x.payment;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        }, 0);
    };

    $scope.recalculate = function () {
      var totalMethod = 0;
      var totalDeduction = 0;
      totalMethod = parseInt($scope.manageCase.firstm) + parseInt($scope.manageCase.lastm);
      totalDeduction = parseFloat($scope.manageCase.tamount) * parseInt(totalMethod);
      totalDeduction = totalDeduction + parseFloat($scope.manageCase.stampduty);
      totalDeduction = totalDeduction + parseFloat($scope.manageCase.deposit);
      if ($scope.manageCase.icollect) {
        totalDeduction = totalDeduction + parseFloat($scope.manageCase.iamount);
      }
      $scope.manageCase.deduction = parseFloat(totalDeduction).toFixed(2);
      $scope.manageCase.cashout = (parseFloat($scope.manageCase.principle) - parseFloat(totalDeduction)).toFixed(2);
    };

    $scope.addPayment = function () {
      $scope.isEditPayment = true;
    };
    $scope.cancelPayment = function () {
      $scope.isEditPayment = false;
    };

    $scope.savePaymentDetails = function (managePayment) {
      console.log('Inside savePaymentDetails');
      console.log('managePayment', managePayment);

      var date = new Date();
      var obj = {};
      obj.params = [];
      var record = {};
      record.caseid = $scope.manageCase.id;
      record.casecode = $scope.manageCase.code;
      record.amount = managePayment.amount;
      record.remarks = managePayment.remarks;
      record.agentid = $rootScope.userData.id;

      var d = managePayment.paydate,
        y = d.getFullYear(),
        m = d.getMonth() + 1;
      var selectedPayDate = y + '-' + m + '-' + d.getDate();

      record.paydate = selectedPayDate;
      record.created = date;
      record.lastupdated = date;

      obj.params.push(record);

      console.log('obj.params', obj.params);


      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS savePaymentDetails");
        console.log(result);
        toastr.success('Payment has been saved successfully!', 'SUCCESS');
        $scope.isEditPayment = false;
        $scope.initManageCase($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'Error');
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, 'Error');
        }
      };

      paymentImportService.createPayment(obj);

    };

    $scope.editPaymentDetails = function (managePayment, payid) {
      console.log('Inside editPaymentDetails');
      console.log('managePayment', managePayment);

      var obj = {};
      obj.params = {};
      obj.params.id = payid;
      obj.params.amount = managePayment.amount;
      obj.params.remarks = managePayment.remarks;

      console.log('obj.params', obj.params);


      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS editPaymentDetails");
        console.log(result);
        toastr.success('Payment has been saved successfully!', 'SUCCESS');
        $scope.initManageCase($scope.reportFilter);
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'Error');
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, 'Error');
        }
      };

      paymentImportService.savePayment(obj);

    };

    $scope.editCustomer = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log(result);
        $scope.customerList = result;
        $scope.isEditCustomer = true;
      };
      obj.onFailure = function (err) {
        console.log(err);
        $scope.isEditCustomer = false;
      };
      customerService.getCustomer(obj);
    };

    $scope.cancelEditCustomer = function () {
      $scope.isEditCustomer = false;
      $scope.manageCase.customer = $scope.originalCustomer;
    };

    $scope.openDeletePayment = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deletePayment(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.deletePaymentId = null;
    $scope.confirmPaymentDelete = function (id) {
      $scope.openDeletePayment('app/pages/operational/case/modals/dangerPayment.html');
      $scope.deletePaymentId = id;
    };

    $scope.deletePayment = function (res) {
      console.log("Inside deletePayment");
      if (res) {
        console.log('Sure!');
        console.log($scope.deletePaymentId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deletePaymentId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Payment has been deleted successfully!', 'SUCCESS');
          // $scope.getCaseById();
          $scope.initManageCase($scope.reportFilter);
          //$scope.initManageOnlineShop();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        paymentImportService.deletePayment(obj);
      }
    };

    editableOptions.theme = 'bs3';
    editableThemes.bs3.submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes.bs3.cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.getAgentName = function (credentials) {
      if (credentials.name != null && credentials.name.length > 0)
        return credentials.name;
      else
        return credentials.firstName + " " + credentials.lastName;
    };
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.case')
    .service('caseService', caseService);

  /** @ngInject */
  function caseService(Case) {
    var getCase = function (obj) {

      Case.find({
        filter: {
          include: [
            "customer",
            "agent",
            // {
            //   "payment": "payagent"
            // },
            "terms",
            "manager"
          ]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getCaseById = function (obj) {
      Case.findById({
        id: obj.params.caseid,
        filter: {
          include: [
            "customer",
            "agent",
            {
              "payment": "payagent"
            },
            "terms",
            "manager",
          ]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getCaseByZone = function (obj) {
      Case.find({
        filter: {
          where: {
            and: [{
                zoneid: obj.params.zoneid
              },
              {
                status: true
              }
            ]
          },
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createCase = function (obj) {
      var date = new Date();

      Case.create({
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        casetype: obj.params.casetype,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteCase = function (obj) {

      Case.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveCase = function (obj) {
      var date = new Date();

      Case.prototype$updateAttributes({
        id: obj.params.id,
        principle: obj.params.principle,
        amount: obj.params.amount,
        deposit: obj.params.deposit,
        stampduty: obj.params.stampduty,
        firstm: obj.params.firstm,
        lastm: obj.params.lastm,
        cashout: obj.params.cashout,
        agentid: obj.params.agentid,
        code: obj.params.code,
        remark: obj.params.remark,
        custid: obj.params.custid,
        interest: obj.params.interest,
        term: obj.params.term,
        reldate: obj.params.reldate,
        closedate: obj.params.closedate,
        iamount: obj.params.iamount,
        tamount: obj.params.tamount,
        deduction: obj.params.deduction,
        custcode: obj.params.custcode,
        type: obj.params.type,
        pajakitem: obj.params.pajakitem,
        icollect: obj.params.icollect,
        verified: obj.params.verified,
        isdeposit: obj.params.isdeposit,
        status: obj.params.status,
        managerid: obj.params.managerid,
        lastupdated: date,
        isloan: obj.params.isloan
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findAssignedCase = function (obj) {
      Case.find({
        filter: {
          where: {
            id: {
              inq: obj.params.casemap
            }
          },
          include: ["customer"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findNotAssignedCase = function (obj) {
      if (obj.params.casemap) {
        Case.find({
          filter: {
            where: {
              and: [{
                  id: {
                    nin: obj.params.casemap
                  }
                },
                {
                  casetype: obj.params.casetype
                },
                {
                  zoneid: {
                    inq: obj.params.zonemap
                  }
                }
              ]
            },
            include: ["customer"]
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      } else {
        Case.find({
          filter: {
            where: {
              and: [{
                  casetype: obj.params.casetype
                },
                {
                  zoneid: {
                    inq: obj.params.zonemap
                  }
                }
              ]
            }
          },
          include: ["customer"]
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }

    };

    var findNotAssignedCaseForAdmin = function (obj) {
      Case.find({
        filter: {
          where: {
            id: {
              nin: obj.params.casemap
            }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    var unbindCaseStaff = function (obj) {
      var date = new Date();

      Case.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        userid: null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    // new code
    var createManyCases = function (obj) {

      Case.createMany(
        obj.params
      ).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getCase: getCase,
      createCase: createCase,
      deleteCase: deleteCase,
      saveCase: saveCase,
      createManyCases: createManyCases,
      findAssignedCase: findAssignedCase,
      findNotAssignedCase: findNotAssignedCase,
      findNotAssignedCaseForAdmin: findNotAssignedCaseForAdmin,
      unbindCaseStaff: unbindCaseStaff,
      getCaseById: getCaseById
    };

  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.case')
      .controller('scheduleCalendarCtrl', scheduleCalendarCtrl);

  /** @ngInject */
  function scheduleCalendarCtrl(baConfig,$scope) {
    console.log('Inside scheduleCalendarCtrl');
    
    var dashboardColors = baConfig.colors.dashboard;
    var date = new Date();
    var $element = $('#schedule').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month'
      },
      defaultDate:$scope.sDate,
      selectable: false,
      selectHelper: false,
      editable: false,
      eventLimit: true, // allow "more" link when too many events
      eventTextColor: '#000',
      events: $scope.scheduleEntry
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.customer')
    .controller('CustomerPageCtrl', CustomerPageCtrl);

  /** @ngInject */
  function CustomerPageCtrl($scope, $filter, editableOptions, editableThemes,
    customerService, toastr, $uibModal, $state, $rootScope) {
    console.log("Inside CustomerPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size

      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCustomer(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });
    };

    $scope.smartTablePageSize = 25;
    $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No"
    };




    $scope.init = function () {};
    $scope.init();

    $scope.manageCustomer = {
      customer: {}
    };
    $scope.manageCustomerList = [];
    $scope.reportFilter = {};
    $scope.initManageCustomer = function () {
      var obj = {};
      obj.params = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageCustomerList = result;
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      customerService.getCustomer(obj);
    };
    $scope.initManageCustomer();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageCustomerList.push($scope.inserted);
    };

    $scope.createCustomer = function (manageCustomer) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createCustomer");
      console.log(manageCustomer);

      var obj = {};
      obj.params = {};
      obj.params.code = manageCustomer.code;
      obj.params.name = manageCustomer.name;
      obj.params.ic = manageCustomer.ic;
      obj.params.passport = manageCustomer.passport;
      obj.params.address = manageCustomer.address;
      obj.params.contact = manageCustomer.contact;
      obj.params.gname = manageCustomer.gname;
      obj.params.gic = manageCustomer.gic;
      obj.params.gpassport = manageCustomer.gpassport;
      obj.params.gaddress = manageCustomer.gaddress;
      obj.params.gcontact = manageCustomer.gcontact;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.isEditSupplier = false;
        toastr.success('New Customer has been saved successfully!', 'SUCCESS');
        $scope.manageCustomer = Object.assign({}, $scope.manageCustomer, result);
        $scope.saveCustomerDetails();
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Customer successfully created.");
      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      customerService.createCustomer(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/operational/customer/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteCustomer = function (res) {
      console.log("Inside deleteCustomer");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Customer has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageCustomer($scope.reportFilter);
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        customerService.deleteCustomer(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (customer) {
      console.log("Inside editCustomer");
      console.log(customer);
      // $scope.manageCustomer.id = $scope.manageCustomer.id;
      // $scope.manageCustomer.name = state.name;
      // $scope.manageCustomer.description = state.description;
      // $scope.manageCustomer.created = state.created;
      // $scope.manageCustomer.lastupdated = state.lastupdated;
      $scope.manageCustomer = customer;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveCustomer = function (manageCustomer) {

      console.log("Inside saveCustomer");
      console.log(manageCustomer);

      if (manageCustomer.id === undefined) {
        $scope.createCustomer(manageCustomer);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageCustomer
        obj.params.id = manageCustomer.id;
        obj.params.code = manageCustomer.code;
        obj.params.name = manageCustomer.name;
        obj.params.ic = manageCustomer.ic;
        obj.params.passport = manageCustomer.passport;
        obj.params.address = manageCustomer.address;
        obj.params.contact = manageCustomer.contact;
        obj.params.gname = manageCustomer.gname;
        obj.params.gic = manageCustomer.gic;
        obj.params.gpassport = manageCustomer.gpassport;
        obj.params.gaddress = manageCustomer.gaddress;
        obj.params.gcontact = manageCustomer.gcontact;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.saveCustomerDetails();

          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        customerService.saveCustomer(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    //manageActiveCustomerList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveCustomerList.length) {
        var selected = $filter('filter')($scope.manageActiveCustomerList, {
          customerid: id
        }, true);
        return selected.length ? selected[0] : null;
      } else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editCustomer = function (manageCustomer) {
      console.log("Inside editCustomer");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageCustomer = manageCustomer;
      console.log('$scope.manageCustomer', $scope.manageCustomer);
      console.log('$scope.manageCustomer', $scope.manageCustomer.id);


      var obj = {};
      obj.params = {};
      obj.params.custid = $scope.manageCustomer.id;
      console.log('$scope.manageCustomer.custid', $scope.manageCustomer.custid)

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS addPayment");
        console.log(result);
        $scope.manageCustomer.customer = result[0] || {};
        console.log('$scope.manageCustomer', $scope.manageCustomer.customer)
        // console.log('$scope.manageCustomer.custid', $scope.manageCustomer.customer.custid)
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      customerService.getCustomerDetailsById(obj);

    };

    $scope.addCustomer = function () {
      console.log("Inside addCustomer");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageCustomer = {
        customer: {}
      };
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;
    };


    $scope.qrString = "";
    $scope.viewQRcode = function (code) {
      console.log('Inside viewQRcode', code);
      $scope.open('app/pages/operational/customer/modals/qrModal.html');
      $scope.qrString = code;
    };

    $scope.print = function () {
      window.print();
    };

    $scope.addCustomerShop = function () {
      $scope.inserted = {
        shopid: null,
        customerid: $scope.manageCustomer.id,
        macrate: null,
        macvirtual: null
      };
      $scope.manageCustomershopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function (supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showShop = function (shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shop.id
        }, true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.openDeleteCustomershop = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCustomershop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.deleteCustomershopId = null;
    $scope.confirmCustomershopDelete = function (id) {
      $scope.openDeleteCustomershop('app/pages/operational/customer/modals/dangerCustomerGameModal.html');
      $scope.deleteCustomershopId = id;
    };

    $scope.onFileSelect = function (model, key, result, error) {
      if (error) {
        toastr.error(error.message);
      } else {
        model[key] = result;
        $scope.$digest();
      }
    }

    $scope.saveCustomerDetails = function () {

      var params = $scope.manageCustomer.customer;
      params.custid = $scope.manageCustomer.id;
      var obj = {
        params: params,
        onSuccess: function (result) {
          console.log(result);
          $scope.manageCustomer = {
            customer: {}
          };
          toastr.success('Customer photos has been updated successfully!', 'SUCCESS');
          $scope.initManageCustomer($scope.reportFilter);

        },
        onFailure: function (err) {
          console.error('saveCustomerDetails', err);
        }
      }
      customerService.saveCustomerDetails(obj);
    }

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.operational.customer')
    .service('customerService', customerService);

  /** @ngInject */
  function customerService(Customer, Customerdetails) {
    var getCustomer = function (obj) {

      if (obj.params.zoneid != null) {
        Customer.find({
          filter: {
            where: {
              zoneid: obj.params.zoneid.length > 0 ? {
                inq: obj.params.zoneid
              } : obj.params.zoneid
            },
            include: ["game", "zone", "supplier", {
              "relation": "customershop",
              "scope": {
                "include": ["shop"]
              }
            }]
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      } else {
        Customer.find().$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }
    };

    var getCustomerDetailsById = function (obj) {
      Customerdetails.find({
        filter: {
          where: {
            custid: obj.params.custid
          }
        }
      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getAllCustomer = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Customer.find({
        filter: {
          include: ["supplier"]
        }
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getCustomerByZone = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Customer.find({
        filter: {
          where: {
            zoneid: obj.params.zoneid
          },
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createCustomer = function (obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Customer.create({
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        ic: obj.params.ic,
        passport: obj.params.passport,
        address: obj.params.address,
        contact: obj.params.contact,
        gname: obj.params.gname,
        gic: obj.params.gic,
        gpassport: obj.params.gpassport,
        gaddress: obj.params.gaddress,
        gcontact: obj.params.gcontact

      }).$promise.then(function (data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteCustomer = function (obj) {

      Customer.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveCustomer = function (obj) {
      var date = new Date();

      Customer.prototype$updateAttributes({
        id: obj.params.id,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        ic: obj.params.ic,
        passport: obj.params.passport,
        address: obj.params.address,
        contact: obj.params.contact,
        gname: obj.params.gname,
        gic: obj.params.gic,
        gpassport: obj.params.gpassport,
        gaddress: obj.params.gaddress,
        gcontact: obj.params.gcontact

      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };


    var saveCustomerDetails = function (obj) {
      var params = obj.params;
      params.lastupdated = new Date();
      Customerdetails.replaceOrCreate(
        params
      ).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createManyCustomers = function (obj) {

      Customer.createMany(
        obj.params
      ).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getCustomer: getCustomer,
      getAllCustomer: getAllCustomer,
      createCustomer: createCustomer,
      deleteCustomer: deleteCustomer,
      saveCustomer: saveCustomer,
      getCustomerByZone: getCustomerByZone,
      createManyCustomers: createManyCustomers,
      getCustomerDetailsById: getCustomerDetailsById,
      saveCustomerDetails: saveCustomerDetails
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.casesummary')
    .controller('CaseSummaryreportPageCtrl', CaseSummaryreportPageCtrl);

  /** @ngInject */
  function CaseSummaryreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    caseSummaryreportService, baConfig, validationService, toastr, $uibModal, $rootScope, caseService, paymentImportService, $state) {
    console.log("Inside CaseSummaryreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCaseSummary(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    if (typeof $rootScope.userData.credentials.caseType !== "undefined") {
      $scope.caseTypeFilter = [{
        value: $rootScope.userData.credentials.caseType
      }];
    } else {
      $scope.caseTypeFilter = [{
        value: '5/5'
      }, {
        value: '100%'
      }];
    }


    $scope.dayNightFilter = [{
      value: 'Open'
    }, {
      value: 'Closed'
    }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {}; //my edit start
    $scope.dpOpenStatus1 = {};
    $scope.isEditPayment = false;
    // finish



    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    // start
    $scope.setDpOpenStatus1 = function (id) {
      $scope.dpOpenStatus1[id] = true;
    };
    //finish


    $scope.dateList = {
      fromRelDate: new Date(new Date().setDate(1)),
      toRelDate: new Date(),
      toCloseDate: new Date(),
    };

    $scope.shopTypeFilter = [{
      value: 'L'
    }, {
      value: 'D'
    }];

    // $scope.manageZones = {};
    // $scope.manageZonesList = [];
    // $scope.initManageZones = function () {
    //   var obj = {};
    //   obj.onSuccess = function (result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
    //       console.log('Inside Zonemap');
    //       for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
    //         var zonelist = $filter('filter')(result, {
    //           id: $rootScope.userData.credentials.zonemap[index]
    //         }, true);
    //         console.log('zonelist', zonelist);

    //         $scope.manageZonesList.push(zonelist[0]);
    //       }
    //     } else {
    //       $scope.manageZonesList = result;
    //     }
    //     console.log('$scope.manageZonesList', $scope.manageZonesList);
    //   };
    //   obj.onFailure = function (err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   zoneService.getZones(obj);
    // };

    // $scope.manageUsersList = [];
    // $scope.initAgents = function(){
    //   var obj = {};

    //   obj.onSuccess = function (result) {
    //     console.log("Inside SUCCESS initAgents");
    //     console.log(result);
    //     $scope.manageUsersList = result;
    //   };
    //   obj.onFailure = function (err) {
    //     console.log("Inside Failure initAgents");
    //     console.log(err);
    //   };
    //   userService.getUsersCSync(obj);
    // };


    $scope.reportFilter = {};
    $scope.searchCaseSummary = function (reportFilter) {
      console.log("Inside searchCaseSummary");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.fromRelDate) &&
        validationService.isEmptyOrNullValidation($scope.dateList.toRelDate)) {

        if (!validationService.verifyDate($scope.dateList.fromRelDate) || !validationService.verifyDate($scope.dateList.toRelDate)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromReleleaseDate = $scope.dateList.fromRelDate;
        obj.params.toReleleaseDate = $scope.dateList.toRelDate;

        obj.params.fromCloseDate = $scope.dateList.fromCloseDate;
        obj.params.toCloseDate = $scope.dateList.toCloseDate;

        // if (reportFilter.zone) {
        //   obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        // } else {
        //   if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        //     var value = "";
        //     for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
        //       if (index == 0) {
        //         value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
        //       } else {
        //         value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
        //       }
        //     }
        //     value = value + ")";
        //     obj.params.zoneid = value;
        //   } else {
        //     obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        //   }
        // }
        if ($scope.reportFilter.shoptype) {
          obj.params.type = $scope.reportFilter.shoptype ? $scope.reportFilter.shoptype.value : null;
        }

        // if (reportFilter.agent){
        //   obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
        // }
        if ($scope.reportFilter.daynight) {
          obj.params.status = $scope.reportFilter.daynight ? $scope.reportFilter.daynight.value : null;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;
          $scope.totalCommissionLabel = 0;
          $scope.manageCaseSummaryList = result.result;
          for (var i = 0; i < $scope.manageCaseSummaryList.length; i++) {
            if (!$scope.manageCaseSummaryList[i].icollect) {
              // $scope.manageCaseSummaryList[i].payment = parseFloat($scope.manageCaseSummaryList[i].payment) + parseFloat($scope.manageCaseSummaryList[i].iamount);
              $scope.manageCaseSummaryList[i].balance = 0;
            }
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        caseSummaryreportService.getSummaryL1(obj);
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.totalSalesLabel = 0;
    $scope.manageCaseSummary = {};
    $scope.manageCaseSummaryList = [];

    $scope.editState = function (onlinesales) {
      console.log("Inside viewCaseSummary");
      console.log(onlinesales);

      $scope.manageCaseSummary = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.getTotalprinciple = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.principle;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotaliamount = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.iamount;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotalstampduty = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.stampduty;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotaldeposit = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.deposit;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotalcashout = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.cashout;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotalamount = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.amount;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotalpayment = function (items) {
      return items
        .map(function (x) {
          return x.payment || x.amount;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        }, 0);
    };
    $scope.getTotalbalance = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.balance;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotalprofitloss = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.profitloss;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          }, 0);
      }
    };
    $scope.getTotalItem = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.pajakitem
          })
          .filter(function (pajakitem) {
            return !!pajakitem
          })
          .length;
      }
    };

    $scope.manageCase = {};

    $scope.getScheduleDate = function (adate) {
      var mm = adate.getMonth() + 1; // getMonth() is zero-based
      var dd = adate.getDate();

      if (dd <= 0) {
        var d1 = adate;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        adate.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
      ].join('-');
    };

    $scope.showPartner = function (partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partner.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };



    var dashboardColors = baConfig.colors;
    //var $element;
    $scope.editCase = function (manageCase) {

      var obj = {};
      obj.params = {};
      obj.params.caseid = manageCase.id;

      obj.onSuccess = function (result) {
        $scope.manageCase = result;
        $scope.isEdit = false;
        $scope.getSchedule();
      };
      obj.onFailure = function (err) {
        console.error(err);
      };
      caseService.getCaseById(obj);
    };

    $scope.scheduleEntry = [];
    $scope.interval = 0;
    $scope.getSchedule = function () {

      $scope.manageCase.totalPaid = $scope.getTotalamount($scope.manageCase.payment) +
        parseFloat($scope.manageCase.deposit) +
        parseFloat(
          $scope.manageCase.tamount * ($scope.manageCase.firstm + $scope.manageCase.lastm)
        );

      $scope.manageCase.amountDue = $scope.manageCase.amount - $scope.manageCase.totalPaid;

      $scope.managePaymentList = $scope.manageCase.payment;


      $scope.scheduleEntry = [];
      $scope.interval = 0;
      if ($scope.manageCase.terms.length) {
        for (var index = 0; index < $scope.manageCase.terms.length; index++) {
          if ($scope.manageCase.terms[index].status === true) {
            $scope.interval = $scope.manageCase.terms[index].interval;
          }
        }

        if ($scope.manageCase.iamount !== $scope.manageCase.tamount) {
          $scope.terms = $scope.manageCase.amount / $scope.manageCase.tamount;
          $scope.terms = $scope.terms * $scope.interval;
        } else {
          $scope.terms = 365 * 2;
        }
        console.log('$scope.interval', $scope.interval);
        console.log('terms', $scope.terms);
        if ($scope.terms) {
          //var date = new Date($scope.manageCase.reldate);

          var days = $scope.terms; // Days you want to Add
          var startDate = new Date($scope.manageCase.reldate);
          // var syear = startDate.getFullYear();
          // var smonth = startDate.getMonth()+1;
          // var sday = startDate.getDate();
          $scope.eDate = new Date(startDate.getTime() + (days * 24 * 60 * 60 * 1000));
          // var eday =endDate.getDate();
          // var emonth=endDate.getMonth()+1;
          // var eyear=endDate.getFullYear();

          $scope.sDate = $scope.getScheduleDate(startDate);
          // $scope.eDate = $scope.getScheduleDate(endDate);

          console.log('startDate', $scope.sDate);
          console.log('endDate', $scope.eDate);

          for (var i = 0; i < $scope.terms; i++) {
            var entryDate;
            if (i === 0) {
              entryDate = new Date(startDate.getTime());
            } else {
              entryDate = new Date(entryDate.getTime() + ($scope.interval * 24 * 60 * 60 * 1000));
            }


            //var scheduleDate =

            var entry = {};
            entry.title = "Schedule: " + $scope.manageCase.tamount;
            entry.start = $scope.getScheduleDate(entryDate);
            // entry.color = '#C39BD3';
            entry.color = '#FFF';
            entry.allDay = true;
            $scope.scheduleEntry.push(entry);
          }

          console.log('scheduleEntry');
          console.log($scope.scheduleEntry);
        }



        if ($scope.manageCase.firstm) {
          for (var f = 0; f < $scope.manageCase.firstm; f++) {

            var firstmDate = new Date(new Date($scope.manageCase.reldate).getTime() + (f * 24 * 60 * 60 * 1000));
            var entryfirstm = {};
            entryfirstm.title = "First: " + $scope.manageCase.tamount;
            entryfirstm.start = $scope.getScheduleDate(firstmDate);
            entryfirstm.color = '#b9f2a1';
            entryfirstm.allDay = true;
            $scope.scheduleEntry.push(entryfirstm);
          }
        }

        if ($scope.manageCase.lastm) {
          for (var l = 0; l < $scope.manageCase.lastm; l++) {
            var lastmDate;
            if (l === 0) {
              lastmDate = new Date($scope.eDate.getTime() - ($scope.manageCase.lastm * 24 * 60 * 60 * 1000));
            } else {
              lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            }

            //var lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            var entrylastm = {};
            entrylastm.title = "Last: " + $scope.manageCase.tamount;
            entrylastm.start = $scope.getScheduleDate(lastmDate);
            entrylastm.color = '#b9f2a1';
            entrylastm.allDay = true;
            $scope.scheduleEntry.push(entrylastm);
          }
        }
      }

      if ($scope.manageCase.payment.length) {
        for (var n = 0; n < $scope.manageCase.payment.length; n++) {
          var entryPayment = {};
          entryPayment.title = "Payment 付: " + parseFloat($scope.manageCase.payment[n].amount).toFixed(2);
          entryPayment.start = $scope.getScheduleDate(new Date($scope.manageCase.payment[n].paydate));
          entryPayment.color = $scope.manageCase.payment[n].amount >= $scope.manageCase.tamount ? '#b9f2a1' : '#ff6666';
          entryPayment.allDay = true;
          $scope.scheduleEntry.push(entryPayment);
        }
      }

      if ($scope.manageCase.isdeposit) {
        var depositTerm = $scope.manageCase.deposit / $scope.manageCase.tamount;
        var depTermFull = Math.ceil(depositTerm);
        console.log('depositTerm', depositTerm);
        console.log('depTermFull', depTermFull);
        var check = depTermFull - depositTerm;
        if (check != 0 && check > 0.5) {
          check = check - 0.5;
          check = 0.5 - check;
        }
        console.log('check', check);
        for (var d = 0; d < depTermFull; d++) {
          var lastmDate;
          var title = "";
          var entrydeposit = {};

          if (d === 0) {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + depTermFull) * 24 * 60 * 60 * 1000));
            if (check != 0) {
              var amount = (parseFloat($scope.manageCase.tamount) * parseFloat(check)).toFixed(2);
              title = "Deposit: " + amount;
            } else {
              title = "Deposit: " + $scope.manageCase.tamount;
            }
          } else {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + d) * 24 * 60 * 60 * 1000));
            title = "Deposit: " + $scope.manageCase.tamount;
          }

          entrydeposit.title = title;
          entrydeposit.start = $scope.getScheduleDate(lastmDate);
          entrydeposit.color = '#C39BD3';
          entrydeposit.allDay = true;
          $scope.scheduleEntry.push(entrydeposit);
        }

      }





      // if ($scope.manageCase.firstm!=0){
      //   var entryfirstm = {};
      //   entryfirstm.title = $scope.manageCase.tamount;
      //   entryfirstm.start =   $scope.sDate;
      //   entryfirstm.color = '#b9f2a1';
      //   entryfirstm.allDay = true;
      //   $scope.scheduleEntry.push(entryfirstm);
      // }
      console.log($scope.manageCase)
      $scope.manageCase.isReport = true;
      $scope.isEdit = true;
    };



    // end for edit

    //new edit

    // $scope.getTotalpayment = function (items) {
    //   if(items.length>0){
    //   return items
    //     .map(function (x) { return x.amount; })
    //     .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
    //   }//new edit finish
    // };

    $scope.resetSearch = function () {
      $scope.totalBalance = 0;
      $scope.totalDebit = 0;
      $scope.totalCredit = 0;
      $scope.manageCaseSummaryList = [];
      $scope.balance = 0;
      $scope.reportFilter = {};
    };

    $scope.resetCloseDate = function () {
      delete $scope.dateList.fromCloseDate;
      $scope.dateList.toCloseDate = new Date();
    }
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.init = function () {
      // $scope.initManageZones();
      // $scope.initManagePartner();
      // $scope.initManageGames();
      // $scope.initManageMachineShop();
      // $scope.initAgents();
      $scope.dateList.fromRelDate = new Date($state.params.from_date);
      $scope.dateList.toRelDate = caseSummaryreportService.getMonthLastDay(new Date($state.params.from_date || ''));

      $scope.reportFilter = {
        shoptype: {
          value: $state.params.type || undefined
        },
        daynight: {
          value: $state.params.status === "true" ?
            'Open' : $state.params.status === "false" ?
            'Closed' : undefined,
        }
      }

      if (!!$state.params.from_date) {
        $scope.searchCaseSummary();
      }
    };

    $scope.init();

  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.casesummary')
    .service('caseSummaryreportService', caseSummaryreportService);


  function formatFilterDate(from, to) {
    if (from == null || to == null) {
      return [null, null];
    }

    var fd = new Date(from),
      y = fd.getFullYear(),
      m = fd.getMonth() + 1;
    var parsedFromDate = y + '-' + m + '-' + fd.getDate();

    var td = new Date(to);
    y = td.getFullYear();
    m = td.getMonth() + 1;
    td.setHours(23);
    td.setMinutes(59);
    td.setSeconds(59);
    var parsedToDate = y + '-' + m + '-' + td.getDate();

    return [parsedFromDate, parsedToDate];
  }


  /** @ngInject */
  function caseSummaryreportService(Case) {

    var getSummaryL1 = function (obj) {

      var releaseDate = formatFilterDate(obj.params.fromReleleaseDate, obj.params.toReleleaseDate)
      var closeDate = formatFilterDate(obj.params.fromCloseDate, obj.params.toCloseDate)

      Case.getSummaryL1({
        from_rel_date: releaseDate[0],
        to_rel_date: releaseDate[1],
        from_close_date: closeDate[0],
        to_close_date: closeDate[1],
        type: obj.params.type ? obj.params.type : null,
        status: obj.params.status ? obj.params.status : null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getMonthLastDay = function (date) {
      var month = new Date(date).getMonth();
      var year = new Date(date).getFullYear();
      return new Date(year, month + 1, 0);
    }

    return {
      getSummaryL1: getSummaryL1,
      getMonthLastDay: getMonthLastDay
    };

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.cashinhand')
    .controller('CashinHandreportPageCtrl', CashinHandreportPageCtrl);

  /** @ngInject */
  function CashinHandreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    cashinHandreportService, validationService, toastr, $uibModal, $rootScope,categoryService) {
    console.log("Inside CashinHandreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCashinHandy(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    
    $scope.dayNightFilter = [{ value: 'Open' }, { value: 'Closed' }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};

    $scope.shopTypeFilter = [{ value: 'L' }, { value: 'D' }];

    $scope.managecategoryList=[];
    $scope.manageParentList=[];
    $scope.initManagecategory = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.managecategoryList = result;
          $scope.manageParentList = $filter('filter')($scope.managecategoryList, {
            parentid: null
          },true);
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        categoryService.getcategory(obj);
    };

    $scope.init = function () {
      $scope.initManagecategory();
    };
    $scope.init();

    $scope.reportFilter = {};

    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.totalSalesLabel = 0;
    $scope.manageCashinHand = {};
    $scope.manageCashinHandList = [];
    $scope.totalDebit = 0;
    $scope.totalCredit = 0;

    $scope.searchCashinHand = function (reportFilter) {
      console.log("Inside searchCashinHand");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;
        
        if (reportFilter.category){
        obj.params.categoryid = reportFilter.category ? reportFilter.category.id : null;
        }
        if (reportFilter.parent){
        obj.params.parentid = reportFilter.parent ? reportFilter.parent.id : null;
        }


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);

          $scope.totalBalance = 0;
          $scope.manageCashinHandList = result.result;
          $scope.balance = 0;
          for (var i = 0; i < $scope.manageCashinHandList.length; i++) {
            //$scope.manageCashinHandList[i].balance = 0;
            if ($scope.manageCashinHandList[i].debit!='0.00'){
              $scope.manageCashinHandList[i].balance = $scope.balance + parseFloat($scope.manageCashinHandList[i].debit);
              $scope.balance = $scope.manageCashinHandList[i].balance;
              $scope.totalDebit += parseFloat($scope.manageCashinHandList[i].debit);
            }
            if ($scope.manageCashinHandList[i].credit!='0.00'){
              $scope.manageCashinHandList[i].balance = $scope.balance - parseFloat($scope.manageCashinHandList[i].credit);
              $scope.balance = $scope.manageCashinHandList[i].balance;
              $scope.totalCredit += parseFloat($scope.manageCashinHandList[i].credit);
            }

            if ($scope.manageCashinHandList[i].categoryid && $scope.managecategoryList.length) {
              var selected = $filter('filter')($scope.managecategoryList, {
                id: $scope.manageCashinHandList[i].categoryid
              },true);
              if (selected.length){
                $scope.manageCashinHandList[i].category = selected[0];
              }
            }

            // if ($scope.manageCashinHandList[i].icollect){
            //   $scope.manageCashinHandList[i].payment = parseFloat($scope.manageCashinHandList[i].payment) + parseFloat($scope.manageCashinHandList[i].iamount);
            //   $scope.manageCashinHandList[i].balance = parseFloat($scope.manageCashinHandList[i].amount) - parseFloat($scope.manageCashinHandList[i].payment);
            // }
            // $scope.manageCashinHandList[i].profitloss = (parseFloat($scope.manageCashinHandList[i].payment) - parseFloat($scope.manageCashinHandList[i].principle))+parseFloat($scope.manageCashinHandList[i].stampduty);
            // if ($scope.manageCashinHandList[i].isloan){
            //   if ($scope.manageCashinHandList[i].payment>$scope.manageCashinHandList[i].amount){
            //     $scope.manageCashinHandList[i].balance = 0;
            //   }else{
            //     $scope.manageCashinHandList[i].balance = $scope.manageCashinHandList[i].amount;
            //   }
            // }
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        cashinHandreportService.getCashinHandL1(obj);
      }
    };

    $scope.getTotaldebit = function (items) {
      if (items){
      return items
        .map(function (x) { return x.debit; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalcredit = function (items) {
      if (items){
      return items
        .map(function (x) { return x.credit; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotalbalance = function (items) {
      if (items){
      return items
        .map(function (x) { return x.balance; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };


    $scope.showparentid = function(parentid) {
      
      if (parentid && $scope.managecategoryList.length) {
        var selected = $filter('filter')($scope.managecategoryList, {
          id: parentid
        },true);
        return selected.length ? selected[0].name : '';
      } else return '';
    };

    $scope.resetSearch = function() {
      $scope.dateList = {};
      $scope.totalBalance = 0;
      $scope.totalDebit = 0;
      $scope.totalCredit = 0;
      $scope.manageCashinHandList = [];
      $scope.balance = 0;
    };


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.cashinhand')
    .service('cashinHandreportService', cashinHandreportService);


  /** @ngInject */
  function cashinHandreportService(Case) {

    var getCashinHandL1 = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);

      Case.getCashinHandL1({
        adate: date1,
        bdate: date2,
        categoryid: obj.params.categoryid ? obj.params.categoryid : null,
        parentid: obj.params.parentid ? obj.params.parentid : null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    return {
      getCashinHandL1: getCashinHandL1,
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.closecasesummary')
    .controller('CloseCaseSummaryreportPageCtrl', CloseCaseSummaryreportPageCtrl);

  /** @ngInject */
  function CloseCaseSummaryreportPageCtrl($scope, $filter, editableOptions, editableThemes,
    closecaseSummaryreportService, validationService, toastr, $uibModal, $rootScope, baConfig, caseService) {
    console.log("Inside CloseCaseSummaryreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCloseCaseSummary(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.dayNightFilter = [{
      value: 'Open'
    }, {
      value: 'Closed'
    }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};
    $scope.dpOpenStatus1 = {};
    $scope.isEditPayment = false;

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };

    $scope.setDpOpenStatus1 = function (id) {
      $scope.dpOpenStatus1[id] = true;
    };

    $scope.dateList = {
      from: new Date(new Date().setDate(1)),
      to: new Date(),
      toCloseDate: new Date(),
    };

    $scope.shopTypeFilter = [{
      value: 'L'
    }, {
      value: 'D'
    }];

    // $scope.manageZones = {};
    // $scope.manageZonesList = [];
    // $scope.initManageZones = function () {
    //   var obj = {};
    //   obj.onSuccess = function (result) {
    //     console.log("Inside SUCCESS");
    //     console.log(result);
    //     if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
    //       console.log('Inside Zonemap');
    //       for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
    //         var zonelist = $filter('filter')(result, {
    //           id: $rootScope.userData.credentials.zonemap[index]
    //         }, true);
    //         console.log('zonelist', zonelist);

    //         $scope.manageZonesList.push(zonelist[0]);
    //       }
    //     } else {
    //       $scope.manageZonesList = result;
    //     }
    //     console.log('$scope.manageZonesList', $scope.manageZonesList);
    //   };
    //   obj.onFailure = function (err) {
    //     console.log("Inside Failure");
    //     console.log(err);
    //   };
    //   zoneService.getZones(obj);
    // };

    // $scope.manageUsersList = [];
    // $scope.initAgents = function(){
    //   var obj = {};

    //   obj.onSuccess = function (result) {
    //     console.log("Inside SUCCESS initAgents");
    //     console.log(result);
    //     $scope.manageUsersList = result;
    //   };
    //   obj.onFailure = function (err) {
    //     console.log("Inside Failure initAgents");
    //     console.log(err);
    //   };
    //   userService.getUsersCSync(obj);
    // };

    $scope.init = function () {
      // $scope.initManageZones();
      // $scope.initManagePartner();
      // $scope.initManageGames();
      // $scope.initManageMachineShop();
      // $scope.initAgents();
    };
    $scope.init();

    $scope.reportFilter = {};
    $scope.searchCloseCaseSummary = function (reportFilter) {
      console.log("Inside searchCloseCaseSummary");
      console.log($scope.dateList);
      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;

        // if (reportFilter.zone) {
        //   obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        // } else {
        //   if (typeof $rootScope.userData.credentials.zonemap !== "undefined") {
        //     var value = "";
        //     for (var index = 0; index < $rootScope.userData.credentials.zonemap.length; index++) {
        //       if (index == 0) {
        //         value = "('" + $rootScope.userData.credentials.zonemap[index] + "'";
        //       } else {
        //         value = value + ",'" + $rootScope.userData.credentials.zonemap[index] + "'";
        //       }
        //     }
        //     value = value + ")";
        //     obj.params.zoneid = value;
        //   } else {
        //     obj.params.zoneid = reportFilter.zone ? "('" + reportFilter.zone.id + "')" : null;
        //   }
        // }
        if (reportFilter.shoptype) {
          obj.params.type = reportFilter.shoptype ? reportFilter.shoptype.value : null;
        }

        // if (reportFilter.agent){
        //   obj.params.agentid=reportFilter.agent?reportFilter.agent.id:null;
        // }
        //if (reportFilter.daynight){
        //obj.params.status=reportFilter.daynight?reportFilter.daynight.value:null;
        //}

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.totalSalesLabel = 0;
          $scope.totalCommissionLabel = 0;
          $scope.manageCloseCaseSummaryList = result.result;
          for (var i = 0; i < $scope.manageCloseCaseSummaryList.length; i++) {
            if (!$scope.manageCloseCaseSummaryList[i].icollect) {
              $scope.manageCloseCaseSummaryList[i].balance = 0;
            }
          }
          console.log($scope.totalSalesLabel.toFixed(2));
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        closecaseSummaryreportService.getCloseSummaryL1(obj);
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.totalSalesLabel = 0;
    $scope.manageCloseCaseSummary = {};
    $scope.manageCloseCaseSummaryList = [];

    $scope.editState = function (onlinesales) {
      console.log("Inside viewCloseCaseSummary");
      console.log(onlinesales);

      $scope.manageCloseCaseSummary = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.getTotalprinciple = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.principle;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotaliamount = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.iamount;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalstampduty = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.stampduty;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotaldeposit = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.deposit;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalcashout = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.cashout;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalamount = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.amount;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalpayment = function (items) {
      return items
        .map(function (x) {
          return x.payment || x.amount;
        })
        .reduce(function (a, b) {
          return parseFloat(a) + parseFloat(b);
        }, 0);
    };
    $scope.getTotalbalance = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.balance;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalprofitloss = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.profitloss;
          })
          .reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b);
          });
      }
    };
    $scope.getTotalItem = function (items) {
      if (items) {
        return items
          .map(function (x) {
            return x.pajakitem
          })
          .filter(function (pajakitem) {
            return !!pajakitem
          })
          .length;
      }
    };

    $scope.init = function () {};

    $scope.manageCase = {};

    $scope.getScheduleDate = function (adate) {
      var mm = adate.getMonth() + 1; // getMonth() is zero-based
      var dd = adate.getDate();

      if (dd <= 0) {
        var d1 = adate;
        d1.setDate(1);
        d1.setHours(-1);
        dd = d1.getDate();
        mm = d1.getMonth() + 1;
      }

      return [
        adate.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
      ].join('-');
    };




    var dashboardColors = baConfig.colors;
    //var $element;
    $scope.editCase = function (manageCase) {

      var obj = {};
      obj.params = {
        caseid: manageCase.id
      };

      obj.onSuccess = function (result) {
        $scope.manageCase = result;
        $scope.isEdit = false;
        $scope.getSchedule();
      };
      obj.onFailure = function (err) {
        console.error(err);
      };
      caseService.getCaseById(obj);
    };

    $scope.scheduleEntry = [];
    $scope.interval = 0;
    $scope.getSchedule = function () {
      $scope.manageCase.totalPaid = $scope.getTotalpayment($scope.manageCase.payment) + parseFloat($scope.manageCase.deposit) + parseFloat($scope.manageCase.tamount * ($scope.manageCase.firstm + $scope.manageCase.lastm));
      $scope.manageCase.amountDue = $scope.manageCase.amount - $scope.manageCase.totalPaid;

      $scope.managePaymentList = $scope.manageCase.payment;


      $scope.scheduleEntry = [];
      $scope.interval = 0;
      if ($scope.manageCase.terms.length) {
        for (var index = 0; index < $scope.manageCase.terms.length; index++) {
          if ($scope.manageCase.terms[index].status === true) {
            $scope.interval = $scope.manageCase.terms[index].interval;
          }
        }

        if ($scope.manageCase.iamount !== $scope.manageCase.tamount) {
          $scope.terms = $scope.manageCase.amount / $scope.manageCase.tamount;
          $scope.terms = $scope.terms * $scope.interval;
        } else {
          $scope.terms = 365 * 2;
        }
        console.log('$scope.interval', $scope.interval);
        console.log('terms', $scope.terms);
        if ($scope.terms) {
          //var date = new Date($scope.manageCase.reldate);

          var days = $scope.terms; // Days you want to Add
          var startDate = new Date($scope.manageCase.reldate);
          // var syear = startDate.getFullYear();
          // var smonth = startDate.getMonth()+1;
          // var sday = startDate.getDate();
          $scope.eDate = new Date(startDate.getTime() + (days * 24 * 60 * 60 * 1000));
          // var eday =endDate.getDate();
          // var emonth=endDate.getMonth()+1;
          // var eyear=endDate.getFullYear();

          $scope.sDate = $scope.getScheduleDate(startDate);
          // $scope.eDate = $scope.getScheduleDate(endDate);

          console.log('startDate', $scope.sDate);
          console.log('endDate', $scope.eDate);

          for (var i = 0; i < $scope.terms; i++) {
            var entryDate;
            if (i === 0) {
              entryDate = new Date(startDate.getTime());
            } else {
              entryDate = new Date(entryDate.getTime() + ($scope.interval * 24 * 60 * 60 * 1000));
            }


            //var scheduleDate =

            var entry = {};
            entry.title = "Schedule: " + $scope.manageCase.tamount;
            entry.start = $scope.getScheduleDate(entryDate);
            // entry.color = '#C39BD3';
            entry.color = '#FFF';
            entry.allDay = true;
            $scope.scheduleEntry.push(entry);
          }

          console.log('scheduleEntry');
          console.log($scope.scheduleEntry);
        }



        if ($scope.manageCase.firstm) {
          for (var f = 0; f < $scope.manageCase.firstm; f++) {

            var firstmDate = new Date(new Date($scope.manageCase.reldate).getTime() + (f * 24 * 60 * 60 * 1000));
            var entryfirstm = {};
            entryfirstm.title = "First: " + $scope.manageCase.tamount;
            entryfirstm.start = $scope.getScheduleDate(firstmDate);
            entryfirstm.color = '#b9f2a1';
            entryfirstm.allDay = true;
            $scope.scheduleEntry.push(entryfirstm);
          }
        }

        if ($scope.manageCase.lastm) {
          for (var l = 0; l < $scope.manageCase.lastm; l++) {
            var lastmDate;
            if (l === 0) {
              lastmDate = new Date($scope.eDate.getTime() - ($scope.manageCase.lastm * 24 * 60 * 60 * 1000));
            } else {
              lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            }

            //var lastmDate = new Date($scope.eDate.getTime() - (l * 24 * 60 * 60 * 1000));
            var entrylastm = {};
            entrylastm.title = "Last: " + $scope.manageCase.tamount;
            entrylastm.start = $scope.getScheduleDate(lastmDate);
            entrylastm.color = '#b9f2a1';
            entrylastm.allDay = true;
            $scope.scheduleEntry.push(entrylastm);
          }
        }
      }

      if ($scope.manageCase.payment.length) {
        for (var n = 0; n < $scope.manageCase.payment.length; n++) {
          var entryPayment = {};
          entryPayment.title = "Payment 付: " + parseFloat($scope.manageCase.payment[n].amount).toFixed(2);
          entryPayment.start = $scope.getScheduleDate(new Date($scope.manageCase.payment[n].paydate));
          entryPayment.color = $scope.manageCase.payment[n].amount >= $scope.manageCase.tamount ? '#b9f2a1' : '#ff6666';
          entryPayment.allDay = true;
          $scope.scheduleEntry.push(entryPayment);
        }
      }

      if ($scope.manageCase.isdeposit) {
        var depositTerm = $scope.manageCase.deposit / $scope.manageCase.tamount;
        var depTermFull = Math.ceil(depositTerm);
        console.log('depositTerm', depositTerm);
        console.log('depTermFull', depTermFull);
        var check = depTermFull - depositTerm;
        if (check != 0 && check > 0.5) {
          check = check - 0.5;
          check = 0.5 - check;
        }
        console.log('check', check);
        for (var d = 0; d < depTermFull; d++) {
          var lastmDate;
          var title = "";
          var entrydeposit = {};

          if (d === 0) {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + depTermFull) * 24 * 60 * 60 * 1000));
            if (check != 0) {
              var amount = (parseFloat($scope.manageCase.tamount) * parseFloat(check)).toFixed(2);
              title = "Deposit: " + amount;
            } else {
              title = "Deposit: " + $scope.manageCase.tamount;
            }
          } else {
            lastmDate = new Date($scope.eDate.getTime() - (($scope.manageCase.lastm + d) * 24 * 60 * 60 * 1000));
            title = "Deposit: " + $scope.manageCase.tamount;
          }

          entrydeposit.title = title;
          entrydeposit.start = $scope.getScheduleDate(lastmDate);
          entrydeposit.color = '#C39BD3';
          entrydeposit.allDay = true;
          $scope.scheduleEntry.push(entrydeposit);
        }

      }
      console.log($scope.manageCase);
      $scope.manageCase.isReport = true;
      $scope.isEdit = true;
    };

    // $scope.getTotalpayment = function (items) {
    //   return items
    //     .map(function (x) {
    //       return x.amount;
    //     })
    //     .reduce(function (a, b) {
    //       return parseFloat(a) + parseFloat(b);
    //     }, 0);
    // };

    $scope.resetSearch = function () {
      $scope.dateList = {
        from: new Date(new Date().setDate(1)),
        to: new Date(),
        toCloseDate: new Date(),
      };
      $scope.totalBalance = 0;
      $scope.totalDebit = 0;
      $scope.totalCredit = 0;
      $scope.manageCloseCaseSummaryList = [];
      $scope.balance = 0;
    };


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';






  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.closecasesummary')
    .service('closecaseSummaryreportService', closecaseSummaryreportService);


  /** @ngInject */
  function closecaseSummaryreportService(Case) {

    var getCloseSummaryL1 = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);

      Case.getCloseSummaryL1({
        adate: date1,
        bdate: date2,
        type: obj.params.type ? obj.params.type : null,
       // status: obj.params.status ? obj.params.status : null
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });

    };

    return {
      getCloseSummaryL1: getCloseSummaryL1,
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.collection')
    .controller('CollectionreportPageCtrl', CollectionreportPageCtrl);

  /** @ngInject */
  function CollectionreportPageCtrl($scope, $filter, userService, editableOptions, editableThemes, validationService, toastr, $uibModal, $rootScope, collectionreportService, assignAgentService) {
    console.log("Inside CollectionreportPageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteCollection(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });

    };
    
    $scope.dayNightFilter = [{ value: 'Open' }, { value: 'Closed' }];

    $scope.dtWith = new Date();
    $scope.dtWithout = new Date();

    $scope.dpOpenStatus = {};

    $scope.setDpOpenStatus = function (id) {
      $scope.dpOpenStatus[id] = true;
    };
    $scope.dateList = {};

    $scope.shopTypeFilter = [{ value: 'L' }, { value: 'D' }];

    $scope.reportFilter = {};
    $scope.searchCollection = function (reportFilter) {
      console.log("Inside searchCollection");
      console.log($scope.dateList);
      console.log(reportFilter);

      //console.log($scope.dtWithout);
      //Performing Validations
      var isFormValidated = true;

      if (validationService.isEmptyOrNullValidation($scope.dateList.from) &&
        validationService.isEmptyOrNullValidation($scope.dateList.to)) {

        if (!validationService.verifyDate($scope.dateList.from) || !validationService.verifyDate($scope.dateList.to)) {
          isFormValidated = false;
          toastr.error('Please enter a valid Date (dd/mm/yyyy) or Select from date picker', 'ERROR');
        }
      } else {
        isFormValidated = false;
        toastr.error('Please fill From and To Date for Search', 'ERROR');
      }

      if (isFormValidated) {

        var obj = {};
        obj.params = {};
        console.log('reportFilter.agent',reportFilter.agent);

        obj.params.fromDt = $scope.dateList.from;
        obj.params.toDt = $scope.dateList.to;
        obj.params.agentid = reportFilter.agent? reportFilter.agent.id :null ;

        if (reportFilter.shoptype){
        obj.params.type = reportFilter.shoptype ? reportFilter.shoptype.value : null;
        }

        if (reportFilter.daynight){
          obj.params.status=reportFilter.daynight?reportFilter.daynight.value:null;
        }

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageCollectionList = result;
          $scope.isEdit = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        collectionreportService.getSummaryL1(obj);
      }
    };


    $scope.smartTablePageSize = 250;
    $scope.isEdit = false;

    $scope.totalSalesLabel = 0;
    $scope.manageCollection = {};
    $scope.manageCollectionList = [];

    $scope.editState = function (onlinesales) {
      console.log("Inside viewCollection");
      console.log(onlinesales);

      $scope.manageCollection = onlinesales;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    
    
    $scope.getTotalamount = function (items) {
      if (items){
      return items
        .map(function (x) { return x.amount; })
        .reduce(function (a, b) { return parseFloat(a) + parseFloat(b); });
      }
    };
    $scope.getTotaltamount = function (items) {
      var tamount = 0;
      if (items) {
        for (var index = 0; index < items.length; index++) {
          if (items[index].case) {
            if (items[index].case.tamount) {
              tamount += parseFloat(items[index].case.tamount);
            }
          }
        }
        return tamount;
      }
    };


    // $scope.initManageAgent = function (){
    //     var obj ={};
    //     obj.onSuccess = function (result)
    //     {
    //       console.log("Inside SUCCESS");
    //       console.log(result);
    //       $scope.manageAgentsList = result;
    //       $scope.manageParentList = $filter('filter')($scope.manageAgentsList, {
    //         parentid: null
    //       },true);
    //     };
    //     obj.onFailure = function (err)
    //     {
    //       console.log("Inside Failure");
    //       console.log(err);
    //     };
    //     assignAgentService.get(obj);
    // };
    $scope.manageAgentsList=[];

    $scope.initManageUsers = function () {
      console.log('Inside initManageUsers');
      console.log('$rootScope.userData.id', $rootScope.userData.id);

        var obj = {};

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageAgentsList = result;
          $scope.isEdit = false;
          $scope.isAssignNewCase = false;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        userService.getAllUser(obj);

    };


    $scope.resetSearch = function() {
      $scope.dateList = {};
      $scope.totalBalance = 0;
      $scope.totalDebit = 0;
      $scope.totalCredit = 0;
      $scope.manageCollectionList = [];
      $scope.balance = 0;
    };

      $scope.initManageUsers();
   

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    $scope.getAgentName = function(credentials)
    {
        if(credentials.name != null && credentials.name.length > 0)
            return credentials.name;
        else
            return credentials.firstName + " " + credentials.lastName;
    };
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.report.collection')
    .service('collectionreportService', collectionreportService);


  /** @ngInject */
  function collectionreportService(Payment) {

    var getSummaryL1 = function (obj) {

      var from = obj.params.fromDt ? obj.params.fromDt : null;
      var to = obj.params.toDt ? obj.params.toDt : null;

      var fd = new Date(from), y = fd.getFullYear(), m = fd.getMonth() + 1;
      var date1 = y + '-' + m + '-' + fd.getDate();

      var td = new Date(to); y = td.getFullYear(); m = td.getMonth() + 1;
      td.setHours(23);
      td.setMinutes(59);
      td.setSeconds(59);
      var date2 = y + '-' + m + '-' + td.getDate();
      console.log('client from date', fd);
      console.log('client from date1', date1);
      console.log('client to date', td);
      console.log('client to date2', date2);
      console.log('obj.params.agentid', obj.params.agentid);

      if (obj.params.agentid != null) {

        Payment.find({
          filter: {
            include: ["payagent", "case"],
            where: {
              and: [
                { paydate: { gte: fd } },
                { paydate: { lt: td } },
                { agentid: obj.params.agentid }, // get collector id from obj
              ]
            }
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });

      } else {

        Payment.find({
          filter: {
            include: ["payagent", "case"],
            where: {
              and: [
                { paydate: { gte: fd } },
                { paydate: { lt: td } }
              ]
            }
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }



    };

    return {
      getSummaryL1: getSummaryL1,
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas')
    .controller('AreasPageCtrl', AreasPageCtrl);

  /** @ngInject */
  function AreasPageCtrl($scope, $filter, editableOptions, editableThemes,
    areaService, toastr, $uibModal, stateService, zoneService) {
    console.log("Inside AreasPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteArea(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;

    //Getting States
    $scope.manageStatesList = [];
    $scope.manageZonesList = [];
    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };

    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };




    $scope.manageAreasList = [];
    $scope.manageArea = {};
    $scope.initManageAreas = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreasList = result;
        $scope.initManageStates();
        $scope.initManageZones();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };
    $scope.initManageAreas();

    $scope.addArea = function() {
      //genericModalService.show('modules/modals/addArea.html',$scope);
      $scope.inserted = {
        name: null,
        description: null,
      };
      $scope.manageAreasList.push($scope.inserted);
    };

    $scope.createArea = function(manageArea) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createArea");
      console.log(manageArea);

      var obj = {};
      obj.params = {};
      obj.params = manageArea;
      // obj.params.name = manageArea.name;
      // obj.params.description = manageArea.description;
      // obj.params.zoneid = manageArea.zones
      // obj.params.stateid = manageArea.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageArea = {};
        toastr.success('New Area has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageAreas();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      areaService.createArea(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/system/areas/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteArea = function(res) {
      console.log("Inside deleteArea");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Area has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully deleted.");
          $scope.initManageAreas();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        areaService.deleteArea(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editArea = function(state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageArea.id = $scope.manageArea.id;
      // $scope.manageArea.name = state.name;
      // $scope.manageArea.description = state.description;
      // $scope.manageArea.created = state.created;
      // $scope.manageArea.lastupdated = state.lastupdated;
      $scope.manageArea = state;
      genericModalService.show('modules/modals/addArea.html', $scope);
    }

    $scope.saveArea = function(manageArea, id) {

      console.log("Inside saveArea");
      console.log(manageArea);
      console.log(id);

      console.log(manageArea.zones);
      console.log(manageArea.state);


      if (id === undefined) {
        $scope.createArea(manageArea);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageArea;
        obj.params.id = id;
        // obj.params.name = $scope.manageArea.name;
        // obj.params.description = $scope.manageArea.description;
        //obj.params.created = $scope.manageArea.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageArea = {};
          toastr.success('Area has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageAreas();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        areaService.saveArea(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.areas')
    .service('areaService', areaService);

  /** @ngInject */
  function areaService(Area) {
    var getAreas = function(obj) {

    Area.find({
      filter:{
        include:["state","zone"]
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var createArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Area.create({
      name:obj.params.name,
      description:obj.params.description?obj.params.description:null,
      stateid: obj.params.state,
	     zoneid: obj.params.zone,
      created: date,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  var deleteArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Area.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveArea = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Area.prototype$updateAttributes({
      id: obj.params.id,
      name: obj.params.name,
      description: obj.params.description?obj.params.description:null,
      stateid: obj.params.state,
	    zoneid: obj.params.zone,
      lastupdated: date
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getAreas: getAreas,
      createArea: createArea,
      deleteArea: deleteArea,
      saveArea: saveArea
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory')
      .controller('GamecategoryPageCtrl', GamecategoryPageCtrl);

  /** @ngInject */
  function GamecategoryPageCtrl($scope, $filter, editableOptions, editableThemes,
    gamecategoryService,toastr,$uibModal ) {
    console.log("Inside GamecategoryPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteGamecategory(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 10;


    $scope.manageGamecategory={};
    $scope.manageGamecategoryList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageGamecategoryList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        gamecategoryService.getGamecategory(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageGamecategoryList.push($scope.inserted);
    };

    $scope.createGamecategory = function(manageGamecategory) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createGamecategory");
      console.log(manageGamecategory.name);
      //console.log(manageGamecategory.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageGamecategory.name;
      //obj.params.description = manageGamecategory.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategory = {};
        toastr.success('New Gamecategory has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Gamecategory successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gamecategoryService.createGamecategory(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/gamecategory/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteGamecategory = function (res){
      console.log("Inside deleteGamecategory");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Gamecategory has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            gamecategoryService.deleteGamecategory(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (gamecategory){
      console.log("Inside editGamecategory");
      console.log(gamecategory);
      // $scope.manageGamecategory.id = $scope.manageGamecategory.id;
      // $scope.manageGamecategory.name = state.name;
      // $scope.manageGamecategory.description = state.description;
      // $scope.manageGamecategory.created = state.created;
      // $scope.manageGamecategory.lastupdated = state.lastupdated;
      $scope.manageGamecategory = gamecategory;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveGamecategory = function (manageGamecategory, id){

      console.log("Inside saveGamecategory");
      console.log(manageGamecategory);
      console.log(id);

      if (id===undefined){
        $scope.createGamecategory(manageGamecategory);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageGamecategory
      obj.params.id = id;
      // obj.params.name = $scope.manageGamecategory.name;
      // obj.params.description = $scope.manageGamecategory.description;
      //obj.params.created = $scope.manageGamecategory.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamecategory = {};
        toastr.success('Gamecategory has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gamecategoryService.saveGamecategory(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.gamecategory')
    .service('gamecategoryService', gamecategoryService);
 
  /** @ngInject */
  function gamecategoryService(Gamecategory) {
    var getGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Gamecategory.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Gamecategory.create({
        name:obj.params.name,
       // description:obj.params.description,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Gamecategory.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveGamecategory = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Gamecategory.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getGamecategory: getGamecategory,
      createGamecategory: createGamecategory,
      deleteGamecategory: deleteGamecategory,
      saveGamecategory: saveGamecategory
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games')
      .controller('GamesPageCtrl', GamesPageCtrl);

  /** @ngInject */
  function GamesPageCtrl($scope, $filter, editableOptions, editableThemes,
    gameService,toastr,$uibModal,gamecategoryService ) {
    console.log("Inside GamesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteGame(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 10;
    $scope.status = [{value:'Active'},{value:'Inactive'}];

    //Getting States
    $scope.manageGamecategoryList=[];
    $scope.initManageGamecategory = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageGamecategoryList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        gamecategoryService.getGamecategory(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };






    $scope.manageGamesList=[];
    $scope.manageArea={};
    $scope.initManageGames = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageGamesList = result;
          $scope.initManageGamecategory();
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
       gameService.getGame(obj);
    };
    $scope.initManageGames();

    $scope.addArea = function (){
      //genericModalService.show('modules/modals/addArea.html',$scope);
      $scope.inserted = {
        name: null,
        //description:null,
		gamecatid:null,
		status:null,
      };
      $scope.manageGamesList.push($scope.inserted);
    };

    $scope.createGame = function(manageArea) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createGame");
      console.log(manageArea.name);
      console.log(manageArea.status);

      var obj ={};
      obj.params={};
      obj.params.name = manageArea.name;
      obj.params.gamecatid = manageArea.gamecategory;
	    obj.params.status = manageArea.status.value;
      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageArea = {};
        toastr.success('New Area has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
          $scope.initManageGames();
      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      gameService.createGame(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/games/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteGame = function (res){
      console.log("Inside deleteGame");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Game has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Game successfully deleted.");
              $scope.initManageGames();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            gameService.deleteGame(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editArea = function (state){
      console.log("Inside editGame");
      console.log(state);
      // $scope.manageArea.id = $scope.manageArea.id;
      // $scope.manageArea.name = state.name;
      // $scope.manageArea.description = state.description;
      // $scope.manageArea.created = state.created;
      // $scope.manageArea.lastupdated = state.lastupdated;
      $scope.manageArea = state;
      genericModalService.show('modules/modals/addArea.html',$scope);
    }

    $scope.saveGame = function (manageArea, id){

      console.log("Inside saveGame");
      console.log(manageArea);
      console.log(id);

      if (id===undefined){
        $scope.createGame(manageArea);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageArea
      obj.params.id = id;
	  obj.params.gamecatid = manageArea.gamecategory;
	  obj.params.status = manageArea.status.value;
      // obj.params.name = $scope.manageArea.name;
      // obj.params.description = $scope.manageArea.description;
      //obj.params.created = $scope.manageArea.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
		//$scope.statuses = result.status;
        $scope.manageArea = {};
        toastr.success('Game has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
		console.log("sandip");
	    console.log(result.status);
        $scope.initManageGames();
      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }

      gameService.saveGame(obj);

      //$scope.modal.hide();
    }

    }

	$scope.showStatus = function(status) {
      var selected = [];
      if(typeof status==="object") {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return status.value ? status.value : 'Not set';
      }else{
          return status;
      }

    };

    $scope.showGamecategory = function(gamecategory) {
      //console.log("Inside showGamecategory = "+JSON.stringify(state));
	  //console.log(gamecategory);
	  //console.log(item.gamecategory.id);
      if(gamecategory && $scope.manageGamecategoryList.length) {
	  //console.log(gamecategory.id);
		//console.log(gamecategory.id);
        var selected = $filter('filter')($scope.manageGamecategoryList, {id: gamecategory.id});
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.games')
    .service('gameService', gameService);

  /** @ngInject */
  function gameService(Games) {

    var getGame = function(obj) {

    Games.find({
      filter:{
        include:"gamecat"
      }
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      obj.onFailure(err);
    });
  };

  var getOnlineGame = function(obj) {
    
        Games.find({
          filter:{
            where:{
              gamecatid: 1
            },
            include:"gamecat"
          }
        }).$promise.then(function(data) {
          //$ionicLoading.hide();
          obj.onSuccess(data);
    
        }, function(err) {
          //$ionicLoading.hide();
          obj.onFailure(err);
        });
  };
  
  var getMachineGame = function(obj) {
        
            Games.find({
              filter:{
                where:{
                  gamecatid: 2
                },
                include:"gamecat"
              }
            }).$promise.then(function(data) {
              //$ionicLoading.hide();
              obj.onSuccess(data);
        
            }, function(err) {
              //$ionicLoading.hide();
              obj.onFailure(err);
            });
  };

  var createGame = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Games.create({
      name:obj.params.name,
      created: date,
      lastupdated: date,
      gamecatid: obj.params.gamecatid,
	  status: obj.params.status

    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };


  var deleteGame = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    Games.deleteById({
      id:obj.params.id
    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      //console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      //console.log(err)
      obj.onFailure(err);
    });
  };

  var saveGame = function(obj) {
    //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

    var date = new Date();

    Games.prototype$updateAttributes({
      id: obj.params.id,
      name: obj.params.name,
      gamecatid: obj.params.gamecatid,
	  status: obj.params.status,
      lastupdated: date

    }).$promise.then(function(data) {
      //$ionicLoading.hide();
      console.log(data);
      obj.onSuccess(data);

    }, function(err) {
      //$ionicLoading.hide();
      console.log(err)
      obj.onFailure(err);
    });
  };

    return{
      getGame: getGame,
      createGame: createGame,
      deleteGame: deleteGame,
      saveGame: saveGame,
      getOnlineGame:getOnlineGame,
      getMachineGame:getMachineGame
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine')
    .controller('MachinePageCtrl', MachinePageCtrl);

  /** @ngInject */
  function MachinePageCtrl($scope, $filter, editableOptions, editableThemes,
    machineService, toastr, $uibModal, gameService, machineShopService, zoneService, $state,
    supplierService,shopService) {
    console.log("Inside MachinePageCtrl");

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        size: size

      });
      modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachine(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function () {
        console.log('Modal dismissed at: ' + new Date());
      });
    };

    $scope.smartTablePageSize = 10;
    $scope.isEdit = false;
    $scope.isEditSupplier = false;
    $scope.yesNo = {
      true: "Yes",
      false: "No"
    };




    $scope.manageGamesList = [];
    $scope.initManageGames = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getMachineGame(obj);

    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };


    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };

    $scope.manageActiveMachineList = [];
    $scope.initManageActiveMachine = function () {
      var obj = {};
      obj.params = {};
      obj.params.status = true;
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageActiveMachineList = result;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineShopService.getAllMachineshop(obj);
    };

    $scope.manageShopList = [];
    $scope.initManageShop = function(zoneid) {
      var obj = {};
      obj.params={};
      obj.params.zoneid = zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShopByZone(obj);

    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function (manageMachineid) {
      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};
        obj.params.machineid = manageMachineid;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS initManageMachineShop");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshopByMachineId(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };

    $scope.manageMachine = {};
    $scope.manageMachineList = [];
    $scope.initManageMachine = function () {
      var obj = {};
      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachineList = result;
        $scope.initManageGames();
        $scope.initManageZones();
        $scope.initManageSupplier();
        $scope.initManageActiveMachine();
        $scope.isEdit = false;
      };
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachine(obj);
    };
    $scope.initManageMachine();

    $scope.addState = function () {
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        code: null,
        /*gameid: null,
        zoneid: null,
        isjackpot: null,
        cm_in: null,
        cm_out: null,
        bm_in: null,
        bm_out: null,
        cm_rate: null,
        bm_rate: null,*/
        //description:null,
      };
      $scope.manageMachineList.push($scope.inserted);
    };

    $scope.createMachine = function (manageMachine) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createMachine");
      console.log(manageMachine);

      var obj = {};
      obj.params = {};
      obj.params.code = manageMachine.code;
      obj.params.gameid = manageMachine.game.id;
      obj.params.zoneid = manageMachine.zone.id;
      obj.params.supplierid = manageMachine.supplier? manageMachine.supplier.id:null;
      obj.params.isjackpot = manageMachine.isjackpot;
      obj.params.calby = manageMachine.calby;
      obj.params.cm_in = manageMachine.cmIn;
      obj.params.cm_out = manageMachine.cmOut;
      obj.params.bm_in = manageMachine.bmIn;
      obj.params.bm_out = manageMachine.bmOut;
      obj.params.cm_rate = manageMachine.cmRate;
      obj.params.bm_rate = manageMachine.bmRate;
      obj.params.status = manageMachine.status;
      obj.params.remarks = manageMachine.remarks;

      //obj.params.description = manageMachine.description;

      obj.onSuccess = function (result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageMachine = {};
        $scope.isEditSupplier = false;
        toastr.success('New Machine has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Machine successfully created.");
        $scope.initManageMachine();

      }
      obj.onFailure = function (err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      machineService.createMachine(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id) {
      $scope.open('app/pages/system/machine/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteMachine = function (res) {
      console.log("Inside deleteMachine");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
          $scope.initManageMachine();
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.deleteMachine(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editState = function (machine) {
      console.log("Inside editMachine");
      console.log(machine);
      // $scope.manageMachine.id = $scope.manageMachine.id;
      // $scope.manageMachine.name = state.name;
      // $scope.manageMachine.description = state.description;
      // $scope.manageMachine.created = state.created;
      // $scope.manageMachine.lastupdated = state.lastupdated;
      $scope.manageMachine = machine;
      genericModalService.show('modules/modals/addState.html', $scope);
    }

    $scope.saveMachine = function (manageMachine) {

      console.log("Inside saveMachine");
      console.log(manageMachine);

      console.log(manageMachine.zones);
      console.log(manageMachine.games);

      if (manageMachine.id === undefined) {
        $scope.createMachine(manageMachine);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageMachine
        obj.params.id = manageMachine.id;
        obj.params.code = manageMachine.code;
        obj.params.gameid = manageMachine.game.id;
        obj.params.zoneid = manageMachine.zone.id;
        obj.params.supplierid = manageMachine.supplier?manageMachine.supplier.id:null;
        obj.params.isjackpot = manageMachine.isjackpot;
        obj.params.calby = manageMachine.calby;
        obj.params.cm_in = manageMachine.cmIn;
        obj.params.cm_out = manageMachine.cmOut;
        obj.params.bm_in = manageMachine.bmIn;
        obj.params.bm_out = manageMachine.bmOut;
        obj.params.cm_rate = manageMachine.cmRate;
        obj.params.bm_rate = manageMachine.bmRate;
        obj.params.status = manageMachine.status;
        obj.params.remarks = manageMachine.remarks;
        // obj.params.name = $scope.manageMachine.name;
        // obj.params.description = $scope.manageMachine.description;
        //obj.params.created = $scope.manageMachine.created;


        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachine = {};
          $scope.isEditSupplier = false;
          toastr.success('Machine has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();

        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        machineService.saveMachine(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showGames = function (game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showZones = function (zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set'
    };
    //manageActiveMachineList
    $scope.showShopDetails = function (id) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (id && $scope.manageActiveMachineList.length) {
        var selected = $filter('filter')($scope.manageActiveMachineList, {
          machineid: id
        },true);
        return selected.length ? selected[0] : null;
      }else return null;
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editMachine = function (manageMachine) {
      console.log("Inside editMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = manageMachine;
      console.log($scope.manageMachine);
      //$scope.manageMachine.shopDetails = $scope.showShopDetails(manageMachine.id)
      $scope.initManageMachineShop(manageMachine.id);
      $scope.initManageShop(manageMachine.zoneid);

    };

    $scope.addMachine = function () {
      console.log("Inside addMachine");
      $scope.isEdit = true;
      $scope.isEditSupplier = false;
      $scope.manageSupplier = {};
      $scope.manageMachine = {};
      console.log($scope.manageZonesList);
    };
    $scope.manageSupplier = {};
    $scope.addSupplier = function () {
      console.log("Inside addSupplier");
      $scope.isEditSupplier = true;    
    };

    $scope.cancelSupplier = function () {
      $scope.isEditSupplier = false;    
    };

    $scope.saveSupplierDetails = function (manageSupplier) {
      console.log("Inside saveSupplierDetails");
      console.log($scope.manageSupplier);
        var obj = {};
        obj.params = {};
        obj.params = manageSupplier
        //obj.params.created = $scope.manageSupplier.created;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSupplier = {};
          $scope.initManageSupplier();          
          toastr.success('Supplier has been saved successfully!', 'SUCCESS');
          $scope.isEditSupplier = false;
        }
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        supplierService.createSupplier(obj);
    }

    $scope.qrString = "";
    $scope.viewQRcode = function (code){
      console.log('Inside viewQRcode', code);
      $scope.open('app/pages/system/machine/modals/qrModal.html');
      $scope.qrString = code;
    };

    $scope.print = function(){
      window.print();
    };

    $scope.addMachineShop = function() {
      $scope.inserted = {
        shopid: null,
        machineid: $scope.manageMachine.id,
        macrate: null,
        macvirtual: null
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.showSupplierCode = function(supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showShop = function(shop) {
      if (shop && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageShopList, {
          id: shop.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.createMachineshop = function (manageMachineshop) {

      console.log('createMachineshop',manageMachineshop);

      if ($scope.manageMachine.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Machines.', 'Error');
      }
    };

    $scope.saveMachineshop = function(manageMachineshop, id) {

      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.shopid = manageMachineshop.shop.id;
        obj.params.machineid = $scope.manageMachine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code==="23505"){
            toastr.error('This Machine is already assigned.', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.saveMachineshop(obj);
      }

    };

    $scope.openDeleteMachineshop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachineshop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function(id) {
      $scope.openDeleteMachineshop('app/pages/system/machine/modals/dangerMachineGameModal.html');
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function(res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log('Sure!');
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        obj.params.status = false;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been deleted successfully!', 'SUCCESS');
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop($scope.manageMachine.id);
          $scope.initManageShop($scope.manageMachine.zoneid);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log('Not sure!');
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.machine')
    .service('machineService', machineService);

  /** @ngInject */
  function machineService(Machine) {
    var getMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getAllMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          include: ["supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var getMachineByZone = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.find({
        filter: {
          where: {
            zoneid: obj.params.zoneid
          },
          include: ["game", "zone", "supplier"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.create({
        // description:obj.params.description,
        created: date,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Machine.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveMachine = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Machine.prototype$updateAttributes({
        id: obj.params.id,
        //description: obj.params.description,
        lastupdated: date,
        code: obj.params.code,
        gameid: obj.params.gameid,
        zoneid: obj.params.zoneid,
        supplierid: obj.params.supplierid,
        isjackpot: obj.params.isjackpot,
        calby: obj.params.calby,
        cmIn: obj.params.cm_in,
        cmOut: obj.params.cm_out,
        bmIn: obj.params.bm_in,
        bmOut: obj.params.bm_out,
        cmRate: obj.params.cm_rate,
        bmRate: obj.params.bm_rate,
        status: obj.params.status,
        remarks: obj.params.remarks,

      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getMachine: getMachine,
      getAllMachine: getAllMachine,
      createMachine: createMachine,
      deleteMachine: deleteMachine,
      saveMachine: saveMachine,
      getMachineByZone: getMachineByZone
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .controller('ShopPageCtrl', ShopPageCtrl);

  /** @ngInject */
  function ShopPageCtrl($scope, $filter, editableOptions, editableThemes,
    shopService, toastr, $uibModal, partnerService, zoneService, $state,
    gameService, onlineShopService, machineShopService, machineService,
    suppliersalesreportService, supplierService, areaService,siteService) {
    console.log("Inside ShopPageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteShop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.openDeleteOnlineShop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteOnlineShop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.openDeleteMachineshop = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteMachineshop(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;
    $scope.isEdit = false;


    $scope.manageOnlineShopList = [];
    $scope.initManageOnlineShop = function() {
      if ($scope.manageShop.id){
      var obj = {};
      obj.params = {};
      obj.params.shopid = $scope.manageShop.id;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageOnlineShopList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      onlineShopService.getOnlineshop(obj);
    }else{
      $scope.manageOnlineShopList = [];
    }
    };

    $scope.manageGamesList = [];
    $scope.initManageGames = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageGamesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      gameService.getGame(obj);
    };

    $scope.managePartnerList = [];
    $scope.initManagePartner = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.managePartnerList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      partnerService.getPartner(obj);

    };

    $scope.manageZonesList = [];
    $scope.initManageZones = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZonesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      zoneService.getZones(obj);
    };

    $scope.manageAreaList = [];
    $scope.initManageAreas = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };

    $scope.manageSiteList = [];
    $scope.initManageSites = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };

    $scope.manageMachineshopList = [];
    $scope.initManageMachineShop = function () {
      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};
        obj.params.shopid = $scope.manageShop.id;
        obj.params.status = true;
        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageMachineshopList = result;
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
        };
        machineShopService.getMachineshop(obj);
      } else {
        $scope.manageMachineshopList = [];
      }
    };
    $scope.manageSupplierList = [];
    $scope.initManageSupplier = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSupplierList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      supplierService.getSupplier(obj);
    };
    $scope.manageMachineList = [];
    $scope.initManageMachine = function() {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid)// ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineList = result.result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      //machineService.getMachineByZone(obj);
      suppliersalesreportService.getAvailableMachineByZone(obj);
    };

    $scope.manageMachineListZone = [];
    $scope.initManageMachineZone = function() {
      var obj = {};
      obj.params = {};
      console.log($scope.manageShop.zoneid)// ="+JSON.stringify($scope.manageShop));
      obj.params.zoneid = $scope.manageShop.zoneid;
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS initManageMachine");
        console.log(result);
        $scope.manageMachineListZone = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      machineService.getMachineByZone(obj);
    };

    $scope.manageShop = {};
    $scope.manageShopList = [];
    $scope.initManageShop = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShopList = result;
        $scope.initManagePartner();
        $scope.initManageZones();
        $scope.initManageAreas();
        $scope.initManageGames();
        $scope.initManageSupplier();
        $scope.initManageSites();
        //$scope.initManageOnlineShop();
        $scope.isEdit = false;
        for (var i = 0; i < result.length; i++) {
          if ($scope.manageShopList[i].contact1) {
            $scope.manageShopList[i].contact1 = JSON.parse($scope.manageShopList[i].contact1);
          }
          if ($scope.manageShopList[i].contact2) {
            $scope.manageShopList[i].contact2 = JSON.parse($scope.manageShopList[i].contact2);
          }
          if ($scope.manageShopList[i].contact3) {
            $scope.manageShopList[i].contact3 = JSON.parse($scope.manageShopList[i].contact3);
          }

        }
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      shopService.getShop(obj);

    };
    $scope.initManageShop();



    $scope.createShop = function(manageShop) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createShop");
      console.log(manageShop);

      var obj = {};
      obj.params = {};
      obj.params.code = manageShop.code;
      obj.params.name = manageShop.name;
      obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;

      obj.params.zoneid = manageShop.zone?manageShop.zone.id:null;
      obj.params.areaid = manageShop.area?manageShop.area.id:null;
      obj.params.siteid = manageShop.site?manageShop.site.id:null;
      obj.params.onrate = manageShop.onrate;
      obj.params.macrate = manageShop.macrate;
      obj.params.onvirtual = manageShop.onvirtual;
      obj.params.ontips = manageShop.ontips;
      obj.params.creditlimit = manageShop.creditlimit;
      obj.params.shoptype = manageShop.shoptype;
      obj.params.address = manageShop.address;
      obj.params.status = manageShop.status;
      obj.params.contact1 = JSON.stringify(manageShop.contact1);
      obj.params.contact2 = JSON.stringify(manageShop.contact2);
      obj.params.contact3 = JSON.stringify(manageShop.contact3);
      obj.params.remarks = manageShop.remarks;
      obj.params.onrebate = manageShop.onrebate;
      obj.params.macrebate = manageShop.macrebate;
      obj.params.mactips = manageShop.mactips;
      obj.params.macvirtual = manageShop.macvirtual;

      //obj.params.description = manageShop.description;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageShop = {};
        toastr.success('New Shop has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Shop successfully created.");
        $scope.initManageShop();

      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          toastr.error('Service Unavailable. Please try again later', 'Error');
        } else {
          var errdetails = err.data.error.detail;
          toastr.error(errdetails, 'Error');
        }
      };
      shopService.createShop(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/system/shop/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteShop = function(res) {
      console.log("Inside deleteShop");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Shop has been deleted successfully!', 'SUCCESS');

          $scope.initManageShop();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        shopService.deleteShop(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.editState = function(shop) {
      console.log("Inside editShop");
      console.log(shop);
      // $scope.manageShop.id = $scope.manageShop.id;
      // $scope.manageShop.name = state.name;
      // $scope.manageShop.description = state.description;
      // $scope.manageShop.created = state.created;
      // $scope.manageShop.lastupdated = state.lastupdated;
      $scope.manageShop = shop;
      genericModalService.show('modules/modals/addState.html', $scope);
    };

    $scope.saveShop = function(manageShop) {

      console.log("Inside saveShop");
      console.log(manageShop);

      console.log(manageShop.zone);
      console.log(manageShop.partner);

      if (manageShop.id === undefined) {
        $scope.createShop(manageShop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = manageShop.id;
        obj.params.code = manageShop.code;
        obj.params.name = manageShop.name;
        obj.params.partnerid = manageShop.partner ? manageShop.partner.id : null;
        obj.params.zoneid = manageShop.zone?manageShop.zone.id:null;
        obj.params.areaid = manageShop.area?manageShop.area.id:null;
        obj.params.siteid = manageShop.site?manageShop.site.id:null;
        obj.params.onrate = manageShop.onrate;
        obj.params.macrate = manageShop.macrate;
        obj.params.onvirtual = manageShop.onvirtual;
        obj.params.ontips = manageShop.ontips;
        obj.params.creditlimit = manageShop.creditlimit;
        obj.params.shoptype = manageShop.shoptype;
        obj.params.address = manageShop.address;
        obj.params.status = manageShop.status;
        obj.params.contact1 = JSON.stringify(manageShop.contact1);
        obj.params.contact2 = JSON.stringify(manageShop.contact2);
        obj.params.contact3 = JSON.stringify(manageShop.contact3);

        obj.params.remarks = manageShop.remarks;
        obj.params.onrebate = manageShop.onrebate;
        obj.params.macrebate = manageShop.macrebate;
        obj.params.mactips = manageShop.mactips;
        obj.params.macvirtual = manageShop.macvirtual;

        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageShop = {};
          toastr.success('Shop has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageShop();

        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        shopService.saveShop(obj);
      }

    };

    $scope.showPartner = function(partner) {
      //console.log("Inside showPartner = "+JSON.stringify(partner));
      if (partner && $scope.managePartnerList.length) {
        var selected = $filter('filter')($scope.managePartnerList, {
          id: partner.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    $scope.showZones = function(zone) {
      //console.log("Inside showState = "+JSON.stringify(zone));
      if (zone && $scope.manageZonesList.length) {
        var selected = $filter('filter')($scope.manageZonesList, {
          id: zone.id
        });
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    editableOptions.theme = 'bs3';
    editableThemes.bs3.submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes.bs3.cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


    $scope.editShop = function(manageShop) {
      console.log("Inside editShop");
      $scope.isEdit = true;
      $scope.manageShop = manageShop;
      $scope.initManageMachine();
      $scope.initManageMachineZone();
      $scope.initManageOnlineShop();
      $scope.initManageMachineShop();
      console.log($scope.manageShop);
    };

    $scope.addShop = function() {
      console.log("Inside addShop");
      $scope.isEdit = true;
      $scope.manageShop = {};
      $scope.manageOnlineShopList = [];
      $scope.manageMachineshopList = [];
      console.log($scope.manageZonesList);
    };

    $scope.showGames = function(game) {
      //console.log("Inside showGames = "+JSON.stringify(game));
      if (game && $scope.manageGamesList.length) {
        var selected = $filter('filter')($scope.manageGamesList, {
          id: game.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set';
    };

    //Online Games

    $scope.addOnlineShop = function() {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        gameid: null,
        playtechid: null
      };
      $scope.manageOnlineShopList.push($scope.inserted);
    };

    $scope.saveOnlineShop = function(manageOnlineShop, id) {

      console.log("Inside saveOnlineShop");
      console.log(manageOnlineShop);
      console.log(id);

      if (id === undefined) {
        $scope.createOnlineShop(manageOnlineShop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Online Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageOnlineShop();

        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.saveOnlineshop(obj);
      }

    };

    $scope.createOnlineShop = function (manageOnlineShop) {

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.gameid = manageOnlineShop.games;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.playtechid = manageOnlineShop.playtechid;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been saved successfully!', 'SUCCESS');
          $scope.initManageOnlineShop();

        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.createOnlineshop(obj);
      } else {
        $scope.initManageOnlineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Online Games.', 'Error');
      }
    };

    $scope.deleteOnlineShopId = null;
    $scope.confirmOnlineShopDelete = function(id) {
      $scope.openDeleteOnlineShop('app/pages/system/shop/modals/dangerOnlineGameModal.html');
      $scope.deleteOnlineShopId = id;
    };

    $scope.deleteOnlineShop = function(res) {
      console.log("Inside deleteOnlineShop");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteOnlineShopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteOnlineShopId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Online Game has been deleted successfully!', 'SUCCESS');

          $scope.initManageOnlineShop();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageOnlineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        onlineShopService.deleteOnlineshop(obj);
      }
    };

    //Machine Shop
    $scope.showMachine = function(machine) {
      if (machine && $scope.manageMachineListZone.length) {
        var selected = $filter('filter')($scope.manageMachineListZone, {
          id: machine.id
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };

    $scope.addMachineShop = function() {
      $scope.inserted = {
        shopid: $scope.manageShop.id,
        machineid: null,
        macrate: null,
        macvirtual: null
      };
      $scope.manageMachineshopList.push($scope.inserted);
    };

    $scope.saveMachineshop = function(manageMachineshop, id) {

      console.log("Inside saveMachineshop");
      console.log(manageMachineshop);
      console.log(id);

      if (id === undefined) {
        $scope.createMachineshop(manageMachineshop);
      } else {

        var obj = {};
        obj.params = {};
        //obj.params = manageShop
        obj.params.id = id;
        //obj.params.supplierid = manageOnlineShop.supplier;
        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machineid;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);
        // obj.params.name = $scope.manageShop.name;
        // obj.params.description = $scope.manageShop.description;
        //obj.params.created = $scope.manageShop.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          //$scope.manageOnlineShop = {};
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
          $scope.initManageMachine();
          $scope.initManageMachineShop();

        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code==="23505"){
            toastr.error('This Machine is already assigned.', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.saveMachineshop(obj);
      }

    };

    $scope.createMachineshop = function (manageMachineshop) {

      console.log('createMachineshop',manageMachineshop);

      if ($scope.manageShop.id) {
        var obj = {};
        obj.params = {};

        obj.params.shopid = $scope.manageShop.id;
        obj.params.machineid = manageMachineshop.machine.id;
        obj.params.macrate = manageMachineshop.macrate;
        obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = true;
        obj.params.suprate = manageMachineshop.suprate;
        obj.params.supplierid = manageMachineshop.supplier.id;

        console.log(obj.params);

        obj.onSuccess = function (result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been saved successfully!', 'SUCCESS');
          $scope.initManageMachineShop();
          $scope.initManageMachine();
        };
        obj.onFailure = function (err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          } if (err.data.error.code === "23505") {
            toastr.error('This Machine is already assigned.', 'Error');
          } else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.createMachineshop(obj);
      } else {
        $scope.initManageMachineShop();
        toastr.error('Please make sure that this shop is SAVED, before setting up Machines.', 'Error');
      }
    };

    $scope.deleteMachineshopId = null;
    $scope.confirmMachineshopDelete = function(id) {
      $scope.openDeleteMachineshop('app/pages/system/shop/modals/dangerMachineGameModal.html');
      $scope.deleteMachineshopId = id;
    };

    $scope.deleteMachineshop = function(res) {
      console.log("Inside deleteMachineshop");
      if (res) {
        console.log('Sure!');
        //console.log($scope.deleteMachineshopId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteMachineshopId;
        // obj.params.shopid = $scope.manageShop.id;
        // obj.params.machineid = manageMachineshop.machineid;
        // obj.params.macrate = manageMachineshop.macrate;
        // obj.params.macvirtual = manageMachineshop.macvirtual;
        obj.params.status = false;

        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Machine Game has been deleted successfully!', 'SUCCESS');
          $scope.initManageMachine();
          $scope.initManageMachineShop();
        };
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          $scope.initManageMachineShop();
          if (err.status === -1) {
            toastr.error('Service Unavailable. Please try again later', 'Error');
          }else {
            var errdetails = err.data.error.detail;
            toastr.error(errdetails, 'Error');
          }
        };
        machineShopService.deleteMachineshop(obj);
      } else {
        console.log('Not sure!');
      }

    };

    $scope.showSupplierCode = function(supplierid) {
      if (supplierid && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: supplierid
        },true);
        return selected.length ? selected[0].code : 'Not set';
      } else return 'Not set';
    };
    $scope.showSupplierComm = function(machine) {
      if (machine && $scope.manageSupplierList.length) {
        var selected = $filter('filter')($scope.manageSupplierList, {
          id: machine.supplierid
        },true);
        return selected.length ? selected[0].rate : 'Not set';
      } else return 'Not set';
    };
  }

})();

/**
 * @author udit.jain
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('machineShopService', machineShopService);

  /** @ngInject */
  function machineShopService(Machineshop) {
    var getMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {shopid: obj.params.shopid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getMachineshopByMachineId = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            and:[
              {machineid: obj.params.machineid},
              {status: obj.params.status}
            ]
          },
          include: ["shop", "machine","supplier"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshop = function(obj) {

      Machineshop.find({
        filter: {
          where:{
            status: obj.params.status
          },
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllMachineshopWithoutStatus = function(obj) {
      
      Machineshop.find({
        filter: {
          include: ["shop", "machine"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var createMachineshop = function(obj) {
      var date = new Date();

      Machineshop.create({
        created: date,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    // var deleteMachineshop = function(obj) {

    //   Machineshop.deleteById({
    //     id: obj.params.id
    //   }).$promise.then(function(data) {
    //     obj.onSuccess(data);
    //   }, function(err) {
    //     obj.onFailure(err);
    //   });
    // };

    var deleteMachineshop = function(obj) {
      var date = new Date();
      Machineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        status: obj.params.status
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };
    var saveMachineshop = function(obj) {

      var date = new Date();

      Machineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        shopid: obj.params.shopid,
        machineid: obj.params.machineid,
        macrate: obj.params.macrate,
        macvirtual: obj.params.macvirtual,
        status: obj.params.status,
        suprate: obj.params.suprate,
        supplierid: obj.params.supplierid
        
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getMachineshop: getMachineshop,
      getAllMachineshop:getAllMachineshop,
      getAllMachineshopWithoutStatus: getAllMachineshopWithoutStatus,
      createMachineshop: createMachineshop,
      deleteMachineshop: deleteMachineshop,
      saveMachineshop: saveMachineshop,
      getMachineshopByMachineId: getMachineshopByMachineId
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('onlineShopService', onlineShopService);

  /** @ngInject */
  function onlineShopService(Onlineshop) {
    var getOnlineshop = function(obj) {

      Onlineshop.find({
        filter: {
          where:{
            shopid:obj.params.shopid
          },
          include: ["game", "shop"]
        }
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var getAllOnlineshop = function(obj) {
      
            Onlineshop.find({
              filter: {
                include: ["game", "shop"]
              }
            }).$promise.then(function(data) {
              obj.onSuccess(data);
            }, function(err) {
              obj.onFailure(err);
            });
          };
    var createOnlineshop = function(obj) {
      var date = new Date();

      Onlineshop.create({
        created: date,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        console.log(data);
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var deleteOnlineshop = function(obj) {

      Onlineshop.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    var saveOnlineshop = function(obj) {

      var date = new Date();

      Onlineshop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        gameid: obj.params.gameid,
        shopid: obj.params.shopid,
        playtechid: obj.params.playtechid
      }).$promise.then(function(data) {
        obj.onSuccess(data);
      }, function(err) {
        obj.onFailure(err);
      });
    };

    return {
      getOnlineshop: getOnlineshop,
      createOnlineshop: createOnlineshop,
      deleteOnlineshop: deleteOnlineshop,
      saveOnlineshop: saveOnlineshop,
      getAllOnlineshop:getAllOnlineshop
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.shop')
    .service('shopService', shopService);

  /** @ngInject */
  function shopService(Shop) {
    var getShop = function (obj) {
      Shop.find({
        filter: {
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getShopById = function (obj) {
      Shop.findById({
        id: obj.params.shopid,
        filter: {
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var getShopByZone = function (obj) {
      Shop.find({
        filter: {
          where:{
            and:[
              {zoneid: obj.params.zoneid},
              {status: true}
            ]
          },
          include: ["partner", "zone", "area", "site"]
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var createShop = function (obj) {
      var date = new Date();

      Shop.create({
        created: date,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };


    var deleteShop = function (obj) {

      Shop.deleteById({
        id: obj.params.id
      }).$promise.then(function (data) {
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var saveShop = function (obj) {
      var date = new Date();

      Shop.prototype$updateAttributes({
        id: obj.params.id,
        lastupdated: date,
        code: obj.params.code,
        name: obj.params.name,
        zoneid: obj.params.zoneid,
        areaid: obj.params.areaid,
        siteid: obj.params.siteid,
        partnerid: obj.params.partnerid,
        onrate: obj.params.onrate,
        macrate: obj.params.macrate,
        onvirtual: obj.params.onvirtual,
        ontips: obj.params.ontips,
        creditlimit: obj.params.creditlimit,
        shoptype: obj.params.shoptype,
        address: obj.params.address,
        status: obj.params.status,
        contact1: obj.params.contact1,
        contact2: obj.params.contact2,
        contact3: obj.params.contact3,
        remarks: obj.params.remarks,
        onrebate: obj.params.onrebate,
        macrebate: obj.params.macrebate,
        mactips: obj.params.mactips,
        macvirtual: obj.params.macvirtual

      }).$promise.then(function (data) {
        console.log(data);
        obj.onSuccess(data);

      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findAssignedShop = function (obj) {
      Shop.find({
        filter: {
          where:{
            id: {
              inq: obj.params.shopmap
            }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    var findNotAssignedShop = function (obj) {
      if (obj.params.shopmap){
        Shop.find({
          filter: {
            where:{
              and:[
                {id: { nin: obj.params.shopmap}},
                {shoptype: obj.params.shoptype},
                {zoneid: {inq: obj.params.zonemap}}
              ]
            }
          }
        }).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }else{
        Shop.find({
          filter: {
            where:{
              and:[
                {shoptype: obj.params.shoptype},
                {zoneid: {inq: obj.params.zonemap}}
              ]
            }
          }
        }
        ).$promise.then(function (data) {
          obj.onSuccess(data);
        }, function (err) {
          obj.onFailure(err);
        });
      }

    };

    
    var findNotAssignedShopForAdmin = function (obj) {

      Shop.find({
        filter: {
          where: {
            id: { nin: obj.params.shopmap }
          }
        }
      }).$promise.then(function (data) {
        obj.onSuccess(data);
      }, function (err) {
        obj.onFailure(err);
      });
    };

    return {
      getShop: getShop,
      createShop: createShop,
      deleteShop: deleteShop,
      saveShop: saveShop,
      findAssignedShop: findAssignedShop,
      findNotAssignedShop: findNotAssignedShop,
      getShopById:getShopById,
      getShopByZone:getShopByZone,
      findNotAssignedShopForAdmin:findNotAssignedShopForAdmin
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.site')
    .controller('SitePageCtrl', SitePageCtrl);

  /** @ngInject */
  function SitePageCtrl($scope, $filter, editableOptions, editableThemes,
    siteService, toastr, $uibModal, stateService, areaService) {
    console.log("Inside SitePageCtrl");

    $scope.open = function(page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function(selectedItem) {
        //$scope.selected = selectedItem;
        $scope.deleteSite(selectedItem);
        console.log("hurry = " + selectedItem);
      }, function() {
        console.log('Modal dismissed at: ' + new Date());
      });

    };

    $scope.smartTablePageSize = 10;

    //Getting States
    $scope.manageStatesList = [];
    $scope.manageAreaList = [];

    $scope.initManageStates = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageStatesList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      stateService.getStates(obj);
    };

    $scope.initManageArea = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageAreaList = result;
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      areaService.getAreas(obj);
    };




    $scope.manageSiteList = [];
    $scope.manageSite = {};
    $scope.initManageSite = function() {
      var obj = {};
      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSiteList = result;
        $scope.initManageStates();
        $scope.initManageArea();
      };
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
      };
      siteService.getSite(obj);
    };
    $scope.initManageSite();

    $scope.addSite = function() {
      //genericModalService.show('modules/modals/addSite.html',$scope);
      $scope.inserted = {
        name: null,
      };
      $scope.manageSiteList.push($scope.inserted);
    };

    $scope.createSite = function(manageSite) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createSite");
      console.log(manageSite);

      var obj = {};
      obj.params = {};
      obj.params = manageSite;
      // obj.params.name = manageSite.name;
      // obj.params.areaid = manageSite.area
      // obj.params.stateid = manageSite.state;

      obj.onSuccess = function(result) {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageSite = {};
        toastr.success('New Site has been saved successfully!', 'SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Area successfully created.");
        $scope.initManageSite();

      }
      obj.onFailure = function(err) {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1) {
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else {

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      siteService.createSite(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function(id) {
      $scope.open('app/pages/system/site/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteSite = function(res) {
      console.log("Inside deleteSite");
      if (res) {
        console.log('Sure!');
        console.log($scope.deleteId);
        var obj = {};
        obj.params = {};
        obj.params.id = $scope.deleteId;
        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          toastr.success('Site has been deleted successfully!', 'SUCCESS');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Site successfully deleted.");
          $scope.initManageSite();
        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          } else {
            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        siteService.deleteSite(obj);
      } else {
        console.log('Not sure!');
      }

    }

    $scope.editSite = function(state) {
      console.log("Inside editArea");
      console.log(state);
      // $scope.manageSite.id = $scope.manageSite.id;
      // $scope.manageSite.name = state.name;
      // $scope.manageSite.description = state.description;
      // $scope.manageSite.created = state.created;
      // $scope.manageSite.lastupdated = state.lastupdated;
      $scope.manageSite = state;
      genericModalService.show('modules/modals/addSite.html', $scope);
    }

    $scope.saveSite = function(manageSite, id) {

      console.log("Inside saveSite");
      console.log(manageSite);
      console.log(id);

      console.log(manageSite.area);
      console.log(manageSite.state);


      if (id === undefined) {
        $scope.createSite(manageSite);
      } else {

        var obj = {};
        obj.params = {};
        obj.params = manageSite;
        obj.params.id = id;
        // obj.params.name = $scope.manageSite.name;
        // obj.params.description = $scope.manageSite.description;
        //obj.params.created = $scope.manageSite.created;


        obj.onSuccess = function(result) {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageSite = {};
          toastr.success('Site has been saved successfully!', 'SUCCESS');
          //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
          //PopupMessagesService.showConfirmPopupMessage("SUCCESS","Area successfully Updated.");
          $scope.initManageSite();

        }
        obj.onFailure = function(err) {
          console.log("Inside Failure");
          console.log(err);
          if (err.status === -1) {
            //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
            toastr.error('NO INTERNET CONNECTION', 'Error');
          } else {

            //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
          }
        }
        siteService.saveSite(obj);

        //$scope.modal.hide();
      }

    }

    $scope.showState = function(state) {
      //console.log("Inside showState = " + JSON.stringify(state));
      if (state && $scope.manageStatesList.length) {
        var selected = $filter('filter')($scope.manageStatesList, {
          id: state.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    $scope.showArea = function(area) {
      //console.log("Inside showState = "+JSON.stringify(area));
      if (area && $scope.manageAreaList.length) {
        var selected = $filter('filter')($scope.manageAreaList, {
          id: area.id
        });
        return selected.length ? selected[0].name : 'Not set';
      } else return 'Not set'
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author dufrolabs
 * created on 08/07/2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.system.site')
    .service('siteService', siteService);

  /** @ngInject */
  function siteService(Site) {
    var getSite = function(obj) {

      Site.find({
        filter: {
          include: ["state", "area"]
        }
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        obj.onFailure(err);
      });
    };

    var createSite = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Site.create({
        name: obj.params.name,
        stateid: obj.params.state,
        areaid: obj.params.area,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteSite = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Site.deleteById({
        id: obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveSite = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Site.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        stateid: obj.params.state,
        areaid: obj.params.area,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return {
      getSite: getSite,
      createSite: createSite,
      deleteSite: deleteSite,
      saveSite: saveSite
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states')
      .controller('StatesPageCtrl', StatesPageCtrl);

  /** @ngInject */
  function StatesPageCtrl($scope, $filter, editableOptions, editableThemes,
    stateService,toastr,$uibModal ) {
    console.log("Inside StatesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteState(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 10;


    $scope.manageState={};
    $scope.manageStatesList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageStatesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        stateService.getStates(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
        description:null,
      };
      $scope.manageStatesList.push($scope.inserted);
    };

    $scope.createState = function(manageState) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createState");
      console.log(manageState.name);
      console.log(manageState.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageState.name;
      obj.params.description = manageState.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageState = {};
        toastr.success('New State has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New State successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      stateService.createState(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/states/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteState = function (res){
      console.log("Inside deleteState");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('State has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            stateService.deleteState(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (state){
      console.log("Inside editState");
      console.log(state);
      // $scope.manageState.id = $scope.manageState.id;
      // $scope.manageState.name = state.name;
      // $scope.manageState.description = state.description;
      // $scope.manageState.created = state.created;
      // $scope.manageState.lastupdated = state.lastupdated;
      $scope.manageState = state;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveState = function (manageState, id){

      console.log("Inside saveState");
      console.log(manageState);
      console.log(id);

      if (id===undefined){
        $scope.createState(manageState);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageState
      obj.params.id = id;
      // obj.params.name = $scope.manageState.name;
      // obj.params.description = $scope.manageState.description;
      //obj.params.created = $scope.manageState.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageState = {};
        toastr.success('State has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      stateService.saveState(obj);

      //$scope.modal.hide();
    }

    }


    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.states')
    .service('stateService', stateService);

  /** @ngInject */
  function stateService(State) {
    var getStates = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      State.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      State.create({
        name:obj.params.name,
        description:obj.params.description,
        created: date,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      State.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveState = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      State.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        description: obj.params.description,
        lastupdated: date
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getStates: getStates,
      createState: createState,
      deleteState: deleteState,
      saveState: saveState
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones')
      .controller('ZonesPageCtrl', ZonesPageCtrl);
 
  /** @ngInject */
  function ZonesPageCtrl($scope, $filter, editableOptions, editableThemes,
    zoneService,toastr,$uibModal ) {
    console.log("Inside ZonesPageCtrl");

    $scope.open = function (page, size) {
       var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });
      modalInstance.result.then(function (selectedItem) {
    //$scope.selected = selectedItem;
    $scope.deleteZones(selectedItem);
    console.log("hurry = "+selectedItem);
  }, function () {
    console.log('Modal dismissed at: ' + new Date());
  });

    };

    $scope.smartTablePageSize = 10;
    $scope.status = [{value:'Active'},{value:'Inactive'}];

    $scope.manageZones={};
    $scope.manageZonesList=[];
    $scope.initManageStates = function (){
        var obj ={};
        obj.onSuccess = function (result)
        {
          console.log("Inside SUCCESS");
          console.log(result);
          $scope.manageZonesList = result;
        };
        obj.onFailure = function (err)
        {
          console.log("Inside Failure");
          console.log(err);
        };
        zoneService.getZones(obj);
        $scope.$broadcast('scroll.refreshComplete');
    };
    $scope.initManageStates();

    $scope.addState = function (){
      //genericModalService.show('modules/modals/addState.html',$scope);
      $scope.inserted = {
        name: null,
		status:null,
        //description:null,
      };
      $scope.manageZonesList.push($scope.inserted);
    };

    $scope.createZones = function(manageZones) {
      //$scope.contacts.push({ name: u.firstName + ' ' + u.lastName });
      console.log("Inside createZones");
	  console.log(manageZones);
      console.log(manageZones.name);
	  console.log(manageZones.code);
	  console.log(manageZones.status);
      //console.log(manageZones.description);

      var obj ={};
      obj.params={};
      obj.params.name = manageZones.name;
	  obj.params.code = manageZones.code;
	  obj.params.status = manageZones.status.value;
      //obj.params.description = manageZones.description;

      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZones = {};
        toastr.success('New Zones has been saved successfully!','SUCCESS');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","New Zones successfully created.");
          $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      zoneService.createZones(obj);

      //$scope.modal.hide();
    };
    $scope.deleteId = null;
    $scope.confirmDelete = function (id){
      $scope.open('app/pages/system/zones/modals/dangerModal.html');
      $scope.deleteId = id;
    };

    $scope.deleteZones = function (res){
      console.log("Inside deleteZones");
         if(res) {
            console.log('Sure!');
            console.log($scope.deleteId);
            var obj = {};
            obj.params = {};
            obj.params.id = $scope.deleteId;
            obj.onSuccess = function (result){
              console.log("Inside SUCCESS");
              console.log(result);
              toastr.success('Zones has been deleted successfully!','SUCCESS');
            //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully deleted.");
              $scope.initManageStates();
            }
            obj.onFailure = function (err){
              console.log("Inside Failure");
              console.log(err);
              if (err.status === -1){
                //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
              } else{
                //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
              }
            }
            zoneService.deleteZones(obj);
         } else {
            console.log('Not sure!');
         }

    }

    $scope.editState = function (zones){
      console.log("Inside editZones");
      console.log(zones);
      // $scope.manageZones.id = $scope.manageZones.id;
      // $scope.manageZones.name = state.name;
      // $scope.manageZones.description = state.description;
      // $scope.manageZones.created = state.created;
      // $scope.manageZones.lastupdated = state.lastupdated;
      $scope.manageZones = zones;
      genericModalService.show('modules/modals/addState.html',$scope);
    }

    $scope.saveZones = function (manageZones, id){

      console.log("Inside saveZones");
      console.log(manageZones);
      console.log(id);

      if (id===undefined){
        $scope.createZones(manageZones);
      }else{

      var obj ={};
      obj.params={};
      obj.params = manageZones
      obj.params.id = id;
	  obj.params.status = manageZones.status.value;
      // obj.params.name = $scope.manageZones.name;
      // obj.params.description = $scope.manageZones.description;
      //obj.params.created = $scope.manageZones.created;


      obj.onSuccess = function (result)
      {
        console.log("Inside SUCCESS");
        console.log(result);
        $scope.manageZones = {};
        toastr.success('Zones has been saved successfully!','SUCCESS');
        //$scope.open('app/pages/ui/modals/modalTemplates/successModal.html');
        //PopupMessagesService.showConfirmPopupMessage("SUCCESS","State successfully Updated.");
		console.log(result.status);
        $scope.initManageStates();

      }
      obj.onFailure = function (err)
      {
        console.log("Inside Failure");
        console.log(err);
        if (err.status === -1){
          //PopupMessagesService.showErrorPopupMessage("ERROR", 'NO INTERNET CONNECTION');
          toastr.error('NO INTERNET CONNECTION', 'Error');
        } else{

          //PopupMessagesService.showErrorPopupMessage("ERROR", err.data.error.detail);
        }
      }
      zoneService.saveZones(obj);

      //$scope.modal.hide();
    }

    }

	$scope.showStatus = function(status) {
      var selected = [];
      if(typeof status==="object") {
        //selected = $filter('filter')($scope.status, {value: status.value});
        return status.value ? status.value : 'Not set';
      }else{
          return status;
      }

    };
	
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.system.zones')
    .service('zoneService', zoneService); 

  /** @ngInject */
  function zoneService(Zones) {
    var getZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Zones.find().$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var createZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Zones.create({
        name:obj.params.name,
       // description:obj.params.description,
        created: date,
        lastupdated: date,
		code: obj.params.code,
		status: obj.params.status
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };


    var deleteZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      Zones.deleteById({
        id:obj.params.id
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    var saveZones = function(obj) {
      //$ionicLoading.show({template: '<div class="loader"><svg class="circular"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div>'});

      var date = new Date();

      Zones.prototype$updateAttributes({
        id: obj.params.id,
        name: obj.params.name,
        //description: obj.params.description,
        lastupdated: date,
		status: obj.params.status,
		code: obj.params.code
      }).$promise.then(function(data) {
        //$ionicLoading.hide();
        //console.log(data);
        obj.onSuccess(data);

      }, function(err) {
        //$ionicLoading.hide();
        //console.log(err)
        obj.onFailure(err);
      });
    };

    return{
      getZones: getZones,
      createZones: createZones,
      deleteZones: deleteZones,
      saveZones: saveZones
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 300);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService,$rootScope) {

    // $scope.menuItems = baSidebarService.getMenuItems();
    $scope.menuItems = baSidebarService.getAuthorizedMenuItems($rootScope.userData.credentials.role);
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.getAuthorizedMenuItems = function(role) {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0 && _.includes(item.authRoles, role);
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta;
            })
            .map(function(s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                level: ((s.name.match(/\./g) || []).length - 1),
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
                authRoles:s.authRoles,
              };
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('sumProps', function sumProps() {
      return function (array, key) {
        array = array || [];
        var sum = 0;

        array.map(function (obj) {
          if (!!obj[key] && !isNaN(obj[key])) {
            sum += parseFloat(obj[key]);
          }
        });

        return sum;
      };
    })
})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/authSignIn/authSignIn.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign in to Loan Portal</h1><a ui-sref="authSignUp" class="auth-link">New to Loan Portal? Sign up!</a><form class="form-horizontal" ng-submit="login(user)"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Username</label><div class="col-sm-10"><input type="text" ng-model="user.username" class="form-control" id="inputEmail3" placeholder="Username"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" ng-model="user.password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">Sign in</button> <a href="" class="forgot-pass">Forgot password?</a></div></div></form></div></main></div>');
$templateCache.put('app/pages/authSignUp/authSignUp.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>Sign up to Loan Portal</h1><a ui-sref="authSignIn" class="auth-link">Already have a Loan Portal account? Sign in!</a><form class="form-horizontal" ng-submit="validateRegistration(register)"><div class="form-group"><label for="inputName3" class="col-sm-3 control-label">Name</label><div class="col-sm-9"><input type="text" ng-model="register.name" class="form-control" id="inputName3" placeholder="Full Name"></div></div><div class="form-group"><label for="inputMobile3" class="col-sm-3 control-label">Mobile (+60)</label><div class="col-sm-9"><input type="tel" ng-model="register.mobile" class="form-control" id="inputMobile3" placeholder="Mobile Number"></div></div><div class="form-group"><label for="inputEmail3" class="col-sm-3 control-label">Username</label><div class="col-sm-9"><input type="text" ng-model="register.username" class="form-control" id="inputEmail3" placeholder="Username"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" ng-model="register.password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-3 col-sm-9"><button type="submit" class="btn btn-default btn-auth">Sign up</button></div></div></form></div></main></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row" ng-if="userData.roleId===1 || userData.roleId===3"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-6 col-xs-12" ba-panel="" ba-panel-class="popular-app"><div class="popular-app-cost row" style="background-color:chocolate ;color:black"><div class="col-xs-9">Cashflow Summary \u51FA\u8D26/\u6536\u8D26\u6458\u8981 (\u6708)</div></div><div class="horizontal-scroll"><table class="table table-bordered" st-table="dashboardV1List"><thead><tr><th class="text-center bold-text">Year \u5E74</th><th class="text-center bold-text">Month \u6708</th><th class="text-center bold-text bg-warning" colspan="2" style="color:black">Debit</th><th class="text-center bold-text bg-info" colspan="2" style="color:black">Credit</th><th class="text-center bold-text bg-purple" style="color:black"></th></tr><tr><th></th><th></th><th class="text-center bold-text bg-warning" style="color:black">Capital</th><th class="text-center bold-text bg-warning" style="color:black">Collection \u653E\u8D26 (\u6536)</th><th class="text-center bold-text bg-info" style="color:black">Cash Out \u653E\u8D26(\u51FA)</th><th class="text-center bold-text bg-info" style="color:black">Expense</th><th class="text-center bold-text bg-purple" style="color:black">Balance \u4F59\u989D</th></tr></thead><tbody><tr class="popular-app-info" ng-repeat="item in dashboardV1List | groupBy: \'[year,m]\'"><td class="text-center">{{item[0].year}}</td><td class="text-center">{{item[0].m}}</td><td class="text-right bg-warning" style="color:black">{{(getDebit(item)||0) | currency:\'\'}}</td><td class="text-right bg-warning" style="color:black">{{(getPayment(item)||0) | currency:\'\'}}</td><td class="text-right bg-info" style="color:black">{{(getCashout(item)||0) | currency:\'\'}}</td><td class="text-right bg-info" style="color:black">{{(getCredit(item)||0) | currency:\'\'}}</td><td class="text-right bg-purple" style="color:black">{{(getDebit(item)+getPayment(item))-(getCashout(item)+getCredit(item)) | currency:\'\'}}</td></tr><tr class="popular-app-info"><td class="text-right" style="background-color:chocolate ;color:black"></td><td class="text-right" style="background-color:chocolate ;color:black"></td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotaldebit(dashboardV1List) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalpayment(dashboardV1List) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalcashout(dashboardV1List) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalcredit(dashboardV1List) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalbalance() | currency:\'\'}}</td></tr></tbody></table></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-6 col-xs-12" ba-panel="" ba-panel-class="popular-app"><div class="popular-app-cost row" style="background-color:chocolate ;color:black"><div class="col-xs-9">Debt \u5728\u5916\u9762\u7684\u8D26</div></div><div class="horizontal-scroll"><table class="table table-bordered" st-table="dashboardV2List"><thead><tr><th class="text-center bold-text">Year \u5E74</th><th class="text-center bold-text">Month \u6708</th><th class="text-center bold-text bg-info" style="color:black">Loan Amount \u8D37\u6B3E\u989D</th><th class="text-center bold-text bg-warning" style="color:black">Collection \u653E\u8D26 (\u6536)</th><th class="text-center bold-text bg-purple" style="color:black">Balance \u4F59\u989D</th></tr></thead><tbody><tr class="popular-app-info" ng-repeat="item in dashboardV2List | groupBy: \'[year,m]\'"><td class="text-center">{{item[0].year}}</td><td class="text-center">{{item[0].m}}</td><td class="text-right bg-info" style="color:black">{{(getAmount(item)||0) | currency:\'\'}}</td><td class="text-right bg-warning" style="color:black">{{(getPayment(item)||0) | currency:\'\'}}</td><td class="text-right bg-purple" style="color:black">{{(getBalance(item)||0) | currency:\'\'}}</td></tr><tr class="popular-app-info"><td class="text-right" style="background-color:chocolate ;color:black"></td><td class="text-right" style="background-color:chocolate ;color:black"></td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalamount(dashboardV2List) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalpayment(dashboardV2List) | currency:\'\'}}</td><td class="text-right" style="background-color:chocolate ;color:black">{{getTotalbalanceV2() | currency:\'\'}}</td></tr></tbody></table></div></div></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" ba-panel="" ba-panel-class="popular-app"><div class="popular-app-cost row" style="background-color:chocolate ;color:black"><div class="col-xs-9">Deposit in hand Summary (\u5F53\u8D27\u54C1\u9884\u89C8)</div></div><div class="horizontal-scroll"><table class="table table-bordered" st-table="depositSummary"><thead><tr><th class="text-center bold-text">Year \u5E74</th><th class="text-center bold-text">Month \u6708</th><th class="text-center bold-text bg-info dashboard-th" style="color:black">Pajak Item (Case-Closed/\u5DF2\u5173\u95ED\u6848\u4EF6)</th><th class="text-center bold-text bg-warning dashboard-th" style="color:black">Pajak Item (Case-Open/\u6709\u6548\u6848\u4EF6)</th><th class="text-center bold-text bg-purple dashboard-th" style="color:black">Pajak Item (Total/\u5168\u90E8\u6848\u4EF6)</th></tr></thead><tbody><tr class="popular-app-info" ng-repeat="item in depositSummary"><td class="text-center">{{item.year}}</td><td class="text-center">{{item.mm}}</td><td class="text-right bg-info" style="color:black"><a href="" ng-click="viewMonthlyCaseDetail(item, false)">{{ item.pajak_items_closed }}</a></td><td class="text-right bg-warning" style="color:black"><a href="" ng-click="viewMonthlyCaseDetail(item, true)">{{ item.pajak_items_open }}</a></td><td class="text-right bg-purple" style="color:black"><a href="" ng-click="viewMonthlyCaseDetail(item, null)">{{ item.pajak_items_total }}</a></td></tr><tr class="popular-app-info"><td class="text-right" style="background-color:chocolate ;color:black"></td><td class="text-right" style="background-color:chocolate ;color:black"></td><td class="text-right" style="background-color:chocolate ;color:black">{{ (depositSummary | sumProps:\'pajak_items_closed\') }}</td><td class="text-right" style="background-color:chocolate ;color:black">{{ (depositSummary | sumProps:\'pajak_items_open\') }}</td><td class="text-right" style="background-color:chocolate ;color:black">{{ (depositSummary | sumProps:\'pajak_items_total\') }}</td></tr></tbody></table></div></div></div></div></div><div class="row"><div class="col-xlg-12 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-right">Powered By TSW Labs <i class="fa fa-bolt"></i></div><div class="al-footer-main clearfix"><div class="al-copy"><i class="fa fa-copyright"></i> Loan Portal 2018 | Version 2.2</div></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><h3 class="with-line">General Information \u57FA\u672C\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Name \u540D\u5B57</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" ng-model="manageProfile.credentials.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Role \u90E8\u95E8</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-3 control-label">{{ showRoles(manageProfile.credentials.role) }}</label></div></div></div></div><h3 class="with-line">Change Password \u66F4\u6362\u5BC6\u7801</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password \u5BC6\u7801</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" ng-model="manageProfile.password"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password \u786E\u8BA4\u5BC6\u7801</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder="" ng-model="manageProfile.confirmPassword"></div></div></div></div><h3 class="with-line">Contact Information \u8054\u7EDC\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" ng-model="manageProfile.credentials.mobile"></div></div></div></div><button type="button" class="btn btn-primary save-profile" ng-click="udpateProfile(manageProfile)">Update \u66F4\u65B0\u8D44\u6599</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/account/collector/collector.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Collectors ({{manageCollectorList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/collector/widgets/collectorTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/partner/partner.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Partners ({{managePartnerList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/partner/widgets/partnerTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/usermapping/usermapping.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage User Mapping ({{manageUsermappingList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/usermapping/widgets/usermappingTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUsermapping()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/roles/roles.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Roles \u6B0A\u9650\u7BA1\u7406 ({{manageRolesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/roles/widgets/rolesTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/account/supplier/supplier.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Suppliers ({{manageSupplierList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/supplier/widgets/supplierTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/account/users/users.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Users \u7528\u6236\u7BA1\u7406 ({{manageUsersList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/account/users/widgets/usersTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/assignagent/assignAgent/assignAgent.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Agent Assignment({{manageAgentsList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/assignagent/assignAgent/widgets/assignAgentTable.html"></div></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="name" class="col-sm-3 control-label">Collector Name</label><div class="col-sm-9"><label class="col-sm-3 control-label">{{manageAgent.credentials.firstName + " " + manageAgent.credentials.lastName}}</label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"></div></div></div><h4>Assigned Case ({{selectedCaseList.length}}) &nbsp; &nbsp;<button class="btn btn-primary btn-xs" ng-click="addCase()">Assign New Case</button></h4><table class="table table-striped table-condensed" st-safe-src="selectedCaseList" st-table="selectedCaseL"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Case Code</th><th st-sort="name">Customer Name</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Case Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.code" placeholder="Search Customer Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in selectedCaseL" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'Not Set\' }}</td><td class="select-td"><span editable-select="item.customer" e-name="customer" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageCustomerList">{{ item.customer.code+\', \'+item.customer.name }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="removeCase(item)">Remove</button></div></td></tr></tbody></table><br><br><div class="row" ng-show="isAssignNewCase"><h4>Unassigned Case ({{notSelectedCaseList.length}})</h4><table class="table table-striped table-condensed" st-safe-src="notSelectedCaseList" st-table="notSelectedCaseL"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Case Code</th><th st-sort="name">Customer Name</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Case Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.code" placeholder="Search Customer Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in notSelectedCaseL" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'Not Set\' }}</td><td class="select-td"><span editable-select="item.customer" e-name="customer" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageCustomerList">{{ item.customer.code+\', \'+item.customer.name }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachinesales($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="assignCase(item)">Assign</button></div></td></tr></tbody></table></div></div><button type="button" class="btn btn-default save-profile" ng-click="initManageUsers()">Close</button></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/clerkSetup/case/case.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Case \u6848\u4EF6\u7BA1\u7406 ({{manageCaseList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/clerkSetup/case/widgets/caseTable.html"></div></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Payment \u4ED8\u6B3E" form="vm.productInfoForm"><div include-with-scope="app/pages/clerkSetup/case/widgets/casePayment.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-primary save-profile" ng-click="saveCase(manageCase)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageCase(reportFilter)">Close</button></div></div></div>');
$templateCache.put('app/pages/clerkSetup/customer/customer.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><h3 class="with-line">Customer Setup \u987E\u5BA2\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Account Number \u6237\u53E3\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.ic"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">I/C Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.cic!==null" ng-src="{{manageCustomer.customer.cic}}" style="text-align: center; width:200px;height:200px"> <input type="file" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'cic\', result, error)" file-size-mb="10"></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.contact"></div></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.name"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.passport"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Passport Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.cpassport!==null" ng-src="{{manageCustomer.customer.cpassport}}" style="text-align: center; width:200px;height:200px"> <input type="file" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'cpassport\', result, error)" file-size-mb="10"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageCustomer.address"></textarea></div></div></div></div><h3 class="with-line">Guarantor Setup \u62C5\u4FDD\u4EBA\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gname"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gic"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">I/C Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.gic!==null" ng-src="{{manageCustomer.customer.gic}}" style="text-align: center; width:200px;height:200px"> <input type="file" id="uploadFile" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'gic\', result, error)" file-size-mb="10"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageCustomer.gaddress"></textarea></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gcontact"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gpassport"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Passport Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.gpassport!==null" ng-src="{{manageCustomer.customer.gpassport}}" style="text-align: center; width:200px;height:200px"> <input type="file" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'gpassport\', result, error)" file-size-mb="10"></div></div></div></div><button ng-disabled="!manageCustomer.code" type="button" class="btn btn-primary save-profile" ng-click="saveCustomer(manageCustomer)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageCustomer(reportFilter)">Cancel</button></div></div>');
$templateCache.put('app/pages/clerkSetup/payment/payment.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Upload and Review Payments \u4E0A\u4F20\u8207\u5BA1\u6838\u4ED8\u6B3E\u4FE1\u606F ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/clerkSetup/payment/widgets/paymentTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createPayment(managePayment)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManagePayment()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action \u66F4\u6539" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/expense/category/category.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Category \u5206\u985E\u7BA1\u7406 ({{managecategoryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/expense/category/widgets/categoryTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addcategory()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/flowtransaction/transaction/transaction.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Transaction \u4EA4\u6613\u7BA1\u7406 ({{managetransactionList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/flowtransaction/transaction/widgets/transactionTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addtransaction()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/form/case/case.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Upload and Review Cases \u4E0A\u4F20\u8207\u5BA1\u6838\u6848\u4EF6\u4FE1\u606F ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/case/widgets/caseTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createCase(manageCase)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageCase()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/customer/customer.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Upload and Review Customers \u4E0A\u4F20\u8207\u5BA1\u6838\u5BA2\u6236\u8CC7\u6599 ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/customer/widgets/customerTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createCustomer(manageCustomer)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageCustomer()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/interval/interval.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Upload and Review Intervals \u4E0A\u4F20\u8207\u5BA1\u6838\u9593\u9694\u6642\u9593 ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/interval/widgets/intervalTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createInterval(manageInterval)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageInterval()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/onlinesales/onlinesales.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Uplpoad and Review Online Sales ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/onlinesales/widgets/onlinesalesTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createOnlinesales(manageOnlinesales)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageOnlinesales()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/payment/payment.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Upload and Review Payments \u4E0A\u4F20\u8207\u5BA1\u6838\u4ED8\u6B3E\u4FE1\u606F ({{gridOptions.data.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/form/payment/widgets/paymentTable.html"></div></div><div class="add-row-editable-table"><button type="button" class="btn btn-primary save-profile" ng-click="createPayment(managePayment)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManagePayment()">Cancel</button></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/operational/case/case.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Case \u6848\u4EF6\u7BA1\u7406 ({{manageCaseList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/case/widgets/caseTable.html"></div></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Case \u6848\u4EF6" form="vm.personalInfoForm"><div include-with-scope="app/pages/operational/case/widgets/caseDetails.html"></div></ba-wizard-step><ba-wizard-step title="Loan Calcalator \u8D37\u6B3E\u8BA1\u7B97\u673A" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/loanCalculator.html"></div></ba-wizard-step><ba-wizard-step title="Schedule \u65E5\u7A0B\u8868" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/caseSchedule.html"></div></ba-wizard-step><ba-wizard-step title="Payment \u4ED8\u6B3E" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/casePayment.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-primary save-profile" ng-click="saveCase(manageCase)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageCase(reportFilter)">Close</button></div></div></div>');
$templateCache.put('app/pages/operational/customer/customer.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Customers \u5BA2\u6236\u7BA1\u7406 ({{manageCustomerList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/operational/customer/widgets/customerTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addCustomer()">Add New</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Customer Setup \u987E\u5BA2\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Account Number \u6237\u53E3\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.ic"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">I/C Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.cic!==null" ng-src="{{manageCustomer.customer.cic}}" style="text-align: center; width:200px;max-height:200px;object-fit: contain;"> <input type="file" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'cic\', result, error)" file-size-mb="10"></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.contact"></div></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.name"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.passport"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Passport Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.cpassport!==null" ng-src="{{manageCustomer.customer.cpassport}}" style="text-align: center; width:200px;height:200px"> <input type="file" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'cpassport\', result, error)" file-size-mb="10"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageCustomer.address"></textarea></div></div></div></div><h3 class="with-line">Guarantor Setup \u62C5\u4FDD\u4EBA\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gname"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gic"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">I/C Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.gic!==null" ng-src="{{manageCustomer.customer.gic}}" style="text-align: center; width:200px;height:200px"> <input type="file" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'gic\', result, error)" file-size-mb="10"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageCustomer.gaddress"></textarea></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gcontact"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCustomer.gpassport"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Passport Picture</label><div class="col-sm-8"><img ng-show="manageCustomer.customer.gpassport!==null" ng-src="{{manageCustomer.customer.gpassport}}" style="text-align: center; width:200px;height:200px"> <input type="file" class="padding-vertical" accept="image/*" ng-file-select="" on-file-select="onFileSelect(manageCustomer.customer, \'gpassport\', result, error)" file-size-mb="10"></div></div></div></div><button ng-disabled="!manageCustomer.code" type="button" class="btn btn-primary save-profile" ng-click="saveCustomer(manageCustomer)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageCustomer(reportFilter)">Cancel</button></div></div>');
$templateCache.put('app/pages/reports/casesummary/casesummary.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Case Summary \u6848\u4EF6\u5831\u544A\u7BA1\u7406 ({{manageCaseSummaryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/casesummary/widgets/casesummaryTable.html"></div></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Case \u6848\u4EF6" form="vm.personalInfoForm"><div include-with-scope="app/pages/operational/case/widgets/caseDetails.html"></div></ba-wizard-step><ba-wizard-step title="Loan Calcalator \u8D37\u6B3E\u8BA1\u7B97\u673A" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/loanCalculator.html"></div></ba-wizard-step><ba-wizard-step title="Schedule \u65E5\u7A0B\u8868" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/caseSchedule.html"></div></ba-wizard-step><ba-wizard-step title="Payment \u4ED8\u6B3E" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/casePayment.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-default save-profile" ng-click="searchCaseSummary(reportFilter)">Close</button></div></div></div>');
$templateCache.put('app/pages/reports/cashinhand/cashinhand.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Cash in Hand Report ({{manageCashinHandList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/cashinhand/widgets/cashinhandTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/reports/closecasesummary/closecasesummary.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Close Case Summary \u5DF2\u95DC\u9589\u6848\u4EF6\u5831\u544A\u7BA1\u7406 ({{manageCloseCaseSummaryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/closecasesummary/widgets/closecasesummaryTable.html"></div></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Case \u6848\u4EF6" form="vm.personalInfoForm"><div include-with-scope="app/pages/operational/case/widgets/caseDetails.html"></div></ba-wizard-step><ba-wizard-step title="Loan Calcalator \u8D37\u6B3E\u8BA1\u7B97\u673A" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/loanCalculator.html"></div></ba-wizard-step><ba-wizard-step title="Schedule \u65E5\u7A0B\u8868" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/caseSchedule.html"></div></ba-wizard-step><ba-wizard-step title="Payment \u4ED8\u6B3E" form="vm.productInfoForm"><div include-with-scope="app/pages/operational/case/widgets/casePayment.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-default save-profile" ng-click="searchCloseCaseSummary(reportFilter)">Close</button></div></div></div>');
$templateCache.put('app/pages/reports/collection/collection.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Collection Report \u8CB8\u6B3E\u6536\u96C6\u5831\u544A\u7BA1\u7406 ({{manageCollectionList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/collection/widgets/collectionTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/system/areas/areas.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Areas ({{manageAreasList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/areas/widgets/areasTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addArea()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/gamecategory/gamecategory.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Game Category ({{manageGamecategoryList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/gamecategory/widgets/gamecategoryTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/games/games.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Games ({{manageGamesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/games/widgets/gamesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addArea()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/machine/machine.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Machines ({{manageMachineList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/machine/widgets/machineTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addMachine()">Add New</button></div></div></div></div><div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Machine Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Machine Code</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.code"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageMachine.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.status"> <span>{{manageMachine.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Game</label><div class="col-sm-9"><ui-select ng-model="manageMachine.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">is Jackpot?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.isjackpot"> <span>{{manageMachine.isjackpot?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageMachine.remarks"></textarea></div></div></div></div></div><h3 class="with-line">Meter Reading</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">CM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmOut"></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Calculate By?</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageMachine.calby"> <span>{{manageMachine.calby?"CM":"BM"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">BM Total IN</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmIn"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM Total OUT</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmOut"></div></div></div></div><h3 class="with-line">Coversion Rates (CM to BM) {{(manageMachine.cmRate/manageMachine.bmRate)| currency: \'\'}}</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">CM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.cmRate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">BM To RM</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageMachine.bmRate"></div></div></div></div><div include-with-scope="app/pages/system/machine/widgets/machineShopTable.html"></div><button type="button" class="btn btn-primary save-profile" ng-click="saveMachine(manageMachine)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageMachine()">Cancel</button></div>');
$templateCache.put('app/pages/system/shop/old.html','<div ba-panel="" ba-panel-class="profile-page" ng-if="isEdit"><div class="panel-content"><h3 class="with-line">Shop Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.shoptype"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.address"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">Machine and Online %</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Online Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Online Game Tips%</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Comp Online Game %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Comp Online %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Mach Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Mach Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Comp Machine %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrate"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Comp Mach %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macvirtual"></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 1</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 2</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2"></div></div><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Contact Name 3</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 1</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 2</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Contact Number 3</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3"></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.remarks"></div></div></div></div><h3 class="with-line">Partner info</h3><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Partner</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code"></span></ui-select-choices></ui-select></div></div><button type="button" class="btn btn-primary save-profile" ng-click="saveShop(manageShop)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageShop()">Cancel</button></div></div>');
$templateCache.put('app/pages/system/shop/shop.html','<div class="widgets" ng-hide="isEdit"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Shop ({{manageShopList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/shop/widgets/shopTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addShop()">Add New</button></div></div></div></div><div class="row" ng-if="isEdit"><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Shop Information" form="vm.personalInfoForm"><div include-with-scope="app/pages/system/shop/widgets/shopInfo.html"></div></ba-wizard-step><ba-wizard-step title="Online Games" form="vm.productInfoForm"><div include-with-scope="app/pages/system/shop/widgets/onlineGames.html"></div></ba-wizard-step><ba-wizard-step title="Machines" form="vm.addressForm"><div include-with-scope="app/pages/system/shop/widgets/machines.html"></div></ba-wizard-step><ba-wizard-step title="Partner & Contact"><div include-with-scope="app/pages/system/shop/widgets/partner.html"></div></ba-wizard-step></ba-wizard><h3 class="with-line"></h3><button type="button" class="btn btn-primary save-profile" ng-click="saveShop(manageShop)">Save</button> <button type="button" class="btn btn-default save-profile" ng-click="initManageShop()">Cancel</button></div></div></div>');
$templateCache.put('app/pages/system/site/site.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Balai ({{manageSiteList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/site/widgets/siteTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addSite()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/states/states.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage States ({{manageStatesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/states/widgets/statesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/system/zones/zones.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Zones ({{manageZonesList.length}})" ba-panel-class="with-scroll"><div include-with-scope="app/pages/system/zones/widgets/zonesTable.html"></div></div><div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addState()">Add New</button></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a ui-sref="main.dashboard" class="al-logo clearfix"><span>Loan</span>-Portal</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="kameleon-icon with-round-bg warning"><img ng-src="assets/img/Money-icon.png"> <span>{{userData.credentials.name}}</span></div></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/main/profile"><i class="fa fa-user"></i>Profile</a></li><li><a href="#/authSignIn" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/account/collector/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Collector!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/collector/widgets/collectorTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageCollectorList" st-table="manageCollector"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Collector Code</th><th st-sort="name">Collector Name</th><th st-sort="contact">Contact Details</th><th st-sort="isparent">Access Level</th><th st-sort="parent.code">Parent Collector</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Collector Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Collector Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="parent.code" placeholder="Search Parent Code" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCollector" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td><span editable-checkbox="item.isparent" e-title="is this Parent?" e-name="isparent" e-form="rowform">{{ item.isparent && "Parent" || "Supervisor" }}</span></td><td class="select-td"><div ng-hide="item.isparent"><span editable-ui-select="item.parent" e-form="rowform" e-name="parent" name="parent" e-ng-model="item.parent" theme="bootstrap">{{ item.parent.code }}<editable-ui-select-match placeholder="Collector Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="parent in manageParentCollectorList | filter: $select.search track by $index">{{parent.code}}, {{parent.name}}</editable-ui-select-choices></span></div></td><td><form editable-form="" name="rowform" onbeforesave="saveCollector($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid || !item.isparent" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/partner/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Partner!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/partner/widgets/partnerTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="managePartnerList" st-table="managePartner"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Partner Code</th><th st-sort="name">Partner Name</th><th st-sort="contact">Contact Details</th><th st-sort="isparent">Access Level</th><th st-sort="parent.code">Parent Partner</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Partner Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Partner Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="parent.code" placeholder="Search Parent Code" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in managePartner" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td><span editable-checkbox="item.isparent" e-title="is this Parent?" e-name="isparent" e-form="rowform">{{ item.isparent && "Parent" || "Supervisor" }}</span></td><td class="select-td"><div ng-hide="item.isparent"><span editable-ui-select="item.parent" e-form="rowform" e-name="parent" name="parent" e-ng-model="item.parent" theme="bootstrap">{{ item.parent.code }}<editable-ui-select-match placeholder="Partner Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="parent in manageParentPartnerList | filter: $select.search track by $index">{{parent.code}}, {{parent.name}}</editable-ui-select-choices></span></div></td><td><form editable-form="" name="rowform" onbeforesave="savePartner($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/usermapping/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this User Mapping!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/usermapping/widgets/usermappingTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped" st-safe-src="manageUsermappingList" st-table="manageUsermappings"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="role.name">Role</th><th st-sort="user.username">User Name</th><th st-sort="zone.code">Zone</th><th st-sort="area.name">Area</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="role.name" placeholder="Search Role" class="input-sm form-control search-input" type="search"></th><th><input st-search="user.username" placeholder="Search User Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Area" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsermappings" class="editable-row"><td class="table-id">{{$index+1}}</td><td class="select-td"><span editable-select="item.role.id" e-name="role" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageRoleList">{{ showRoles(item.role) }}</span></td><td class="select-td"><span editable-select="item.user.id" e-name="user" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.username for g in manageUserList">{{ showUsers(item.user) }}</span></td><td class="select-td"><span editable-select="item.zone.id" e-name="zone" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList">{{ showZones(item.zone) }}</span></td><td class="select-td"><span editable-select="item.area.id" e-name="area" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreaList">{{ showAreas(item.area) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUsermapping($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/roles/widgets/rolesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageRolesList" st-table="manageRoles"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="created">Created</th><th st-sort="modified">Last Updated</th></tr><tr><th></th><th>\u540D\u5B57</th><th>\u804C\u4F4D</th><th>\u5F00\u7528\u65E5\u671F</th><th>\u6700\u540E\u66F4\u65B0</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="modified" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in manageRoles" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.modified | date: \'dd/MM/yyyy hh:mm a\'}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/roles/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this State!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/supplier/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Supplier!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/supplier/widgets/supplierTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageSupplierList" st-table="manageSupplier"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Supplier Code</th><th st-sort="name">Supplier Name</th><th st-sort="contact">Contact Details</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Supplier Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Supplier Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact Details" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSupplier" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.contact" e-name="contact" e-form="rowform" e-required="">{{ item.contact || \'empty\'}}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveSupplier($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp; &nbsp; <button ng-hide="item.userid" class="btn btn-warning editable-table-button btn-xs" ng-click="userAccess(item)" ng-disabled="item.userid">Access</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/account/users/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Users!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/account/users/modals/passwordModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-locked modal-icon"></i><span>Password</span></div><div class="modal-body text-center"><div id="qrLabel"><span>{{newPassword}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/account/users/widgets/usersTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageUsersList" st-table="manageUsers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="username">Username</th><th st-sort="credentials.name">Name</th><th st-sort="credentials.mobile">Mobile</th><th st-sort="emailVerified">Access?</th><th st-sort="credentials.role">Role</th><th>Action</th></tr><tr><th></th><th>\u7528\u6237</th><th>\u540D\u5B57</th><th>\u624B\u63D0\u7535\u8BDD</th><th>\u767B\u5165\u7CFB\u7EDF</th><th>\u90E8\u95E8</th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="credentials.mobile" placeholder="Search Mobile" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.username}}</td><td><span editable-text="item.credentials.name" e-name="name" e-form="rowform" e-required="">{{ item.credentials.name || \'empty\'}}</span></td><td><span editable-text="item.credentials.mobile" e-name="mobile" e-form="rowform" e-required="">{{ item.credentials.mobile || \'empty\' }}</span></td><td><span editable-radiolist="item.emailVerified" e-ng-options="s.value as s.text for s in ::emailVerified track by s.value" e-name="emailVerified" e-form="rowform">{{ showAccess(item.emailVerified) }}</span></td><td class="select-td"><span editable-select="item.credentials.role" e-name="role" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageRoleList">{{ showRoles(item.credentials.role) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveUser($data,item.id,item)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id,item.credentials.partner.id,item.credentials.collector.id,item.credentials.shop.id,item.credentials.supplier.id)">Delete</button> &nbsp;&nbsp; <button class="btn btn-warning editable-table-button btn-xs" ng-click="resetPassword(item.id)">Reset</button></div></td></tr></tbody><br><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/assignagent/assignAgent/widgets/assignAgentTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><table class="table table-striped" st-safe-src="manageAgentsList" st-table="manageUsers"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Agent Name</th><th st-sort="cases">Count</th><th>Action</th></tr><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageUsers" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.credentials.firstName +" " + item.credentials.lastName || \'empty\' }}</td><td>{{ item.credentials.casemap.length || \'0\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveUser($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="viewAgentsDetails(item)">Edit</button></div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><button ng-show="isAgentView" type="button" class="btn btn-default save-profile" ng-click="initManageUsers()">Back</button></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/clerkSetup/case/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Case!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/clerkSetup/case/modals/dangerPayment.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Payment!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/caseDetails.html','<div include-with-scope="app/pages/operational/case/widgets/caseInfo.html"></div><div include-with-scope="app/pages/operational/case/widgets/caseSummary.html"></div><div include-with-scope="app/pages/operational/case/widgets/customerInfo.html"></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/caseInfo.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label> <label class="col-sm-3 control-label">{{manageCase.code}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks \u5907\u6CE8</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageCase.remark"></textarea></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label><div class="col-sm-9"><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="manageCase.reldate" ng-value="manageCase.reldate| date: \'dd/MM/yyyy\'" show-button-bar="false" is-open="dpOpenStatus1.withRequired" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus1(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate ||eDate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Status \u6848\u4EF6 \uFF08\u5F00/\u5173\uFF09</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.status"> <span>{{manageCase.status?"Open":"Closed"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Closed Date \u622A\u6B62\u65E5\u671F</label><div class="col-sm-9"><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="manageCase.closedate" ng-value="manageCase.closedate| date: \'dd/MM/yyyy\'" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/casePayment.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.code}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.reldate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate ||eDate | date: \'dd/MM/yyyy\'}}</label></div></div></div><h3 class="with-line">Payment Information \u4ED8\u6B3E\u8CC7\u6599 <button class="btn btn-primary editable-table-button btn-xs" ng-click="addPayment()" ng-if="!manageCase.isReport">Add</button></h3><div class="row" ng-show="isEditPayment"><div class="col-md-12"><form class="form-inline"><div class="row"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="managePayment.amount" placeholder="Amount"></div><div class="form-group col-sm-2 col-xs-3"><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="managePayment.paydate" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="Payment Date (dd/mm/yyyy)"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><button type="submit" class="btn btn-primary" ng-click="savePaymentDetails(managePayment)">Save Payment</button> <button type="submit" class="btn btn-default" ng-click="cancelPayment()">Cancel</button></div><div class="row"><div class="form-group col-sm-4 col-xs-6"><textarea class="form-control fill-width" ng-model="managePayment.remarks" placeholder="Remarks \u5099\u8A3B"></textarea></div></div></form><br></div></div><div class="row"><div class="col-md-12"><table class="table" st-safe-src="manageCase.payment" st-table="paymentList"><thead><tr class="black-muted-bg"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="id">Payment No.</th><th>Payment Date</th><th>Amount</th><th>Agent</th><th>Remarks</th><th ng-if="!manageCase.isReport">Action</th></tr><tr class="black-muted-bg"><th></th><th>\u4ED8\u6B3E\u6536\u636E</th><th>\u4ED8\u6B3E\u65E5\u671F</th><th>\u7E3D\u984D</th><th>\u4EE3\u7406\u4EBA</th><th>\u5099\u8A3B</th><th>\u66F4\u6539</th></tr></thead><tbody><tr ng-repeat="item in paymentList | orderBy: \'-paydate\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.id}}</td><td>{{item.paydate | date: \'dd/MM/yyyy\'}}</td><td><span editable-text="item.amount" e-name="amount" e-form="rowform" e-required="">{{ item.amount | currency:\'\'}}</span></td><td><span>{{getAgentName(item.payagent.credentials)}}</span></td><td><span editable-textarea="item.remarks" e-name="remarks" e-form="rowform" e-rows="4" e-cols="40">{{item.remarks || \'-\'}}</span></td><td ng-show="!manageCase.isReport"><form editable-form="" name="rowform" onbeforesave="editPaymentDetails($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp;</div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/caseSchedule.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.code}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.reldate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate||eDate | date: \'dd/MM/yyyy\'}}</label></div></div></div><h3 class="with-line">Schedule Information \u65E5\u7A0B\u8868\u8CC7\u6599</h3><div ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><div id="schedule" class="blurCalendar" ng-controller="scheduleCalendarCtrl"></div></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/caseSummary.html','<h3 class="with-line">Summary \u6458\u8981</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">\u603B\u671F\u6570 - \u4E0A\u671F - \u8FD8\u671F\u6570 = \u6B20\u671F\u6570</label> <label class="col-sm-4 control-label">{{terms+\' - \'+(manageCase.firstm+manageCase.lastm)+\' - \'+(manageCase.payment.length)+\' = \'+(terms-(manageCase.payment.length+manageCase.firstm+manageCase.lastm))}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Total Paid \u603B\u8FD8\u6570\u989D</label><label class="col-sm-4 control-label">{{manageCase.totalPaid | currency:\'\'}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Installment Amount \u5206\u671F\u4ED8\u6B3E\u91D1\u989D</label> <label class="col-sm-4 control-label">{{manageCase.tamount | currency:\'\'}}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Outstanding Balance \u672A\u7ED3\u4F59\u989D</label> <label class="col-sm-4 control-label">{{(manageCase.tamount*manageCase.payment.length)-getTotalpayment(manageCase.payment) | currency:\'\'}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Amount Due \u603B\u6B20</label><label ng-show="!manageCase.isloan && manageCase.status" class="col-sm-4 control-label">{{manageCase.amountDue | currency:\'\'}}</label> <label ng-show="manageCase.isloan && !manageCase.status" class="col-sm-4 control-label">{{manageCase.amountDue > 0 ? manageCase.amountDue : 0 | currency:\'\'}}</label> <label ng-show="manageCase.isloan && manageCase.status" class="col-sm-4 control-label">{{manageCase.amount | currency:\'\'}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Cash Deposit \u73B0\u94B1\u62B5\u62BC</label> <label class="col-sm-2 control-label">{{manageCase.deposit | currency:\'\'}}</label> <label class="col-sm-1 control-label"><i class="ion-arrow-right-c" style="font-size:22px;"></i></label> <label class="col-sm-2 custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.isdeposit"> <span>{{manageCase.isdeposit?"Installments":"Forfeited"}}</span></label></div></div></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/caseTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCaseList" st-table="manageCase"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Case No.</th><th st-sort="customer.name">Name</th><th st-sort="customer.contact">Contact</th><th>Action</th></tr><tr><th></th><th>\u6848\u4EF6\u7F16\u53F7</th><th>\u540D\u5B57</th><th>\u7535\u8BDD\u53F7\u7801</th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Case No. \u6848\u4EF6\u7F16\u53F7" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.name" placeholder="Search Name \u540D\u5B57" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.contact" placeholder="Search Contact" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in manageCase" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'empty\'}}</td><td>{{ item.customer.name || \'empty\'}}</td><td>{{ item.customer.contact || \'empty\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editCase(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="13" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/customerInfo.html','<h3 class="with-line">Customer \u987E\u5BA2\u8D44\u6599 <button class="btn btn-primary editable-table-button btn-xs" ng-click="editCustomer()" ng-if="!isEditCustomer">Edit</button> <button class="btn btn-default editable-table-button btn-xs" ng-click="cancelEditCustomer()" ng-if="isEditCustomer">Cancel</button></h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-show="!isEditCustomer"><label for="inputFirstName" class="col-sm-3 control-label">Account Number \u6237\u53E3\u53F7\u7801</label> {{manageCase.customer.code}}</div><div class="form-group row clearfix" ng-show="isEditCustomer"><label for="inputFirstName" class="col-sm-3 control-label">Account Number \u6237\u53E3\u53F7\u7801</label><div><ui-select ng-model="manageCase.customer" class="col-sm-6 btn-group bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Account"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="customer in customerList | filter: $select.search"><span>{{customer.code}}, {{customer.name}}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label> {{manageCase.customer.ic}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label> {{manageCase.customer.contact}}</div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label> {{manageCase.customer.name}}</div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label> {{manageCase.customer.passport}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label> {{manageCase.customer.address}}</div></div></div><h3 class="with-line">Guarantor \u62C5\u4FDD\u4EBA\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label> {{manageCase.customer.gname}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label> {{manageCase.customer.gic}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label> {{manageCase.customer.gaddress}}</div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label> {{manageCase.customer.gcontact}}</div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label> {{manageCase.customer.gpassport}}</div></div></div>');
$templateCache.put('app/pages/clerkSetup/case/widgets/loanCalculator.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.code}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.reldate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate ||eDate | date: \'dd/MM/yyyy\'}}</label></div></div></div><h3 class="with-line">Loan Information \u8D37\u6B3E\u8CC7\u6599 <button class="btn btn-primary btn-xs" ng-click="recalculate()">Re-Calculate</button></h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Principle \u672C\u94B1\u8D37\u6B3E</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.principle"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Loan Amount \u8D37\u6B3E\u989D</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.amount"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">First Method \u505A\u6CD5</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="manageCase.firstm"></div><label class="col-sm-3 control-label">Last Method \u505A\u6CD5</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="manageCase.lastm"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Collect Interest \u7B79\u96C6\u5229\u606F</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.icollect"> <span>{{manageCase.icollect?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Interest Amount \u5229\u606F\u91D1\u989D</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.iamount"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Deductions \u6263\u9664</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.deduction"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Cash Deposit \u73B0\u94B1\u62B5\u62BC</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.deposit"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Stamp Duty \u5370\u82B1\u7A0E</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.stampduty"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Intervals \u95F4\u9694\u6642\u9593</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="interval"></div><label class="col-sm-3 control-label">Terms (in Days)</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="terms"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Close with Loan Amount? \u540C\u6642\u95DC\u9589\u8CB8\u6B3E\u91D1\u984D</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.isloan"> <span>{{manageCase.isloan?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Installment Amount \u5206\u671F\u4ED8\u6B3E\u91D1\u989D</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.tamount"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Cash Out \u62FF</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.cashout"></div></div></div></div>');
$templateCache.put('app/pages/clerkSetup/payment/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Payment!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/clerkSetup/payment/widgets/paymentTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>Upload Payments</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/clerkSetup/payment/widgets/paymentUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="managePaymentList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th></th><th st-sort="AccNo">CaseNo</th><th st-sort="Name">Amount</th><th st-sort="IC">PayDate</th><th>Action</th></tr><tr><th></th><th></th><th>\u6848\u4EF6\u7F16\u53F7</th><th>\u7E3D\u984D</th><th>\u4ED8\u6B3E\u65E5\u671F</th><th>\u66F4\u6539</th></tr></thead><tbody><tr ng-repeat="item in managePaymentList" class="editable-row"><td class="table-id">{{$index+1}}</td><td nowrap=""><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><span editable-text="item.CaseNo" e-name="CaseNo" e-form="rowform" e-required="">{{ item.CaseNo || \'empty\'}}</span></td><td><span editable-text="item.Amount" e-name="Amount" e-form="rowform" e-required="">{{item.Amount || \'empty\' }}</span></td><td><span editable-text="item.PayDate" e-name="PayDate" e-form="rowform" e-required="">{{item.PayDate || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/expense/category/modals/dangerModel.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Category!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/expense/category/widgets/categoryTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="row" ng-show="isEditCategory"><div class="col-md-12"><form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="managecategory.code" placeholder="Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="managecategory.name" placeholder="Name"></div><div class="form-group col-sm-2 col-xs-3"><ui-select ng-model="managecategory.category" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Parent"><span>{{$select.selected.name || \'empty\'}}</span></ui-select-match><ui-select-choices repeat="category in managecategoryList | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-2 col-xs-3"><ui-select ng-model="managemaincategory.maincategory" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Type"><span>{{$select.selected.name || \'empty\'}}</span></ui-select-match><ui-select-choices repeat="maincategory in managemaincategoryList | filter: $select.search"><span ng-bind-html="maincategory.name"></span></ui-select-choices></ui-select></div><button type="submit" class="btn btn-primary" ng-click="createcategory(managecategory)">Save</button> <button type="submit" class="btn btn-default" ng-click="cancelcategory()">Cancel</button></form><br></div></div><table class="table table-striped table-condensed" st-safe-src="managecategoryList" st-table="categoryList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="name">Name</th><th st-sort="parentid">Parent</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th st-sort="mainid">Type</th><th>Action</th></tr><tr><th></th><th>\u4EE3\u78BC</th><th>\u540D\u5B57</th><th>\u4E0A\u7DDA</th><th>\u5F00\u7528\u65E5\u671F</th><th>\u6700\u540E\u66F4\u65B0</th><th>L \u501F/ D \u5F53</th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="parentid" placeholder="Search Parent" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="mainid" placeholder="Search Type" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in categoryList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.parentid" e-name="parentid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in managecategoryList">{{ showparentid(item.parentid) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td class="select-td"><span editable-select="item.mainid" e-name="mainid" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in managemaincategoryList">{{ showmainid(item.mainid) }}</span></td><td><form editable-form="" name="rowform" onbeforesave="savecategory($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="25" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="25"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/flowtransaction/transaction/modals/dangerModel.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Transaction!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/flowtransaction/transaction/widgets/transactionTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2"><label>Select Type</label><ui-select ng-model="reportFilter.managemaincategory.maincategory" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="maincategory in managemaincategoryList | filter: $select.search"><span ng-bind-html="maincategory.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchCollection(reportFilter)">Search</button></div></div><div class="row" ng-show="isEditPayment"><div class="col-md-12"><form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><ui-select ng-model="managetransaction.category" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code+\', \'+$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="category in managecategoryList | filter: $select.search"><span ng-bind-html="category.code+\', \'+category.name"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="managetransaction.amount" placeholder="Amount"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="managetransaction.remarks" placeholder="Remarks"></div><div class="form-group col-sm-2 col-xs-3"><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="managetransaction.entrydate" show-button-bar="false" is-open="dpOpenStatus1.withRequired" placeholder="Entry Date (dd/mm/yyyy)"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus1(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><button type="submit" class="btn btn-primary" ng-click="createtransaction(managetransaction)">Create Transaction</button> <button type="submit" class="btn btn-default" ng-click="canceltransaction()">Cancel</button></form><br></div></div><table class="table table-striped table-condensed" st-safe-src="managetransactionList" st-table="transactions"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="category.code">Code</th><th st-sort="categoryid">Category</th><th st-sort="amount">Amount</th><th st-sort="mainid">Type</th><th st-sort="remarks">Remarks</th><th st-sort="entrydate">Entry Date</th><th>Action</th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr><tr><th></th><th><input st-search="category.code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="category.name" placeholder="Search Category Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th><input st-search="remarks" placeholder="Search Remarks" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in transactions" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.category.code || \'empty\' }}</td><td class="select-td"><span editable-select="item.categoryid" e-name="category" e-form="rowform" e-selectpicker="" e-ng-options="g as g.name for g in managecategoryList">{{item.category.name}}</span></td><td><span editable-text="item.amount" e-name="amount" e-form="rowform" e-required="">{{ item.amount || \'empty\' }}</span></td><td class="select-td">{{ showmainid(item.mainid) }}</td><td><span editable-text="item.remarks" e-name="remarks" e-form="rowform" e-required="">{{ item.remarks || \'empty\' }}</span></td><td>{{ item.entrydate | date: \'dd/MM/yyyy\'}}</td><td><form editable-form="" name="rowform" onbeforesave="savetransaction($data,item)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/case/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Case!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/case/widgets/caseTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>Upload Cases</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/case/widgets/caseUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageCaseList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th></th><th st-sort="AccNo">AccNo</th><th st-sort="CaseNo">CaseNo</th><th st-sort="Type">Type</th><th st-sort="Principle">Principle</th><th st-sort="LoanAmount">LoanAmount</th><th st-sort="InterestAmount">InterestAmount</th><th st-sort="InstallmentAmount">InstallmentAmount</th><th st-sort="Deposit">Deposit</th><th st-sort="Stampduty">Stampduty</th><th st-sort="FirstMethod">FirstMethod</th><th st-sort="LastMethod">LastMethod</th><th st-sort="CollectInterest">CollectInterest</th><th st-sort="ReleaseDate">ReleaseDate</th><th st-sort="PajakItem">PajakItem</th><th>Action</th></tr><tr><th></th><th></th><th>\u6237\u53E3\u53F7\u7801</th><th>\u6848\u4EF6\u7F16\u53F7</th><th>L \u501F/ D \u5F53</th><th>\u94B1\u8D37\u6B3E</th><th>\u8D37\u6B3E\u989D</th><th>\u5229\u606F\u91D1\u989D</th><th>\u5206\u671F\u4ED8\u6B3E\u91D1\u989D</th><th>\u73B0\u94B1\u62B5\u62BC</th><th>\u5370\u82B1\u7A0E</th><th>\u505A\u6CD5</th><th>\u505A\u6CD5</th><th>\u7B79\u96C6\u5229\u606F</th><th>\u51FA\u6B3E\u65E5\u671F</th><th></th><th>\u66F4\u6539</th></tr></thead><tbody><tr ng-repeat="item in manageCaseList" class="editable-row"><td class="table-id">{{$index+1}}</td><td nowrap=""><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><span editable-text="item.AccNo" e-name="AccNo" e-form="rowform" e-required="">{{ item.AccNo || \'empty\'}}</span></td><td><span editable-text="item.CaseNo" e-name="CaseNo" e-form="rowform" e-required="">{{ item.CaseNo || \'empty\'}}</span></td><td><span editable-text="item.Type" e-name="Type" e-form="rowform" e-required="">{{ item.Type || \'empty\'}}</span></td><td><span editable-text="item.Principle" e-name="Principle" e-form="rowform" e-required="">{{item.Principle || \'empty\' }}</span></td><td><span editable-text="item.LoanAmount" e-name="LoanAmount" e-form="rowform" e-required="">{{item.LoanAmount || \'empty\'}}</span></td><td><span editable-text="item.InterestAmount" e-name="InterestAmount" e-form="rowform" e-required="">{{item.InterestAmount || \'empty\'}}</span></td><td><span editable-text="item.InstallmentAmount" e-name="InstallmentAmount" e-form="rowform" e-required="">{{item.InstallmentAmount || \'empty\'}}</span></td><td><span editable-text="item.Deposit" e-name="Deposit" e-form="rowform" e-required="">{{item.Deposit || \'empty\'}}</span></td><td><span editable-text="item.Stampduty" e-name="Stampduty" e-form="rowform" e-required="">{{item.Stampduty || \'empty\'}}</span></td><td><span editable-text="item.FirstMethod" e-name="FirstMethod" e-form="rowform" e-required="">{{item.FirstMethod || \'empty\'}}</span></td><td><span editable-text="item.LastMethod" e-name="LastMethod" e-form="rowform" e-required="">{{item.LastMethod || \'empty\'}}</span></td><td><span editable-text="item.CollectInterest" e-name="CollectInterest" e-form="rowform" e-required="">{{item.CollectInterest || \'empty\'}}</span></td><td><span editable-text="item.ReleaseDate" e-name="ReleaseDate" e-form="rowform" e-required="">{{item.ReleaseDate || \'empty\'}}</span></td><td><span editable-text="item.PajakItem" e-name="PajakItem" e-form="rowform" e-required="">{{item.PajakItem || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="25" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/customer/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Customer!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/customer/widgets/customerTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>Upload Customers</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/customer/widgets/customerUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageCustomerList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="AccNo">AccNo</th><th st-sort="Name">Name</th><th st-sort="IC">IC</th><th st-sort="Passport">Passport</th><th st-sort="Address">Address</th><th st-sort="Contact">Contact</th><th st-sort="GName">GName</th><th st-sort="GIC">GIC</th><th st-sort="GPassport">GPassport</th><th st-sort="GAddress">GAddress</th><th st-sort="GContact">GContact</th><th></th><th>Action \u66F4\u6539</th></tr><tr><th></th><th>\u6237\u53E3\u53F7\u7801</th><th>\u540D\u5B57</th><th>\u767B\u8BB0\u53F7\u7801</th><th>\u62A4\u7167\u53F7\u7801</th><th>\u5730\u5740</th><th>\u7535\u8BDD\u53F7\u7801</th><th>\u540D\u5B57</th><th>\u767B\u8BB0\u53F7\u7801</th><th>\u62A4\u7167\u53F7\u7801</th><th>\u5730\u5740</th><th>\u7535\u8BDD\u53F7\u7801</th><th></th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="AccNo" placeholder="AccNo" class="input-sm form-control search-input" type="search"></th><th><input st-search="Name" placeholder="Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="IC" placeholder="IC" class="input-sm form-control search-input" type="search"></th><th><input st-search="Passport" placeholder="Passport" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="Contact" placeholder="Contact" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCustomerList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.AccNo" e-name="AccNo" e-form="rowform" e-required="">{{ item.AccNo || \'empty\'}}</span></td><td><span editable-text="item.Name" e-name="Name" e-form="rowform" e-required="">{{item.Name || \'empty\' }}</span></td><td><span editable-text="item.IC" e-name="IC" e-form="rowform" e-required="">{{item.IC || \'empty\'}}</span></td><td><span editable-text="item.Passport" e-name="Passport" e-form="rowform" e-required="">{{item.Passport || \'empty\'}}</span></td><td><span editable-text="item.Address" e-name="Address" e-form="rowform" e-required="">{{item.Address || \'empty\'}}</span></td><td><span editable-text="item.Contact" e-name="Contact" e-form="rowform" e-required="">{{item.Contact || \'empty\'}}</span></td><td><span editable-text="item.GName" e-name="GName" e-form="rowform" e-required="">{{item.GName || \'empty\'}}</span></td><td><span editable-text="item.GIC" e-name="GIC" e-form="rowform" e-required="">{{item.GIC || \'empty\'}}</span></td><td><span editable-text="item.GPassport" e-name="GPassport" e-form="rowform" e-required="">{{item.GPassport || \'empty\'}}</span></td><td><span editable-text="item.GAddress" e-name="GAddress" e-form="rowform" e-required="">{{item.GAddress || \'empty\'}}</span></td><td><span editable-text="item.GContact" e-name="GContact" e-form="rowform" e-required="">{{item.GContact || \'empty\'}}</span></td><td><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/interval/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Interval!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/interval/widgets/intervalTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>Upload Intervals</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/interval/widgets/intervalUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageIntervalList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="AccNo">CaseNo</th><th st-sort="Name">Intervals</th><th></th><th>Action</th></tr><tr><th></th><th>\u6848\u4EF6\u7F16\u53F7</th><th>\u95F4\u9694\u6642\u9593</th><th></th><th>\u66F4\u6539</th></tr></thead><tbody><tr ng-repeat="item in manageIntervalList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.CaseNo" e-name="CaseNo" e-form="rowform" e-required="">{{ item.CaseNo || \'empty\'}}</span></td><td><span editable-text="item.Amount" e-name="Amount" e-form="rowform" e-required="">{{item.Intervals || \'empty\' }}</span></td><td><code ng-show="item.ERROR">{{item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/form/onlinesales/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Sales!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/onlinesales/widgets/onlinesalesTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [100,200,500,1000]"></select></div><div class="col-sm-2"><label>Select Online Game</label><ui-select ng-model="manageOnlinesales.game" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="game in manageGamesList | filter: $select.search"><span ng-bind-html="game.name"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>Upload Online Sales</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/onlinesales/widgets/sampleUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="manageOnlinesalesList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="Kiosk">Kiosk</th><th st-sort="PS">Progressive Share</th><th st-sort="PW">Progressive Wins</th><th st-sort="NP">Net Purchase</th><th st-sort="NG">Net Gaming</th><th></th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="playtechid" placeholder="Kiosk" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlinesalesList" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.Kiosk" e-name="Kiosk" e-form="rowform" e-required="">{{ item.Kiosk || \'empty\'}}</span></td><td><span editable-text="item.PS" e-name="PS" e-form="rowform" e-required="">{{item.PS.replace(\'MYR\',\'\') || 0 }}</span></td><td><span editable-text="item.PW" e-name="PW" e-form="rowform" e-required="">{{item.PW.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NP" e-name="NP" e-form="rowform" e-required="">{{item.NP.replace(\'MYR\',\'\') || 0}}</span></td><td><span editable-text="item.NG" e-name="NG" e-form="rowform" e-required="">{{item.NG.replace(\'MYR\',\'\') || 0 }}</span></td><td><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/form/payment/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Payment!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/form/payment/widgets/paymentTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>Upload Payments</label> <input class="form-control" type="file" id="uploadFile" import-sheet-js="" opts="gridOptions" multiple="false" accept=".xls, .xlsx"></div><div class="col-sm-3"><label>Note: Please download the sample file for reference</label> <label><a href="app/pages/form/payment/widgets/paymentUpload.xlsx">Sample Upload File</a></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="gridOptions.data" st-table="managePaymentList"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th></th><th st-sort="AccNo">CaseNo</th><th st-sort="Name">Amount</th><th st-sort="IC">PayDate</th><th>Action</th></tr><tr><th></th><th></th><th>\u6848\u4EF6\u7F16\u53F7</th><th>\u7E3D\u984D</th><th>\u4ED8\u6B3E\u65E5\u671F</th><th>\u66F4\u6539</th></tr></thead><tbody><tr ng-repeat="item in managePaymentList" class="editable-row"><td class="table-id">{{$index+1}}</td><td nowrap=""><code ng-show="item.ERROR">{{ item.ERROR}}</code></td><td><span editable-text="item.CaseNo" e-name="CaseNo" e-form="rowform" e-required="">{{ item.CaseNo || \'empty\'}}</span></td><td><span editable-text="item.Amount" e-name="Amount" e-form="rowform" e-required="">{{item.Amount || \'empty\' }}</span></td><td><span editable-text="item.PayDate" e-name="PayDate" e-form="rowform" e-required="">{{item.PayDate || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/operational/case/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Case!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/case/modals/dangerPayment.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Payment!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/case/widgets/caseDetails.html','<div include-with-scope="app/pages/operational/case/widgets/caseInfo.html"></div><div include-with-scope="app/pages/operational/case/widgets/caseSummary.html"></div><div include-with-scope="app/pages/operational/case/widgets/customerInfo.html"></div>');
$templateCache.put('app/pages/operational/case/widgets/caseInfo.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="manageCase.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Remarks \u5907\u6CE8</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageCase.remark"></textarea></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label><div class="col-sm-9"><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="manageCase.reldate" ng-value="manageCase.reldate| date: \'dd/MM/yyyy\'" show-button-bar="false" is-open="dpOpenStatus1.withRequired" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus1(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate ||eDate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Status \u6848\u4EF6 \uFF08\u5F00/\u5173\uFF09</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.status"> <span>{{manageCase.status?"Open":"Closed"}}</span></label></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Closed Date \u622A\u6B62\u65E5\u671F</label><div class="col-sm-9"><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="manageCase.closedate" ng-value="manageCase.closedate| date: \'dd/MM/yyyy\'" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div>');
$templateCache.put('app/pages/operational/case/widgets/casePayment.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.code}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.reldate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate ||eDate | date: \'dd/MM/yyyy\'}}</label></div></div></div><h3 class="with-line">Payment Information \u4ED8\u6B3E\u8CC7\u6599 <button class="btn btn-primary editable-table-button btn-xs" ng-click="addPayment()" ng-if="!manageCase.isReport">Add</button></h3><div class="row" ng-show="isEditPayment"><div class="col-md-12"><form class="form-inline"><div class="row"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="managePayment.amount" placeholder="Amount"></div><div class="form-group col-sm-2 col-xs-3"><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="managePayment.paydate" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="Payment Date (dd/mm/yyyy)"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><button type="submit" class="btn btn-primary" ng-click="savePaymentDetails(managePayment)">Save Payment</button> <button type="submit" class="btn btn-default" ng-click="cancelPayment()">Cancel</button></div><div class="row"><div class="form-group col-sm-4 col-xs-6"><textarea class="form-control fill-width" ng-model="managePayment.remarks" placeholder="Remarks \u5099\u8A3B"></textarea></div></div></form><br></div></div><div class="row"><div class="col-md-12"><table class="table" st-safe-src="manageCase.payment" st-table="paymentList"><thead><tr class="black-muted-bg"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="id">Payment No.</th><th>Payment Date</th><th>Amount</th><th>Agent</th><th>Remarks</th><th ng-if="!manageCase.isReport">Action</th></tr><tr class="black-muted-bg"><th></th><th>\u4ED8\u6B3E\u6536\u636E</th><th>\u4ED8\u6B3E\u65E5\u671F</th><th>\u7E3D\u984D</th><th>\u4EE3\u7406\u4EBA</th><th>\u5099\u8A3B</th><th>\u66F4\u6539</th></tr></thead><tbody><tr ng-repeat="item in paymentList | orderBy: \'-paydate\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.id}}</td><td>{{item.paydate | date: \'dd/MM/yyyy\'}}</td><td><span editable-text="item.amount" e-name="amount" e-form="rowform" e-required="">{{ item.amount | currency:\'\'}}</span></td><td><span>{{getAgentName(item.payagent.credentials)}}</span></td><td><span editable-textarea="item.remarks" e-name="remarks" e-form="rowform" e-rows="4" e-cols="40">{{item.remarks || \'-\'}}</span></td><td ng-show="!manageCase.isReport"><form editable-form="" name="rowform" onbeforesave="editPaymentDetails($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmPaymentDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/case/widgets/caseSchedule.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.code}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.reldate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate||eDate | date: \'dd/MM/yyyy\'}}</label></div></div></div><h3 class="with-line">Schedule Information \u65E5\u7A0B\u8868\u8CC7\u6599</h3><div ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><div id="schedule" class="blurCalendar" ng-controller="scheduleCalendarCtrl"></div></div>');
$templateCache.put('app/pages/operational/case/widgets/caseSummary.html','<h3 class="with-line">Summary \u6458\u8981</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">\u603B\u671F\u6570 - \u4E0A\u671F - \u8FD8\u671F\u6570 = \u6B20\u671F\u6570</label> <label class="col-sm-4 control-label">{{terms+\' - \'+(manageCase.firstm+manageCase.lastm)+\' - \'+(manageCase.payment.length)+\' = \'+(terms-(manageCase.payment.length+manageCase.firstm+manageCase.lastm))}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Total Paid \u603B\u8FD8\u6570\u989D</label><label class="col-sm-4 control-label">{{manageCase.totalPaid | currency:\'\'}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Installment Amount \u5206\u671F\u4ED8\u6B3E\u91D1\u989D</label> <label class="col-sm-4 control-label">{{manageCase.tamount | currency:\'\'}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Pajak Item</label><div class="col-sm-4"><input type="text" class="form-control" ng-model="manageCase.pajakitem"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Outstanding Balance \u672A\u7ED3\u4F59\u989D</label> <label class="col-sm-4 control-label">{{(manageCase.amount - manageCase.totalPaid) | currency:\'\'}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Amount Due \u603B\u6B20</label><label ng-show="!manageCase.isloan && manageCase.status" class="col-sm-4 control-label">{{manageCase.amountDue | currency:\'\'}}</label> <label ng-show="manageCase.isloan && !manageCase.status" class="col-sm-4 control-label">{{manageCase.amountDue > 0 ? manageCase.amountDue : 0 | currency:\'\'}}</label> <label ng-show="manageCase.isloan && manageCase.status" class="col-sm-4 control-label">{{manageCase.amount | currency:\'\'}}</label></div><div class="form-group row clearfix"><label class="col-sm-4 control-label">Cash Deposit \u73B0\u94B1\u62B5\u62BC</label> <label class="col-sm-2 control-label">{{manageCase.deposit | currency:\'\'}}</label> <label class="col-sm-1 control-label"><i class="ion-arrow-right-c" style="font-size:22px;"></i></label> <label class="col-sm-2 custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.isdeposit"> <span>{{manageCase.isdeposit?"Installments":"Forfeited"}}</span></label></div></div></div>');
$templateCache.put('app/pages/operational/case/widgets/caseTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCaseList" st-table="manageCase"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Case No.</th><th st-sort="type">Type</th><th st-sort="customer.name">Name</th><th st-sort="customer.code">Acc No.</th><th st-sort="customer.address">Address</th><th st-sort="customer.contact">Contact</th><th st-sort="tamount">Installment</th><th st-sort="status">Status</th><th st-sort="reldate">Release Date</th><th st-sort="reldate">Maturity Date</th><th st-sort="closedate">Close Date</th><th>Action</th></tr><tr><th></th><th>\u6848\u4EF6\u7F16\u53F7</th><th>L \u501F/ D \u5F53</th><th>\u540D\u5B57</th><th>\u6237\u53E3\u53F7\u7801</th><th>\u5730\u5740</th><th>\u7535\u8BDD\u53F7\u7801</th><th>\u4F9B\u671F\u6570\u989D</th><th>\u6848\u4EF6 \uFF08\u5F00/\u5173\uFF09</th><th>\u51FA\u6B3E\u65E5\u671F</th><th></th><th>\u622A\u6B62\u65E5\u671F</th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Case No. \u6848\u4EF6\u7F16\u53F7" class="input-sm form-control search-input" type="search"></th><th><input st-search="type" placeholder="Search Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.name" placeholder="Search Name \u540D\u5B57" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.code" placeholder="Search Acc No. \u6237\u53E3\u53F7\u7801" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.address" placeholder="Search Address \u5730\u5740" class="input-sm form-control search-input" type="search"></th><th><input st-search="customer.contact" placeholder="Search Contact" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCase" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'empty\'}}</td><td>{{ item.type || \'empty\'}}</td><td>{{ item.customer.name || \'empty\'}}</td><td>{{ item.customer.code || \'empty\'}}</td><td>{{ item.customer.address || \'empty\'}}</td><td>{{ item.customer.contact || \'empty\'}}</td><td>{{ item.tamount || \'empty\'}}</td><td>{{ item.status?\'Open\':\'Closed\'}}</td><td>{{ item.reldate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.maturityDate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.closedate | date: \'dd/MM/yyyy\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editCase(item)">View</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button> &nbsp;</div></td></tr></tbody><tfoot><tr><td colspan="13" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/operational/case/widgets/customerInfo.html','<h3 class="with-line">Customer \u987E\u5BA2\u8D44\u6599 <button class="btn btn-primary editable-table-button btn-xs" ng-click="editCustomer()" ng-if="!isEditCustomer">Edit</button> <button class="btn btn-default editable-table-button btn-xs" ng-click="cancelEditCustomer()" ng-if="isEditCustomer">Cancel</button></h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-show="!isEditCustomer"><label for="inputFirstName" class="col-sm-3 control-label">Account Number \u6237\u53E3\u53F7\u7801</label> {{manageCase.customer.code}}</div><div class="form-group row clearfix" ng-show="isEditCustomer"><label for="inputFirstName" class="col-sm-3 control-label">Account Number \u6237\u53E3\u53F7\u7801</label><div><ui-select ng-model="manageCase.customer" class="col-sm-6 btn-group bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Account"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="customer in customerList | filter: $select.search"><span>{{customer.code}}, {{customer.name}}</span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label> {{manageCase.customer.ic}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label> {{manageCase.customer.contact}}</div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label> {{manageCase.customer.name}}</div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label> {{manageCase.customer.passport}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label> {{manageCase.customer.address}}</div></div></div><h3 class="with-line">Guarantor \u62C5\u4FDD\u4EBA\u8D44\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Name \u540D\u5B57</label> {{manageCase.customer.gname}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">I/C No. \u767B\u8BB0\u53F7\u7801</label> {{manageCase.customer.gic}}</div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address \u5730\u5740</label> {{manageCase.customer.gaddress}}</div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Contact No. \u7535\u8BDD\u53F7\u7801</label> {{manageCase.customer.gcontact}}</div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Passport No. \u62A4\u7167\u53F7\u7801</label> {{manageCase.customer.gpassport}}</div></div></div>');
$templateCache.put('app/pages/operational/case/widgets/loanCalculator.html','<h3 class="with-line">Case Information \u6848\u4EF6\u8CC7\u6599</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Case No. \u6848\u4EF6\u7F16\u53F7</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.code}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Sales Officer \u9500\u552E\u5458</label> <label for="inputFirstName" class="col-sm-3 control-label">{{ manageCase.agent.credentials.name||(manageCase.agent.credentials.firstName+\' \'+manageCase.agent.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Type L \u501F/ D \u5F53</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.type}}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Release Date \u51FA\u6B3E\u65E5\u671F</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.reldate | date: \'dd/MM/yyyy\'}}</label></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Approved by \u6279\u6838\u7ECF\u7406</label> <label for="inputLastName" class="col-sm-3 control-label">{{ manageCase.manager.credentials.name||(manageCase.manager.credentials.firstName+\' \'+manageCase.manager.credentials.lastName)}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Maturity Date</label> <label for="inputFirstName" class="col-sm-3 control-label">{{manageCase.maturityDate ||eDate | date: \'dd/MM/yyyy\'}}</label></div></div></div><h3 class="with-line">Loan Information \u8D37\u6B3E\u8CC7\u6599 <button class="btn btn-primary btn-xs" ng-click="recalculate()">Re-Calculate</button></h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Principle \u672C\u94B1\u8D37\u6B3E</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.principle"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Loan Amount \u8D37\u6B3E\u989D</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.amount"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">First Method \u505A\u6CD5</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="manageCase.firstm"></div><label class="col-sm-3 control-label">Last Method \u505A\u6CD5</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="manageCase.lastm"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Collect Interest \u7B79\u96C6\u5229\u606F</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.icollect"> <span>{{manageCase.icollect?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Interest Amount \u5229\u606F\u91D1\u989D</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.iamount"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Deductions \u6263\u9664</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.deduction"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Cash Deposit \u73B0\u94B1\u62B5\u62BC</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.deposit"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Stamp Duty \u5370\u82B1\u7A0E</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.stampduty"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Intervals \u95F4\u9694\u6642\u9593</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="interval"></div><label class="col-sm-3 control-label">Terms (in Days)</label><div class="col-sm-3"><input type="text" class="form-control" ng-model="terms"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Close with Loan Amount? \u540C\u6642\u95DC\u9589\u8CB8\u6B3E\u91D1\u984D</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageCase.isloan"> <span>{{manageCase.isloan?"Yes":"No"}}</span></label></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Installment Amount \u5206\u671F\u4ED8\u6B3E\u91D1\u989D</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.tamount"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Cash Out \u62FF</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageCase.cashout"></div></div></div></div>');
$templateCache.put('app/pages/operational/customer/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/customer/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Customer!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/operational/customer/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/operational/customer/widgets/customerTable.html','<div class="with-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [25,50,100,200]"></select></label></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCustomerList" st-table="manageCustomer"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Acc No.</th><th st-sort="name">Name</th><th st-sort="contact">Contact</th><th st-sort="ic">I/C</th><th st-sort="passport">Passport</th><th st-sort="address">Address</th><th>Action</th></tr><tr><th></th><th>\u6237\u53E3\u53F7\u7801</th><th>\u540D\u5B57</th><th>\u7535\u8BDD\u53F7\u7801</th><th>\u767B\u8BB0\u53F7\u7801</th><th>\u62A4\u7167\u53F7\u7801</th><th>\u5730\u5740</th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Account Number \u6237\u53E3\u53F7\u7801" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Name \u540D\u5B57" class="input-sm form-control search-input" type="search"></th><th><input st-search="contact" placeholder="Search Contact \u7535\u8BDD\u53F7\u7801" class="input-sm form-control search-input" type="search"></th><th><input st-search="ic" placeholder="Search I/C \u767B\u8BB0\u53F7\u7801" class="input-sm form-control search-input" type="search"></th><th><input st-search="passport" placeholder="Search Passport \u62A4\u7167\u53F7\u7801" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCustomer" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code || \'empty\'}}</td><td>{{item.name}}</td><td>{{item.contact || \'empty\'}}</td><td>{{item.ic || \'empty\'}}</td><td>{{item.passport || \'empty\'}}</td><td>{{item.address || \'empty\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editCustomer(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/operational/customer/widgets/machineShopTable.html','<h3 class="with-line">Shop and Supplier Information &nbsp; <button class="btn btn-primary btn-xs" ng-click="addSupplier()">Add Supplier</button> &nbsp;&nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Shop</button></h3><div class="row" ng-show="isEditSupplier"><div class="col-md-12"><div include-with-scope="app/pages/operational/machine/widgets/supplierTable.html"></div><br></div></div><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Shop Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action \u66F4\u6539</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.shop" data-e-form="rowform" data-e-name="shop" e-name="shop" data-e-ng-model="shop" append-to-body="true">{{ item.shop.code }}<editable-ui-select-match placeholder="Shop Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="shop in manageShopList | filter: $select.search track by $index">{{shop.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ item.supplier.code }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/operational/customer/widgets/supplierTable.html','<form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.code" placeholder="Supplier Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.name" placeholder="Supplier Name"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.contact" placeholder="Contact Details"></div><button type="submit" class="btn btn-primary" ng-click="saveSupplierDetails(manageSupplier)">Save Supplier</button> <button type="submit" class="btn btn-default" ng-click="cancelSupplier()">Cancel</button></form>');
$templateCache.put('app/pages/reports/casesummary/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/casesummary/widgets/casesummaryTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-3"><label>From Release Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.fromRelDate" show-button-bar="false" is-open="dpOpenStatus.fromRelDate" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'fromRelDate\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Release Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.toRelDate" show-button-bar="false" is-open="dpOpenStatus.toRelDate" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'toRelDate\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="!userData.credentials.shopType" class="col-sm-3"><label>Select Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label>Select Status</label><ui-select ng-model="reportFilter.daynight" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in dayNightFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-4"><label>&nbsp;</label><div class="row"><div class="col-sm-12"><button type="submit" class="btn btn-primary" ng-click="searchCaseSummary(reportFilter)">Search</button> <button type="submit" class="btn btn-info" ng-click="resetSearch()">Reset</button></div></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCaseSummaryList" st-table="manageCaseSummary"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Case No.</th><th st-sort="reldate">Release Date</th><th st-sort="maturityDate">Maturity Date</th><th st-sort="principle">Loan Principle</th><th st-sort="cashout">Cash Out</th><th st-sort="amount">Loan Amount</th><th st-sort="pajakitem">Pajak Item</th><th st-sort="payment">Payment</th><th st-sort="deposit">Cash Deposit</th><th st-sort="balance">Balance</th><th st-sort="balance">Profit/(Loss)</th><th st-sort="status">Status</th><th st-sort="closedate">Close Date</th><th st-sort="icollect">Collected</th><th st-sort="iamount">Interest</th><th st-sort="stampduty">Stamp Duty</th><th>Action</th></tr><tr><th></th><th>\u6848\u4EF6\u7F16\u53F7</th><th>\u51FA\u6B3E\u65E5\u671F</th><th></th><th>\u672C\u94B1\u8D37\u6B3E</th><th>\u62FF</th><th>\u8D37\u6B3E\u989D</th><th>\u5F53</th><th>\u4ED8\u6B3E</th><th>\u73B0\u94B1\u62B5\u62BC</th><th>\u4F59\u989D</th><th>\u8D5A/(\u4E8F)</th><th>\u6848\u4EF6 \uFF08\u5F00/\u5173</th><th>\u622A\u6B62\u65E5\u671F</th><th>\u5229\u606F\u5DF2\u6536</th><th>\u5229\u606F</th><th>\u5370\u82B1\u7A0E</th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Case Code \u6848\u4EF6\u7F16\u53F7" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprinciple(manageCaseSummary) | currency:\'\'}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalcashout(manageCaseSummary) | currency:\'\'}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalamount(manageCaseSummary) | currency:\'\'}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalItem(manageCaseSummary)}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalpayment(manageCaseSummary) | currency:\'\'}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaldeposit(manageCaseSummary) | currency:\'\'}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalbalance(manageCaseSummary) | currency:\'\'}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprofitloss(manageCaseSummary) | currency:\'\'}}</th><th></th><th></th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaliamount(manageCaseSummary) | currency:\'\'}}</th><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalstampduty(manageCaseSummary) | currency:\'\'}}</th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th ng-hide="manageCaseSummary.length>0"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCaseSummary" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code}}</td><td>{{ item.reldate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.enddate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.principle | currency:\'\'}}</td><td>{{ item.cashout | currency:\'\'}}</td><td>{{ item.amount | currency:\'\'}}</td><td>{{ item.pajakitem }}</td><td>{{ item.payment | currency:\'\'}}</td><td>{{ item.deposit | currency:\'\'}}</td><td>{{ item.balance | currency:\'\'}}</td><td>{{ item.profitloss | currency:\'\'}}</td><td>{{ item.status?\'Open\':\'Closed\'}}</td><td>{{ item.closedate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.icollect?\'Yes\':\'No\'}}</td><td>{{ item.iamount | currency:\'\'}}</td><td>{{ item.stampduty | currency:\'\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editCase(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprinciple(manageCaseSummary) | currency:\'\'}}</td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalcashout(manageCaseSummary) | currency:\'\'}}</td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalamount(manageCaseSummary) | currency:\'\'}}</td><th ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalItem(manageCaseSummary)}}</th><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalpayment(manageCaseSummary) | currency:\'\'}}</td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaldeposit(manageCaseSummary) | currency:\'\'}}</td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalbalance(manageCaseSummary) | currency:\'\'}}</td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprofitloss(manageCaseSummary) | currency:\'\'}}</td><td></td><td></td><td></td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaliamount(manageCaseSummary) | currency:\'\'}}</td><td ng-if="manageCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalstampduty(manageCaseSummary) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/cashinhand/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/cashinhand/widgets/cashinhandTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-4"><table class="table table-bordered table-condensed"><thead><tr><th class="text-center bold-text bg-warning" style="color:black">Debit</th><th class="text-center bold-text bg-info" style="color:black">Credit</th><th class="text-center bold-text bg-purple" style="color:black">Balance</th></tr></thead><tbody><tr><td class="text-center bold-text bg-warning" style="color:black">{{totalDebit | currency:\'\'}}</td><td class="text-center bold-text bg-info" style="color:black">{{totalCredit | currency:\'\'}}</td><td class="text-center bold-text bg-purple" style="color:black">{{(totalDebit-totalCredit) | currency:\'\'}}</td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Select Category</label><ui-select ng-model="reportFilter.category" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code+\', \'+$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="category in managecategoryList | filter: $select.search"><span ng-bind-html="category.code+\', \'+category.name"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label>Select Parent</label><ui-select ng-model="reportFilter.parent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code+\', \'+$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="parent in manageParentList | filter: $select.search"><span ng-bind-html="parent.code+\', \'+parent.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchCashinHand(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="resetSearch()">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCashinHandList" st-table="manageCashinHand"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="entrydate">Date</th><th st-sort="code">Code</th><th st-sort="category.name">Category</th><th st-sort="category">Parent</th><th st-sort="remarks">Remarks</th><th st-sort="debit">Debit</th><th st-sort="credit">Credit</th><th st-sort="balance">Balance</th></tr><tr><th></th><th></th><th>\u4EE3\u78BC</th><th>\u7A2E\u985E</th><th>\u4E0A\u7DDA</th><th>\u5907\u6CE8</th><th></th><th></th><th>\u8CC7\u7522</th></tr><tr><th></th><th></th><th><input st-search="category.code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th ng-if="manageCashinHand.length>0" style="background-color:chocolate ;color:black">{{ getTotaldebit(manageCashinHand) | currency:\'\'}}</th><th ng-if="manageCashinHand.length>0" style="background-color:chocolate ;color:black">{{ getTotalcredit(manageCashinHand) | currency:\'\'}}</th><th ng-if="manageCashinHand.length>0" style="background-color:chocolate ;color:black">{{ getTotaldebit(manageCashinHand) - getTotalcredit(manageCashinHand) | currency:\'\'}}</th><th ng-hide="manageCashinHand.length>0"></th><th ng-hide="manageCashinHand.length>0"></th><th ng-hide="manageCashinHand.length>0"></th></tr></thead><tbody><tr ng-repeat="item in manageCashinHand" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.entrydate | date: \'dd/MM/yyyy\'}}</td><td>{{item.category.code}}</td><td>{{item.category.name}}</td><td>{{ showparentid(item.parentid)}}</td><td>{{ item.remarks}}</td><td>{{ item.debit | currency:\'\'}}</td><td>{{ item.credit | currency:\'\'}}</td><td>{{ item.balance | currency:\'\'}}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageCashinHand.length>0" style="background-color:chocolate ;color:black">{{ getTotaldebit(manageCashinHand) | currency:\'\'}}</td><td ng-if="manageCashinHand.length>0" style="background-color:chocolate ;color:black">{{ getTotalcredit(manageCashinHand) | currency:\'\'}}</td><td ng-if="manageCashinHand.length>0" style="background-color:chocolate ;color:black">{{ getTotaldebit(manageCashinHand) - getTotalcredit(manageCashinHand) | currency:\'\'}}</td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/closecasesummary/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/closecasesummary/widgets/closecasesummaryTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div ng-if="!userData.credentials.shopType" class="col-sm-2"><label>Select Type</label><ui-select ng-model="reportFilter.shoptype" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.value}}</span></ui-select-match><ui-select-choices repeat="type in shopTypeFilter | filter: $select.search"><span ng-bind-html="type.value"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchCloseCaseSummary(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="resetSearch()">Reset</button></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCloseCaseSummaryList" st-table="manageCloseCaseSummary"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Case No.</th><th st-sort="reldate">Release Date</th><th st-sort="maturityDate">Maturity Date</th><th st-sort="principle">Loan Principle</th><th st-sort="cashout">Cash Out</th><th st-sort="amount">Loan Amount</th><th st-sort="pajakitem">Pajak Item</th><th st-sort="payment">Payment</th><th st-sort="deposit">Cash Deposit</th><th st-sort="balance">Balance</th><th st-sort="balance">Profit/(Loss)</th><th st-sort="closedate">Close Date</th><th st-sort="icollect">Collected</th><th st-sort="iamount">Interest</th><th st-sort="stampduty">Stamp Duty</th><th>Action</th></tr><tr><th></th><th>\u6848\u4EF6\u7F16\u53F7</th><th>\u51FA\u6B3E\u65E5\u671F</th><th></th><th>\u672C\u94B1\u8D37\u6B3E</th><th>\u62FF</th><th>\u8D37\u6B3E\u989D</th><th>\u5F53</th><th>\u4ED8\u6B3E</th><th>\u73B0\u94B1\u62B5\u62BC</th><th>\u4F59\u989D</th><th>\u8D5A/(\u4E8F)</th><th>\u622A\u6B62\u65E5\u671F</th><th>\u5229\u606F\u5DF2\u6536</th><th>\u5229\u606F</th><th>\u5370\u82B1\u7A0E</th><th>\u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Case Code \u6848\u4EF6\u7F16\u53F7" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprinciple(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalcashout(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalamount(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{getTotalItem(manageCloseCaseSummary)}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalpayment(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaldeposit(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalbalance(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprofitloss(manageCloseCaseSummary) | currency:\'\'}}</th><th></th><th></th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaliamount(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalstampduty(manageCloseCaseSummary) | currency:\'\'}}</th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th ng-hide="manageCloseCaseSummary.length>0"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageCloseCaseSummary" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.code}}</td><td>{{ item.reldate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.enddate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.principle | currency:\'\'}}</td><td>{{ item.cashout | currency:\'\'}}</td><td>{{ item.amount | currency:\'\'}}</td><td>{{ item.pajakitem }}</td><td>{{ item.payment | currency:\'\'}}</td><td>{{ item.deposit | currency:\'\'}}</td><td>{{ item.balance | currency:\'\'}}</td><td>{{ item.profitloss | currency:\'\'}}</td><td>{{ item.closedate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.icollect?\'Yes\':\'No\'}}</td><td>{{ item.iamount | currency:\'\'}}</td><td>{{ item.stampduty | currency:\'\'}}</td><td><div class="buttons"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editCase(item)">View</button> &nbsp;</div></td></tr><tr><td></td><td></td><td></td><td></td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprinciple(manageCloseCaseSummary) | currency:\'\'}}</td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalcashout(manageCloseCaseSummary) | currency:\'\'}}</td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalamount(manageCloseCaseSummary) | currency:\'\'}}</td><th ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{getTotalItem(manageCloseCaseSummary)}}</th><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalpayment(manageCloseCaseSummary) | currency:\'\'}}</td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaldeposit(manageCloseCaseSummary) | currency:\'\'}}</td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalbalance(manageCloseCaseSummary) | currency:\'\'}}</td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalprofitloss(manageCloseCaseSummary) | currency:\'\'}}</td><td></td><td></td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotaliamount(manageCloseCaseSummary) | currency:\'\'}}</td><td ng-if="manageCloseCaseSummary.length>0" style="background-color:chocolate ;color:black">{{ getTotalstampduty(manageCloseCaseSummary) | currency:\'\'}}</td><td></td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/collection/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine sale!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/reports/collection/widgets/collectionTable.html','<div class="horizontal-scroll"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-1"><label>Rows on page</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [250,500,1000]"></select></div><div class="col-sm-3"><label>From Date</label><p class="input-group"><input type="text" id="dp1" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.from" show-button-bar="false" is-open="dpOpenStatus.withRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3"><label>To Date</label><p class="input-group"><input type="text" id="dp2" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="dateList.to" show-button-bar="false" is-open="dpOpenStatus.withoutRequired" placeholder="dd/mm/yyyy" ng-required=""> <span class="input-group-btn"><button type="button" class="btn btn-default btn-warning" ng-click="setDpOpenStatus(\'withoutRequired\', $event)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-12"><div class="form-group row clearfix"><div class="col-sm-2"><label>Select Agent</label><ui-select ng-model="reportFilter.agent" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span ng-if="$select.selected.credentials.firstName">{{$select.selected.credentials.firstName+\' \'+$select.selected.credentials.lastName}}</span> <span ng-if="$select.selected.credentials.name">{{$select.selected.credentials.name}}</span></ui-select-match><ui-select-choices repeat="agent in manageAgentsList | filter: $select.search"><span ng-if="agent.credentials.firstName" ng-bind-html="agent.credentials.firstName+\' \'+agent.credentials.lastName"></span> <span ng-if="agent.credentials.name" ng-bind-html="agent.credentials.name"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-primary" ng-click="searchCollection(reportFilter)">Search</button></div></div><div class="col-sm-1"><label>&nbsp;</label><div><button type="submit" class="btn btn-info" ng-click="resetSearch()">Reset</button></div></div></div></div></div></div></div><table class="table table-striped table-condensed" st-safe-src="manageCollectionList" st-table="manageCollection"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="id">Payment No.</th><th>Payment Date</th><th st-sort="casecode">Case No.</th><th>Case Remark</th><th>Agent</th><th>Payment Remarks</th><th>Installment Amount</th><th>Collection Amount</th></tr><tr><th></th><th>\u4ED8\u6B3E\u6536\u636E</th><th>\u4ED8\u6B3E\u65E5\u671F</th><th>\u6848\u4EF6\u7F16\u53F7</th><th></th><th>\u4EE3\u7406\u4EBA</th><th>\u5099\u8A3B</th><th>\u5206\u671F\u4ED8\u6B3E\u91D1\u989D</th><th>\u7E3D\u984D</th></tr><tr><th></th><th></th><th></th><th><input st-search="casecode" placeholder="Case Code \u6848\u4EF6\u7F16\u53F7" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th ng-if="manageCollection.length>0" style="background-color:chocolate ;color:black">{{ getTotaltamount(manageCollection) | currency:\'\'}}</th><th ng-hide="manageCollection.length>0"></th><th ng-if="manageCollection.length>0" style="background-color:chocolate ;color:black">{{ getTotalamount(manageCollection) | currency:\'\'}}</th><th ng-hide="manageCollection.length>0"></th></tr></thead><tbody><tr ng-repeat="item in manageCollection | orderBy: \'-paydate\'" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{item.id}}</td><td>{{ item.paydate | date: \'dd/MM/yyyy\'}}</td><td>{{ item.casecode}}</td><td>{{item.case.remark || \'\'}}</td><td>{{getAgentName(item.payagent.credentials)}}</td><td>{{item.remarks || \'\'}}</td><td>{{ item.case.tamount | currency:\'\'}}</td><td>{{ item.amount | currency:\'\'}}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td ng-if="manageCollection.length>0" style="background-color:chocolate ;color:black">{{ getTotaltamount(manageCollection) | currency:\'\'}}</td><td ng-if="manageCollection.length>0" style="background-color:chocolate ;color:black">{{ getTotalamount(manageCollection) | currency:\'\'}}</td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/areas/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Area!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/areas/widgets/areasTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped" st-safe-src="manageAreasList" st-table="manageAreas"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="zone.code">Zone</th><th st-sort="state.name">State</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageAreas" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td class="select-td"><span editable-select="item.zone.id" e-name="zone" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.code for g in manageZonesList">{{ showZones(item.zone) }}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveArea($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/gamecategory/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Game Category!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/gamecategory/widgets/gamecategoryTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageGamecategoryList" st-table="manageGamecategory"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGamecategory" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveGamecategory($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/games/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/games/widgets/gamesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageGamesList" st-table="manageGames"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="gamecategory.name">Game Category</th><th st-sort="status">Status</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="gamecategory.name" placeholder="Search Game Category" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Game Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageGames" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.gamecatid" e-name="gamecategory" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamecategoryList">{{ showGamecategory(item.gamecat) }}</span></td><td class="select-td"><span editable-select="item.status" e-name="status" e-form="rowform" onshow="loadGroups()" e-selectpicker="" e-ng-options="s.value for s in status">{{ showStatus(item.status) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveGame($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/machine/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/machine/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/machine/modals/qrModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-qr-scanner modal-icon"></i><span>QR Code</span></div><div class="modal-body text-center"><div id="qrLabel" print-section="" print-avoid-break="" print-landscape=""><qr text="qrString" correction-level="H" size="80"></qr><br><span>{{qrString}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="print()">PRINT</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">CLOSE</button></div></div>');
$templateCache.put('app/pages/system/machine/widgets/machineShopTable.html','<h3 class="with-line">Shop and Supplier Information &nbsp; <button class="btn btn-primary btn-xs" ng-click="addSupplier()">Add Supplier</button> &nbsp;&nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Shop</button></h3><div class="row" ng-show="isEditSupplier"><div class="col-md-12"><div include-with-scope="app/pages/system/machine/widgets/supplierTable.html"></div><br></div></div><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Shop Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action \u66F4\u6539</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.shop" data-e-form="rowform" data-e-name="shop" e-name="shop" data-e-ng-model="shop" append-to-body="true">{{ item.shop.code }}<editable-ui-select-match placeholder="Shop Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="shop in manageShopList | filter: $select.search track by $index">{{shop.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ showSupplierCode(item.supplier.id) }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/machine/widgets/machineTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageMachineList" st-table="manageMachine"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Code</th><th st-sort="games.name">Game List</th><th st-sort="zone.code">Zone</th><th st-sort="isjackpot">is Jackpot?</th><th st-sort="calby">Calc By?</th><th st-sort="cm_rate">CM Rate</th><th st-sort="bm_rate">BM Rate</th><th st-sort="">CM to BM</th><th st-sort="status">Status</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="games.name" placeholder="Search Game" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachine" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span> <i class="ion-eye" ng-click="viewQRcode(item.code)"></i></td><td class="select-td">{{item.game.name}}</td><td class="select-td">{{item.zone.code}}</td><td><span editable-text="item.isjackpot" e-name="isjackpot" e-form="rowform" e-required="">{{ item.isjackpot?\'Yes\':\'No\' || \'empty\'}}</span></td><td><span editable-text="item.calby" e-name="calby" e-form="rowform" e-required="">{{ item.calby?\'CM\':\'BM\' || \'empty\'}}</span></td><td><span editable-text="item.cmRate" e-name="cm_rate" e-form="rowform" e-required="">{{ item.cmRate || \'empty\'}}</span></td><td><span editable-text="item.bmRate" e-name="bm_rate" e-form="rowform" e-required="">{{ item.bmRate || \'empty\'}}</span></td><td>{{(item.cmRate/item.bmRate)|currency: \'\'}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachine($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editMachine(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/machine/widgets/supplierTable.html','<form class="row form-inline"><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.code" placeholder="Supplier Code"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.name" placeholder="Supplier Name"></div><div class="form-group col-sm-2 col-xs-3"><input type="text" class="form-control" ng-model="manageSupplier.contact" placeholder="Contact Details"></div><button type="submit" class="btn btn-primary" ng-click="saveSupplierDetails(manageSupplier)">Save Supplier</button> <button type="submit" class="btn btn-default" ng-click="cancelSupplier()">Cancel</button></form>');
$templateCache.put('app/pages/system/shop/modals/dangerMachineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Machine from Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Shop!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/modals/dangerOnlineGameModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Online Game!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/shop/widgets/machines.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.macrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.mactips"></div></div></div></div><h3 class="with-line">Machine Setup &nbsp; <button class="btn btn-primary btn-xs" ng-click="addMachineShop()">Assign Machine</button></h3><div class="row"><div class="col-md-8"><table class="table" st-safe-src="manageMachineshopList" st-table="manageMachineshop"><thead><tr class="black-muted-bg"><th>Machine Code</th><th>Supplier Code</th><th>Supplier Commision %</th><th>Company %</th><th>Virtual Company %</th><th>Action \u66F4\u6539</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageMachineshop" class="editable-row"><td class="select-td"><span editable-ui-select="item.machine" data-e-form="rowform" data-e-name="machine" e-name="machine" data-e-ng-model="machine" append-to-body="true">{{ showMachine(item.machine) }}<editable-ui-select-match placeholder="Machine Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="machine in manageMachineList | filter: $select.search track by $index">{{machine.code}}</editable-ui-select-choices></span></td><td class="select-td"><span editable-ui-select="item.supplier" data-e-form="rowform" data-e-name="supplier" e-name="supplier" data-e-ng-model="supplier" append-to-body="true">{{ showSupplierCode(item.supplier.id) }}<editable-ui-select-match placeholder="Supplier Code" style="width: 150px">{{$select.selected.code}}</editable-ui-select-match><editable-ui-select-choices repeat="supplier in manageSupplierList | filter: $select.search track by $index">{{supplier.code}}</editable-ui-select-choices></span></td><td><span editable-text="item.suprate" e-name="suprate" e-form="rowform" e-required="">{{ item.suprate || \'empty\'}}</span></td><td><span editable-text="item.macrate" e-name="macrate" e-form="rowform" e-required="">{{ item.macrate || \'empty\'}}</span></td><td><span editable-text="item.macvirtual" e-name="macvirtual" e-form="rowform" e-required="">{{ item.macvirtual || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveMachineshop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmMachineshopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/shop/widgets/onlineGames.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrate"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">Rebate %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onrebate"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Vitual Company %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.onvirtual"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Tips %</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.ontips"></div></div></div></div><h3 class="with-line">Online Games Setup &nbsp; <button class="btn btn-primary editable-table-button btn-xs" ng-click="addOnlineShop()">Add</button></h3><div class="row"><div class="col-md-6"><table class="table" st-safe-src="manageOnlineShopList" st-table="manageOnlineShop"><thead><tr class="black-muted-bg"><th>Online Game</th><th>PlayTech ID</th><th>Action \u66F4\u6539</th><th></th></tr></thead><tbody><tr ng-repeat="item in manageOnlineShop" class="editable-row"><td class="select-td"><span editable-select="item.game.id" e-name="games" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageGamesList">{{ showGames(item.game) }}</span></td><td><span editable-text="item.playtechid" e-name="playtechid" e-form="rowform" e-required="">{{ item.playtechid || \'empty\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveOnlineShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmOnlineShopDelete(item.id)">Delete</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/system/shop/widgets/partner.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Partner</label><div class="col-sm-9"><ui-select ng-model="manageShop.partner" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="partner in managePartnerList | filter: $select.search"><span ng-bind-html="partner.code"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Name & Contact</label><div class="col-sm-9"><label for="inputLastName" class="col-sm-9 control-label">{{manageShop.partner.name+\' (\'+manageShop.partner.contact+\')\'}}</label></div></div></div></div><h3 class="with-line">Contact Details</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">1. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">2. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.name"></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">3. Contact Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.name"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">1. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact1.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">2. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact2.number"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">3. Contact Number</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.contact3.number"></div></div></div></div>');
$templateCache.put('app/pages/system/shop/widgets/shopInfo.html','<div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop ID</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.code"></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Type</label><div class="col-sm-9"><select class="form-control" ng-model="manageShop.shoptype" selectpicker=""><option selected="">100%</option><option>5/5</option></select></div></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.address"></textarea></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><label class="custom-checkbox"><input type="checkbox" class="form-control" ng-model="manageShop.status"> <span>{{manageShop.status?"Active":"Inactive"}}</span></label></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Shop Name</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="manageShop.name"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Zone Code</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.zone" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="zone in manageZonesList | filter: $select.search"><span ng-bind-html="zone.code"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Area</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.area" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in manageAreaList | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Shop Balai</label><div class="col-sm-9 form-group"><ui-select ng-model="manageShop.site" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Nothing Selected"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="site in manageSiteList | filter: $select.search"><span ng-bind-html="site.name"></span></ui-select-choices></ui-select></div></div></div></div><h3 class="with-line">Credits & Remarks</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Credit Limit</label><div class="col-sm-9"><input type="float" class="form-control" ng-model="manageShop.creditlimit"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Remarks</label><div class="col-sm-9"><textarea class="form-control" ng-model="manageShop.remarks"></textarea></div></div></div></div>');
$templateCache.put('app/pages/system/shop/widgets/shopTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageShopList" st-table="manageShop"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Shop ID</th><th st-sort="name">Shop Name</th><th st-sort="shoptype">Shop Type</th><th st-sort="partner.name">Partner ID</th><th st-sort="zone.code">Zone</th><th st-sort="status">Status</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Shop ID" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Shop" class="input-sm form-control search-input" type="search"></th><th><input st-search="shoptype" placeholder="Search Shop Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="partner.name" placeholder="Search Partner" class="input-sm form-control search-input" type="search"></th><th><input st-search="zone.code" placeholder="Search Zone" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageShop" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.shoptype" e-name="shoptype" e-form="rowform" e-required="">{{ item.shoptype || \'empty\'}}</span></td><td class="select-td">{{item.partner.name}}</td><td class="select-td">{{item.zone.code}}</td><td><span editable-text="item.status" e-name="status" e-form="rowform" e-required="">{{ item.status?\'Active\':\'Inactive\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="saveShop($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="editShop(item)">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table><br><br></div>');
$templateCache.put('app/pages/system/site/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Site!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/site/widgets/siteTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped" st-safe-src="manageSiteList" st-table="manageSites"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="area.name">Area</th><th st-sort="state.name">State</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="area.name" placeholder="Search Area" class="input-sm form-control search-input" type="search"></th><th><input st-search="state.name" placeholder="Search State" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageSites" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.area.id" e-name="area" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageAreaList">{{ showArea(item.area) }}</span></td><td class="select-td"><span editable-select="item.state.id" e-name="state" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.name for g in manageStatesList">{{ showState(item.state) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveSite($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><br><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/states/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this State!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/states/widgets/statesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageStatesList" st-table="manageStates"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="name">Name</th><th st-sort="description">Description</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="description" placeholder="Search Description" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageStates" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td><span editable-text="item.description" e-name="description" e-form="rowform" e-required="">{{ item.description || \'empty\' }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveState($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/system/zones/modals/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Are you Sure?</span></div><div class="modal-body text-center">You are about to delete this Zone!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="$dismiss()">CANCEL</button></div></div>');
$templateCache.put('app/pages/system/zones/widgets/zonesTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100]"></select></label></div><table class="table table-striped table-condensed" st-safe-src="manageZonesList" st-table="manageZones"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="code">Zone Code</th><th st-sort="name">Name</th><th st-sort="status">Status</th><th st-sort="created">Created</th><th st-sort="lastupdated">Last Updated</th><th>Action \u66F4\u6539</th></tr><tr><th></th><th><input st-search="code" placeholder="Search Zone Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="name" placeholder="Search Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th><th><input st-search="created" placeholder="Search Created Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastupdated" placeholder="Search Last Updated Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in manageZones" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.code" e-name="code" e-form="rowform" e-required="">{{ item.code || \'empty\'}}</span></td><td><span editable-text="item.name" e-name="name" e-form="rowform" e-required="">{{ item.name || \'empty\'}}</span></td><td class="select-td"><span editable-select="item.status" e-name="status" e-form="rowform" onshow="loadGroups()" e-selectpicker="" e-ng-options="s.value for s in status">{{ showStatus(item.status) }}</span></td><td>{{item.created | date: \'dd/MM/yyyy hh:mm a\'}}</td><td>{{item.lastupdated | date: \'dd/MM/yyyy hh:mm a\'}}</td><td><form editable-form="" name="rowform" onbeforesave="saveZones($data,item.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> &nbsp; <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> &nbsp; <button class="btn btn-danger editable-table-button btn-xs" ng-click="confirmDelete(item.id)">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action \u66F4\u6539</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');}]);